import React, { useState } from 'react'
import { Button, Card, Carousel, Modal, OverlayTrigger, Popover, Spinner, Tooltip } from 'react-bootstrap'
import './serviceRequestDetails.scss'
import sample from '../../images/tracker-img/restro-logo.jpg'
import { ticketCallRequest } from "../../service/api/ticket/ticketCallRequest";
import { ticketDetailsApi } from "../../service/api/ticket/getTicketDetails";
import acceptRejectRequest from "../../service/api/ticket/acceptRejectRequest";
import { resendVideoLink } from "../../service/api/callHistory/resendVideoLink";
import updateTicketDetail from "../../service/api/ticket/updateTicketDetail";
import { connectToPro } from "../../service/api/ticket/connectToPro";
import updateTicketStatus from "../../service/api/ticket/updateTicketStatus";
import sendCallRequestTicket from "../../service/api/ticket/sendCallRequestTicket";
import { backDropLoaderRejectedCaseRedux, backLoaderFalse, backLoaderTrue, setCurrentPage, setLoaderTime, setUserProfileTab, updateBackDropLoaderWithoutStateFalse, updateBackDropLoaderWithoutStateTrue } from "../../feature/userData/userData";
import DatePicker from "react-datepicker";
import calendarImg from "../../media/images/servicesAssets/calendarImg.png";
import DIYSoloImg from "../../media/images/servicesAssets/DIYSoloImg.png";
import remoteProImg from "../../media/images/servicesAssets/remoteProImg.png";
import localProImg from "../../media/images/servicesAssets/localProImg.png";
import logo from "../../icons/photos/chillLogo.png";
import serviceImg from '../../media/images/serviceImg.gif'
import NewDIYSoloImg from '../../media/images/servicesAssets/NewDIYSoloImg.png';
import NewDIYRemoteProImg from '../../media/images/servicesAssets/NewDIYRemoteProImg.png';
import NewLocalProImg from '../../media/images/servicesAssets/NewLocalProImg.png';

import { format } from "date-fns";

import ActionButton from '../../jsx/components/button/ActionButton'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useRef } from 'react'
import { useEffect } from 'react'
import InternationalPhoneFormatFun from '../../ui/InternationalPhoneFormatFun';
import PrimaryButton from '../../jsx/components/button/primaryButton';
import TextArea from '../../jsx/components/fields/textArea';
import SelectInputTimeSlot from '../../jsx/components/fields/selectInputTimeSlot';
import SelectInputCommunicationMode from '../../jsx/components/fields/selectInputComMode';
import DummyBackdropLoader from '../../component/backDrop/dummyBackDropLoader';
import BackDrop from '../../component/backDrop/backDropLoader';
import ErrorBackdropLoader from '../../component/backDrop/errorBackDropLoader';
import { lblCommunicationMode, lblEmail, lblEnterProblemDescription, lblTimeSlot, txtCategory, txtClosed, txtCreatedBy, txtCreatedOn, txtPhotos, txtProduct, txtRoute, txtSearchProConfirmation, txtServiceRequestDetails, txtServiceRequestStatus, txtTicketId, txtUpdateServiceRequest, txtUpdated } from '../../dataBaseFile/label';
import { btnAcceptService, btnAcceptedByotherPro, btnConnect, btnConnectWithAnotherPro, btnConnectWithPro, btnJoinVideo, btnMarkAsResolved, btnReInititateLoading, btnReInititateService, btnRejectService, btnRejectedService, btnRejectedServiceMsg, btnResendLink, btnUpdateProfileLoading } from '../../dataBaseFile/alert';
import ResponceToaster from '../../jsx/components/responceToaster/responceToaster';
import SkeletonDivElement from '../../component/skeletonTableRow/skeletonDivElement';
import { emailValidation, noSpaceOnChange, phoneValidation, urlPattern } from '../../validations/validation';
import shareServiceRequest from '../../service/api/ticket/shareServiceRequest';
import EmailPhoneCombine from '../../jsx/components/fields/emailPhoneField';
import { validEmail_OR_MobileNumberText } from '../../dataBaseFile/error';
import { getPurchaseList } from '../../service/api/ticket/getPurchaseList';
import { createPurchaseItem } from '../../service/api/ticket/createPurchaseItem';
import deletePurchaseItem from '../../service/api/ticket/deletePurchaseItem';
import updatePurchaseItem from '../../service/api/ticket/updatePurchaseItem';
import sharePurchaseList from '../../service/api/ticket/sharePurchaseList';
import InputField from '../../jsx/components/fields/inputField';
import unavailableServiceImgLogo from '../../media/images/servicesAssets/unavailableServiceImgLogo.png'
import emptyListImg from '../../media/images/servicesAssets/emptyListImg.png'
import getServiceRequestHistoryApi from '../../service/api/ticket/getServiceRequestHistory';
import { callNoteDetails } from '../../service/api/callHistory/callNoteDetails';
import { callNote } from '../../service/api/callHistory/callNote';
import { deleteCallLogNoteById } from '../../service/api/callHistory/deleteCallLogNoteById';
import { getNotesPurchaseListCallSCountersApi } from '../../service/api/ticket/getNotesPurchaseListCallSCounters';
import { BsStarFill } from 'react-icons/bs';
import { BiStar } from 'react-icons/bi';
import { saveRating } from '../../service/api/user/saveRating';
import raiseRefundApi from '../../service/api/paymentGateway/raiseRefund';
import { getPaymentConfigApi } from '../../service/api/paymentGateway/getPaymentConfig';
import AcceptRejectModal from '../../jsx/components/modalAcceptReject/modalAcceptreject';
import SearchableSelect from '../../jsx/components/fields/serchableSelect';
import { getInviteAndRegisteredUsersApi } from '../../service/api/user/getInviteAndRegisteredUsers';
import reAssignViaRoleApi from '../../service/api/ticket/reAssignViaRole';
import acceptAssignedTicketApi from '../../service/api/ticket/acceptAssignedTicket';
import SearchableSelectForInvites from '../../jsx/components/fields/searchableSelectForInvites';
import { LuMoreVertical } from 'react-icons/lu';
import { FaArrowRightLong } from 'react-icons/fa6';
import ImagePreviewer from '../../jsx/components/imagePreviewer/imagePreviewer';
import { getCallRecordingsApi } from '../../service/api/video/getCallRecordings';
import VideoAudioPlayer from '../../component/videoAudioPlayer/videoAudioPlayer';
import updateTicketSummaryApi from '../../service/api/ticket/updateTicketSummary';
import { createUpdateProjectApi } from '../../service/api/ticket/createUpdateProject';
import { saveCallDurationApi } from '../../service/api/video/saveCallDuration';
import { getPaymentMethodListByCustomerId } from '../../service/api/paymentGateway/getPaymentMethodListByCustomerId';
import { getComposeRecordingsApi } from '../../service/api/video/getComposedRecordings';


const ServiceRequestDetailsPage = () => {
    const dispatch = useDispatch();

    const navigate = useNavigate();
    const hiddenFileInput = useRef(0);
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    // All Tooltips
    const tooltipConnect = (
        <Tooltip id="tooltip">
            <strong >Please update your service request first</strong>
        </Tooltip>
    );

    const { userName, backDropLoaderWithoutUpdate, backDropLoaderRejectedCase, loaderTime, companyId, customerID } = useSelector((state) => state.user);
    const { role, backDropLoaderStatus, isVerified, permissionArr, isSubscribedUser } = useSelector((state) => state.user);
    const permissionArray = permissionArr[0] || []

    const [callDetailsObj, setCallDetailsObj] = useState({});
    const [receiverData, setReceiverData] = useState({});
    const [attachmentsArr, setAttachmentsArr] = useState([]);
    const [joinLoading, setJoinLoading] = useState(false);

    const [resendLoading, setResendLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [time, setTime] = useState(0);
    const [updatedTime, setUpdatedTime] = useState(0);
    const [open, setOpen] = useState(false);
    const [discussionVal, setDiscussionVal] = useState("");
    const [callNoteDetailsArr, setCallNoteDetailsArr] = useState([]);

    // =============================

    const [detailsSection, setDetailsSection] = useState(true);
    const [attachmentSection, setAttachmentSection] = useState(false);
    const [fileName, setFileName] = useState("");
    const [selectedFile, setSelectedFile] = useState([]);
    const [selectedFileLimit, setSelectedFileLimit] = useState("")
    // const [preview, setPreview] = useState([]);
    const [saveLoading, setSaveLoading] = useState(false);
    const [discussionLoading, setDiscussionLoading] = useState(false);
    const [deleteIconVisiblity, setDeleteIconVisiblity] = useState({
        visibility: "hidden",
    });

    const [showUserRating, setShowUserRating] = useState(0);

    const [phoneNumberFormat, setphoneNumberFormat] = useState();
    const [searchProVal, setSearchProVal] = useState("")
    const [productCategorySearch, setProductCategorySearch] = useState("")
    const [proList, setProList] = useState([])
    const [searchAreaPro, setSearchAreaPro] = useState("")
    const [sentRequest, setSentRequest] = useState([])
    const [metaDataChr, setMetaDataChr] = useState("");
    const [acceptRejectFlag, setAcceptRejectFlag] = useState();
    const [videoJoinLink, setVideoJoinLink] = useState('');
    const [isActiveVideoLink, setIsActiveVideoLink] = useState(0);
    const [productCategory, setProductCategory] = useState("");

    const [waitingTime, setWaitingTime] = useState(0);

    const [page, setPage] = React.useState(1)
    const [pageSize, setPageSize] = useState(10)
    const [totalPage, setTotalPage] = useState(1);
    const [totalCount, setTotalCount] = useState(100);
    const [sortByValue, setSortByValue] = useState("DESC")

    const [dialogLoader, setDialogLoader] = useState(false);
    const [imageLoader, setImageLoader] = useState(true);


    const [openDoc, setOpenDoc] = React.useState(false);
    const [imageAttach, setImageAttach] = useState(1);
    const [imageAttachURL, setImageAttachURL] = useState('');
    const [notesMessage, setNotesMessage] = useState("");

    const [proAvailableFlag, setProAvailableFlag] = useState(0);

    const [isCallRecording, setIsCallRecordings] = useState(true);

    const [proRecommendedSolution, setProRecommendedSolution] = useState(0);
    const [customerSelectedSolution, setCustomerSelectedSolution] = useState(0);
    const [updateTicketSummaryLoading, setUpdateTicketSummaryLoading] = useState(false);

    const [projectId, setProjectId] = useState('');

    const [proDiagnosis, setProDiagnosis] = useState("");
    const [proDiagnosisErr, setProDiagnosisErr] = useState(false);
    const [toggleEditProDiagnosis, setToggleEditProDiagnosis] = useState(false);

    const handleProDiagnosis = (e) => {
        setProDiagnosisErr(false);
        setProDiagnosis(e.target.value);
    };

    const handleOpenDoc = () => {
        setOpenDoc(true);
    }
    const handleCloseDoc = () => {
        setOpenDoc(false);
        handleResetImage();
        setNotesMessage('');
    }

    const [handleSnackbarSuccess, setHandleSnackbarSuccess] = useState(false);
    const [handleSnackbarError, setHandleSnackbarError] = useState(false);



    const [responceMsg, setResponceMsg] = useState("");
    const [updateDocumentsLoading, setUpdateDocumentsLoading] = useState(false);
    const [toasterType, setToasterType] = useState();
    const [handleToaster, setHandleToaster] = useState(false);

    const [customLoading, setCustomLoading] = useState(true);

    const [serviceReqHistoryArr, setServiceReqHistoryArr] = useState([]);

    const [serviceActionsLoading, setServiceActionsLoading] = useState(false);
    const [serviceDetailsLoading, setServiceDetailsLoading] = useState(false);

    const [raiseRefundLoading, setRaiseRefundLoading] = useState(false);
    const [particularCallLogId, setParticularCallLogId] = useState('');

    const [isSubscriptionExpired, setIsSubscriptionExpired] = useState(false);
    const [serviceSummaryMetaData, setServiceSummaryMetaData] = useState({});
    const [localProModaltrigger, setLocalProModalTrigger] = useState(false);

    const [customerEstimatedCostMin, setCustomerEstimatedCostMin] = useState(``);
    const [customerEstimatedCostMax, setCustomerEstimatedCostMax] = useState(``);

    const [currentDateLocalPro, setCurrentDateLocalPro] = useState('');
    const [currentTimeLocalPro, setCurrentTimeLocalPro] = useState('');

    const [termsAndConditions, setTermsAndConditions] = useState(localStorage.getItem('projectId') ? true : false);
    const [termsAndConditionsErr, setTermsAndConditionsErr] = useState(false);

    const [localProSectionDateTime, setLocalProSectionDateTime] = useState('1');
    const [toggleForLocalProModal, setToggleForLocalProModal] = useState('1');

    const [createUpdateProjectLoading, setCreateUpdateProjectLoading] = useState(false);

    const [toggleForEstimationsTab, setToggleForEstimationsTab] = useState(+localStorage.getItem("isEstimateService") == 1 ? '2' : '1');

    const [callChargeAmount, setCallChargeAmount] = useState(0);
    const [callDurationTimeLimit, setCallDurationTimeLimit] = useState(0);

    const [confirmationForConnectToProModalTrigger, setConfirmationForConnectToProModalTrigger] = useState(false);
    const [saveCallDurationLoading, setSaveCallDurationLoading] = useState(false);
    const [paymentErrorModalTrigger, setPaymentErrorModalTrigger] = useState(false);
    const [paymentErrorStatusCode, setPaymentErrorStatusCode] = useState(0);

    const [alertCardsModalTrigger, setAlertCardsModalTrigger] = useState(false);
    const [cardArr, setCardArr] = useState([]);

    useEffect(() => {
        if (serviceSummaryMetaData?.estimated_by_customer?.min_cost) {
            setCustomerEstimatedCostMin(serviceSummaryMetaData?.estimated_by_customer?.min_cost)
        }
        else if (serviceSummaryMetaData?.pro_check_info?.pro_estimated_cost_min) {
            setCustomerEstimatedCostMin(serviceSummaryMetaData?.pro_check_info?.pro_estimated_cost_min)
        }

        if (serviceSummaryMetaData?.estimated_by_customer?.max_cost) {
            setCustomerEstimatedCostMax(serviceSummaryMetaData?.estimated_by_customer?.max_cost)
        }
        else if (serviceSummaryMetaData?.pro_check_info?.pro_estimated_cost_max) {
            setCustomerEstimatedCostMax(serviceSummaryMetaData?.pro_check_info?.pro_estimated_cost_max)
        }
    }, [serviceSummaryMetaData])

    useEffect(() => {
        if (customerID) {
            getPaymentMethodList();
        }
    }, [])

    const getPaymentMethodList = (firstTimeID) => {

        let details = {
            customer_id_ids: customerID || firstTimeID,
        }
        dispatch(
            getPaymentMethodListByCustomerId(details,
                (res) => {
                    // console.log(res.data.data)
                    setCardArr(res?.data?.data?.data || []);
                },
                (res) => {
                    // console.log(res.data.data)
                })
        )

    }

    const handleCloseConfirmationForConnectToProModal = (e) => {
        setConfirmationForConnectToProModalTrigger(false);
    };
    const handleShowConfirmationForConnectToProModal = (e) => {
        setConfirmationForConnectToProModalTrigger(true);
    }

    function saveCallDurationForRegisteredCustomer() {

        setSaveCallDurationLoading(true);
        const data = new FormData();
        data.append("user_id_ids", localStorage.getItem("user_id") || "");

        data.append("call_log_id_ids", receiverData?.calls[0]?.call_log_id_ids);
        data.append("joinee_name_chr", userName);
        data.append("call_duration_in_second", 1);
        data.append("after_free_time_flag", 1);


        dispatch(saveCallDurationApi(data, (res) => {
            console.log(res)
            setSaveCallDurationLoading(false);

            ReInitiateByCust();
        }, (err) => {
            console.log(err);
            setSaveCallDurationLoading(false);

            setPaymentErrorStatusCode(err.status);


            setPaymentErrorModalTrigger(true);

            setResponceMsg(err.data.message);
            setToasterType("error");

            handleCloseConfirmationForConnectToProModal();

            // setHandleToaster(true);
            // setTimeout(() => {
            //   setHandleToaster(false);
            // }, 11000);
        }))
    }

    const handleCustomerEstimatedCostMin = (e) => {
        // setCustomerEstimatedCostMin(
        //     e.target.value.replace(/[^\d.]/g, "").replace(/(\.\d*)\./g, "$1")
        // );
    };

    const handleCustomerEstimatedCostMax = (e) => {
        // setCustomerEstimatedCostMax(
        //     e.target.value.replace(/[^\d.]/g, "").replace(/(\.\d*)\./g, "$1")
        // );
    };

    useEffect(() => {
        if (+customerEstimatedCostMin > +customerEstimatedCostMax) {
            setCustomerEstimatedCostMax((+customerEstimatedCostMin * 1.2).toFixed(2));
        }
    }, [customerEstimatedCostMin])

    const handleOpenLocalProModal = () => setLocalProModalTrigger(true);
    const handleCloseLocalProModal = () => {
        setLocalProModalTrigger(false);
        setToggleForLocalProModal('1');
    }

    useEffect(() => {
        dispatch(setCurrentPage("Service details"))
    }, [])

    let serviceId = "";

    if (urlParams.has('serviceRequestId')) {

        serviceId = urlParams.get('serviceRequestId')

        localStorage.setItem("ticket_id", serviceId);

    }


    useEffect(() => {
        if (localStorage.getItem("ticket_id")) {
            particularTicketDetails();
        }
        return () => {
            //     dispatch(updateBackDropLoaderWithoutStateFalse())
            //   dispatch(backLoaderFalse());
        }
    }, [localStorage.getItem("ticket_id")]);

    const [roomId, setRoomId] = useState('');
    const [userCallLogIdIds, setUserCallLogIdIds] = useState('');
    const [callLogIdIds, setCallLogIdIds] = useState('');

    const handleShowCallDetails = (element) => {
        setCallLogIdIds(element.call_log_id_ids)
        setUserCallLogIdIds(element.user_call_log_id_ids)
        navigate('/callDetails')
    }

    function isCurrentUnixTimeLessThan(targetUnixTime) {

        const currentUnixTime = Math.floor(Date.now() / 1000);

        return currentUnixTime < targetUnixTime;
    }


    function ticketStatus() {

        setServiceActionsLoading(true);

        let ticketData = new FormData();

        ticketData.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        ticketData.append("page_index", 1);
        ticketData.append("page_size", 10);
        ticketData.append("sorting_order", "DESC");
        ticketData.append("sorting_column_name", "");
        ticketData.append("search_area", '');
        ticketData.append("is_accepted_flag", 0);

        // const ticketData = {
        //     ticket_id_ids: localStorage.getItem("ticket_id"),
        //     search_area: "",
        //     longitute_float: 0,
        //     latitude_float: 0,
        //     page_index: 1,
        //     page_size: 10,
        //     sorting_order: "DESC",
        //     sorting_column_name: "",
        // }

        dispatch(ticketCallRequest(ticketData, (res) => {

            setServiceActionsLoading(false);

            setSentRequest(res?.data?.data);
            setMetaDataChr(res?.data?.data[0]?.meta_data_chr);
            setAcceptRejectFlag(res?.data?.data[0]?.is_accepted_ysn);
            setProAvailableFlag(1);
            setVideoJoinLink(res?.data?.data[0]?.video_link_chr);
            // setIsActiveVideoLink(res.data.data[0].status_ysn);

            setResendLoading(false);
            setDialogLoader(false);
            setRaiseRefundLoading(false);

            if (localStorage.getItem("user_id") == res?.data?.data[0]?.reciever_id_ids || localStorage.getItem("user_id") == res?.data?.data[0]?.sender_id_ids) {
                if (isCallRecording) {
                    res?.data?.data?.map((item, index) => {
                        setCallLogIdsArr(prev => [...prev, item.call_log_id_ids]);
                    });

                    // setCallLogIdsArr(prev => [...prev, res?.data?.data[0]?.call_log_id_ids]);
                    setIsCallRecordings(false);
                }
            }


            if (isCurrentUnixTimeLessThan(res?.data?.data[0]?.video_token_expiry_time)) {
                // console.log("video token not expired");
                setIsActiveVideoLink(1);
            } else {
                // console.log("video token expired");
                setIsActiveVideoLink(0);
            }

            // console.log(res.data.data[0].room_id, "room_id");
            // console.log(res.data.data[0].user_call_log_id_ids, "user_call_log_id_ids");
            // console.log(res.data.data[0].call_log_id_ids, "call_log_id_ids");

            setRoomId(res?.data?.data[0]?.room_id);
            setUserCallLogIdIds(res?.data?.data[0]?.user_call_log_id_ids);
            setCallLogIdIds(res?.data?.data[0]?.call_log_id_ids);

            // localStorage.setItem("roomCode", res.data[0].room_id);
            // localStorage.setItem('user_call_log_id_ids', res.data[0].user_call_log_id_ids)
            // localStorage.setItem('call_log_id', res.data.data[0].call_log_id_ids)

        },
            () => {
                setResendLoading(false);
                setServiceActionsLoading(false)
            })
        )
    }


    useEffect(() => {
        localStorage.setItem("roomCode", roomId);
        localStorage.setItem('user_call_log_id_ids', userCallLogIdIds)
        localStorage.setItem('call_log_id', callLogIdIds || "")
    }, [roomId, userCallLogIdIds, callLogIdIds])

    // console.log(sentRequest, 'sentRequest');
    // console.log(metaDataChr, 'metaDataChr');
    // console.log(acceptRejectFlag, 'acceptRejectFlag');
    // console.log(videoJoinLink, 'videoJoinLink');
    // console.log(isActiveVideoLink, 'isActiveVideoLink');



    const particularTicketDetails = () => {
        ticketStatus()

        setServiceDetailsLoading(true)

        let details = {
            ticket_id_ids: localStorage.getItem("ticket_id"),
        };
        dispatch(
            ticketDetailsApi(details, (res) => {
                setServiceDetailsLoading(false);
                setCustomLoading(false);
                setStatusUpdateLoaderCust(false);
                // console.log(res);

                setReceiverData(res?.data);
                setAttachmentsArr(res?.data?.attachment_data);
                setProductCategorySearch(res?.data?.product_type_chr);
                setTime(res?.data?.created_date_dtm + "000");
                setUpdatedTime(res?.data?.updated_date_dtm + "000");
                setImageLoader(false);

                setTimeSlotArr(res?.time_slot);
                res?.data?.time_slot_id && setTimeSlotID(res?.data?.time_slot_id);

                setCommunicationModeArr(res?.communication_mode);
                res?.data?.communication_mode_id && setCommunicationModeID(res?.data?.communication_mode_id);
                setProductCategory(res.data.category_name_chr);

                res?.data?.problem_description_chr && setDescription(res?.data?.problem_description_chr);
                res?.data?.model_number_chr && setModelNum(res?.data?.model_number_chr);
                localStorage.setItem("proType", res?.data?.product_type_chr);

                res?.data?.serial_number_chr && setSerialNumber(res?.data?.serial_number_chr);
                res?.data?.device_brand_chr && setBrandName(res?.data?.device_brand_chr);
                // dispatch(setLoaderTime(res))

                if (res?.data?.summary_meta_data) {

                    // debugger;
                    // const finalObject = JSON.parse(JSON.parse(res?.data?.summary_meta_data));
                    // const finalObjectTwo = (JSON.parse(res?.data?.summary_meta_data));

                    const finalObjectTwo = (JSON.parse(res?.data?.summary_meta_data));

                    let finalObject = {};

                    // if(!Object.keys(finalObjectTwo).length > 0) {
                    if (typeof (finalObjectTwo) === 'string') {
                        finalObject = JSON.parse(finalObjectTwo);
                    }


                    console.log(finalObject, "finalObject");
                    console.log(finalObjectTwo, "finalObjectTwo");

                    if (Object.keys(finalObject).length > 0) {
                        setServiceSummaryMetaData(finalObject);
                        setProRecommendedSolution(finalObject?.pro_check_info?.pro_recommended_solution || 0);
                        setCustomerSelectedSolution(finalObject?.customer_check_info?.customer_selected_solution || 4);
                        setProDiagnosis(finalObject?.pro_check_info?.pro_diagnosis || "");
                    } else if (Object.keys(finalObjectTwo).length > 0) {
                        setServiceSummaryMetaData(finalObjectTwo);
                        setProRecommendedSolution(finalObjectTwo?.pro_check_info?.pro_recommended_solution || 0);
                        setCustomerSelectedSolution(finalObjectTwo?.customer_check_info?.customer_selected_solution || 4);
                        setProDiagnosis(finalObjectTwo?.pro_check_info?.pro_diagnosis || "");
                    } else {
                        setServiceSummaryMetaData({});
                    }

                }
            }, (err) => {
                setServiceDetailsLoading(false);
                setResponceMsg(err.data.message);

                setToasterType("error");

                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
            })
        );
    };




    useEffect(() => {

        if (productCategorySearch != "") {
            const details = {
                expertise_name_chr: productCategorySearch,
                longitute_float: 0,
                latitude_float: 0,
                page_index: page,
                page_size: pageSize,
                sorting_order: sortByValue,
                sorting_column_name: "",
                search_area: searchAreaPro,

                ticket_id_ids: localStorage.getItem("ticket_id"),

            }
            // if (role === 2) {
            //   dispatch(searchPro(details, (res) => {

            //     setProList(res.data.data);
            //     setTotalCount(res.data.total_count);
            //     if (res.data.total_count % pageSize === 0) {
            //       setTotalPage(parseInt(res.data.total_count / pageSize));
            //     } else {
            //       setTotalPage(parseInt(res.data.total_count / pageSize + 1));
            //     }

            //   }, () => { }))
            // }
        }
    }, [productCategorySearch, searchAreaPro, sortByValue, pageSize, page,])

    const handleChangeRowsPerPage = (e) => {
        // console.log(e)
        setSearchAreaPro('')
        setPage(1)
        setPageSize(e.target.value)
    }
    const onChangePage = (e, p) => {
        setPage(p)
    }


    //   useEffect(() => {
    //     dispatch(gettingLayout());
    //   }, []);


    useEffect(() => {

        if (receiverData?.phone_number == null || receiverData?.phone_number == "") {
            setphoneNumberFormat("NA")
        } else {
            setphoneNumberFormat(InternationalPhoneFormatFun(`${receiverData.country_code}`, `${receiverData?.phone_number}`))
        }

    }, [receiverData])


    function handleSearchPro(e) {
        setPage(1)
        setSearchAreaPro(e.target.value)
    }

    function handleClickRequest(ele, key) {
        // console.log(ele)
        const newForm = new FormData();
        newForm.append("ticket_id_ids", localStorage.getItem("ticket_id"))
        newForm.append("sender_id_ids", localStorage.getItem("user_id"))
        newForm.append("reciever_id_ids", ele.user_id_ids)
        // dispatch(sendCallRequestTicket(newForm, (res) => {
        //   // console.log(res.data)

        // }))
        const newArr = [...proList]
        newArr[key] = { ...proList[key], call_request_status_ysn: 1 }
        return setProList(newArr)
    }

    function handleGetSentRequest() {
        ticketStatus()
    }

    const [value, setValue] = React.useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    function acceptRejectRequestFn(flag) {
        setDialogLoader(true);
        let details = new FormData();
        details.append("meta_data", metaDataChr);
        details.append("accept_reject_flag", flag)

        dispatch(
            acceptRejectRequest(
                details, () => {
                    ticketStatus();
                    setDialogLoader(false);
                },
                () => {
                    ticketStatus();
                    setDialogLoader(false);
                }
            )
        )

        if (flag == 1) {
            // navigate("/particularTicketDetails")
        }
    }

    // Function to join the video call
    const handleJoinCall = () => {
        setDialogLoader(true);
        let ticketData = new FormData();

        ticketData.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        ticketData.append("page_index", 1);
        ticketData.append("page_size", 10);
        ticketData.append("sorting_order", "DESC");
        ticketData.append("sorting_column_name", "");
        ticketData.append("search_area", '');
        ticketData.append("is_accepted_flag", 0);

        // const ticketData = {
        //     ticket_id_ids: ticketID,
        //     search_area: "",
        //     longitute_float: 0,
        //     latitude_float: 0,
        //     page_index: 1,
        //     page_size: 10,
        //     sorting_order: "DESC",
        //     sorting_column_name: "",
        // }

        dispatch(
            ticketCallRequest(
                ticketData,
                (res) => {
                    setSentRequest(res?.data?.data);
                    setMetaDataChr(res?.data?.data[0]?.meta_data_chr);
                    setAcceptRejectFlag(res?.data?.data[0]?.is_accepted_ysn);
                    setProAvailableFlag(1);
                    setVideoJoinLink(res?.data?.data[0]?.video_link_chr);
                    // setIsActiveVideoLink(res.data.data[0].status_ysn);

                    setDialogLoader(false);
                    setResendLoading(false);

                    if (isCurrentUnixTimeLessThan(res?.data?.data[0]?.video_token_expiry_time)) {
                        // console.log("video token not expired");
                        setIsActiveVideoLink(1);
                    } else {
                        // console.log("video token expired");
                        setIsActiveVideoLink(0);
                    }

                    setRoomId(res?.data?.data[0]?.room_id);
                    setUserCallLogIdIds(res?.data?.data[0]?.user_call_log_id_ids);
                    setCallLogIdIds(res?.data?.data[0]?.call_log_id_ids);

                    localStorage.setItem("roomCode", res?.data?.data[0]?.room_id);
                    localStorage.setItem("user_call_log_id_ids", res?.data?.data[0]?.user_call_log_id_ids);
                    localStorage.setItem("call_log_id", res?.data?.data[0]?.call_log_id_ids || "");

                    localStorage.setItem("triggerFlag", 1);
                    navigate("/videoCall");
                },
                () => {
                    setDialogLoader(false);
                    setResendLoading(false);
                }
            )
        );
    }

    // Function for accepting the Global Tickets 
    function acceptGlobalRequest() {
        setDialogLoader(true);
        const data = new FormData();

        data.append("ticket_id_ids", localStorage.getItem("ticket_id"))
        data.append("sender_id_ids", localStorage.getItem("user_id"))
        data.append("reciever_id_ids", receiverData.user_id_lng)

        dispatch(
            sendCallRequestTicket(data,
                (res) => {
                    setResponceMsg(res.data.message);
                    // ticketStatus();
                    // particularTicketDetails();
                    handleJoinCall();
                    setToasterType("success")
                    // navigate('/callHistory')
                    // setDialogLoader(false);

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                },
                (res) => {
                    console.log(res);
                    setDialogLoader(false);
                    particularTicketDetails();
                    setResponceMsg(res.data.message);
                    setToasterType("error")

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                },
            )
        )
    }

    //Resend the video link if it expires after accepting the request 
    const resendLink = () => {
        setDialogLoader(true);
        setResendLoading(true);
        let resendDetails = {
            user_id_ids: localStorage.getItem("user_id"),
            call_log_id_ids: localStorage.getItem("call_log_id"),
        };
        dispatch(
            resendVideoLink(
                resendDetails,
                (res) => {
                    setResponceMsg(res.data.message)
                    setToasterType("success")
                    ticketStatus();
                    setDialogLoader(false);
                    // setResendLoading(false);

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                },
                (res) => {
                    setResponceMsg(res.data.message)
                    setToasterType("error")

                    ticketStatus();
                    setDialogLoader(false);
                    setResendLoading(false);


                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        );
    };

    // Get confirmation from the customer to search for another pro
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

    function ReInitiateByCust() {

        setOpenConfirmDialog(false);
        initiateProSearching()
        setToggleUpdateService(0);
        handleCloseConnectWithAnotherProModal();
        // handleCloseConfirmationForConnectToProModal();
    }

    function onlyCloseCustDia() {
        setOpenConfirmDialog(false);
    }

    // Update Service request status
    const [staticButtonUpdateTicket, setStaticButtonUpdateTicket] = useState(true);
    const [toggleUpdateServices, setToggleUpdateService] = useState(0);
    const [isDescrError, setIsDescrError] = useState(false);
    const [description, setDescription] = useState("");
    const [brandName, setBrandName] = useState("");

    const [serialNumber, setSerialNumber] = useState("");
    const [saveUpdateTicketLoading, setSaveUpdateTicketLoading] = useState(false);
    const [timeSlotID, setTimeSlotID] = useState(4);
    const [communicationModeID, setCommunicationModeID] = useState(3);
    const [modelNum, setModelNum] = useState("");
    const [timeSlotArr, setTimeSlotArr] = useState([]);
    const [communicationModeArr, setCommunicationModeArr] = useState([]);

    const [toggleEditBrand, setToggleEditBrand] = useState(false);
    const [toggleEditModel, setToggleEditModel] = useState(false);
    const [toggleEditSerial, setToggleEditSerial] = useState(false);

    const [width, setWidth] = useState(0);
    useEffect(() => {
        setWidth(window.screen.width);

    }, [window.screen.width])

    window.addEventListener("resize", () => {
        setWidth(window.screen.width);
    });
    const handleDescription = (e) => {
        // console.log(e.target.value);
        setIsDescrError(false)
        setDescription(e.target.value);
    }

    const handleBrandName = (e) => {
        // console.log(e.target.value);
        setBrandName(e.target.value);
    }

    const handleModelNumber = (e) => {
        // console.log(e.target.value);
        setModelNum(e.target.value);
    }

    const handleSerialNumber = (e) => {
        // console.log(e.target.value);
        setSerialNumber(e.target.value);
    }



    function updateTimeSlotFn(e) {
        setTimeSlotID(e.target.value);
    }

    function updateCommunicationModeFn(e) {
        setCommunicationModeID(e.target.value);
    }

    function updateServiceRequestFn(e) {
        e.preventDefault();

        setSaveUpdateTicketLoading(true);

        let formData = new FormData();

        formData.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        timeSlotID && formData.append("time_slot_id", parseInt(timeSlotID))
        communicationModeID && formData.append("communication_mode_id", parseInt(communicationModeID));
        // formData.append("address_id_ids", 0);
        (localStorage.getItem("proType") !== "null" && localStorage.getItem("proType")) && formData.append("product_type_chr", localStorage.getItem("proType"));
        formData.append("product_category_chr", productCategory);
        modelNum && formData.append("model_number_chr", modelNum);
        serialNumber && formData.append("serial_number_chr", serialNumber);
        description && formData.append("problem_description_chr", description);
        brandName && formData.append("device_brand_chr", brandName);

        selectedFileAttach?.map((attachmentData, attachmentI) => {
            formData.append(`attachment${attachmentI}`, attachmentData);
        })

        // uploadAttachedImage1 != null && formData.append("attachment_id_ids0", "");
        // uploadAttachedImage1 != null && formData.append("attachment0", uploadAttachedImage1);
        // uploadAttachedImage2 != null && formData.append("attachment_id_ids1", "")
        // uploadAttachedImage2 != null && formData.append("attachment1", uploadAttachedImage2)

        dispatch(updateTicketDetail(formData, (res) => {


            setResponceMsg(res.data.message);
            setToasterType("success")

            // setHandleToaster(true);
            // setTimeout(() => {
            //     setHandleToaster(false);
            // }, 11000);

            setSaveUpdateTicketLoading(false);
            setToggleUpdateService(0);
            particularTicketDetails();
            handleCloseUpdateServiceModal();
            setSelectedFileAttach([]);
            setSelectedFileLimitAttach('')

            // setTimeout(() => {
            //     setSaveUpdateTicketLoading(false);
            //     setToggleUpdateService(0);
            //     particularTicketDetails();
            //     handleCloseUpdateServiceModal();
            //     setSelectedFileAttach([]);
            //     setSelectedFileLimitAttach('')
            // }, 2500)
        }, (err) => {
            setSaveUpdateTicketLoading(false);
            setToggleUpdateService(0);

            setResponceMsg(err.data.message);
            setToasterType("error")

            setHandleToaster(true);
            setTimeout(() => {
                setHandleToaster(false);
            }, 11000);
        }))
    }


    const handleUpdateServiceDirectly = (e) => {
        e?.preventDefault();

        // setSaveUpdateTicketLoading(true);

        let formData = new FormData();

        formData.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        timeSlotID && formData.append("time_slot_id", parseInt(timeSlotID))
        communicationModeID && formData.append("communication_mode_id", parseInt(communicationModeID));
        // formData.append("address_id_ids", 0);
        (localStorage.getItem("proType") !== "null" && localStorage.getItem("proType")) && formData.append("product_type_chr", localStorage.getItem("proType"));
        formData.append("product_category_chr", productCategory);
        modelNum && formData.append("model_number_chr", modelNum);
        serialNumber && formData.append("serial_number_chr", serialNumber);
        description && formData.append("problem_description_chr", description);
        brandName && formData.append("device_brand_chr", brandName);

        selectedFileAttach?.map((attachmentData, attachmentI) => {
            formData.append(`attachment${attachmentI}`, attachmentData);
        })

        setToggleEditBrand(false)
        setToggleEditModel(false)
        setToggleEditSerial(false)

        dispatch(updateTicketDetail(formData, (res) => {


            setResponceMsg(res.data.message);
            setToasterType("success")


            // setHandleToaster(true);
            // setTimeout(() => {
            //     setHandleToaster(false);
            // }, 11000);

            res?.data?.device_brand_chr && setBrandName(res?.data?.device_brand_chr)
            res?.data?.model_number_chr && setModelNum(res?.data?.model_number_chr)
            res?.data?.serial_number_chr && setSerialNumber(res?.data?.serial_number_chr)

            setSaveUpdateTicketLoading(false);
            // setToggleUpdateService(0);
            // particularTicketDetails();
            // handleCloseUpdateServiceModal();
            // setSelectedFileAttach([]);
            // setSelectedFileLimitAttach('')


        }, (err) => {
            setSaveUpdateTicketLoading(false);
            setToggleUpdateService(0);

            setResponceMsg(err.data.message);
            setToasterType("error")

            setHandleToaster(true);
            setTimeout(() => {
                setHandleToaster(false);
            }, 11000);
        }))
    }

    function skipUpdates(e) {
        e.preventDefault();
        setToggleUpdateService(0);
    }

    // Re-initate Professional searching
    const [backDropLoaderResp, setBackDropLoaderResp] = useState(false);
    const [backDropLoader, setBackDropLoader] = useState(false);
    const [errBackDropLoaderResp, setErrBackDropLoaderResp] = useState(false);




    const initiateProSearching = () => {
        // dispatch(backLoaderTrue());

        let data = {
            ticket_id_ids: localStorage.getItem("ticket_id"),
            re_initiate_flag: sentRequest.length === 0 ? 0 : 1,
        }

        setBackDropLoaderResp(true);

        // dispatch(updateBackDropLoaderWithoutStateTrue());

        dispatch(connectToPro(data, (res) => {
            setBackDropLoaderResp(false);

            // dispatch(backDropLoaderRejectedCaseRedux(true));
            // setBackDropLoader(true);
            handleCloseConfirmationForConnectToProModal();
            if (res.data.search_pro) {
                dispatch(backLoaderTrue());
            } else {
                setErrBackDropLoaderResp(true);
            }
            // setTimeout(()=>{

            //   setBackDropLoader(false);
            //   particularTicketDetails();
            // }, 91000)
            setTimeout(() => {
                setErrBackDropLoaderResp(false);
                // particularTicketDetails();
            }, 2500);

        }, (err) => {
            dispatch(updateBackDropLoaderWithoutStateFalse());

            setBackDropLoaderResp(false);
            setResponceMsg(err.data.message);



            if (err.status != 402) {
                setToasterType("error");
                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
            }

            // setErrBackDropLoaderResp(true);
            // setTimeout(() => {
            //     setErrBackDropLoaderResp(false);
            // }, 2500);
        }))
    }


    // Open details 
    const callDetailsFn = () => {
        navigate('/callDetails')
    }

    const [statusUpdateLoader, setStatusUpdateLoader] = useState(false);

    const closeRequest = () => {
        setStatusUpdateLoader(true);
        let formData = new FormData();
        // formData.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        formData.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        formData.append("ticket_status_ysn", 0);

        dispatch(updateTicketStatus(formData, (res) => {
            // console.log(res)
            setResponceMsg(res.data.message);
            setToasterType("success")

            particularTicketDetails();
            setStatusUpdateLoader(false);

            handleCloseChangeJobStatusModal();

            // setHandleToaster(true);
            // setTimeout(() => {
            //     setHandleToaster(false);
            // }, 11000);

        }), (res) => {
            console.log(res);
            setResponceMsg(res.data.message);
            setToasterType("error")
            setStatusUpdateLoader(false);

            setHandleToaster(true);
            setTimeout(() => {
                setHandleToaster(false);
            }, 11000);
        })
    }

    const [statusUpdateLoaderCust, setStatusUpdateLoaderCust] = useState(false);

    const reOpenRequest = () => {
        setStatusUpdateLoaderCust(true);
        let formData = new FormData();
        // formData.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        formData.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        formData.append("ticket_status_ysn", 5);

        dispatch(updateTicketStatus(formData, (res) => {
            // console.log(res)

            setResponceMsg(res.data.message);

            particularTicketDetails();
            // setStatusUpdateLoaderCust(false);

            handleCloseReactivateServiceModal();

            handleCloseChangeJobStatusModal();

            setHandleSnackbarSuccess(true);
            setTimeout(() => {
                setHandleSnackbarSuccess(false);
            }, 16000);

        }), (res) => {
            console.log(res);
            setResponceMsg(res.data.message);
            setStatusUpdateLoaderCust(false);

            setHandleSnackbarError(true);
            setTimeout(() => {
                setHandleSnackbarError(false);
            }, 16000);
        })
    }

    const [loadingForCancelRequest, setLoadingForCancelRequest] = useState(false);
    const cancelRequest = () => {
        setLoadingForCancelRequest(true);
        let formData = new FormData();
        // formData.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        formData.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        formData.append("ticket_status_ysn", 7);

        dispatch(updateTicketStatus(formData, (res) => {
            // console.log(res)
            setResponceMsg(res.data.message);


            particularTicketDetails();

            handleCloseChangeJobStatusModal();

            handleCloseCancelServiceModal();
            setTimeout(() => {
                setLoadingForCancelRequest(false);
            }, 1000);

            setHandleSnackbarSuccess(true);
            setTimeout(() => {
                setHandleSnackbarSuccess(false);
            }, 16000);

        }), (res) => {
            console.log(res);
            setResponceMsg(res.data.message);
            setLoadingForCancelRequest(false);

            setHandleSnackbarError(true);
            setTimeout(() => {
                setHandleSnackbarError(false);
            }, 16000);
        })
    }

    const backToPrevious = () => {
        navigate(-1);
    }

    // Modal trigger for the Update the service request
    const [updateServiceModalTrigger, setUpdateServiceModalTrigger] = useState(false);
    const handleCloseUpdateServiceModal = (e) => {
        e?.preventDefault();
        setUpdateServiceModalTrigger(false);
        deleteAttachedImage1();
        deleteAttachedImage2();
    };
    const handleShowUpdateServiceModal = (e) => {
        setUpdateServiceModalTrigger(true);
    }

    // Modal trigger for confirmation to connect with another pro
    const [connectWithAnotherProModalTrigger, setConnectWithAnotherProModalTrigger] = useState(false);
    const handleCloseConnectWithAnotherProModal = (e) => {
        e?.preventDefault();
        setConnectWithAnotherProModalTrigger(false);
    };
    const handleShowConnectWithAnotherProModal = (e) => {
        setConnectWithAnotherProModalTrigger(true);
    }

    // Format the unix time in given format
    function formatUnixTimestamp(unixTimestamp) {
        const date = new Date(unixTimestamp * 1000);

        const month = date.toLocaleString('default', { month: 'short' });
        const day = date.getDate();
        let hour = date.getHours();
        const minute = date.getMinutes();

        const hourFormatted = hour % 12 || 12; // Convert 24-hour time to 12-hour format
        const amPm = hour < 12 ? 'am' : 'pm';
        const minuteFormatted = minute < 10 ? `0${minute}` : minute;

        return `${month} ${day}, ${hourFormatted}:${minuteFormatted} ${amPm}`;
    }

    const [tabsToggleServiceReq, setTabsToggleServiceReq] = useState(+localStorage.getItem("serviceDetailsTab") || 1);

    const [attachImageIndex, setAttachImageIndex] = useState(0);

    useEffect(() => {
        return () => {
            if (localStorage.getItem("serviceDetailsTab")) {
                localStorage.removeItem("serviceDetailsTab");
            };

            if (localStorage.getItem("isEstimateService")) {
                localStorage.removeItem("isEstimateService");
            };

        }
    }, [localStorage.getItem("serviceDetailsTab"), localStorage.getItem("isEstimateService")])

    const handleImageIndex = (index) => {
        setAttachImageIndex(index);
    }

    const handlePrevAttachImg = () => {
        if (attachImageIndex !== 0) {
            setAttachImageIndex(attachImageIndex - 1)
        }
    }
    const handleNextAttachImg = () => {
        if (attachImageIndex <= attachmentsArr?.length - 1) {
            setAttachImageIndex(attachImageIndex + 1)
        }
    }


    const [showPopover, setShowPopover] = useState(false);
    // More actions for both customer and pro
    const popover = (
        <Popover id="popover-basic"
            style={{ minWidth: "100px", border: 'none' }}>
            <Popover.Body
                className="p-2 popover-body"
                style={{
                    //   padding: "5px",
                    boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.2)",
                }}
            >
                <div
                    onClick={(e) => {
                        // editExpertise(e, expertiseObject);
                        // setActivePopover(null)
                        handleShowShareServiceModal();
                        setShowPopover(false)
                    }}
                    className='border-bottom cursor-pointer p-2 font-w500 fs-6 text-black overlay-action-btn'
                >
                    <span className='me-2'>
                        <i className="bi bi-send"></i>
                    </span>
                    <span>{"Share via email or SMS"}</span>
                </div>

                {/* Customer more action buttons */}
                {permissionArray.includes("SCAN TAB") &&
                    <div className="d-flex flex-column font-w500 fs-6"
                        style={{
                            // pointerEvents: "none", 
                            // opacity: "0.5"
                        }}
                    >


                        {/* <div
                            onClick={(e) => {
                                // editExpertise(e, expertiseObject);
                                // setActivePopover(null)
                                setShowPopover(false);
                                handleCreatePurchaseList();
                            }}
                            className='border-bottom cursor-pointer p-2  text-black overlay-action-btn'
                        >
                            <span className='me-2'>
                                <i className="bi bi-list-check"></i>
                            </span>
                            <span>{"Add shopping item"}</span>
                        </div> */}

                        {permissionArray.includes("UPDATE SERVICE REQUETS DETAILS") && receiverData?.update_service_request_flag &&
                            <div
                                onClick={(e) => {
                                    handleShowUpdateServiceModal()
                                    setShowPopover(false)
                                }}
                                className='border-bottom cursor-pointer p-2  text-black overlay-action-btn'
                            >
                                <span className='me-2'>
                                    <i className="bi bi-pencil"></i>
                                </span>
                                <span>{"Edit"}</span>
                            </div>
                        }

                        {permissionArray.includes("CONNECT TO PRO") && (receiverData?.category_name_chr !== null && receiverData?.category_name_chr !== 'null') && receiverData.ticket_status_ysn !== 0 && receiverData.ticket_status_ysn !== 7 &&
                            receiverData.ticket_status_ysn !== 4 &&
                            <>
                                {receiverData.ticket_status_ysn !== 6 ?
                                    <>
                                        {sentRequest.length === 0 ?
                                            <>
                                                <div
                                                    onClick={() => {
                                                        initiateProSearching()
                                                        setShowPopover(false)
                                                    }}
                                                    className='cursor-pointer p-2  text-black overlay-action-btn'
                                                >
                                                    <span className='me-2'>
                                                        <i className="bi bi-people"></i>
                                                    </span>
                                                    <span>{"Connect to pro"}</span>
                                                </div>
                                            </> :
                                            <>
                                                {receiverData.category_name_chr !== "Inspection" &&
                                                    <div
                                                        onClick={() => {
                                                            handleShowConnectWithAnotherProModal()
                                                            setShowPopover(false)
                                                        }}
                                                        className=' cursor-pointer p-2  text-black overlay-action-btn'
                                                    >
                                                        <span className='me-2'>
                                                            <i className="bi bi-people"></i>
                                                        </span>
                                                        <span>{"Connect to another pro"}</span>
                                                    </div>
                                                }
                                            </>
                                        }
                                    </>
                                    :
                                    <div
                                        onClick={(e) => {
                                            // editExpertise(e, expertiseObject);
                                            // setActivePopover(null)
                                        }}
                                        className=' cursor-pointer p-2  text-black overlay-action-btn'
                                        style={{ pointerEvents: "none", opacity: "0.5" }}
                                    >
                                        <span className='me-2'>
                                            <i className="bi bi-people"></i>
                                        </span>
                                        <span>{"To connect with pro, update service first"}</span>
                                    </div>
                                }
                            </>
                        }
                    </div>
                }



                {/* Pro more action buttons */}
                {permissionArray.includes("UPDATE WORK INFORMATION") &&
                    <div className="d-flex flex-column font-w500 fs-6"
                        style={{
                            // pointerEvents: "none", 
                            // opacity: "0.5"
                        }}
                    >

                        {permissionArray.includes("UPDATE SERVICE REQUETS DETAILS") && receiverData?.update_service_request_flag &&
                            <div
                                onClick={(e) => {
                                    handleShowUpdateServiceModal()
                                    setShowPopover(false)
                                }}
                                className='border-bottom cursor-pointer p-2  text-black overlay-action-btn'
                            >
                                <span className='me-2'>
                                    <i className="bi bi-pencil"></i>
                                </span>
                                <span>{"Edit"}</span>
                            </div>
                        }

                        {/* <div
                            onClick={(e) => {
                                // editExpertise(e, expertiseObject);
                                // setActivePopover(null)
                                setShowPopover(false);
                                handleCreatePurchaseList();
                            }}
                            className='border-bottom cursor-pointer p-2  text-black overlay-action-btn'
                        >
                            <span className='me-2'>
                                <i className="bi bi-list-check"></i>
                            </span>
                            <span>{"Add shopping item"}</span>
                        </div> */}

                        {sentRequest.length > 0 &&
                            // permissionArray.includes("UPDATE WORK INFORMATION") &&
                            acceptRejectFlag == 0 ?
                            <>
                                <div
                                    onClick={(e) => {
                                        acceptRejectRequestFn(1)
                                        setShowPopover(false)
                                    }}
                                    className='border-bottom cursor-pointer p-2  text-black overlay-action-btn'
                                    style={{
                                        pointerEvents: !isVerified ? 'none' : 'auto',
                                        opacity: !isVerified ? '0.5' : '1',
                                    }}
                                >
                                    <span className='me-2'>
                                        <i className="bi bi-list-check"></i>
                                    </span>
                                    <span>{"Accept"}</span>
                                </div>

                                <div
                                    onClick={(e) => {
                                        acceptRejectRequestFn(0)
                                        setShowPopover(false)
                                    }}
                                    className='border-bottom cursor-pointer p-2  text-danger overlay-action-btn'
                                >
                                    <span className='me-2'>
                                        <i className="bi bi--x-lg"></i>
                                    </span>
                                    <span>{"Reject"}</span>
                                </div>
                            </> :
                            // permissionArray.includes("UPDATE WORK INFORMATION") &&
                            acceptRejectFlag == 1 ?
                                <>
                                    {(receiverData.ticket_status_ysn === 2) &&
                                        <>
                                            {permissionArray.includes("RESEND VIDEO LINK") &&
                                                <div
                                                    onClick={(e) => {
                                                        resendLink();
                                                    }}
                                                    className='cursor-pointer p-2  text-orange overlay-action-btn'
                                                    style={{
                                                        pointerEvents: resendLoading ? "none" : "auto",
                                                        opacity: resendLoading ? "0.5" : '1',
                                                    }}
                                                >
                                                    <span className='me-2'>
                                                        {resendLoading ?
                                                            <Spinner animation="border" size="sm" /> :
                                                            <i className="bi bi-camera-video"></i>
                                                        }
                                                    </span>
                                                    <span>{"Resend link"}</span>
                                                </div>
                                            }

                                            {false &&
                                                <>
                                                    {isActiveVideoLink == 1 ?

                                                        <div
                                                            onClick={(e) => {
                                                                localStorage.setItem("triggerFlag", 1);
                                                                navigate("/videoCall");
                                                                setShowPopover(false);
                                                            }}
                                                            className=' cursor-pointer p-2  text-orange overlay-action-btn'
                                                        >
                                                            <span className='me-2'>
                                                                <i className="bi bi-camera-video"></i>
                                                            </span>
                                                            <span>{"Join video"}</span>
                                                        </div>
                                                        :
                                                        <div
                                                            onClick={(e) => {
                                                                resendLink();
                                                            }}
                                                            className='cursor-pointer p-2  text-orange overlay-action-btn'
                                                            style={{
                                                                pointerEvents: resendLoading ? "none" : "auto",
                                                                opacity: resendLoading ? "0.5" : '1',
                                                            }}
                                                        >
                                                            <span className='me-2'>
                                                                {resendLoading ?
                                                                    <Spinner animation="border" size="sm" /> :
                                                                    <i className="bi bi-camera-video"></i>
                                                                }
                                                            </span>
                                                            <span>{"Resend link"}</span>
                                                        </div>
                                                    }
                                                </>
                                            }
                                        </>

                                    }
                                </> :
                                // permissionArray.includes("UPDATE WORK INFORMATION") && 
                                acceptRejectFlag == 2 ?
                                    <>
                                        <div
                                            onClick={(e) => {

                                            }}
                                            className='border-bottom cursor-pointer p-2  text-orange overlay-action-btn'
                                            style={{
                                                pointerEvents: "none",
                                                opacity: "0.5",
                                            }}
                                        >
                                            <span className='me-2'>
                                                <i className="bi bi-x-lg"></i>
                                            </span>
                                            <span>{"You have rejected service"}</span>
                                        </div>
                                    </> :
                                    // permissionArray.includes("UPDATE WORK INFORMATION") &&
                                    acceptRejectFlag == 3 ?
                                        <>
                                            <div
                                                onClick={(e) => {

                                                }}
                                                className='border-bottom cursor-pointer p-2  text-black overlay-action-btn'
                                                style={{
                                                    pointerEvents: "none",
                                                    opacity: "0.5",
                                                }}
                                            >
                                                <span className='me-2'>
                                                    <i className="bi bi-x-lg"></i>
                                                </span>
                                                <span>{"Closed"}</span>
                                            </div>
                                        </> : null

                        }


                    </div>
                }

                {/* Company admin or pemission with manage services action button */}
                {permissionArray.includes("VIEW COMPANY USERS") &&
                    <>
                        {/* {receiverData.ticket_status_ysn == 10 && */}
                        {permissionArray.includes("UPDATE SERVICE REQUETS DETAILS") && receiverData?.update_service_request_flag &&
                            <div
                                onClick={(e) => {
                                    handleShowUpdateServiceModal()
                                    setShowPopover(false)
                                }}
                                className='border-bottom cursor-pointer p-2  text-black overlay-action-btn'
                            >
                                <span className='me-2'>
                                    <i className="bi bi-pencil"></i>
                                </span>
                                <span>{"Edit"}</span>
                            </div>
                        }

                    </>
                }

            </Popover.Body>
        </Popover>
    );

    // Change service status for both customer and pro
    const popoverServiceStatus = (
        <Popover id="popover-basic"
            style={{ minWidth: "100px", border: 'none' }}>
            <Popover.Body
                className="p-2 popover-body"
                style={{
                    //   padding: "5px",
                    boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.2)",
                }}>

                {/* Customer action for change status */}

                {permissionArray.includes("SCAN TAB") &&
                    <>
                        {
                            (receiverData?.product_type_chr !== null && receiverData?.product_type_chr !== 'null') && receiverData.ticket_status_ysn === 0 ?
                                <>
                                    <div className="d-flex flex-column font-w500 fs-6"
                                        style={{
                                            pointerEvents: statusUpdateLoaderCust ? "none" : "auto",
                                            opacity: statusUpdateLoaderCust ? "0.5" : "1"
                                        }}
                                    >
                                        <div
                                            onClick={(e) => {
                                                reOpenRequest()
                                                // setActivePopover(null)
                                            }}
                                            className=' cursor-pointer p-2  text-black overlay-action-btn'
                                        >
                                            <span className='me-2'>
                                                {statusUpdateLoaderCust ?
                                                    <Spinner animation="border" size="sm" /> :
                                                    <i className="bi bi-search"></i>
                                                }
                                            </span>
                                            <span>{"Re-initiate service"}</span>
                                        </div>
                                    </div>
                                </> :
                                (receiverData.ticket_status_ysn == 1 || receiverData.ticket_status_ysn == 5) ?
                                    <div className="d-flex flex-column font-w500 fs-6"
                                        style={{
                                            pointerEvents: loadingForCancelRequest ? "none" : "auto",
                                            opacity: loadingForCancelRequest ? "0.5" : "1"
                                        }}
                                    >
                                        <div
                                            onClick={(e) => {
                                                cancelRequest()
                                                // setActivePopover(null)
                                            }}
                                            className=' cursor-pointer p-2  text-danger overlay-action-btn'
                                        >
                                            <span className='me-2'>
                                                {loadingForCancelRequest ?
                                                    <Spinner animation="border" size="sm" /> :
                                                    <i className="bi bi-x-lg"></i>
                                                }
                                            </span>
                                            <span>{"Cancel the service request"}</span>
                                        </div>
                                    </div> :
                                    (receiverData.ticket_status_ysn == 6) ?
                                        <div className="d-flex flex-column font-w500 fs-6"
                                            style={{
                                                pointerEvents: "none",
                                                opacity: "0.5",
                                            }}
                                        >
                                            <div
                                                onClick={(e) => {
                                                    // editExpertise(e, expertiseObject);
                                                    // setActivePopover(null)
                                                }}
                                                className=' cursor-pointer p-2  text-danger overlay-action-btn'
                                            >
                                                <span className='me-2'>
                                                    <i className="bi bi-x-lg"></i>
                                                </span>
                                                <span>{"Incomplete service request"}</span>
                                            </div>
                                        </div>
                                        :
                                        (receiverData.ticket_status_ysn == 7) ?
                                            <div className="d-flex flex-column font-w500 fs-6"
                                                style={{
                                                    pointerEvents: "none",
                                                    opacity: "0.5",
                                                }}
                                            >
                                                <div
                                                    onClick={(e) => {
                                                        // editExpertise(e, expertiseObject);
                                                        // setActivePopover(null)
                                                    }}
                                                    className=' cursor-pointer p-2  text-danger overlay-action-btn'
                                                >
                                                    <span className='me-2'>
                                                        <i className="bi bi-x-lg"></i>
                                                    </span>
                                                    <span>{"canceled"}</span>
                                                </div>
                                            </div>
                                            :
                                            <div className="d-flex flex-column font-w500 fs-6"
                                                style={{
                                                    pointerEvents: "none",
                                                    opacity: "0.5",
                                                }}
                                            >
                                                <div
                                                    onClick={(e) => {
                                                        // editExpertise(e, expertiseObject);
                                                        // setActivePopover(null)
                                                    }}
                                                    className=' cursor-pointer p-2  text-danger overlay-action-btn'
                                                >
                                                    <span className='me-2'>
                                                        <i className="bi bi-x-lg"></i>
                                                    </span>
                                                    <span>{"In progress cannot be canceled"}</span>
                                                </div>
                                            </div>
                        }
                    </>
                }



                {/* PRO action for change status mark completed */}
                {permissionArray.includes("UPDATE WORK INFORMATION") && sentRequest.length > 0 && acceptRejectFlag === 1 && receiverData.ticket_status_ysn !== 0 &&
                    <div className="d-flex flex-column font-w500 fs-6"
                        style={{
                            pointerEvents: statusUpdateLoader ? "none" : "auto",
                            opacity: statusUpdateLoader ? "0.5" : "1"
                        }}
                    >
                        <div
                            onClick={(e) => {
                                closeRequest()
                                // setActivePopover(null)
                            }}
                            className=' cursor-pointer p-2  text-success overlay-action-btn'
                        >
                            <span className='me-2'>
                                {statusUpdateLoader ?
                                    <Spinner animation="border" size="sm" /> :
                                    <i className="bi bi-check"></i>}
                            </span>
                            <span>{"Mark completed"}</span>
                        </div>
                    </div>
                }

                {permissionArray.includes("UPDATE WORK INFORMATION") && sentRequest.length > 0 && acceptRejectFlag === 1 && receiverData.ticket_status_ysn == 0 &&
                    <div className="d-flex flex-column font-w500 fs-6"
                        style={{
                            pointerEvents: "none",
                            opacity: "0.5",
                        }}
                    >
                        <div
                            onClick={(e) => {
                                // closeRequest()
                                // setActivePopover(null)
                            }}
                            className=' cursor-pointer p-2  text-success overlay-action-btn'
                        >
                            <span className='me-2'>
                                <i className="bi bi-check"></i>
                            </span>
                            <span>{"Completed"}</span>
                        </div>
                    </div>
                }
            </Popover.Body>
        </Popover >
    );


    // Share Service Request functions start here ---------
    const [showShareServiceModal, setShowShareServiceModal] = useState(false);
    const handleShowShareServiceModal = () => setShowShareServiceModal(true);
    const handleCloseShareServiceModal = () => {
        setShowShareServiceModal(false);
        setEmailPhoneValue("");
        setCodeValue();
        setIsEmailPhoneVal(false);
    }

    const [isEmailPhoneVal, setIsEmailPhoneVal] = useState(false);
    const [emailPhoneValue, setEmailPhoneValue] = useState("");
    const [codeValue, setCodeValue] = useState(1);
    const [isPhone, setIsPhone] = useState(false);
    const [shareLoading, setShareLoading] = useState(false);

    const handleShareService = (e) => {
        e.preventDefault();
        if (phoneValidation(emailPhoneValue) || emailValidation(emailPhoneValue)) {
            setShareLoading(true);
            if (isPhone) {
                const data = new FormData();
                data.append("ticket_id_ids", localStorage.getItem("ticket_id"))
                data.append("is_sharable_ysn", 1);
                data.append("email_chr", "");
                data.append("phone_code_id_int", parseInt(codeValue) || 1);
                data.append("phone_number_int", emailPhoneValue);

                dispatch(
                    shareServiceRequest(data, (res) => {
                        setShareLoading(false)
                        setResponceMsg(res.data.message)
                        setToasterType("success")

                        handleCloseShareServiceModal();

                        // setHandleToaster(true);
                        // setTimeout(() => {
                        //     setHandleToaster(false);
                        // }, 11000);
                    }, (err) => {
                        setShareLoading(false)
                        setResponceMsg(err.data.message)
                        setToasterType("error")

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    })
                );
            } else if (!isPhone) {

                const data = new FormData();
                data.append("ticket_id_ids", localStorage.getItem("ticket_id"))
                data.append("is_sharable_ysn", 1);
                data.append("email_chr", emailPhoneValue);
                // data.append("phone_code_id_int", parseInt(codeValue) || 1);
                // data.append("phone_number_int", emailPhoneValue);

                dispatch(
                    shareServiceRequest(data, (res) => {
                        setShareLoading(false)
                        setResponceMsg(res.data.message)
                        setToasterType("success")

                        handleCloseShareServiceModal();

                        // setHandleToaster(true);
                        // setTimeout(() => {
                        //     setHandleToaster(false);
                        // }, 11000);
                    }, (err) => {
                        setShareLoading(false)
                        setResponceMsg(err.data.message)
                        setToasterType("error")

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    })
                );
            }
        } else {
            setIsEmailPhoneVal(true);
        }
    };

    const handleEmailPhone = (e) => {
        setIsEmailPhoneVal(false);

        noSpaceOnChange(e.target.value) && setEmailPhoneValue(e.target.value);
    };
    const handleDropdownValue = (e) => {
        // setCodeValue(e.target.value);
        setCodeValue(e);
    };

    useEffect(() => {
        const dot = ".";
        const leng = emailPhoneValue.length - 1;
        if (!isNaN(emailPhoneValue) && emailPhoneValue.charAt(leng) !== dot) {
            if (emailPhoneValue.length < 11) {
                setIsPhone(true);
            } else {
                setIsPhone(false);
            }
        } else {
            setIsPhone(false);
        }
        if (emailPhoneValue === "") {
            setIsPhone(false);
        }
    }, [emailPhoneValue]);

    function handleEmailPhoneBlur() {
        if (isPhone) {
            if (!phoneValidation(emailPhoneValue)) {
                setIsEmailPhoneVal(true);
            }
        } else {
            if (!emailValidation(emailPhoneValue)) {
                setIsEmailPhoneVal(true);
            }
        }
    }
    // Share Service Request functions ends here ---------


    // Purchase list code start here -----------------
    // Modal triggers for the Purchase List
    const [purchaseListTrigger, setPurchaseListTrigger] = useState(false);
    const handleClosePurchaseList = () => {
        setPurchaseListTrigger(false);
        handleCloseCreatePurchaseItem();
        setBottomShoppingDrawerTrigger(false);
    };

    const handleShowPurchaseList = (e) => {
        setPurchaseListTrigger(true);
    }




    const [pageShopping, setPageShopping] = React.useState(1)
    const [pageSizeShopping, setPageSizeShopping] = useState(25)
    const [totalPageShopping, setTotalPageShopping] = useState(1)
    const [sortByValueShopping, setSortByValueShopping] = useState('DESC')
    const [searchValueShopping, setSearchValueShopping] = useState('')
    const [bulkDeleteArrShopping, setBulkDeleteArrShopping] = useState([])
    const [skeltonValShopping, setSkeltonValShopping] = useState(false)
    const [columnNameShopping, setColumnNameShopping] = useState("")
    const [totalNoRecordShopping, setTotalNoRecordShopping] = useState(100)
    const [elementsShopping, setElementsShopping] = useState([]);
    const [customeSkeletonLoaingShopping, setCustomeSkeletonLoaingShopping] = useState(false)

    const [flag, setFlag] = useState(false);


    const [currentTimeString, setCurrentTimeString] = useState("");
    const [toggleForPurchase, setToggleForPurchase] = useState(1);

    const [purchaseItemId, setPurchaseItemId] = useState();
    const [itemName, setItemName] = useState("");
    const [quantity, setQuantity] = useState(1);
    const [totalEstimatedCost, setTotalEstimatedCost] = useState(0);
    const [purchaseLink, setPurchaseLink] = useState("");
    const [itemDescription, setItemDescription] = useState("");

    const [itemNameErr, setItemNameErr] = useState(false);
    const [quantityErr, setQuantityErr] = useState(false);
    const [totalEstimatedCostErr, setTotalEstimatedCostErr] = useState(false);
    const [purchaseLinkErr, setPurchaseLinkErr] = useState(false);
    const [itemDescriptionErr, setItemDescriptionErr] = useState(false);

    const [purchaseLoading, setPurchaseLoading] = useState(false);
    const [totalCost, setTotalCost] = useState(0);
    const [shoppingItemId, setShoppingItemId] = useState('');

    const [bottomShoppingDrawerTrigger, setBottomShoppingDrawerTrigger] = useState(false);
    const [toggleBottomShoppingDrawer, setToggleBottomShoppingDrawer] = useState(1);

    const rows = elementsShopping


    const handleChangeRowsPerPageShopping = (e) => {
        setSearchValueShopping('')
        setPageShopping(1)
        setPageSizeShopping(e.target.value)
    }



    const getCallHistoryDetails = (res) => {
        // console.log(res, "Res")
        setElementsShopping(res.data.data)
        setTotalNoRecordShopping(res.data.total_count);
        setTotalCost(res.data?.total_estimated_cost)
        if (res.data.total_count % pageSize === 0) {
            setTotalNoRecordShopping(parseInt(res.data.total_count / pageSize))
        } else {
            setTotalNoRecordShopping(parseInt(res.data.total_count / pageSize + 1))
        }

        if (res.data.total_count === 0) {
            setTimeout(() => {
                setSkeltonValShopping(true)
            }, '3000')
        } else {
            setSkeltonValShopping(true)
        }
        // console.log(parseInt(res.total_records / pageSize), 'quoitent')
    }

    function getCurrentDateTime() {
        const now = new Date();

        const options = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        };

        return now.toLocaleString('en-US', options);
    }

    function encodeDateString(currentTimeString) {
        return encodeURIComponent(currentTimeString);
    }

    useEffect(() => {
        setCurrentTimeString(getCurrentDateTime());
    }, [])

    const onLoadData = () => {
        setCustomeSkeletonLoaingShopping(true);

        let data = new FormData();
        data.append("user_id_ids", localStorage.getItem('user_id') || "");
        data.append("ticket_id_ids", localStorage.getItem('ticket_id'));
        data.append("generated_date_dtm", getCurrentDateTime());
        data.append("page_index", pageShopping);
        data.append("page_size", pageSizeShopping);
        data.append("sorting_order", sortByValueShopping);
        data.append("sorting_column_name", columnNameShopping);
        data.append("search_area", searchValueShopping);

        dispatch(
            getPurchaseList(data, (res) => {
                getCallHistoryDetails(res);
                setCustomeSkeletonLoaingShopping(false);
                setPurchaseLoading(false);
            })
        )
    }



    const handleSorting = (e) => {
        if (e.target.value === 'Latest') {
            setSortByValueShopping('DESC')
        } else {
            setSortByValueShopping('ASC')
        }
    }

    const onChangePageShopping = (e, p) => {
        // setPage(p)
        setPageShopping(e);
    }
    // console.log(page, "page")

    const handleSearch = (e) => {
        // setPage(1)
        if (searchValueShopping.trim().length >= 2) {
            onChangePageShopping(1)
            setColumnNameShopping('')
        }
        setSearchValueShopping(e.target.value)
    }

    const handleOrderValue = (order) => {
        setSortByValueShopping(order)
    }

    const handleColumnName = (name) => {
        setSortingCol(false);
        setColumnNameShopping(name)
        if (sortByValue === "ASC") {
            setSortByValueShopping("DESC")
        }
        if (sortByValue === "DESC") {
            setSortByValueShopping("ASC")
        }

    }

    useEffect(() => {

        // onLoadData()
    }, [sortByValue, pageSize, page, columnNameShopping])
    // useEffect(() => {
    //     if (renderMenuBar == 4) {
    //         onLoadData()
    //     }
    // }, [renderMenuBar])

    function onLoadSearch() {
        let data = new FormData();
        data.append("user_id_ids", localStorage.getItem('user_id') || "");
        data.append("ticket_id_ids", localStorage.getItem('ticket_id'));
        data.append("generated_date_dtm", getCurrentDateTime());
        data.append("page_index", pageShopping);
        data.append("page_size", pageSizeShopping);
        data.append("sorting_order", sortByValueShopping);
        data.append("sorting_column_name", columnNameShopping);
        data.append("search_area", searchValueShopping);

        dispatch(
            getPurchaseList(data, (res) => {
                getCallHistoryDetails(res);
                setCustomeSkeletonLoaingShopping(false);
            })
        )
    }

    useEffect(() => {
        if (searchValueShopping.trim().length > 2) {
            setFlag(true);
            const timeOutId = setTimeout(onLoadSearch, 1000);
            return () => clearTimeout(timeOutId);
        } else if (searchValueShopping.trim().length === 0) {
            if (flag) {
                onLoadSearch();
            }
        }
    }, [searchValueShopping]);

    const [sortingCol, setSortingCol] = useState(true);


    const tooltipDelete = (
        <Tooltip id="tooltip">
            <strong>Delete</strong>
        </Tooltip>
    );
    const tooltipEdit = (
        <Tooltip id="tooltip">
            <strong>Edit</strong>
        </Tooltip>
    );
    const tooltipDownload = (
        <Tooltip id="tooltip" >
            <strong >Download Shopping List</strong>
        </Tooltip>
    );
    const sharePurchaseListToolTip = (
        <Tooltip id="tooltip" >
            <strong >Share Shopping List</strong>
        </Tooltip>
    );
    const tooltipCopyTxt = (
        <Tooltip id="tooltip">
            <strong>Copy to clipboard</strong>
        </Tooltip>
    );

    const handleCreatePurchaseList = () => {
        setToggleForPurchase(1);
        // handleShowPurchaseList();
        setBottomShoppingDrawerTrigger(true);
    }

    const handleEditPurchaseList = (e) => {
        e?.stopPropagation();
        setToggleForPurchase(3)
    }

    const handleItemName = (e) => {
        setItemNameErr(false);
        setItemName(e.target.value)
    }

    const handleQuantity = (e) => {
        setQuantityErr(false);
        setQuantity(e.target.value.replace(/\D/g, ''))
    }

    const handleTotalEstimatedCost = (e) => {
        setTotalEstimatedCostErr(false);
        setTotalEstimatedCost(e.target.value.replace(/[^\d.]/g, '').replace(/(\.\d*)\./g, '$1'))
    }

    const handlePurchaseLink = (e) => {
        setPurchaseLinkErr(false);
        setPurchaseLink(e.target.value)
    }

    const handleDescriptionShopping = (e) => {
        setItemDescriptionErr(false);
        setItemDescription(e.target.value);
    }

    const handleItemNameBlurCheck = () => {
        if (itemName === '') {
            setItemNameErr(true)
        }
    }

    const handleQuantityBlurCheck = () => {
        if (isNaN(quantity) || quantity === '') {
            setQuantityErr(true)
        }
    }

    const handleTotalEstimatedCostBlurCheck = () => {
        if (isNaN(totalEstimatedCost) || totalEstimatedCost === '') {
            setTotalEstimatedCostErr(true)
        }
    }

    const handlePurchaseLinkBlurCheck = () => {
        if (purchaseLink === '') {
            setPurchaseLinkErr(true)
        }
    }

    const handleDescriptionBlurCheck = () => {
        if (itemDescription === '') {
            setItemDescriptionErr(true)
        }
    }


    // console.log(quantity, "quantity")
    const handleSubmitPurchase = (e) => {
        e.preventDefault();

        if (itemName === '') {
            setItemNameErr(true)
        }
        // if (quantity === '') {
        //   setQuantityErr(true)
        // }
        // if (totalEstimatedCost === '') {
        //   setTotalEstimatedCostErr(true)
        // }
        // if (purchaseLink === '') {
        //   setPurchaseLinkErr(true)
        // }
        // if (itemDescription === '') {
        //   setItemDescriptionErr(true)
        // }

        if (itemName) {
            // console.log(itemName, quantity, totalEstimatedCost, purchaseLink, itemDescription)
            setPurchaseLoading(true)

            let data = new FormData();
            data.append("user_id_ids", localStorage.getItem('user_id') || "");
            data.append("call_log_id_ids", localStorage.getItem('call_log_id') || "");
            data.append("ticket_id_ids", localStorage.getItem('ticket_id') || "");
            data.append("item_name_chr", itemName);
            data.append("quantity_int", quantity == "" ? 1 : quantity);
            data.append("estimated_price_float", parseFloat(((quantity || 1) * totalEstimatedCost).toFixed(2)));
            data.append("description_chr", itemDescription);
            data.append("purchase_link_chr", purchaseLink);

            dispatch(
                createPurchaseItem(data, (res) => {
                    setPurchaseLoading(false)
                    setResponceMsg(res.data.message)
                    setToasterType("success")
                    // setToggleForPurchase(1);

                    handleClosePurchaseList();

                    handleCloseCreatePurchaseItem();

                    onLoadData();

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);

                }, (err) => {
                    setPurchaseLoading(false)
                    setResponceMsg(err.data.message)
                    setToasterType("error")

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                })
            )

        }
    }

    const handleCloseCreatePurchaseItem = (e) => {
        e?.preventDefault();
        setToggleForPurchase(1)
        setItemNameErr(false);
        setQuantityErr(false);
        setTotalEstimatedCostErr(false);
        setPurchaseLinkErr(false);
        setItemDescriptionErr(false);

        setItemName('');
        setQuantity(1);
        setTotalEstimatedCost(0);
        setPurchaseLink('');
        setItemDescription('');

        setEmailPhoneValue('')
        setIsEmailPhoneVal(false);
    }

    const handleUpdatePurchaseList = (element, e) => {
        e.stopPropagation();

        // setPurchaseLoading(true)

        setPurchaseItemId(element?.item_id_ids)
        setItemName(element?.item_name_chr)
        setQuantity(element?.quantity_int)
        setTotalEstimatedCost(((element?.estimated_price_float) / (element?.quantity_int)).toFixed(2))
        setPurchaseLink(element?.purchase_link_chr)
        setItemDescription(element?.description_chr)
        setToggleForPurchase(2)
        // handleShowPurchaseList();
        setBottomShoppingDrawerTrigger(true);
    }

    const handleViewPurchaseItem = (element) => {
        setPurchaseItemId(element?.item_id_ids);
        setItemName(element?.item_name_chr);
        setQuantity(element?.quantity_int);
        setTotalEstimatedCost(element?.estimated_price_float);
        setPurchaseLink(element?.purchase_link_chr);
        setItemDescription(element?.description_chr);
        handleShowPurchaseList();
        setToggleForPurchase(4);
    }

    const handleDeletePurchaseList = (element, e) => {
        e.stopPropagation();
        setPurchaseLoading(true)

        setPurchaseItemId(element?.item_id_ids)

        let details = {
            user_id_ids: localStorage.getItem('user_id') || "",
            item_id_ids: element?.item_id_ids,
        };

        dispatch(
            deletePurchaseItem(details, (res) => {
                setPurchaseLoading(false)
                setResponceMsg(res.data.message)
                setToasterType("success")

                onLoadData();

                handleClosePurchaseList();

                // setHandleToaster(true);
                // setTimeout(() => {
                //     setHandleToaster(false);
                // }, 11000);
            }, (err) => {
                setPurchaseLoading(false)
                setResponceMsg(err.data.message)
                setToasterType("error")

                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
            })
        )
    }



    const handleMarkPurchaseItem = (element, isPurchaseVal = 1) => {
        setPurchaseLoading(true)
        let data = new FormData();
        data.append("user_id_ids", localStorage.getItem('user_id') || "");
        data.append("item_id_ids", element?.item_id_ids);
        data.append("call_log_id_ids", localStorage.getItem('call_log_id'));
        data.append("ticket_id_ids", localStorage.getItem('ticket_id'));
        data.append("item_name_chr", element?.item_name_chr);
        data.append("quantity_int", element?.quantity_int);
        data.append("estimated_price_float", parseFloat(((element?.estimated_price_float) / (element?.quantity_int)).toFixed(2)));
        data.append("description_chr", element?.description_chr);
        data.append("purchase_link_chr", element?.purchase_link_chr);
        data.append("is_purchased_ysn", isPurchaseVal);

        dispatch(
            updatePurchaseItem(data, (res) => {
                // setPurchaseLoading(false)
                setResponceMsg(res.data.message)
                setToasterType("success")
                // setToggleForPurchase(1);

                handleClosePurchaseList();

                handleCloseCreatePurchaseItem();

                onLoadData();

                // setHandleToaster(true);
                // setTimeout(() => {
                //   setHandleToaster(false);
                // }, 11000);
            }, (err) => {
                setPurchaseLoading(false)
                setResponceMsg(err.data.message)
                setToasterType("error")

                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
            })
        )
    }

    const handleUpdatePurchase = (e) => {
        e?.preventDefault();
        setPurchaseLoading(true)
        let data = new FormData();
        data.append("user_id_ids", localStorage.getItem('user_id') || "");
        data.append("item_id_ids", purchaseItemId);
        data.append("call_log_id_ids", localStorage.getItem('call_log_id'));
        data.append("ticket_id_ids", localStorage.getItem('ticket_id'));
        data.append("item_name_chr", itemName);
        data.append("quantity_int", quantity == "" ? 1 : quantity);
        data.append("estimated_price_float", parseFloat(((quantity || 1) * totalEstimatedCost).toFixed(2)));
        data.append("description_chr", itemDescription);
        data.append("purchase_link_chr", purchaseLink);

        dispatch(
            updatePurchaseItem(data, (res) => {
                setPurchaseLoading(false)
                setResponceMsg(res.data.message)
                setToasterType("success")
                // setToggleForPurchase(1);

                handleClosePurchaseList();

                handleCloseCreatePurchaseItem();

                onLoadData();


                // setHandleToaster(true);
                // setTimeout(() => {
                //     setHandleToaster(false);
                // }, 11000);
            }, (err) => {
                setPurchaseLoading(false)
                setResponceMsg(err.data.message)
                setToasterType("error")

                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
            })
        )
    }

    // Send purchase list via email or phone number

    const handleSendPurchaseList = (e) => {
        e.preventDefault();
        if (phoneValidation(emailPhoneValue) || emailValidation(emailPhoneValue)) {
            setPurchaseLoading(true);
            if (isPhone) {
                const data = new FormData();
                data.append("user_id_ids", localStorage.getItem("user_id") || "")
                data.append("ticket_id_ids", localStorage.getItem('ticket_id'))
                data.append("generated_date_dtm", getCurrentDateTime());
                data.append("email_chr", "");
                data.append("phone_code_id_int", parseInt(codeValue) || 1);
                data.append("phone_number_int", emailPhoneValue);

                dispatch(
                    sharePurchaseList(data, (res) => {
                        setPurchaseLoading(false)
                        setResponceMsg(res.data.message)
                        setToasterType("success")
                        // setToggleForPurchase(1);
                        handleClosePurchaseList();

                        handleCloseCreatePurchaseItem();

                        // setHandleToaster(true);
                        // setTimeout(() => {
                        //     setHandleToaster(false);
                        // }, 11000);
                    }, (err) => {
                        setPurchaseLoading(false)
                        setResponceMsg(err.data.message)
                        setToasterType("error")

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    })
                );
            } else if (!isPhone) {

                const data = new FormData();
                data.append("user_id_ids", localStorage.getItem("user_id") || "")
                data.append("ticket_id_ids", localStorage.getItem('ticket_id'))
                data.append("generated_date_dtm", getCurrentDateTime());
                data.append("email_chr", emailPhoneValue);
                // data.append("phone_code_id_int", null);
                // data.append("phone_number_int", null);

                dispatch(
                    sharePurchaseList(data, (res) => {
                        setPurchaseLoading(false)
                        setResponceMsg(res.data.message)
                        setToasterType("success")
                        // setToggleForPurchase(1);
                        handleClosePurchaseList();

                        handleCloseCreatePurchaseItem();

                        // setHandleToaster(true);
                        // setTimeout(() => {
                        //     setHandleToaster(false);
                        // }, 11000);
                    }, (err) => {
                        setPurchaseLoading(false)
                        setResponceMsg(err.data.message)
                        setToasterType("error")

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    })
                );

            }
        } else {
            setIsEmailPhoneVal(true);
        }
    };

    useEffect(() => {
        const dot = ".";
        const leng = emailPhoneValue.length - 1;
        if (!isNaN(emailPhoneValue) && emailPhoneValue.charAt(leng) !== dot) {
            if (emailPhoneValue.length < 11) {
                setIsPhone(true);
            } else {
                setIsPhone(false);
            }
        } else {
            setIsPhone(false);
        }
        if (emailPhoneValue === "") {
            setIsPhone(false);
        }
    }, [emailPhoneValue]);

    const copyToClipboard = () => {
        setResponceMsg("Link copied to clipboard!");
        setToasterType("success");

        setHandleToaster(true);
        setTimeout(() => {
            setHandleToaster(false);
        }, 11000);
    }

    // Format the price to USD 
    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    const [showPopoverShopping, setShowPopoverShopping] = useState(false);
    // More actions for both customer and pro
    const popoverShopping = (
        <Popover id="popover-basic"
            style={{ minWidth: "100px", border: 'none' }}>
            <Popover.Body
                className="p-2 popover-body"
                style={{
                    //   padding: "5px",
                    boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.2)",
                }}>
                <div className="d-flex flex-column font-w500 fs-6"

                >

                    <div
                        onClick={(e) => {
                            // editExpertise(e, expertiseObject);
                            // setActivePopover(null)
                            setShowPopoverShopping(false);
                            handleCreatePurchaseList();
                        }}
                        className='border-bottom cursor-pointer p-2  text-black overlay-action-btn'
                    >
                        <span className='me-2'>
                            <i className="bi bi-list-check"></i>
                        </span>
                        <span>{"Add shopping item"}</span>
                    </div>

                    <div
                        onClick={(e) => {
                            handleShowPurchaseList();
                            setToggleForPurchase(3);
                            setShowPopoverShopping(false);
                        }}
                        className='border-bottom cursor-pointer p-2  text-black overlay-action-btn'
                        style={{
                            pointerEvents: rows.length > 0 ? "auto" : "none",
                            opacity: rows.length > 0 ? "1" : "0.5",
                        }}
                    >
                        <span className='me-2'>
                            <i className="bi bi-send"></i>
                        </span>
                        <span>{"Share shopping list"}</span>
                    </div>

                    <a
                        download
                        href={process.env.REACT_APP_BASE_URL + `ServiceRequest/DownloadPurchaseList?user_id_ids=${localStorage.getItem('user_id') || ""}&ticket_id_ids=${localStorage.getItem('ticket_id')}&generated_date_dtm=${encodeDateString(currentTimeString)}`}
                        target='_blank'
                        rel="noreferrer noopen"
                        style={{
                            pointerEvents: rows.length > 0 ? "auto" : "none",
                            opacity: rows.length > 0 ? "1" : "0.5",
                        }}
                    >
                        <div
                            onClick={(e) => {
                                // editExpertise(e, expertiseObject);
                                // setActivePopover(null)
                                setShowPopoverShopping(false);
                            }}
                            className='cursor-pointer p-2  text-black overlay-action-btn'

                        >
                            <span className='me-2'>
                                <i className="bi bi-download"></i>
                            </span>
                            <span>{"Download shopping list"}</span>
                        </div>
                    </a>

                </div>

            </Popover.Body>
        </Popover>
    );

    const [shoppingItemObject, setShoppingItemObject] = useState({});

    const popoverShoppingActions = (index) => (
        <Popover
            // id="popover-basic"
            id={`popover-basic-${index}`}

            //   className="custom-popover"
            style={{ minWidth: "100px", border: 'none' }}
        >
            <Popover.Body
                className="p-2 popover-body"
                style={{
                    //   padding: "5px",
                    boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.2)",

                }}>
                <div className="d-flex flex-column font-w500 fs-6" style={{}}>
                    <div
                        onClick={(e) => {
                            // editExpertise(e, shoppingItemObject);
                            setActivePopoverShopping(null)
                            handleUpdatePurchaseList(shoppingItemObject, e);
                        }}
                        className='border-bottom cursor-pointer p-2  text-black overlay-action-btn text-hovered'
                    >
                        <span className='me-2'>
                            <i className="bi bi-pencil"></i>
                        </span>
                        <span>Edit</span>
                    </div>
                    <div
                        onClick={(e) => {
                            // handleOpenExpertiseTrigger(e, 3, expertiseObject.expertise_id_ids);
                            setActivePopoverShopping(null);
                            handleViewPurchaseItem(shoppingItemObject);
                        }}
                        className=' cursor-pointer p-2 text-danger overlay-action-btn'
                    >
                        <span className='me-2'>
                            <i className="bi bi-trash"></i>
                        </span>
                        <span>Delete</span>
                    </div>
                </div>
            </Popover.Body>
        </Popover>
    );

    const [activePopoverShopping, setActivePopoverShopping] = useState(null);


    const handleMenuClickShopping = (element, index) => {
        setShoppingItemObject(element)
        setActivePopoverShopping(activePopoverShopping === index ? null : index)
    }





    // Purchase list code end here -------------------

    // Dynamic image height and width
    const imageRef = useRef(null);
    const [imgMaxHeight, setImgMaxHeight] = useState(0);
    const [imgMaxWidth, setImgMaxWidth] = useState(0);

    useEffect(() => {
        if (imageRef.current) {
            const height = imageRef?.current?.getBoundingClientRect().height;
            const width = imageRef?.current?.getBoundingClientRect().width;
            setImgMaxWidth(width);
            setImgMaxHeight(height);
        }

        // const resizeObserver = new ResizeObserver(entries => {
        //     for (let entry of entries) {
        //         setImgMaxWidth(entry.contentRect.width);
        //         setImgMaxHeight(entry.contentRect.height);
        //     }
        // });

        // if (imageRef.current) {
        //     resizeObserver.observe(imageRef.current);
        // }

        // return () => resizeObserver.disconnect();

    }, [imageRef.current]);

    // Zoom functionality for the images
    const [scale, setScale] = useState(1);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [dragging, setDragging] = useState(false);

    // Function to handle the change in range input
    const handleZoomChange = (event) => {
        setScale(event.target.value);
    };

    // Start dragging
    const handleDragStart = (event) => {
        event.preventDefault();
        setDragging(true);
        // setPosition({
        //     ...position, // Keep the previous position
        //     startX: event.clientX - position.x, // Calculate initial start position
        //     startY: event.clientY - position.y,
        // });

        const clientX = event.type.includes('mouse') ? event.clientX : event.touches[0].clientX;
        const clientY = event.type.includes('mouse') ? event.clientY : event.touches[0].clientY;

        setPosition({
            ...position,
            startX: clientX - position.x,
            startY: clientY - position.y,
        });

    };

    // Handle dragging
    const handleDragging = (event) => {
        if (dragging) {
            // setPosition({
            //     ...position,
            //     x: event.clientX - position.startX,
            //     y: event.clientY - position.startY,
            // });
            const clientX = event.type.includes('mouse') ? event.clientX : event.touches[0].clientX;
            const clientY = event.type.includes('mouse') ? event.clientY : event.touches[0].clientY;

            setPosition({
                ...position,
                x: clientX - position.startX,
                y: clientY - position.startY,
            });
        }
    };

    // Stop dragging
    const handleDragEnd = () => {
        setDragging(false);
    };

    // Reset image
    const handleResetImage = () => {
        setScale(1);
        setPosition({ x: 0, y: 0 });
    }

    useEffect(() => {
        handleResetImage();
        setIsLoadingImg(true);
    }, [attachImageIndex]);

    // Loading effect for the images
    const [isLoadingImg, setIsLoadingImg] = useState(true);

    const handleImageLoaded = () => {
        setIsLoadingImg(false);
    };

    const handleImageError = () => {
        console.error('Failed to load the image.');
        setIsLoadingImg(false);
    };



    useEffect(() => {
        if (!bottomShoppingDrawerTrigger) {
            handleClosePurchaseList();
        }
    }, [bottomShoppingDrawerTrigger]);


    // Functions for the service history starts here
    const getServiceRequestHistoryFn = () => {
        let data = new FormData();

        data.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        data.append("page_index", 1);
        data.append("page_size", 25);
        data.append("sorting_order", "DESC");
        data.append("sorting_column_name", "");
        data.append("search_area", '');


        dispatch(getServiceRequestHistoryApi(data,
            (res) => {
                // console.log(res?.data?.data)
                setServiceReqHistoryArr(res?.data?.data)
            },
            (err) => {
                console.log(err)
            })
        )
    }

    // useEffect(() => {
    //     getServiceRequestHistoryFn();
    // }, [])

    // Call notes for the service request starts here
    const [bottomNotesDrawerTrigger, setBottomNotesDrawerTrigger] = useState(false);
    const tooltipAttachment = (
        <Tooltip id="tooltip" >
            <strong >Attachments</strong>
        </Tooltip>
    );
    const callNoteData = () => {
        setDiscussionLoading(true);
        let data = new FormData();

        data.append("user_id_ids", localStorage.getItem("user_id"));
        // data.append("call_log_id_ids", localStorage.getItem("call_log_id"));
        data.append("ticket_id_ids", localStorage.getItem("ticket_id"));

        data.append("page_index", 1);
        data.append("page_size", 25);
        data.append("sorting_order", "DESC");
        data.append("sorting_column_name", "");
        data.append("search_area", '');

        dispatch(
            callNoteDetails(data, (res) => {
                setCallNoteDetailsArr(res.data.data);
                setDiscussionLoading(false);
                getNotesPurchaseListCallSCountersFn();
            })
        );
    };

    // useEffect(() => {
    //     callNoteData();
    // }, []);

    const discussionOnChange = (e) => {
        setDiscussionVal(e.target.value);
    };

    const inputFileTarget = (e) => {


        const selectedFileLength = [...selectedFile];
        if (selectedFileLength.length < 10) {
            setDeleteIconVisiblity({ visibility: "visible" });
            setSelectedFile([...selectedFile, e.target.files[0]]);

            return;
        }
        return setSelectedFileLimit("*You can't add more than 10 files.")
    };

    const deleteUpload = (fileIndex) => {
        const updatedFile = selectedFile.filter((delElem, delElemIndex) => {
            return fileIndex !== delElemIndex;
        })
        setSelectedFile([...updatedFile]);
        setSelectedFileLimit("");

    };

    const handleAttach = () => {
        hiddenFileInput.current.click();
    };

    const handleSaveDiscussion = () => {

        setSaveLoading(true);
        let data = new FormData();

        data.append("user_id_ids", localStorage.getItem("user_id"));
        // data.append("call_log_id_ids", localStorage.getItem("call_log_id"));
        data.append("call_note", discussionVal);
        selectedFile?.map((attachmentData, attachmentI) => {
            data.append(`attachment${attachmentI}`, attachmentData);
        })
        data.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        toggleForAddPersonalNote && data.append("is_personal_note_ysn", 1);
        // console.log(data,"particular ")
        dispatch(callNote(data, () => {
            setSelectedFile([]);
            setDiscussionVal("");
            setSaveLoading(false);

            !toggleForAddPersonalNote && callNoteData();

            toggleForAddPersonalNote && particularTicketDetails();

            setBottomNotesDrawerTrigger(false);

            setToggleForAddPersonalNote(false);

        }, (err) => {
            setSaveLoading(false);
        }))
    };

    // Delete the notes
    // Popover for the delete call notes
    const [noteObject, setNoteObject] = useState({});
    const [modalTriggerNotes, setModalTriggerNotes] = useState(false);
    const [activePopoverNotes, setActivePopoverNotes] = useState(null);

    const handleOpenModalNotes = () => {
        setModalTriggerNotes(true);
    };
    const handleCloseModalNotes = () => {
        setModalTriggerNotes(false);
    };
    const popoverNoteActions = (index) => (
        <Popover
            // id="popover-basic"
            id={`popover-basic-${index}`}
            //   className="custom-popover"
            style={{ minWidth: "100px", border: "none" }}>
            <Popover.Body
                className="p-2 popover-body"
                style={{
                    //   padding: "5px",
                    boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.2)",
                }}>
                <div className="d-flex flex-column font-w500 fs-6" style={{}}>
                    <div
                        onClick={(e) => {
                            // handleOpenExpertiseTrigger(e, 3, expertiseObject.expertise_id_ids);
                            setActivePopoverNotes(null);
                            handleOpenModalNotes();
                        }}
                        className=" cursor-pointer p-2 text-danger overlay-action-btn">
                        <span className="me-2">
                            <i className="bi bi-trash"></i>
                        </span>
                        <span>Delete</span>
                    </div>
                </div>
            </Popover.Body>
        </Popover>
    );

    const handleMenuClickNotes = (element, index) => {
        setNoteObject(element);
        setActivePopoverNotes(activePopoverNotes === index ? null : index);
    };

    const handleDeleteNote = (element, e) => {
        e?.preventDefault();

        setSaveLoading(true);

        let details = {
            user_id_ids: localStorage.getItem("user_id") || "",
            call_log_note_id_ids: element?.call_log_note_id_ids,
        };

        dispatch(
            deleteCallLogNoteById(
                details,
                (res) => {
                    setSaveLoading(false);
                    setResponceMsg(res.data.message);
                    setToasterType("success");

                    callNoteData();
                    handleCloseModalNotes();

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                },
                (err) => {
                    setSaveLoading(false);
                    setResponceMsg(err.data.message);
                    setToasterType("error");

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        );
    };

    // Add personal note
    const [toggleForAddPersonalNote, setToggleForAddPersonalNote] = useState(false);
    const [personalNoteObj, setPersonalNoteObj] = useState({});
    useEffect(() => {
        setDiscussionVal("");
        setToggleForAddPersonalNote(false);
    }, [tabsToggleServiceReq])

    useEffect(() => {
        receiverData?.personal_notes && setPersonalNoteObj(receiverData?.personal_notes);
    }, [receiverData])

    // Counter functionality 
    const [countersCheck, setCountersCheck] = useState(true);
    const [callCount, setCallCount] = useState(0);
    const [notPurchasedShoppingItemCount, setNotPurchasedShoppingItemCount] = useState(0);
    const [serviceReqHistoryCount, setServiceReqHistoryCount] = useState(0);
    const [notesCount, setNotesCount] = useState(0);
    const getNotesPurchaseListCallSCountersFn = () => {
        if (!localStorage.getItem("ticket_id")) {
            return
        }
        let data = {
            ticket_id_ids: localStorage.getItem("ticket_id"),
        }
        dispatch(getNotesPurchaseListCallSCountersApi(data,
            (res) => {
                // console.log(res.data, "counters")
                setCallCount(res.data?.call_count || 0);
                setNotPurchasedShoppingItemCount(res.data?.not_purchased_shopping_item_count || 0);
                setServiceReqHistoryCount(res.data?.service_request_history_count || 0);
                setNotesCount(res.data?.notes_count || 0);
            }, (err) => {
                console.log(err)
            }
        ))
    }


    useEffect(() => {
        if (tabsToggleServiceReq == 2 || tabsToggleServiceReq == 3 || tabsToggleServiceReq == 4 || countersCheck) {
            getNotesPurchaseListCallSCountersFn();
        }
        setCountersCheck(false);
    }, [tabsToggleServiceReq, localStorage.getItem("ticket_id")])


    // functions for the change job statuses
    const [changeJobStatusLoading, setChangeJobStatusLoading] = useState(false)
    const [ratingValue, setRatingValue] = useState(5);
    const [hover, setHover] = useState(0);
    const [jobStatus, setJobStatus] = useState();
    const [changeJobStatusModalTrigger, setChangeJobStatusModalTrigger] = useState(false);
    const [isReqRefund, setIsReqRefund] = useState(false);
    const handleOpenChangeJobStatusModal = () => {
        setChangeJobStatusModalTrigger(true);
    }
    const handleCloseChangeJobStatusModal = () => {
        setChangeJobStatusModalTrigger(false);
    }

    // ticket_status = {
    //     "closed": 0,
    //     "open": 1,
    //     "accepted": 2,
    //     "rejected": 3,
    //     "not_global": 4, -> changed to "unresolved"
    //     "reopen": 5,
    //     "incomplete": 6,
    //     "cancel":7,
    // }
    const handleChangeJobStatusFn = () => {
        setChangeJobStatusLoading(true);
        let formData = new FormData();
        // formData.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        formData.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        formData.append(
            "ticket_status_ysn",
            jobStatus == 0 ? 0 :
                jobStatus == 1 ? 1 :
                    jobStatus == 4 ? 4 :
                        jobStatus == 5 ? 5 :
                            jobStatus == 7 ? 7 : ''
        );

        // console.log(jobStatus, "jobStatus")

        if (jobStatus == 0 || jobStatus == 4) {
            submitFeedback();
        }

        if (isReqRefund) {
            raiseRefundFn();
        }

        dispatch(updateTicketStatus(formData, (res) => {
            // console.log(res)
            setResponceMsg(res.data.message);
            setChangeJobStatusLoading(false);

            particularTicketDetails();

            handleCloseChangeJobStatusModal();

            setToasterType("success")

            // setHandleToaster(true);
            // setTimeout(() => {
            //     setHandleToaster(false);
            // }, 11000);

        }), (res) => {
            console.log(res);
            setResponceMsg(res.data.message);
            setToasterType("error");
            setChangeJobStatusLoading(false);

            setHandleToaster(true);
            setTimeout(() => {
                setHandleToaster(false);
            }, 11000);
        })
    }

    // Save user rating
    const [feedbackMessage, setFeedbackMessage] = useState("");

    const submitFeedback = (e) => {
        e?.preventDefault();
        var data = {
            user_id_ids: sentRequest[0]?.sender_id_ids || "",
            // call_log_id_ids: localStorage.getItem("call_log_id"),
            call_log_id_ids: sentRequest[0]?.call_log_id_ids,
            rating_value_int: ratingValue,
            comment_chr: feedbackMessage,
            given_by_name_chr: localStorage.getItem("fullName"),
        };
        // console.log(data, "data feedback")
        dispatch(
            saveRating(
                data,
                (res) => {
                    setRatingValue(0);
                    setFeedbackMessage("");
                    // setResponceMsg(res.data.message);
                    // setToasterType("success");

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 5000);
                },
                (res) => {
                    console.log(res);
                    // setResponceMsg(res.data.message);
                    // setToasterType("error");
                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                }
            )
        );
    }

    // raise refunds by customer functions
    const raiseRefundFn = () => {

        let details = new FormData();
        // details.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        // details.append("is_latest_call", 1);
        details.append("call_log_id_ids", callLogIdIds);
        details.append("call_log_transaction_id_ids", '');


        dispatch(
            raiseRefundApi(
                details,
                (res) => {
                    // console.log(res)
                    setResponceMsg(res.data.message)
                    setToasterType("success")

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                },
                (res) => {
                    // console.log(res)
                    setResponceMsg(res.data.message)
                    setToasterType("error");

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        )
    }

    const raiseRefundForParticularFn = () => {

        setRaiseRefundLoading(true);
        let details = new FormData();
        // details.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        // details.append("is_latest_call", 1);
        details.append("call_log_id_ids", particularCallLogId);
        details.append("call_log_transaction_id_ids", '');


        dispatch(
            raiseRefundApi(
                details,
                (res) => {
                    ticketStatus();
                    // console.log(res)
                    setResponceMsg(res.data.message)
                    setToasterType("success")
                    // setRaiseRefundLoading(false);

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                },
                (res) => {
                    // console.log(res)
                    setResponceMsg(res.data.message)
                    setToasterType("error");

                    setRaiseRefundLoading(false);

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        )
    }

    // New Payments methods functions starts here
    const [paymentGatewayFlag, setPaymentGatewayFlag] = useState(0);

    const getPaymentConfigFn = () => {
        let details = {}
        dispatch(
            getPaymentConfigApi(details,
                (res) => {
                    // console.log(res.data.data)
                    // console.log(res?.data?.data)
                    setPaymentGatewayFlag(res?.data?.data?.purchase?.payment_gateway_flag);

                    setCallChargeAmount(
                        res?.data?.data?.purchase?.call_charge_amount_in_cents_int / 100
                    );
                    setCallDurationTimeLimit(
                        res?.data?.data?.purchase?.call_duration_time_limit_in_sec / 60
                    );
                },
                (res) => {
                    console.log(res.data.data)
                })
        )
    }

    // console.log(paymentGatewayFlag, 'paymentGatewayFlag', callChargeAmount, '$ callChargeAmount', callDurationTimeLimit, 'min callDurationTimeLimit')

    useEffect(() => {
        if (permissionArray.includes("SCAN TAB")) {
            getPaymentConfigFn();
        }
    }, [])

    // console.log(isReqRefund, 'isReqRefund')

    // Attach more images update service request
    const [uploadAttachedImage1, setUploadAttachedImage1] = useState(null);
    const [attachedImage1, setAttachedImage1] = useState(null);

    const [uploadAttachedImage2, setUploadAttachedImage2] = useState(null);
    const [attachedImage2, setAttachedImage2] = useState(null);


    // Attachment Upload 1
    const attachedImage1Ref = useRef();

    const handleClickAttachedImage1 = () => {
        attachedImage1Ref.current.click();
    }
    function handleAttachedImage1(e) {
        if (e.target.files) {
            setUploadAttachedImage1(e.target.files[0]);
            setAttachedImage1(URL.createObjectURL(e.target.files[0]))
        }
    }

    function deleteAttachedImage1() {
        setUploadAttachedImage1(null);
        setAttachedImage1(null)
    }

    // Attachment Upload 2
    const attachedImage2Ref = useRef();

    const handleClickAttachedImage2 = () => {
        attachedImage2Ref.current.click();
    }
    function handleAttachedImage2(e) {
        if (e.target.files) {
            setUploadAttachedImage2(e.target.files[0]);
            setAttachedImage2(URL.createObjectURL(e.target.files[0]))
        }
    }

    function deleteAttachedImage2() {
        setUploadAttachedImage2(null);
        setAttachedImage2(null)
    }

    // Attach single attachment to update service request
    const [uploadAttachedImage, setUploadAttachedImage] = useState(null);
    const [attachedImage, setAttachedImage] = useState(null);


    // Attachment Upload 1
    const attachedImageRef = useRef();

    const handleClickAttachedImage = () => {
        attachedImageRef.current.click();
    }
    function handleAttachedImage(e) {
        if (e.target.files) {
            setUploadAttachedImage(e.target.files[0]);
            setAttachedImage(URL.createObjectURL(e.target.files[0]))
        }
    }

    const deleteAttachedImage = () => {
        setUploadAttachedImage(null);
        setAttachedImage(null)
    }

    const updateServiceSingleAttachement = (e) => {
        e?.preventDefault();

        setSaveUpdateTicketLoading(true);

        let formData = new FormData();

        formData.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        timeSlotID && formData.append("time_slot_id", parseInt(timeSlotID))
        communicationModeID && formData.append("communication_mode_id", parseInt(communicationModeID));

        uploadAttachedImage != null && formData.append("attachment_id_ids0", "");
        uploadAttachedImage != null && formData.append("attachment0", uploadAttachedImage);

        dispatch(updateTicketDetail(formData, (res) => {

            setResponceMsg(res.data.message);
            setToasterType("success")

            // setHandleToaster(true);
            // setTimeout(() => {
            //     setHandleToaster(false);
            // }, 11000);

            setSaveUpdateTicketLoading(false);
            particularTicketDetails();
            deleteAttachedImage();

        }, (err) => {
            setSaveUpdateTicketLoading(false);

            setResponceMsg(err.data.message);
            setToasterType("error")

            setHandleToaster(true);
            setTimeout(() => {
                setHandleToaster(false);
            }, 11000);
        }))
    }

    useEffect(() => {
        if (uploadAttachedImage != null) {
            updateServiceSingleAttachement();
        }
    }, [uploadAttachedImage])


    // Multiple attachments update service request
    const [selectedFileAttach, setSelectedFileAttach] = useState([]);
    const [selectedFileLimitAttach, setSelectedFileLimitAttach] = useState("");
    const [deleteIconVisiblityAttach, setDeleteIconVisiblityAttach] = useState({
        visibility: "hidden",
    });
    const hiddenFileInputAttach = useRef(0);

    const inputFileTargetAttach = (e) => {


        const selectedFileLengthAttach = [...selectedFileAttach];
        if (selectedFileLengthAttach.length < 3) {
            setDeleteIconVisiblityAttach({ visibility: "visible" });
            setSelectedFileAttach([...selectedFileAttach, e.target.files[0]]);

            return;
        }
        return setSelectedFileLimitAttach("*You can't add more than 3 files.")
    };

    const deleteUploadAttach = (fileIndex) => {
        const updatedFile = selectedFileAttach.filter((delElem, delElemIndex) => {
            return fileIndex !== delElemIndex;
        })
        setSelectedFileAttach([...updatedFile]);
        setSelectedFileLimitAttach("");

    };

    const handleAttachService = () => {
        hiddenFileInputAttach.current.click();
    };

    const [cancelServiceModalTrigger, setCancelServiceModalTrigger] = useState(false);

    const handleOpenCancelServiceModal = () => {
        setCancelServiceModalTrigger(true);
    };
    const handleCloseCancelServiceModal = () => {
        setCancelServiceModalTrigger(false);
    };

    const [reactivateServiceModalTrigger, setReactivateServiceModalTrigger] = useState(false);

    const handleOpenReactivateServiceModal = () => {
        setReactivateServiceModalTrigger(true);
    };
    const handleCloseReactivateServiceModal = () => {
        setReactivateServiceModalTrigger(false);
    };

    // Scheduling start here ----------
    // New calendar functions start here
    const [selectedDate, setSelectedDate] = useState(new Date()); // Initialize with current date or null
    const [dateTime, setDateTime] = useState("");
    const [unixTimestamp, setUnixTimestamp] = useState("");
    const [unixEndTime, setUnixEndTime] = useState("");
    const [isDateTimeErr, setIsDateTimeErr] = useState(false);
    const today = new Date();

    const handleDateChange = (date) => {
        // Format the date when it is selected and log it or use it as needed
        const formattedDate = format(date, "yyyy-MM-dd");
        // console.log(formattedDate, "Formated date"); // Outputs the date in "2024-04-24" format
        setCurrentDate(formattedDate);
        setSelectedDate(date);
    };

    // Modal functions for the date time confirmation
    const [scheduleModalTrigger, setScheduleModalTrigger] = React.useState(false);
    const handleOpenScheduleModal = () => {
        setScheduleModalTrigger(true);
    };

    const handleCloseDocScheduleModal = () => {
        setScheduleModalTrigger(false);
        setIsDateTimeErr(false);
        handleClearSchedule();
    };

    const handleClearSchedule = () => {
        setDateTime("");
        setUnixTimestamp("");
        setUnixEndTime("");
    };

    // New functions for the Schedule call
    const [currentDate, setCurrentDate] = useState("");
    const [currentTime, setCurrentTime] = useState("");

    useEffect(() => {
        handleSetCurrentDateAndTime();
    }, []);

    // const handleSetCurrentDateAndTime = () => {
    //     // Get the current date and time
    //     const now = new Date();
    //     const date = now.toISOString().split("T")[0]; // format yyyy-mm-dd for the date input

    //     // Set the time one hour ahead, format hh:mm for the time input
    //     now.setHours(now.getHours() + 1);
    //     let hours = now.getHours();
    //     let minutes = now.getMinutes();
    //     // Ensure two-digit formatting for hours and minutes
    //     hours = hours < 10 ? `0${hours}` : hours;
    //     minutes = minutes < 10 ? `0${minutes}` : minutes;
    //     const time = `${hours}:${minutes}`;

    //     // Update the state
    //     setCurrentDate(date);
    //     setCurrentTime(time);
    // };

    const handleSetCurrentDateAndTime = () => {
        // Get the current date and time
        const now = new Date();
        const date = now.toISOString().split('T')[0]; // format yyyy-mm-dd for the date input

        // Set the time one hour ahead
        now.setHours(now.getHours() + 1);

        let hours = now.getHours();
        let minutes = now.getMinutes();

        // Adjust minutes to the nearest 30-minute slot
        minutes = minutes < 30 ? 0 : 30;

        // If minutes round up to 0 and it causes the hour to increase (e.g., 23:59 -> 00:00)
        if (minutes === 0 && now.getMinutes() >= 30) {
            hours += 1;
        }

        // Ensure two-digit formatting for hours and minutes
        hours = hours < 10 ? `0${hours}` : hours;
        minutes = minutes === 0 ? `00` : `30`;

        const time = `${hours}:${minutes}`;

        // Update the state
        setCurrentDate(date);
        setCurrentTime(time);

        setCurrentTimeLocalPro(time);
        setCurrentDateLocalPro(date);
    };

    const handleTimeChange = (e) => {
        const value = e.target.value;
        const [hours, minutes] = value.split(':').map(Number);

        // Adjust minutes to nearest valid option (0 or 30)
        const validMinutes = minutes < 15 ? '00' : '30';

        const correctedTime = `${hours.toString().padStart(2, '0')}:${validMinutes}`;
        setCurrentTime(correctedTime);
    };

    // console.log(currentDate, "Date");
    // console.log(currentTime, "Time");

    const convertToUnixTime = () => {
        // Combine the date and time into a single Date object
        const combinedDateTime = new Date(`${currentDate}T${currentTime}`);
        // Convert to Unix timestamp
        return Math.floor(combinedDateTime.getTime() / 1000);
    };

    const calculateEndTime = (unixTime) => {
        // Adding 3600 seconds (1 hour) to the current unix timestamp
        return unixTime + 3600;
    };

    const updateServiceScheduleCallFn = (e) => {
        e?.preventDefault();

        const startTimeUnix = convertToUnixTime();
        const endTimeUnix = calculateEndTime(startTimeUnix);

        setSaveUpdateTicketLoading(true);

        let formData = new FormData();

        formData.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        timeSlotID && formData.append("time_slot_id", parseInt(timeSlotID))
        communicationModeID && formData.append("communication_mode_id", parseInt(communicationModeID));

        formData.append("is_scheduling_flag", 1);
        formData.append("unix_datetime_stamp_start", startTimeUnix);
        formData.append("unix_datetime_stamp_end", endTimeUnix);

        dispatch(updateTicketDetail(formData, (res) => {

            setResponceMsg(res.data.message);
            setToasterType("success")

            handleCloseDocScheduleModal();

            // setHandleToaster(true);
            // setTimeout(() => {
            //     setHandleToaster(false);
            // }, 11000);

            setSaveUpdateTicketLoading(false);
            particularTicketDetails();


        }, (err) => {
            setSaveUpdateTicketLoading(false);

            setResponceMsg(err.data.message);
            setToasterType("error")

            setHandleToaster(true);
            setTimeout(() => {
                setHandleToaster(false);
            }, 11000);
        }))
    }
    // Scheduling ends here -----------

    useEffect(() => {
        if (receiverData.ticket_status_ysn === 2) {
            setJobStatus(2)
        }
    }, [receiverData])

    // Re-assign the services by company admin functions
    const [searchValue, setSearchValue] = useState("")
    const [userId, setUserId] = useState("")
    const [userInvitationId, setUserInvitationId] = useState("")
    const [elements, setElements] = useState([])
    const [isProSelected, setIsProSelected] = useState(false)
    const [reAssignViaRoleLoading, setReAssingViaRoleLoading] = useState(false)
    const [reAssignServiceModalTrigger, setReAssignServiceModalTrigger] = useState(false);
    const handleOpenReAssignServiceModal = () => {
        setReAssignServiceModalTrigger(true)
    }
    const handleCloseReAssignServiceModal = () => {
        setReAssignServiceModalTrigger(false)
        setUserId('');
        setUserInvitationId('');
        setIsProSelected(false);
    }

    const getInviteAndRegisteredUserFn = () => {

        if (searchValue.length > 2 || searchValue.length == 0) {
            setElements([])

            const data = new FormData();
            data.append("user_id_ids", localStorage.getItem("user_id"));
            data.append("role_id_int", 1)
            data.append("pagination_flag", 0);
            data.append("page_index", 1);
            data.append("page_size", 10000);
            data.append("sorting_order", "ASC");
            data.append("sorting_column_name", "");
            data.append("search_area", searchValue);

            dispatch(
                getInviteAndRegisteredUsersApi(data, (res) => {

                    setElements(res.data.data);

                }, (err) => {

                })
            );
        }
    }

    useEffect(() => {
        if (reAssignServiceModalTrigger) {
            getInviteAndRegisteredUserFn();
        }
    }, [searchValue, reAssignServiceModalTrigger])

    const handleReAssignViaRoleFn = (e) => {
        e.preventDefault();
        // console.log(dateTime, unixTimestamp, unixEndTime);

        // const startTimeUnix = convertToUnixTime();
        // const endTimeUnix = calculateEndTime(startTimeUnix);


        if (userId || userInvitationId) {
            setReAssingViaRoleLoading(true)
            let data = new FormData();

            data.append("user_id_ids", localStorage.getItem("user_id"));


            data.append("ticket_id_ids", localStorage.getItem("ticket_id"));

            userInvitationId && data.append("invitation_id_chr", userInvitationId);
            userId && data.append("assigned_to_chr", userId);

            dispatch(
                reAssignViaRoleApi(
                    data,
                    (res) => {
                        setReAssingViaRoleLoading(false)

                        handleCloseReAssignServiceModal();

                        particularTicketDetails();

                        setResponceMsg(res.data.message);
                        setToasterType("success");
                        // setHandleToaster(true);
                        // setTimeout(() => {
                        //   setHandleToaster(false);
                        // }, 11000);
                    },
                    (err) => {
                        setReAssingViaRoleLoading(false)
                        setResponceMsg(err.data.message);
                        setToasterType("error");
                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    }
                )
            );

        } else {
            setIsProSelected(true)
        }
    }

    // Function for accepting the Global Tickets 
    const acceptAssignedTicketFn = () => {
        setDialogLoader(true);
        const data = new FormData();

        data.append("ticket_id_ids", localStorage.getItem("ticket_id"))
        data.append("user_id_ids", localStorage.getItem("user_id"))

        dispatch(
            acceptAssignedTicketApi(data,
                (res) => {
                    setResponceMsg(res.data.message);
                    // ticketStatus();
                    particularTicketDetails();
                    setToasterType("success")
                    // navigate('/callHistory')
                    // setDialogLoader(false);

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                },
                (res) => {
                    console.log(res);
                    setDialogLoader(false);
                    particularTicketDetails();
                    setResponceMsg(res.data.message);
                    setToasterType("error")

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                },
            )
        )
    }

    // Call recordings functions are start here ->>
    const [callLogIdsArr, setCallLogIdsArr] = useState([]);
    const [getCallRecordingsLoading, setGetCallRecordingsLoading] = useState(false);
    const [callRecordingsArr, setCallRecordingsArr] = useState([]);

    const [getComposeRecordingsLoading, setGetComposeRecordingsLoading] = useState(false);
    const [composeRecordingsArr, setComposeRecordingsArr] = useState([]);

    useEffect(() => {
        if (callLogIdsArr?.length > 0) {
            callLogIdsArr?.map((item, index) => {
                console.log(item, "call log ids");
                handleCallRecordingsFn(item)
            })
        }
    }, [callLogIdsArr]);

    const handleCallRecordingsFn = (callLogId) => {
        if (callLogId) {
            setGetCallRecordingsLoading(true);
            setGetComposeRecordingsLoading(true);
            let details = {
                call_log_id: callLogId,
                page_index: 1,
                page_size: 1000,
                sorting_order: 'DESC',
                // sorting_column_name: columnName,
                // search_area: searchValue,
            };

            dispatch(
                getCallRecordingsApi(details, (res) => {
                    // setElements(res.data.data);
                    setGetCallRecordingsLoading(false);
                    //    console.log(res?.data?.data, 'call recordings data')

                    setCallRecordingsArr(prevState => [...prevState, res?.data?.data[0]]);


                }, (err) => {
                    setGetCallRecordingsLoading(false);
                })
            );


            // Composed recordings are combined in getCallRecordingsApi itself
            // dispatch(
            //     getComposeRecordingsApi(details, (res) => {
            //         console.log(res?.data?.data, 'compose recordings data')
            //         // setElements(res.data.data);
            //         //    console.log(res?.data?.data, 'call recordings data')
            //         setGetComposeRecordingsLoading(false);
            //         setComposeRecordingsArr(prevState => [...prevState, res?.data?.data[0]]);

            //     }, (err) => {
            //         setGetComposeRecordingsLoading(false);
            //     })
            // );
        }
    }



    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;

        if (minutes === 0) {
            return `${remainingSeconds} seconds`;
        } else if (remainingSeconds === 0) {
            return `${minutes} min`;
        } else {
            return `${minutes} min ${remainingSeconds} seconds`;
        }
    }

    const [videoAudioURL, setVideoAudioURL] = useState('');
    const [openVideoAudio, setOpenVideoAudio] = useState(false);

    const handleOpenVideoAudio = () => {
        setOpenVideoAudio(true);
    }
    const handleCloseVideoAudio = () => {
        setOpenVideoAudio(false);
        setVideoAudioURL('');
    }


    // Update service summary
    const handleUpdateTicketSummary = (e, recommendedVal = 0) => {
        e?.preventDefault();

        setToggleEditProDiagnosis(false);

        const safeNum = (val) => isNaN(parseFloat(val)) ? 0 : parseFloat(val);

        if (recommendedVal == 3) {
            var formattedDate = new Date(currentDateLocalPro).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
            });

            function to12Hour(time24) {
                // expects "HH:MM"
                const [hStr, mStr] = time24.split(":");
                let h = Number(hStr);
                const suffix = h >= 12 ? "PM" : "AM";
                h = h % 12 || 12; // 0 -> 12, 13 -> 1, etc.
                return `${h}:${mStr} ${suffix}`;
            }


            var formattedTime = to12Hour(currentTimeLocalPro);
            // console.log(formattedDate, formattedTime);


            if (!termsAndConditions && recommendedVal == 3) {
                setTermsAndConditionsErr(true);
                return;
            }
        }


        let summary_meta_data = {
            recognized_image_summary: serviceSummaryMetaData?.recognized_image_summary || '',
            recognized_estimation_summary: serviceSummaryMetaData?.recognized_estimation_summary || '',
            recognized_repair_and_install_summary: serviceSummaryMetaData?.recognized_repair_and_install_summary || '',
            estimate_costing: {
                cost: safeNum(serviceSummaryMetaData?.estimate_costing?.cost),
                disposal_cost: safeNum(serviceSummaryMetaData?.estimate_costing?.disposal_cost),
                labor_cost: safeNum(serviceSummaryMetaData?.estimate_costing?.labor_cost),
                total_range: safeNum(serviceSummaryMetaData?.estimate_costing?.total_range),
            },
            repair_install_costing: {
                estimated_cost_by_pro: safeNum(serviceSummaryMetaData?.repair_install_costing?.estimated_cost_by_pro),
            },
            pro_check_info: {
                pro_diagnosis: proDiagnosis || serviceSummaryMetaData?.pro_check_info?.pro_diagnosis || '',
                pro_estimated_cost_min: safeNum(serviceSummaryMetaData?.pro_check_info?.pro_estimated_cost_min),
                pro_estimated_cost_max: safeNum(serviceSummaryMetaData?.pro_check_info?.pro_estimated_cost_max),
                pro_recommended_solution: proRecommendedSolution || 0,
                // pro_recommended_solution: recommendedVal || proRecommendedSolution || 0,
            },
            customer_check_info: {
                customer_selected_solution: recommendedVal || customerSelectedSolution || 4,
            },
            estimated_by_customer: {
                date: customerSelectedSolution == 3 ? localProSectionDateTime == 1 ? '' : localProSectionDateTime == 2 ? formattedDate : (serviceSummaryMetaData?.estimated_by_customer?.date || '') : (serviceSummaryMetaData?.estimated_by_customer?.date || ''),
                time: customerSelectedSolution == 3 ? localProSectionDateTime == 1 ? '' : localProSectionDateTime == 2 ? formattedTime : (serviceSummaryMetaData?.estimated_by_customer?.time || '') : (serviceSummaryMetaData?.estimated_by_customer?.time || ''),
                max_cost: customerSelectedSolution == 3 ? safeNum(customerEstimatedCostMax) : safeNum(serviceSummaryMetaData?.estimated_by_customer?.max_cost) || '',
                min_cost: customerSelectedSolution == 3 ? safeNum(customerEstimatedCostMin) : safeNum(serviceSummaryMetaData?.estimated_by_customer?.min_cost) || '',
            },
            is_estimations_call: serviceSummaryMetaData?.is_estimations_call,
            is_recommendation_updated_by_cust: 1,
        }

        // console.log(summary_meta_data, "summary_meta_data");

        setUpdateTicketSummaryLoading(true);

        // setProductManualFlag(val);

        let formData = new FormData();

        formData.append("ticket_id", localStorage.getItem("ticket_id"));
        formData.append("summary", JSON.stringify(summary_meta_data));
        formData.append("customer_selected_solution", recommendedVal || customerSelectedSolution || 4);

        if (recommendedVal == 3) {
            formData.append("is_local_pro_flag", 1);
            callLogIdsArr?.length > 0 && formData.append("call_log_id", callLogIdsArr[0]);
        }

        dispatch(
            updateTicketSummaryApi(
                formData,
                (res) => {
                    // console.log(res?.data?.data?.['Model number'], "res?.data?.data?.['Model number']");

                    // console.log(res?.data?.data?.manual, "here");

                    setToggleForEstimationsTab('1');
                    particularTicketDetails();

                    if (recommendedVal == 3) {
                        // setTabsToggleServiceReq(1);
                        let formData = new FormData();
                        // formData.append("ticket_id_ids", localStorage.getItem("ticket_id"));
                        formData.append("ticket_id_ids", localStorage.getItem("ticket_id"));
                        formData.append("ticket_status_ysn", 1);

                        setToggleForLocalProModal('2');
                        setUpdateTicketSummaryLoading(false);

                        // dispatch(updateTicketStatus(formData, (res) => {
                        //     setToggleForLocalProModal('2');
                        //     setUpdateTicketSummaryLoading(false);
                        //     // console.log(res)
                        //     setResponceMsg(res.data.message);
                        //     setToasterType("success")

                        //     particularTicketDetails();
                        //     setStatusUpdateLoader(false);

                        //     // setHandleToaster(true);
                        //     // setTimeout(() => {
                        //     //     setHandleToaster(false);
                        //     // }, 11000);

                        // }), (res) => {
                        //     console.log(res);
                        //     setResponceMsg(res.data.message);
                        //     setToasterType("error")
                        //     setStatusUpdateLoader(false);

                        //     setHandleToaster(true);
                        //     setTimeout(() => {
                        //         setHandleToaster(false);
                        //     }, 11000);
                        // })
                    }
                },
                (res) => {
                    console.log(res);
                    setUpdateTicketSummaryLoading(false);

                    setResponceMsg(res.data.message);
                    setToasterType("error");

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        );

    }

    const handleCreateDIYProject = async (file) => {
        setCreateUpdateProjectLoading(true);
        // const res = await fetch(file,
        //     {
        //         mode: 'cors',
        //         method: "GET",
        //         headers: {
        //             "Content-Type": "multipart/form-data",
        //             "Access-Control-Allow-Origin": "*",
        //             devicetype: "BROWSER",
        //         },
        //     }
        // );
        // // if (!res.ok) {
        // //     throw new Error('Failed to fetch image');
        // // }
        // const blob = await res.blob();

        // if (projectTitle === '') {
        //     setProjectTitleErr(true);
        // }

        // if (projectDescription === '' || projectDescription?.length < 10) {
        //     setProjectDescriptionErr(true);
        // }

        // if (!AITermsAndConditions) {
        //     setAITermsAndConditionsErr(true);
        // }

        // if (projectDescription !== '' && projectDescription?.length > 10 && AITermsAndConditions) {
        let projectDescription = '';
        if (receiverData?.problem_description_chr) {
            projectDescription = receiverData?.problem_description_chr;
        } else if (proDiagnosis) {
            projectDescription = proDiagnosis;
        } else if (serviceSummaryMetaData?.recognized_image_summary) {
            projectDescription = serviceSummaryMetaData?.recognized_image_summary;
        } else if (receiverData?.product_type_chr) {
            projectDescription = `The issue is with my ${receiverData?.product_type_chr} device`;
        } else {
            projectDescription = `The issue is with my ${receiverData?.category_display_name_chr} device`;
        }

        let formData = new FormData();

        formData.append("user_id_ids", localStorage.getItem("user_id"));
        formData.append("ticket_id", localStorage.getItem("ticket_id"));
        // formData.append("project_id_ids", projectId);
        formData.append("project_title_chr", `${receiverData?.product_type_chr ? receiverData?.product_type_chr : receiverData?.category_display_name_chr} Project`);
        formData.append("category_name_chr", receiverData?.category_name_chr);
        formData.append("project_description_chr", `${projectDescription}`);
        // formData.append("project_description_chr", `${receiverData?.product_type_chr ? receiverData?.product_type_chr : receiverData?.category_display_name_chr}`);
        // projectBudget && formData.append("budget_in_cents_float", parseFloat(projectBudget * 100));
        // projectPriorityLevel && formData.append("priority_int", projectPriorityLevel);
        // formData.append("difficulty_level_int", difficultyRangeValue);
        // formData.append("project_status_int", '');
        // projectCompletionDateUnix && formData.append("completion_date_dtm", projectCompletionDateUnix);

        // formData.append("attachment_id_ids0", '');
        // blob && formData.append("attachment0", file);
        // uploadAttachedImage1 != null && formData.append("attachment_id_ids1", attachedImage1Id || '');
        // uploadAttachedImage1 != null && formData.append("attachment1", uploadAttachedImage1);
        // uploadAttachedImage2 != null && formData.append("attachment_id_ids2", attachedImage2Id || '');
        // uploadAttachedImage2 != null && formData.append("attachment2", uploadAttachedImage2);

        dispatch(createUpdateProjectApi(formData, (res) => {
            setCreateUpdateProjectLoading(false);
            // console.log(res.data.data, "Create update project data");
            setResponceMsg(res.data.message);

            if (res?.data?.data?.project_id_ids) {
                setProjectId(res?.data?.data?.project_id_ids);
                localStorage.setItem("projectId", res?.data?.data?.project_id_ids);
                localStorage.setItem("DIYprojectStep", 3);
                navigate('/DIYproject')
            }

        }, (err) => {
            setCreateUpdateProjectLoading(false);

            setResponceMsg(err.data.message);
            setToasterType("error")

            setHandleToaster(true);
            setTimeout(() => {
                setHandleToaster(false);
            }, 11000);
        }))
        // }
    }

    const handleCreateDIYProjectNewFlow = () => {
        let projectDescription = '';
        if (receiverData?.problem_description_chr) {
            projectDescription = receiverData?.problem_description_chr;
        } else if (proDiagnosis) {
            projectDescription = proDiagnosis;
        } else if (serviceSummaryMetaData?.recognized_image_summary) {
            projectDescription = serviceSummaryMetaData?.recognized_image_summary;
        } else if (receiverData?.product_type_chr) {
            projectDescription = `The issue is with my ${receiverData?.product_type_chr} device`;
        } else {
            projectDescription = `The issue is with my ${receiverData?.category_display_name_chr} device`;
        }
        localStorage.setItem("DIYprojectDesc", projectDescription);
        localStorage.setItem("DIYprojectStep", 1);
        navigate('/DIYproject');
    }

    const handleCustomerSelectedSolutionFn = (e) => {
        if (customerSelectedSolution == 1) {
            if (receiverData?.project_id_lng) {
                localStorage.setItem("projectId", receiverData?.project_id_lng);
                localStorage.setItem("DIYprojectStep", 3);
                navigate('/DIYproject')
            } else {
                // handleCreateDIYProject(attachmentsArr[0].url);
                handleCreateDIYProjectNewFlow();
                handleUpdateTicketSummary(e, 1);
            }
        } else if (customerSelectedSolution == 2) {
            if (cardArr?.length === 0 && sentRequest?.length > 0) {
                setAlertCardsModalTrigger(true);
            } else {
                handleShowConfirmationForConnectToProModal();
            }
        } else if (customerSelectedSolution == 3) {
            handleOpenLocalProModal();
        }
    }

    return (
        <>

            <>
                <div className='row mx-0 mt-3'>
                    <div className='col-12 px-2'>

                        {/* Service Request Details */}

                        <div className='row mx-0  w-100 h-100' style={{ minHeight: 'calc(100vh - 200px)' }} >
                            <div className='col-12  d-flex flex-column' >


                                {/* Open Jobs */}
                                <div className='row mx-0 h-100' >
                                    <div className='col-12 d-flex'>
                                        <div onClick={backToPrevious} className='overlay-action-btn text-hovered py-1 pe-3 fs-5 font-w500 cursor-pointer rounded-1 mb-1 d-flex align-items-center'>
                                            <i class="bi bi-arrow-left-short pe-2"></i>
                                            <span>{"Back"}</span>
                                        </div>
                                    </div>

                                    <div className='col-12 px-0 shadow-lg'
                                        style={{
                                            minHeight: 'calc(100% - 40px)',
                                            borderRadius: '16px'
                                        }}
                                    >
                                        <div className='row mx-0 h-100 custome-row'>
                                            <>
                                                {/* Open Jobs left side image  */}
                                                {window.innerWidth > 768 &&
                                                    <div
                                                        className='col-lg-6 px-0 d-flex flex-column justify-content-between border-end'
                                                        style={{}}
                                                        ref={imageRef}
                                                    >
                                                        <div
                                                            style={{
                                                                minHeight: attachmentsArr?.length > 0 ? 'calc(100% - 130px)' : 'calc(100% - 67px)'
                                                            }}
                                                        >
                                                            <div className='w-100 h-100 position-relative d-flex align-items-center justify-content-center'
                                                                style={{
                                                                    minHeight: '250px',
                                                                    background: 'rgba(244, 248, 255, 1)'
                                                                }}
                                                            >
                                                                {receiverData?.category_display_name_chr !== null ?
                                                                    <div className='position-absolute px-3 py-1 rounded-pill fs-7 text-white font-w700'
                                                                        style={{
                                                                            top: '10px',
                                                                            left: '10px',
                                                                            background: 'rgba(79, 93, 116, 1)',
                                                                            zIndex: 1,
                                                                        }}
                                                                    >
                                                                        <span>{` ${receiverData?.category_display_name_chr} ${((receiverData.product_type_chr !== "null") && (receiverData.product_type_chr !== null) && (receiverData.product_type_chr !== "")) ? `/ ${receiverData?.product_type_chr}` : ''}`}</span>
                                                                    </div> :
                                                                    <div className='position-absolute px-3 py-1 rounded-pill fs-7 text-white font-w700'
                                                                        style={{
                                                                            top: '10px',
                                                                            left: '10px',
                                                                            background: 'rgba(199, 212, 234, 1)',
                                                                            zIndex: 1,
                                                                        }}
                                                                    >
                                                                        <span>{`No category`}</span>
                                                                    </div>
                                                                }

                                                                {attachmentsArr?.length > 0 ?
                                                                    <></> :
                                                                    <div className='position-absolute px-3 py-1 rounded-pill fs-4 font-w700'
                                                                        style={{
                                                                            bottom: '10px',
                                                                            left: '50%',
                                                                            transform: 'translateX(-50%)',
                                                                            color: 'rgba(199, 212, 234, 1)'
                                                                        }}
                                                                    >
                                                                        <span>{`No photo`}</span>
                                                                    </div>
                                                                }

                                                                {attachmentsArr?.length > 0 ?
                                                                    <>
                                                                        {isLoadingImg &&
                                                                            <div
                                                                                className='w-100 h-100 d-flex justify-content-center align-items-center overflow-hidden'
                                                                                style={{
                                                                                    maxWidth: `${imgMaxWidth}px`,
                                                                                    maxHeight: `${imgMaxHeight}px`,
                                                                                    minWidth: `${imgMaxWidth}px`,
                                                                                    minHeight: `${imgMaxHeight}px`,
                                                                                    width: "100%",
                                                                                    height: "100%",
                                                                                }}
                                                                            >
                                                                                <Spinner animation="border" size="lg" style={{}} />
                                                                            </div>
                                                                        }
                                                                        <div
                                                                            className='w-100 h-100 d-flex justify-content-center align-items-center overflow-hidden'
                                                                            style={{ borderRadius: '15px 0 0 0', cursor: dragging ? 'grabbing' : 'grab' }}
                                                                            onMouseMove={handleDragging}
                                                                            onMouseLeave={handleDragEnd}
                                                                            onMouseUp={handleDragEnd}
                                                                            onTouchMove={handleDragging}
                                                                            onTouchEnd={handleDragEnd}
                                                                        >
                                                                            <img
                                                                                src={attachmentsArr[attachImageIndex]?.url}
                                                                                alt=""
                                                                                className=''
                                                                                onLoad={handleImageLoaded}
                                                                                onError={handleImageError}
                                                                                onMouseDown={handleDragStart}
                                                                                onTouchStart={handleDragStart}
                                                                                style={{
                                                                                    maxWidth: `${imgMaxWidth}px`,
                                                                                    maxHeight: `${imgMaxHeight}px`,
                                                                                    minWidth: `${imgMaxWidth}px`,
                                                                                    minHeight: `${imgMaxHeight}px`,
                                                                                    width: "100%",
                                                                                    height: "100%",
                                                                                    objectFit: "contain",
                                                                                    borderRadius: "15px 0 0 0",
                                                                                    transition: 'transform 0.25s ease',
                                                                                    transformOrigin: 'center',
                                                                                    transform: `scale(${scale}) translate(${position.x}px, ${position.y}px)`,
                                                                                    cursor: dragging ? 'grabbing' : 'grab',
                                                                                    display: isLoadingImg ? 'none' : 'block'
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </> :
                                                                    // <div className='fs-1 text-black'>
                                                                    //     <i class="bi bi-file-image-fill"></i>
                                                                    // </div>

                                                                    <div>
                                                                        <img src={unavailableServiceImgLogo} alt="" style={{ width: '150px' }} />
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>


                                                        <div className='row mx-0 pb-3'
                                                            style={{
                                                                zIndex: 1,
                                                                background: 'rgb(199 212 234 / 32%)',
                                                                borderBottomLeftRadius: '16px',
                                                            }}
                                                        >
                                                            {attachmentsArr?.length > 0 &&
                                                                <div className="align-items-center border-2 border-bottom border-white d-flex justify-content-center">
                                                                    <span className="fs-6 font-w600 pe-2">{`Zoom`}</span>
                                                                    <input
                                                                        className=""
                                                                        type="range"
                                                                        min="1"
                                                                        max="3"
                                                                        value={scale}
                                                                        step="0.1"
                                                                        onChange={handleZoomChange}
                                                                        style={{
                                                                            width: '75%',
                                                                            margin: '15px 0',
                                                                            cursor: 'pointer',
                                                                            background: 'linear-gradient(to right, #ddd 0%, #ddd 100%)',
                                                                            borderRadius: '5px',
                                                                            height: '4px',
                                                                            outline: 'none',
                                                                            opacity: '0.7',
                                                                            transition: 'opacity 0.2s',
                                                                        }}
                                                                    />
                                                                    {(scale !== 1 || position.x !== 0 || position.y !== 0) &&
                                                                        <div className=' ms-2'>
                                                                            <div className="tooltipCustom">
                                                                                <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Reset photo"}</span>
                                                                                <i
                                                                                    class="bi bi-arrow-clockwise fs-4 text-black text-hovered cursor-pointer"
                                                                                    onClick={() => {
                                                                                        handleResetImage();
                                                                                    }}
                                                                                ></i>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            }

                                                            <div className='col-12 px-3 d-flex flex-column mt-2'>
                                                                <div className='row mx-0 ' style={{ minHeight: '45px' }}>
                                                                    <div className='col-2 pe-2'>
                                                                        <div
                                                                            onClick={() => {
                                                                                handlePrevAttachImg();
                                                                            }}
                                                                            className='border w-100 h-100 d-flex align-items-center justify-content-center fs-4 fw-bold text-black border border-dark cursor-pointer text-hovered border-hovered'
                                                                            style={{
                                                                                pointerEvents: attachImageIndex === 0 ? 'none' : 'auto',
                                                                                opacity: attachImageIndex === 0 ? '0.5' : '1',
                                                                                borderRadius: '10px',
                                                                            }}
                                                                        >
                                                                            <i className="bi bi-arrow-left"></i>
                                                                        </div>
                                                                    </div>

                                                                    <div className='col-8 pe-2 d-flex  align-items-center justify-content-center overflow-auto' style={{ minHeight: '100%' }}>
                                                                        {
                                                                            attachmentsArr?.length > 0 ?

                                                                                <>
                                                                                    {attachmentsArr.map((attachment, index) => {
                                                                                        return (
                                                                                            <div
                                                                                                onClick={() => {
                                                                                                    handleImageIndex(index);
                                                                                                }}
                                                                                                key={index}
                                                                                                className={` h-100 mx-1 bg-light d-flex align-items-center justify-content-center fs-4 text-black cursor-pointer ${index === attachImageIndex && 'shadow-lg'}`}
                                                                                                style={{
                                                                                                    width: '40px',
                                                                                                    minWidth: '40px',
                                                                                                    border: index === attachImageIndex ? '2px solid orange' : '1px solid gray',
                                                                                                    borderRadius: '10px',
                                                                                                }}
                                                                                            >
                                                                                                <img
                                                                                                    src={attachment?.url}
                                                                                                    alt=""
                                                                                                    className='w-100 h-100 '
                                                                                                    style={{
                                                                                                        objectFit: 'cover',
                                                                                                        aspectRatio: '1',
                                                                                                        borderRadius: index === attachImageIndex ? '8px' : '10px',
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                        )
                                                                                    })}
                                                                                </>
                                                                                :
                                                                                <>
                                                                                    <div
                                                                                        className={` h-100 mx-2 bg-light d-flex align-items-center justify-content-center fs-4 text-black cursor-pointer`}
                                                                                        style={{ width: '40px', border: '2px solid black' }}
                                                                                    >
                                                                                        <i class="bi bi-file-image-fill"></i>
                                                                                    </div>
                                                                                </>
                                                                        }
                                                                    </div>

                                                                    <div className='col-2 pe-1 '>
                                                                        <div
                                                                            onClick={() => {
                                                                                handleNextAttachImg();
                                                                            }}
                                                                            className=' border w-100 h-100 d-flex align-items-center justify-content-center fs-4 fw-bold text-black border border-dark cursor-pointer text-hovered border-hovered'
                                                                            style={{
                                                                                pointerEvents: (attachImageIndex >= attachmentsArr?.length - 1) ? 'none' : 'auto',
                                                                                opacity: (attachImageIndex >= attachmentsArr?.length - 1) ? '0.5' : '1',
                                                                                borderRadius: '10px',
                                                                            }}
                                                                        >
                                                                            <i className="bi bi-arrow-right"></i>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>


                                                    </div>
                                                }

                                                {/* Open Jobs rigth side content  */}

                                                <div
                                                    className='col-lg-6 px-0 d-flex flex-column justify-content-between'
                                                    style={{
                                                        background: 'linear-gradient(182deg, rgb(250 238 227 / 67%) 33%, rgb(255, 255, 255) 85%)',
                                                    }}
                                                >
                                                    <div className=''>

                                                        {/* Most new design Navigations profile */}
                                                        <div
                                                            className='border-bottom overflow-auto row text-nowrap user-profile-nav-bar whitespace-nowrap'
                                                        >
                                                            <div className='col-12 d-flex px-0 fs-5 font-w500'>
                                                                <div
                                                                    onClick={() => {
                                                                        // setTabsToggle(1)
                                                                        setTabsToggleServiceReq(1);
                                                                    }}
                                                                    className={`cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center px-4 py-3 position-relative`}
                                                                    style={{}}
                                                                >
                                                                    <span className={`${tabsToggleServiceReq === 1 ? "text-black" : "text-grey"} ${tabsToggleServiceReq === 1 && "fw-bold"}`} >{"Info"}</span>
                                                                    {tabsToggleServiceReq === 1 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px" }}> </div>}
                                                                </div>

                                                                {((receiverData?.ticket_type_int == 1) || (receiverData?.ticket_type_int == 2)) &&
                                                                    <div
                                                                        onClick={() => {
                                                                            // setTabsToggle(2)
                                                                            setTabsToggleServiceReq(6);
                                                                        }}
                                                                        className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center px-4 py-3 position-relative'
                                                                        style={{}}
                                                                    >
                                                                        <span className={`${tabsToggleServiceReq === 6 ? "text-black" : "text-grey"} ${tabsToggleServiceReq === 6 && "fw-bold"}`}>
                                                                            {receiverData?.ticket_type_int == 1 ?
                                                                                <>{"Estimate"}</> :
                                                                                receiverData?.ticket_type_int == 2 ?
                                                                                    <>{"Repair and Install"}</> : <>{"Service Summary"}</>
                                                                            }
                                                                        </span>
                                                                        {tabsToggleServiceReq === 6 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                                                                    </div>
                                                                }

                                                                {((receiverData.ticket_status_ysn !== 1) || receiverData.created_by_chr == localStorage.getItem("user_id")) &&
                                                                    <div
                                                                        onClick={() => {
                                                                            // setTabsToggle(3)
                                                                            setTabsToggleServiceReq(5);
                                                                            callNoteData();
                                                                        }}
                                                                        className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center px-4 py-3 position-relative'
                                                                        style={{}}
                                                                    >
                                                                        {/* Pro connection with own customers flow changes condition removed -> (serviceRequestFlagPro != 1)) */}
                                                                        {/* <span className={`${userProfileTab === 3 ? "text-black" : "text-grey"} ${userProfileTab === 3 && "fw-bold"}`}>{`Payments ${((permissionArray.includes("UPDATE WORK INFORMATION") || (role == 4)) && (serviceRequestFlagPro != 1)) ? "and Payouts" : ""} `}</span> */}
                                                                        <span className={`${tabsToggleServiceReq === 5 ? "text-black" : "text-grey"} ${tabsToggleServiceReq === 5 && "fw-bold"}`}>{`Notes`}</span>
                                                                        {tabsToggleServiceReq === 5 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                                                                        {notesCount > 0 &&
                                                                            <span
                                                                                className="px-2 rounded-pill d-flex align-items-center justify-content-center font-w600"
                                                                                style={{
                                                                                    // background: 'rgba(131, 154, 192, 1)',
                                                                                    color: 'rgba(252, 74, 26, 1)'
                                                                                }}
                                                                            >
                                                                                {/* {`${callNoteDetailsArr?.length || 0}`} */}
                                                                                {`(${notesCount})`}
                                                                            </span>
                                                                        }
                                                                    </div>
                                                                }




                                                                {((receiverData.ticket_status_ysn !== 1) || receiverData.created_by_chr == localStorage.getItem("user_id")) &&
                                                                    <div
                                                                        onClick={() => {
                                                                            // setTabsToggle(5)
                                                                            setTabsToggleServiceReq(2);
                                                                            onLoadData();
                                                                        }}
                                                                        className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center px-4 py-3 position-relative'
                                                                        style={{}}
                                                                    >
                                                                        <span className={`${tabsToggleServiceReq === 2 ? "text-black" : "text-grey"} ${tabsToggleServiceReq === 2 && "fw-bold"}`}>{"List"}</span>
                                                                        {tabsToggleServiceReq === 2 && <div className='position-absolute w-100 bg-black' style={{ height: "3px", bottom: "0px" }}> </div>}
                                                                        {notPurchasedShoppingItemCount > 0 && <span
                                                                            className="px-2 rounded-pill d-flex align-items-center justify-content-center font-w600"
                                                                            style={{
                                                                                // background: 'rgba(131, 154, 192, 1)',
                                                                                color: 'rgba(252, 74, 26, 1)'
                                                                            }}
                                                                        >
                                                                            {/* {`${rows.length || 0}`} */}
                                                                            {`(${notPurchasedShoppingItemCount})`}
                                                                        </span>}
                                                                    </div>
                                                                }

                                                                <div
                                                                    onClick={() => {
                                                                        // setTabsToggle(5)
                                                                        setTabsToggleServiceReq(3);
                                                                    }}
                                                                    className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center px-4 py-3 position-relative'
                                                                    style={{}}
                                                                >
                                                                    <span className={`${tabsToggleServiceReq === 3 ? "text-black" : "text-grey"} ${tabsToggleServiceReq === 3 && "fw-bold"}`}>{"Call History"}</span>
                                                                    {tabsToggleServiceReq === 3 && <div className='position-absolute w-100 bg-black' style={{ height: "3px", bottom: "0px" }}> </div>}
                                                                    {callCount > 0 &&
                                                                        <span
                                                                            className="px-2 rounded-pill d-flex align-items-center justify-content-center font-w600"
                                                                            style={{
                                                                                // background: 'rgba(131, 154, 192, 1)',
                                                                                color: 'rgba(252, 74, 26, 1)',
                                                                            }}
                                                                        >
                                                                            {/* {`${sentRequest.length || 0}`} */}
                                                                            {`(${callCount})`}
                                                                        </span>
                                                                    }
                                                                </div>

                                                                <div
                                                                    onClick={() => {
                                                                        // setTabsToggle(5)
                                                                        setTabsToggleServiceReq(4);
                                                                        getServiceRequestHistoryFn();
                                                                    }}
                                                                    className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center px-4 py-3 position-relative'
                                                                    style={{}}
                                                                >
                                                                    <span className={`${tabsToggleServiceReq === 4 ? "text-black" : "text-grey"} ${tabsToggleServiceReq === 4 && "fw-bold"}`}>{"Service History"}</span>
                                                                    {tabsToggleServiceReq === 4 && <div className='position-absolute w-100 bg-black' style={{ height: "3px", bottom: "0px" }}> </div>}
                                                                    {serviceReqHistoryCount > 0 &&
                                                                        <span
                                                                            className="px-2 rounded-pill d-flex align-items-center justify-content-center font-w600"
                                                                            style={{
                                                                                // top: '-9px',
                                                                                // right: '2px',
                                                                                // background: 'rgba(131, 154, 192, 1)',
                                                                                color: 'rgba(252, 74, 26, 1)',
                                                                            }}
                                                                        >
                                                                            {/* {`${sentRequest.length || 0}`} */}
                                                                            {`(${serviceReqHistoryCount})`}
                                                                        </span>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>



                                                        {/* Ticket Status */}
                                                        {/* <div className='row mx-2 mt-2 bg-light py-3 px-2'>
                                                            <div className='col-6 d-flex px-3 '>
                                                                <span className='pe-2 text-black font-w600'>
                                                                    {"Status: "}
                                                                </span>
                                                                <span
                                                                    style={{
                                                                        color: (receiverData.ticket_status_ysn === 0 || receiverData.ticket_status_ysn === 1 || receiverData.ticket_status_ysn === 5) ? "blue" :
                                                                            receiverData.ticket_status_ysn === 2 ? "rgb(10, 201, 71)" :
                                                                                (receiverData.ticket_status_ysn === 6 || receiverData.ticket_status_ysn === 7) ? "red" : '',
                                                                        fontWeight: '700'
                                                                    }}
                                                                >
                                                                    {receiverData.ticket_status_ysn === 0 && "Closed"}
                                                                    {receiverData.ticket_status_ysn === 1 && "Open"}
                                                                    {receiverData.ticket_status_ysn === 2 && "In-Progress"}
                                                                    {receiverData.ticket_status_ysn === 5 && "Re-open"}
                                                                    {receiverData.ticket_status_ysn === 6 && "Incomplete"}
                                                                    {receiverData.ticket_status_ysn === 7 && "Cancelled"}
                                                                </span>
                                                            </div>
                                                            <div className='col-6 d-flex   px-3 '>
                                                                <span className='pe-2 text-black font-w600'>
                                                                    {"Earned: "}
                                                                </span>
                                                                <span>
                                                                    {"$0.00"}
                                                                </span>
                                                            </div>
                                                        </div> */}



                                                        {/* Old Navigations */}
                                                        {false &&
                                                            <div className=' px-2 my-1 border-bottom pb-2 overflow-auto row text-nowrap user-profile-nav-bar whitespace-nowrap '>
                                                                <div className='col-12 d-flex px-0 font-w500 pt-3 pb-1'>
                                                                    <span
                                                                        className=" d-flex align-items-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                                                                        style={{
                                                                            border: "1px solid rgba(131, 154, 192, 1)",
                                                                            fontWeight: "700",
                                                                            height: "40px",
                                                                            backgroundColor: tabsToggleServiceReq === 1 ? "rgba(79, 93, 116, 1)" : "white",
                                                                            color: tabsToggleServiceReq === 1 ? "white" : "rgba(131, 154, 192, 1)",
                                                                        }}
                                                                        onClick={() => {
                                                                            setTabsToggleServiceReq(1);
                                                                        }}
                                                                    >
                                                                        {`Info`}

                                                                    </span>

                                                                    {((receiverData?.ticket_type_int == 1) || (receiverData?.ticket_type_int == 2)) &&
                                                                        <span
                                                                            className=" d-flex align-items-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                                                                            style={{
                                                                                border: "1px solid rgba(131, 154, 192, 1)",
                                                                                fontWeight: "700",
                                                                                height: "40px",
                                                                                backgroundColor: tabsToggleServiceReq === 6 ? "rgba(79, 93, 116, 1)" : "white",
                                                                                color: tabsToggleServiceReq === 6 ? "white" : "rgba(131, 154, 192, 1)",
                                                                            }}
                                                                            onClick={() => {
                                                                                setTabsToggleServiceReq(6);
                                                                            }}
                                                                        >
                                                                            {receiverData?.ticket_type_int == 1 ?
                                                                                <>{"Estimate"}</> :
                                                                                receiverData?.ticket_type_int == 2 ?
                                                                                    <>{"Repair and Install"}</> : <>{"Service Summary"}</>
                                                                            }
                                                                        </span>
                                                                    }

                                                                    {((receiverData.ticket_status_ysn !== 1) || receiverData.created_by_chr == localStorage.getItem("user_id")) &&
                                                                        <span
                                                                            className=" d-flex align-items-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                                                                            style={{
                                                                                border: "1px solid rgba(131, 154, 192, 1)",
                                                                                fontWeight: "700",
                                                                                height: "40px",
                                                                                backgroundColor: tabsToggleServiceReq === 5 ? "rgba(79, 93, 116, 1)" : "white",
                                                                                color: tabsToggleServiceReq === 5 ? "white" : "rgba(131, 154, 192, 1)",
                                                                            }}
                                                                            onClick={() => {
                                                                                setTabsToggleServiceReq(5);
                                                                                callNoteData();
                                                                            }}
                                                                        >
                                                                            {`Notes`}
                                                                            {notesCount > 0 &&
                                                                                <span
                                                                                    className="px-2 py-1 fs-7 text-white position-absolute rounded-pill d-flex align-items-center justify-content-center font-w500"
                                                                                    style={{
                                                                                        top: '-9px',
                                                                                        right: '2px',
                                                                                        background: 'rgba(131, 154, 192, 1)',
                                                                                    }}
                                                                                >
                                                                                    {/* {`${callNoteDetailsArr?.length || 0}`} */}
                                                                                    {`${notesCount}`}
                                                                                </span>
                                                                            }
                                                                        </span>
                                                                    }

                                                                    {((receiverData.ticket_status_ysn !== 1) || receiverData.created_by_chr == localStorage.getItem("user_id")) &&
                                                                        <span
                                                                            className=" d-flex align-items-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                                                                            style={{
                                                                                border: "1px solid rgba(131, 154, 192, 1)",
                                                                                fontWeight: "700",
                                                                                height: "40px",
                                                                                backgroundColor: tabsToggleServiceReq === 2 ? "rgba(79, 93, 116, 1)" : "white",
                                                                                color: tabsToggleServiceReq === 2 ? "white" : "rgba(131, 154, 192, 1)",
                                                                            }}
                                                                            onClick={() => {
                                                                                setTabsToggleServiceReq(2);
                                                                                onLoadData();
                                                                            }}
                                                                        >
                                                                            {`List`}

                                                                            {notPurchasedShoppingItemCount > 0 && <span
                                                                                className="px-2 py-1 fs-7 text-white position-absolute rounded-pill d-flex align-items-center justify-content-center font-w500"
                                                                                style={{
                                                                                    top: '-9px',
                                                                                    right: '2px',
                                                                                    background: 'rgba(131, 154, 192, 1)',
                                                                                }}
                                                                            >
                                                                                {/* {`${rows.length || 0}`} */}
                                                                                {notPurchasedShoppingItemCount}
                                                                            </span>}

                                                                        </span>
                                                                    }

                                                                    <span
                                                                        className=" d-flex align-items-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                                                                        style={{
                                                                            border: "1px solid rgba(131, 154, 192, 1)",
                                                                            fontWeight: "700",
                                                                            height: "40px",
                                                                            backgroundColor: tabsToggleServiceReq === 3 ? "rgba(79, 93, 116, 1)" : "white",
                                                                            color: tabsToggleServiceReq === 3 ? "white" : "rgba(131, 154, 192, 1)",
                                                                        }}
                                                                        onClick={() => {
                                                                            setTabsToggleServiceReq(3);
                                                                        }}
                                                                    >
                                                                        {`Call History`}

                                                                        {callCount > 0 &&
                                                                            <span
                                                                                className="px-2 py-1 fs-7 text-white position-absolute rounded-pill d-flex align-items-center justify-content-center font-w500"
                                                                                style={{
                                                                                    top: '-9px',
                                                                                    right: '2px',
                                                                                    background: 'rgba(131, 154, 192, 1)',
                                                                                }}
                                                                            >
                                                                                {/* {`${sentRequest.length || 0}`} */}
                                                                                {callCount}
                                                                            </span>
                                                                        }
                                                                    </span>

                                                                    <span
                                                                        className=" d-flex align-items-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                                                                        style={{
                                                                            border: "1px solid rgba(131, 154, 192, 1)",
                                                                            fontWeight: "700",
                                                                            height: "40px",
                                                                            backgroundColor: tabsToggleServiceReq === 4 ? "rgba(79, 93, 116, 1)" : "white",
                                                                            color: tabsToggleServiceReq === 4 ? "white" : "rgba(131, 154, 192, 1)",
                                                                        }}
                                                                        onClick={() => {
                                                                            setTabsToggleServiceReq(4);
                                                                            getServiceRequestHistoryFn();
                                                                        }}
                                                                    >
                                                                        {`Service History`}

                                                                        {serviceReqHistoryCount > 0 &&
                                                                            <span
                                                                                className="px-2 py-1 fs-7 text-white position-absolute rounded-pill d-flex align-items-center justify-content-center font-w500"
                                                                                style={{
                                                                                    top: '-9px',
                                                                                    right: '2px',
                                                                                    background: 'rgba(131, 154, 192, 1)',
                                                                                }}
                                                                            >
                                                                                {/* {`${sentRequest.length || 0}`} */}
                                                                                {serviceReqHistoryCount}
                                                                            </span>
                                                                        }
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        }

                                                        {/* Navigations send link */}
                                                        {/* <div className='border-bottom mx-2 mt-1 mb-1 overflow-auto row text-nowrap user-profile-nav-bar whitespace-nowrap'>
                                                            <div className='col-12 d-flex px-0 font-w500'>
                                                                <div onClick={() => setTabsToggleServiceReq(2)} className='col-6 px-0 align-items-cente cursor-pointer d-flex justify-content-center position-relative px-3 py-3' style={{}}>
                                                                    <span className={`${tabsToggleServiceReq === 2 ? "text-black" : "text-grey"} ${tabsToggleServiceReq === 1 && "fw-bold"}`} >{`Shopping list (${rows.length})`}</span>
                                                                    {tabsToggleServiceReq === 2 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px" }}> </div>}
                                                                </div>

                                                                <div onClick={() => setTabsToggleServiceReq(3)} className='col-6 px-0 align-items-cente cursor-pointer d-flex justify-content-center position-relative px-3 py-3' style={{}}>
                                                                    <span className={`${tabsToggleServiceReq === 3 ? "text-black" : "text-grey"} ${tabsToggleServiceReq === 2 && "fw-bold"}`}>{`Call history (${sentRequest.length})`}</span>
                                                                    {tabsToggleServiceReq === 3 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                                                                </div>

                                                            </div>
                                                        </div> */}

                                                        {/* Service Info */}
                                                        {tabsToggleServiceReq === 1 &&
                                                            <>
                                                                <div className='row  mx-2 mt-3'  >
                                                                    <div className='col-12 px-0  '>
                                                                        <div
                                                                            className='row mx-0 overflow-auto'
                                                                            style={{
                                                                                //  minHeight: "300px", 
                                                                                //  maxHeight: "300px",
                                                                                // maxHeight: `${imgMaxHeight - 120}px`,
                                                                                // minHeight: `${imgMaxHeight - 120}px`,
                                                                            }}
                                                                        >
                                                                            <div className='col-12 px-0  '>



                                                                                <div className='row mx-0 p-2 py-3 mb-2 rounded-2 bg-white shadow-sm'>
                                                                                    <div className='align-items-center col-12 d-flex fs-5 justify-content-between px-1 text-black mb-3'>
                                                                                        {receiverData?.category_display_name_chr !== null ?
                                                                                            <>
                                                                                                {receiverData?.category_display_name_chr &&
                                                                                                    <div className='px-3 py-1 rounded-3 fs-7 font-w600'
                                                                                                        style={{
                                                                                                            // top: '10px',
                                                                                                            // left: '10px',
                                                                                                            background: 'rgba(255, 231, 213, 1)',
                                                                                                            color: 'rgba(216, 122, 36, 1)',
                                                                                                            zIndex: 1,
                                                                                                        }}
                                                                                                    >
                                                                                                        <span>{` ${receiverData?.category_display_name_chr} ${((receiverData.product_type_chr !== "null") && (receiverData.product_type_chr !== null) && (receiverData.product_type_chr !== "")) ? `/ ${receiverData?.product_type_chr}` : ''}`}</span>
                                                                                                    </div>
                                                                                                }
                                                                                            </>
                                                                                            :
                                                                                            <div className='px-3 py-1 rounded-3 fs-7 font-w600'
                                                                                                style={{
                                                                                                    // top: '10px',
                                                                                                    // left: '10px',
                                                                                                    background: 'rgba(255, 231, 213, 1)',
                                                                                                    color: 'rgba(216, 122, 36, 1)',
                                                                                                    zIndex: 1,
                                                                                                }}
                                                                                            >
                                                                                                <span>{`No category`}</span>
                                                                                            </div>
                                                                                        }

                                                                                        <div className='d-flex fs-5 fw-bold justify-content-center align-items-start px-1 text-black'>
                                                                                            <>
                                                                                                <OverlayTrigger
                                                                                                    trigger="click"
                                                                                                    placement="bottom"
                                                                                                    overlay={popover}
                                                                                                    rootClose={true}
                                                                                                    show={showPopover}
                                                                                                    onToggle={(isOpen) => setShowPopover(isOpen)}
                                                                                                >
                                                                                                    <span className='cursor-pointer overlay-action-btn bg-light rounded-circle p-1 px-2 d-flex align-items-center justify-content-center'>
                                                                                                        <i class="bi bi-three-dots-vertical"></i>
                                                                                                    </span>
                                                                                                </OverlayTrigger>
                                                                                            </>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className='align-items-center col-12 d-flex fs-5 fw-bold justify-content-start px-1 text-black'>
                                                                                        <span>{`${receiverData?.msg_chr ? receiverData?.msg_chr : receiverData?.problem_description_chr ? receiverData?.problem_description_chr : "Problem description not specified"}`}</span>
                                                                                    </div>

                                                                                    {window.innerWidth < 768 &&
                                                                                        <>
                                                                                            {attachmentsArr?.length > 0 && (
                                                                                                <div className="row mt-4">

                                                                                                    {permissionArray.includes("SCAN TAB") && attachmentsArr.length < 3 &&
                                                                                                        <>
                                                                                                            {!saveUpdateTicketLoading ?
                                                                                                                <span
                                                                                                                    className='d-flex align-items-center fs-5 text-hovered cursor-pointer'
                                                                                                                    style={{ color: 'rgba(131, 154, 192, 1)', width: 'auto' }}
                                                                                                                    onClick={handleClickAttachedImage}
                                                                                                                >

                                                                                                                    <span
                                                                                                                        className='rounded-1 d-flex align-items-center justify-content-center font-w900 overlay-action-btn'
                                                                                                                        style={{
                                                                                                                            backgroundColor: "rgb(215 225 243)",
                                                                                                                            height: '55px',
                                                                                                                            width: '50px',
                                                                                                                            marginRight: "10px",
                                                                                                                            marginBottom: "10px",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <i className='bi bi-plus-circle' />
                                                                                                                    </span>

                                                                                                                    <input ref={attachedImageRef} type="file" accept="image/*" hidden onChange={(e) => { handleAttachedImage(e) }} />
                                                                                                                </span>
                                                                                                                :
                                                                                                                <span
                                                                                                                    className='d-flex align-items-center'
                                                                                                                    style={{ color: 'rgba(131, 154, 192, 1)', width: 'auto' }}
                                                                                                                // onClick={() => deleteAttachedImage()}
                                                                                                                >
                                                                                                                    <span
                                                                                                                        className='rounded-1 d-flex align-items-center justify-content-center font-w900'
                                                                                                                        style={{
                                                                                                                            backgroundColor: "rgb(215 225 243)",
                                                                                                                            height: '55px',
                                                                                                                            width: '50px',
                                                                                                                            marginRight: "10px",
                                                                                                                            marginBottom: "10px",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <Spinner size="sm" />
                                                                                                                    </span>
                                                                                                                    {/* <img className='rounded-1 mx-3 border ' src={attachedImage} style={{ height: '30px', width: '30px' }} alt="" /> */}
                                                                                                                </span>
                                                                                                            }
                                                                                                        </>
                                                                                                    }
                                                                                                    {attachmentsArr?.map(
                                                                                                        (data, index) => {
                                                                                                            return (
                                                                                                                <span
                                                                                                                    className="rounded-3 shadow"
                                                                                                                    style={{
                                                                                                                        height: "55px",
                                                                                                                        background: "grey",
                                                                                                                        width: "50px",
                                                                                                                        marginRight: "10px",
                                                                                                                        marginBottom: "10px",
                                                                                                                        border: '2px solid rgba(216, 122, 36, 1)'
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <span className="fs-6 py-1 w-100">
                                                                                                                        <img
                                                                                                                            src={data?.url}
                                                                                                                            className="w-100 h-100 rounded-3 cursor-pointer"
                                                                                                                            alt=""
                                                                                                                            onClick={() => {
                                                                                                                                handleOpenDoc();
                                                                                                                                setImageAttachURL(data?.url)
                                                                                                                            }}
                                                                                                                        />
                                                                                                                    </span>
                                                                                                                </span>
                                                                                                            );
                                                                                                        }
                                                                                                    )}
                                                                                                </div>
                                                                                            )}
                                                                                        </>
                                                                                    }
                                                                                </div>

                                                                                {window.innerWidth >= 768 && permissionArray.includes("SCAN TAB") && attachmentsArr.length < 3 &&
                                                                                    <div className='row px-0 mb-2 d-flex'>
                                                                                        <div className='col-12 px-2 d-flex'>
                                                                                            {!saveUpdateTicketLoading ?
                                                                                                <div
                                                                                                    className='d-flex align-items-center fs-5 text-hovered cursor-pointer'
                                                                                                    style={{ color: 'rgba(131, 154, 192, 1)' }}
                                                                                                    onClick={handleClickAttachedImage}
                                                                                                >

                                                                                                    <div
                                                                                                        className='rounded-1 d-flex align-items-center justify-content-center font-w900 overlay-action-btn'
                                                                                                        style={{
                                                                                                            backgroundColor: "rgb(215 225 243)",
                                                                                                            height: '30px',
                                                                                                            width: '30px',
                                                                                                        }}
                                                                                                    >
                                                                                                        <i className='bi bi-plus-circle' />
                                                                                                    </div>
                                                                                                    <div className='px-3 font-w600' >
                                                                                                        <span>
                                                                                                            {`Add photo of broken device`}
                                                                                                        </span>
                                                                                                    </div>
                                                                                                    <input ref={attachedImageRef} type="file" accept="image/*" hidden onChange={(e) => { handleAttachedImage(e) }} />
                                                                                                </div>
                                                                                                :
                                                                                                <div
                                                                                                    className='d-flex align-items-center'
                                                                                                    style={{ color: 'rgba(131, 154, 192, 1)' }}
                                                                                                    onClick={() => deleteAttachedImage()}
                                                                                                >
                                                                                                    <div
                                                                                                        className='rounded-1 d-flex align-items-center justify-content-center font-w900'
                                                                                                        style={{
                                                                                                            backgroundColor: "rgb(215 225 243)",
                                                                                                            height: '30px',
                                                                                                            width: '30px',
                                                                                                        }}
                                                                                                    >
                                                                                                        <Spinner size="sm" />
                                                                                                    </div>
                                                                                                    <img className='rounded-1 mx-3 border ' src={attachedImage} style={{ height: '30px', width: '30px' }} alt="" />
                                                                                                </div>
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                }

                                                                                <div className='row mx-0  mb-2 rounded-2 bg-white shadow-sm'>


                                                                                    <div
                                                                                        className='row px-3 py-2 fs-4 fw-bold text-black'
                                                                                        style={{
                                                                                            borderBottom: '3px solid #fcf4ed',
                                                                                        }}
                                                                                    >
                                                                                        <div className='col-12 d-flex align-items-center justify-content-start'>
                                                                                            <span>{`#${receiverData?.display_id_int ? receiverData?.display_id_int : ""}`}</span>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div
                                                                                        className='row mx-0 px-3 py-2 mb-1'
                                                                                        style={{
                                                                                            borderBottom: '2px dashed #fbf3ec',
                                                                                        }}
                                                                                    >
                                                                                        <div className='col-4'>
                                                                                            <span>{`Job started`}</span>
                                                                                        </div>
                                                                                        <div className='col-8'>
                                                                                            {/* <span className='text-black font-w600'>{`${receiverData?.created_date_dtm ? formatUnixTimestamp(receiverData?.created_date_dtm) : '-'}`}</span> */}

                                                                                            <span className="text-black font-w600">{`${receiverData?.created_date_dtm ?
                                                                                                new Intl.DateTimeFormat("en-US", {
                                                                                                    year: "numeric",
                                                                                                    month: "short",
                                                                                                    day: "numeric",
                                                                                                    hour: 'numeric',
                                                                                                    minute: 'numeric',
                                                                                                    hour12: true
                                                                                                }).format(
                                                                                                    receiverData?.created_date_dtm * 1000
                                                                                                ) : '-'}`}</span>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div
                                                                                        className='row mx-0 px-3 py-2 mb-1'
                                                                                        style={{
                                                                                            borderBottom: '2px dashed #fbf3ec',
                                                                                        }}
                                                                                    >
                                                                                        <div className='col-4'>
                                                                                            <span>{`Last call`}</span>
                                                                                        </div>
                                                                                        <div className='col-8'>
                                                                                            {/* <span className='text-black font-w600'>{`${receiverData?.last_call_dtm ? formatUnixTimestamp(receiverData?.last_call_dtm) : '-'}`}</span> */}

                                                                                            <span className="text-black font-w600">{`${receiverData?.last_call_dtm ?
                                                                                                new Intl.DateTimeFormat("en-US", {
                                                                                                    year: "numeric",
                                                                                                    month: "short",
                                                                                                    day: "numeric",
                                                                                                    hour: 'numeric',
                                                                                                    minute: 'numeric',
                                                                                                    hour12: true
                                                                                                }).format(
                                                                                                    receiverData?.last_call_dtm * 1000
                                                                                                ) : '-'}`}</span>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div
                                                                                        className='row mx-0 px-3 py-2 mb-1'
                                                                                        style={{
                                                                                            borderBottom: '2px dashed #fbf3ec',
                                                                                        }}
                                                                                    >
                                                                                        <div className='col-4'>
                                                                                            <span>{`Initiator`}</span>
                                                                                        </div>
                                                                                        <div className='col-8'>
                                                                                            <span className='text-black font-w600'>{`${receiverData?.creator_name_chr ? `${receiverData?.creator_name_chr}` : "-"}`}</span>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div
                                                                                        className='row mx-0 px-3 py-2 mb-1'
                                                                                        style={{
                                                                                            borderBottom: '2px dashed #fbf3ec',
                                                                                        }}
                                                                                    >
                                                                                        <div className='col-4'>
                                                                                            <span>{`Status`}</span>
                                                                                        </div>
                                                                                        <div className='col-8 d-flex'>

                                                                                            <div className="fs-7 border border-light px-3 py-1 rounded-pill">
                                                                                                <span
                                                                                                    className='font-w700'
                                                                                                    style={{
                                                                                                        color: (receiverData.ticket_status_ysn === 0) ? "rgba(45, 204, 99, 1)" :
                                                                                                            (receiverData.ticket_status_ysn === 1 || receiverData.ticket_status_ysn === 5) ? "blue" :
                                                                                                                receiverData.ticket_status_ysn === 2 ? "orange" :
                                                                                                                    (receiverData.ticket_status_ysn === 4 || receiverData.ticket_status_ysn === 6 || receiverData.ticket_status_ysn === 7) ? "red" : '',
                                                                                                    }}
                                                                                                >
                                                                                                    {/* {receiverData.ticket_status_ysn === 0 && "Closed"}
                                                                                                {receiverData.ticket_status_ysn === 1 && "Open"}
                                                                                                {receiverData.ticket_status_ysn === 2 && "Work in progress"}
                                                                                                {receiverData.ticket_status_ysn === 4 && "Unresolved"}
                                                                                                {receiverData.ticket_status_ysn === 5 && "Re-open"}
                                                                                                {receiverData.ticket_status_ysn === 6 && "Incomplete"}
                                                                                                {receiverData.ticket_status_ysn === 7 && "Cancelled"} */}
                                                                                                    {(permissionArray.includes(`CONNECT TO PRO`)) ?
                                                                                                        <>
                                                                                                            {receiverData?.status_display_name_chr == 'Open' ? 'Waiting for Pro' : receiverData?.status_display_name_chr}
                                                                                                        </> :
                                                                                                        <>
                                                                                                            {receiverData?.status_display_name_chr}
                                                                                                        </>
                                                                                                    }
                                                                                                </span>
                                                                                            </div>
                                                                                            {receiverData.ticket_status_ysn === 12 &&
                                                                                                <>
                                                                                                    {
                                                                                                        permissionArray.includes("SCAN TAB") ?
                                                                                                            <span
                                                                                                                className='ms-4 cursor-pointer font-w600 text-hovered text-success text-decoration-underline d-flex align-items-center'
                                                                                                                onClick={() => {
                                                                                                                    navigate('/userProfile')
                                                                                                                    dispatch(setUserProfileTab(3))
                                                                                                                }}
                                                                                                            >
                                                                                                                {`Resolve this >`}
                                                                                                            </span> :

                                                                                                            <span
                                                                                                                className='ms-4 font-w600 text-danger d-flex align-items-center'
                                                                                                            >
                                                                                                                {`Payment failed at customer end`}
                                                                                                            </span>
                                                                                                    }
                                                                                                </>
                                                                                            }

                                                                                        </div>
                                                                                    </div>

                                                                                    {/* {permissionArray.includes("UPDATE WORK INFORMATION") &&
                                                                                    <div className='row mx-0 p-3 mb-1 shadow-sm border border-light rounded-2'>
                                                                                        <div className='col-4'>
                                                                                            <span>{`Total earned`}</span>
                                                                                        </div>
                                                                                        <div className='col-8'>
                                                                                            <span className='font-w600 text-success'>{`$0.00`}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                } */}

                                                                                    <div
                                                                                        className='row mx-0 px-3 py-2 mb-1'
                                                                                        style={{
                                                                                            borderBottom: '2px dashed #fbf3ec',
                                                                                        }}
                                                                                    >
                                                                                        <div className='col-4 d-flex align-items-center'>
                                                                                            <span>{`Brand`}</span>
                                                                                        </div>
                                                                                        <div className='col-8'>
                                                                                            <div className='d-flex align-items-center justify-content-between w-100'>
                                                                                                <div className='w-100 me-2'>
                                                                                                    {toggleEditBrand ?
                                                                                                        <InputField
                                                                                                            value={brandName}
                                                                                                            labelName={`Brand`}
                                                                                                            placeholderName={`Brand`}
                                                                                                            onChange={handleBrandName}
                                                                                                            onBlur={() => { }}
                                                                                                            errorOccured={false}
                                                                                                            errorMeesage={''}
                                                                                                        /> :
                                                                                                        <span className='text-black font-w600'>{`${brandName ? `${brandName}` : "-"}`}</span>
                                                                                                    }
                                                                                                </div>

                                                                                                {permissionArray.includes("UPDATE SERVICE REQUETS DETAILS") && receiverData?.update_service_request_flag &&
                                                                                                    <div className={`d-flex ${toggleEditBrand ? 'mb-3' : ''}`}>
                                                                                                        {toggleEditBrand ?
                                                                                                            <>
                                                                                                                <div className="d-flex align-items-center justify-content-center mx-2">
                                                                                                                    <div className="tooltipCustom">
                                                                                                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Save"}</span>
                                                                                                                        <span
                                                                                                                            className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center"
                                                                                                                            onClick={(e) => { handleUpdateServiceDirectly(e) }}
                                                                                                                            style={{ height: '30px', width: '30px', }}
                                                                                                                        >
                                                                                                                            <i className="bi bi-check2-circle text-success" style={{ color: 'green', fontSize: '18px' }} />
                                                                                                                        </span>
                                                                                                                    </div>
                                                                                                                </div>

                                                                                                                <div className="d-flex align-items-center justify-content-center">
                                                                                                                    <div className="tooltipCustom">
                                                                                                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Close"}</span>
                                                                                                                        <span
                                                                                                                            className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center"
                                                                                                                            onClick={(e) => { setToggleEditBrand(false) }}
                                                                                                                            style={{ height: '30px', width: '30px', }}
                                                                                                                        >
                                                                                                                            <i className="bi bi-x-circle text-danger" style={{ fontSize: '18px' }} />
                                                                                                                        </span>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </> :
                                                                                                            <div className="d-flex align-items-center justify-content-center mx-2">
                                                                                                                <div className="tooltipCustom">
                                                                                                                    <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Edit"}</span>
                                                                                                                    <span
                                                                                                                        className="font-w600 text-black overlay-action-btn bg-light cursor-pointer rounded-circle d-flex align-items-center justify-content-center"
                                                                                                                        onClick={(e) => {
                                                                                                                            setToggleEditBrand(true)
                                                                                                                            setToggleEditModel(false)
                                                                                                                            setToggleEditSerial(false)
                                                                                                                        }}
                                                                                                                        style={{ height: '25px', width: '25px', }}
                                                                                                                    >
                                                                                                                        <i className="bi bi-pencil" style={{ fontSize: '12px' }} />
                                                                                                                    </span>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        }
                                                                                                    </div>
                                                                                                }
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div
                                                                                        className='row mx-0 px-3 py-2 mb-1'
                                                                                        style={{
                                                                                            borderBottom: '2px dashed #fbf3ec',
                                                                                        }}
                                                                                    >
                                                                                        <div className='col-4'>
                                                                                            <span>{`Model`}</span>
                                                                                        </div>
                                                                                        <div className='col-8'>
                                                                                            <div className='d-flex align-items-center justify-content-between w-100'>
                                                                                                <div className='w-100 me-2'>
                                                                                                    {toggleEditModel ?
                                                                                                        <InputField
                                                                                                            value={modelNum}
                                                                                                            labelName={`Model`}
                                                                                                            placeholderName={`Model`}
                                                                                                            onChange={handleModelNumber}
                                                                                                            onBlur={() => { }}
                                                                                                            errorOccured={false}
                                                                                                            errorMeesage={''}
                                                                                                        /> :
                                                                                                        <span className='text-black font-w600'>{`${modelNum ? `${modelNum}` : "-"}`}</span>
                                                                                                    }
                                                                                                </div>

                                                                                                {permissionArray.includes("UPDATE SERVICE REQUETS DETAILS") && receiverData?.update_service_request_flag &&
                                                                                                    <div className={`d-flex ${toggleEditModel ? 'mb-3' : ''}`}>
                                                                                                        {toggleEditModel ?
                                                                                                            <>
                                                                                                                <div className="d-flex align-items-center justify-content-center mx-2">
                                                                                                                    <div className="tooltipCustom">
                                                                                                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Save"}</span>
                                                                                                                        <span
                                                                                                                            className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center"
                                                                                                                            onClick={(e) => { handleUpdateServiceDirectly(e) }}
                                                                                                                            style={{ height: '30px', width: '30px', }}
                                                                                                                        >
                                                                                                                            <i className="bi bi-check2-circle text-success" style={{ color: 'green', fontSize: '18px' }} />
                                                                                                                        </span>
                                                                                                                    </div>
                                                                                                                </div>

                                                                                                                <div className="d-flex align-items-center justify-content-center">
                                                                                                                    <div className="tooltipCustom">
                                                                                                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Close"}</span>
                                                                                                                        <span
                                                                                                                            className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center"
                                                                                                                            onClick={(e) => { setToggleEditModel(false) }}
                                                                                                                            style={{ height: '30px', width: '30px', }}
                                                                                                                        >
                                                                                                                            <i className="bi bi-x-circle text-danger" style={{ fontSize: '18px' }} />
                                                                                                                        </span>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </> :
                                                                                                            <div className="d-flex align-items-center justify-content-center mx-2">
                                                                                                                <div className="tooltipCustom">
                                                                                                                    <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Edit"}</span>
                                                                                                                    <span
                                                                                                                        className="font-w600 text-black overlay-action-btn bg-light cursor-pointer rounded-circle d-flex align-items-center justify-content-center"
                                                                                                                        onClick={(e) => {
                                                                                                                            setToggleEditBrand(false)
                                                                                                                            setToggleEditModel(true)
                                                                                                                            setToggleEditSerial(false)
                                                                                                                        }}
                                                                                                                        style={{ height: '25px', width: '25px', }}
                                                                                                                    >
                                                                                                                        <i className="bi bi-pencil" style={{ fontSize: '12px' }} />
                                                                                                                    </span>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        }
                                                                                                    </div>
                                                                                                }
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div
                                                                                        className='row mx-0 px-3 py-2 mb-1'
                                                                                        style={{
                                                                                            borderBottom: '2px dashed #fbf3ec',
                                                                                        }}
                                                                                    >
                                                                                        <div className='col-4'>
                                                                                            <span>{`Serial #`}</span>
                                                                                        </div>
                                                                                        <div className='col-8'>
                                                                                            <div className='d-flex align-items-center justify-content-between w-100'>
                                                                                                <div className='w-100 me-2'>
                                                                                                    {toggleEditSerial ?
                                                                                                        <InputField
                                                                                                            value={serialNumber}
                                                                                                            labelName={`Serial #`}
                                                                                                            placeholderName={`Serial #`}
                                                                                                            onChange={handleSerialNumber}
                                                                                                            onBlur={() => { }}
                                                                                                            errorOccured={false}
                                                                                                            errorMeesage={''}
                                                                                                        /> :
                                                                                                        <span className='text-black font-w600'>{`${serialNumber ? `${serialNumber}` : "-"}`}</span>
                                                                                                    }
                                                                                                </div>

                                                                                                {permissionArray.includes("UPDATE SERVICE REQUETS DETAILS") && receiverData?.update_service_request_flag &&
                                                                                                    <div className={`d-flex ${toggleEditSerial ? 'mb-3' : ''}`}>
                                                                                                        {toggleEditSerial ?
                                                                                                            <>
                                                                                                                <div className="d-flex align-items-center justify-content-center mx-2">
                                                                                                                    <div className="tooltipCustom">
                                                                                                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Save"}</span>
                                                                                                                        <span
                                                                                                                            className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center"
                                                                                                                            onClick={(e) => { handleUpdateServiceDirectly(e) }}
                                                                                                                            style={{ height: '30px', width: '30px', }}
                                                                                                                        >
                                                                                                                            <i className="bi bi-check2-circle text-success" style={{ color: 'green', fontSize: '18px' }} />
                                                                                                                        </span>
                                                                                                                    </div>
                                                                                                                </div>

                                                                                                                <div className="d-flex align-items-center justify-content-center">
                                                                                                                    <div className="tooltipCustom">
                                                                                                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Close"}</span>
                                                                                                                        <span
                                                                                                                            className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center"
                                                                                                                            onClick={(e) => { setToggleEditSerial(false) }}
                                                                                                                            style={{ height: '30px', width: '30px', }}
                                                                                                                        >
                                                                                                                            <i className="bi bi-x-circle text-danger" style={{ fontSize: '18px' }} />
                                                                                                                        </span>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </> :
                                                                                                            <div className="d-flex align-items-center justify-content-center mx-2">
                                                                                                                <div className="tooltipCustom">
                                                                                                                    <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Edit"}</span>
                                                                                                                    <span
                                                                                                                        className="font-w600 text-black overlay-action-btn bg-light cursor-pointer rounded-circle d-flex align-items-center justify-content-center"
                                                                                                                        onClick={(e) => {
                                                                                                                            setToggleEditBrand(false)
                                                                                                                            setToggleEditModel(false)
                                                                                                                            setToggleEditSerial(true)
                                                                                                                        }}
                                                                                                                        style={{ height: '25px', width: '25px', }}
                                                                                                                    >
                                                                                                                        <i className="bi bi-pencil" style={{ fontSize: '12px' }} />
                                                                                                                    </span>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        }
                                                                                                    </div>
                                                                                                }
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div
                                                                                        className='row mx-0 px-3 py-2 mb-1'
                                                                                        style={{
                                                                                            borderBottom: '2px dashed #fbf3ec',
                                                                                        }}
                                                                                    >
                                                                                        <div className='col-4'>
                                                                                            <span>{`QR info`}</span>
                                                                                        </div>
                                                                                        <div className='col-8'>
                                                                                            <span className='text-black font-w600'>{`${receiverData?.qr_info_chr ? `${receiverData?.qr_info_chr}` : "-"}`}</span>
                                                                                        </div>
                                                                                    </div>

                                                                                    {(permissionArray.includes("UPDATE WORK INFORMATION") && false) &&
                                                                                        <div
                                                                                            className='row mx-0 px-3 py-2 mb-1'
                                                                                            style={{
                                                                                                borderBottom: '2px dashed #fbf3ec',
                                                                                            }}
                                                                                        >
                                                                                            <div className='col-4 py-2'>
                                                                                                <span>{`Call recordings`}</span>
                                                                                            </div>
                                                                                            <div className='col-8'>
                                                                                                <div className='row mx-0'>
                                                                                                    <div className=' px-0 py-2'>
                                                                                                        {/* {element?.image_urls?.map((element, index) => {
                                                                                            return (
                                                                                                <img
                                                                                                    key={index}
                                                                                                    src={element}
                                                                                                    className="rounded-3 border me-2"
                                                                                                    alt=''
                                                                                                    style={{ width: '50px', height: '50px', objectFit: 'contain', background: '#b2b0b0' }}
                                                                                                />
                                                                                            )
                                                                                        })} */}
                                                                                                        {getCallRecordingsLoading ?
                                                                                                            <>
                                                                                                                <div className=''>
                                                                                                                    <div className='mb-3'>
                                                                                                                        <SkeletonDivElement height={'20px'} width={'150px'} borderRadius={'0px'} />
                                                                                                                    </div>

                                                                                                                    <div className='d-flex'>
                                                                                                                        <span className='pe-2'>
                                                                                                                            <SkeletonDivElement height={'45px'} width={'45px'} borderRadius={'50%'} />
                                                                                                                        </span>
                                                                                                                        <span className='pe-2'>
                                                                                                                            <SkeletonDivElement height={'45px'} width={'45px'} borderRadius={'50%'} />
                                                                                                                        </span>
                                                                                                                        <span className='pe-2'>
                                                                                                                            <SkeletonDivElement height={'45px'} width={'45px'} borderRadius={'50%'} />
                                                                                                                        </span>
                                                                                                                        <span className='pe-2'>
                                                                                                                            <SkeletonDivElement height={'45px'} width={'45px'} borderRadius={'50%'} />
                                                                                                                        </span>
                                                                                                                    </div>



                                                                                                                </div>
                                                                                                            </> :
                                                                                                            <>
                                                                                                                {callRecordingsArr?.length > 0 ?
                                                                                                                    <>
                                                                                                                        {callRecordingsArr?.map((ele, index) => {
                                                                                                                            let professionalName = '';
                                                                                                                            let customerName = '';
                                                                                                                            let professionalsCallRecordingsArr = [];
                                                                                                                            let customersCallRecordingsArr = [];
                                                                                                                            ele?.recordings?.map(ele => {
                                                                                                                                // if (ele?.user_details?.role_display_name_chr === "Professional") {
                                                                                                                                //     professionalName = ele?.user_details?.first_name_chr;
                                                                                                                                //     professionalsCallRecordingsArr.push(ele);
                                                                                                                                // } else {
                                                                                                                                //     if (ele.user_details.user_id_ids) {
                                                                                                                                //         customerName = ele?.user_details?.first_name_chr;
                                                                                                                                //     } else {
                                                                                                                                //         customerName = `${ele?.user_details?.first_name_chr} (Guest customer)`;
                                                                                                                                //     }
                                                                                                                                //     customersCallRecordingsArr.push(ele);
                                                                                                                                // }

                                                                                                                                if (
                                                                                                                                    ele?.user_details?.roles?.some(
                                                                                                                                        role => role.role_display_name_chr === "Professional"
                                                                                                                                    )
                                                                                                                                ) {
                                                                                                                                    professionalName = ele?.user_details?.first_name_chr;
                                                                                                                                    professionalsCallRecordingsArr.push(ele);
                                                                                                                                } else {
                                                                                                                                    if (ele?.user_details?.user_id_ids) {
                                                                                                                                        customerName = `${ele?.user_details?.first_name_chr} (Customer)`;
                                                                                                                                    } else {
                                                                                                                                        customerName = `${ele?.user_details?.first_name_chr} (Guest customer)`;
                                                                                                                                    }
                                                                                                                                    customersCallRecordingsArr.push(ele);
                                                                                                                                }
                                                                                                                            });

                                                                                                                            // console.log(professionalsCallRecordingsArr, 'professionalsCallRecordingsArr');
                                                                                                                            // console.log(customersCallRecordingsArr, 'customersCallRecordingsArr');
                                                                                                                            return (
                                                                                                                                <div className={`${callRecordingsArr?.length > 1 ? 'border-bottom' : ''} `} key={index}>
                                                                                                                                    {
                                                                                                                                        <div className={`d-flex align-items-center mb-2 ${callRecordingsArr?.length > 1 ? 'pt-2' : ''}`}>
                                                                                                                                            <span className='me-3'>Call date and time : <strong className='text-black'>{`${ele?.created_date_dtm ? formatUnixTimestamp(ele?.created_date_dtm) : '-'}`}</strong></span>
                                                                                                                                            {/* <span>Call duration : <strong className='text-black'>{formatTime(ele?.call_duration_in_second)}</strong></span> */}
                                                                                                                                        </div>
                                                                                                                                    }


                                                                                                                                    {ele?.recordings?.length > 0 ?
                                                                                                                                        <div className='row mx-0'>
                                                                                                                                            <div className='col-12'>
                                                                                                                                                <span className='text-black font-w600'>{`${professionalName} (Professional)`}</span>
                                                                                                                                            </div>

                                                                                                                                            <div className='col-12'>
                                                                                                                                                {professionalsCallRecordingsArr?.length > 0 ?
                                                                                                                                                    <>
                                                                                                                                                        <div className='d-flex  align-items-center overflow-auto w-100'>
                                                                                                                                                            {professionalsCallRecordingsArr?.map((item, index) => {
                                                                                                                                                                return (
                                                                                                                                                                    <div className="me-1" key={index}>
                                                                                                                                                                        <div className="tooltipCustom">
                                                                                                                                                                            <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{`See recording, duration: ${formatTime(item?.duration)}`}</span>
                                                                                                                                                                            <span
                                                                                                                                                                                className="cursor-pointer  rounded-circle overlay-action-btn fs-2 d-flex align-items-center justify-content-center "
                                                                                                                                                                                style={{ height: '45px', width: '45px' }}
                                                                                                                                                                                onClick={(e) => {
                                                                                                                                                                                    e.stopPropagation();
                                                                                                                                                                                    handleOpenVideoAudio();
                                                                                                                                                                                    setVideoAudioURL(item?.media_location);
                                                                                                                                                                                }}
                                                                                                                                                                            >
                                                                                                                                                                                {item?.type === "audio" ?
                                                                                                                                                                                    <i className="bi bi-mic text-success"></i> :
                                                                                                                                                                                    <i className="bi bi-camera-video-fill text-success"></i>
                                                                                                                                                                                }
                                                                                                                                                                            </span>
                                                                                                                                                                        </div>
                                                                                                                                                                    </div>
                                                                                                                                                                )
                                                                                                                                                            })}
                                                                                                                                                        </div>
                                                                                                                                                    </> :
                                                                                                                                                    <>
                                                                                                                                                        <span>{`No sessions are recorded`}</span>
                                                                                                                                                    </>
                                                                                                                                                }

                                                                                                                                            </div>




                                                                                                                                            <div className='col-12 d-flex'>
                                                                                                                                                <span className='text-black font-w600'>{customerName}</span>
                                                                                                                                            </div>

                                                                                                                                            <div className='col-12 d-flex'>
                                                                                                                                                {customersCallRecordingsArr?.length > 0 ?
                                                                                                                                                    <>
                                                                                                                                                        <div className='d-flex  align-items-center overflow-auto w-100'>
                                                                                                                                                            {customersCallRecordingsArr?.map((item, index) => {
                                                                                                                                                                return (
                                                                                                                                                                    <div className="me-1" key={index}>
                                                                                                                                                                        <div className="tooltipCustom">
                                                                                                                                                                            <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{`See recording, duration: ${formatTime(item?.duration)}`}</span>
                                                                                                                                                                            <span
                                                                                                                                                                                className="cursor-pointer  rounded-circle overlay-action-btn fs-2 d-flex align-items-center justify-content-center "
                                                                                                                                                                                style={{ height: '45px', width: '45px' }}
                                                                                                                                                                                onClick={(e) => {
                                                                                                                                                                                    e.stopPropagation();
                                                                                                                                                                                    handleOpenVideoAudio();
                                                                                                                                                                                    setVideoAudioURL(item?.media_location);
                                                                                                                                                                                }}
                                                                                                                                                                            >
                                                                                                                                                                                {item?.type === "audio" ?
                                                                                                                                                                                    <i className="bi bi-mic text-success"></i> :
                                                                                                                                                                                    <i className="bi bi-camera-video-fill text-success"></i>
                                                                                                                                                                                }
                                                                                                                                                                            </span>
                                                                                                                                                                        </div>
                                                                                                                                                                    </div>
                                                                                                                                                                )
                                                                                                                                                            })}
                                                                                                                                                        </div>
                                                                                                                                                    </> :
                                                                                                                                                    <>
                                                                                                                                                        <span>{`No sessions are recorded`}</span>
                                                                                                                                                    </>
                                                                                                                                                }
                                                                                                                                            </div>
                                                                                                                                        </div> :
                                                                                                                                        <>
                                                                                                                                            <span>{`No sessions are recorded`}</span>
                                                                                                                                        </>
                                                                                                                                    }

                                                                                                                                </div>
                                                                                                                            )
                                                                                                                        })}
                                                                                                                    </> :
                                                                                                                    <>
                                                                                                                        <span className=''>{`No sessions are recorded`}</span>
                                                                                                                    </>
                                                                                                                }
                                                                                                            </>
                                                                                                        }


                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    }

                                                                                    {/* Composed Recordings only need to show and hide the individual recordings */}
                                                                                    {callRecordingsArr?.length > 0 &&
                                                                                        <div
                                                                                            className='row mx-0 px-3 py-2 mb-1'
                                                                                            style={{
                                                                                                borderBottom: '2px dashed #fbf3ec',
                                                                                            }}
                                                                                        >

                                                                                            <div className='col-4 py-2'>
                                                                                                <span>{`Call recordings`}</span>
                                                                                            </div>
                                                                                            <div className='col-8'>
                                                                                                <div className='row mx-0'>
                                                                                                    <div className=' px-0 py-2'>
                                                                                                        {/* {element?.image_urls?.map((element, index) => {
                                                                                            return (
                                                                                                <img
                                                                                                    key={index}
                                                                                                    src={element}
                                                                                                    className="rounded-3 border me-2"
                                                                                                    alt=''
                                                                                                    style={{ width: '50px', height: '50px', objectFit: 'contain', background: '#b2b0b0' }}
                                                                                                />
                                                                                            )
                                                                                        })} */}
                                                                                                        {getCallRecordingsLoading ?
                                                                                                            <>
                                                                                                                <div className=''>
                                                                                                                    <div className='mb-3'>
                                                                                                                        <SkeletonDivElement height={'20px'} width={'150px'} borderRadius={'0px'} />
                                                                                                                    </div>

                                                                                                                    <div className='d-flex'>
                                                                                                                        <span className='pe-2'>
                                                                                                                            <SkeletonDivElement height={'45px'} width={'45px'} borderRadius={'50%'} />
                                                                                                                        </span>
                                                                                                                        <span className='pe-2'>
                                                                                                                            <SkeletonDivElement height={'45px'} width={'45px'} borderRadius={'50%'} />
                                                                                                                        </span>
                                                                                                                        <span className='pe-2'>
                                                                                                                            <SkeletonDivElement height={'45px'} width={'45px'} borderRadius={'50%'} />
                                                                                                                        </span>
                                                                                                                        <span className='pe-2'>
                                                                                                                            <SkeletonDivElement height={'45px'} width={'45px'} borderRadius={'50%'} />
                                                                                                                        </span>
                                                                                                                    </div>



                                                                                                                </div>
                                                                                                            </> :
                                                                                                            <>
                                                                                                                {callRecordingsArr?.length > 0 ?
                                                                                                                    <>
                                                                                                                        {callRecordingsArr?.map((ele, index) => {
                                                                                                                            return (
                                                                                                                                <div className={`${callRecordingsArr?.length > 1 ? 'border-bottom' : ''} `} key={index}>
                                                                                                                                    {
                                                                                                                                        <div className={`d-flex align-items-center mb-2 ${callRecordingsArr?.length > 1 ? 'pt-2' : ''}`}>
                                                                                                                                            <span className='me-3'>Call date and time : <strong className='text-black'>{`${ele?.created_date_dtm ? formatUnixTimestamp(ele?.created_date_dtm) : '-'}`}</strong></span>
                                                                                                                                            {/* <span>Call duration : <strong className='text-black'>{formatTime(ele?.call_duration_in_second)}</strong></span> */}
                                                                                                                                        </div>
                                                                                                                                    }

                                                                                                                                    <div className='row mx-0'>

                                                                                                                                        <div className='col-12'>
                                                                                                                                            {ele?.composed_recording?.length > 0 ?
                                                                                                                                                <>
                                                                                                                                                    <div className='d-flex  align-items-center overflow-auto w-100'>
                                                                                                                                                        {ele?.composed_recording?.map((item, index) => {
                                                                                                                                                            return (
                                                                                                                                                                <div className="me-1" key={index}>
                                                                                                                                                                    {item?.status === "completed" ?
                                                                                                                                                                        <div className="tooltipCustom">
                                                                                                                                                                            <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{`See recording, duration: ${formatTime(item?.duration)}`}</span>
                                                                                                                                                                            <span
                                                                                                                                                                                className="cursor-pointer  rounded-circle overlay-action-btn fs-2 d-flex align-items-center justify-content-center "
                                                                                                                                                                                style={{ height: '45px', width: '45px' }}
                                                                                                                                                                                onClick={(e) => {
                                                                                                                                                                                    e.stopPropagation();
                                                                                                                                                                                    handleOpenVideoAudio();
                                                                                                                                                                                    setVideoAudioURL(item?.media_location);
                                                                                                                                                                                }}
                                                                                                                                                                            >
                                                                                                                                                                                <i className="bi bi-camera-video-fill text-success"></i>
                                                                                                                                                                            </span>
                                                                                                                                                                        </div> :
                                                                                                                                                                        (item?.status === "enqueued" || item?.status === "processing") ?
                                                                                                                                                                            <span>{`Composition is in progress, please try after some time.`}</span> :
                                                                                                                                                                            item?.status === "failed" ?
                                                                                                                                                                                <span>{`Composition of this session is failed`}</span> : ''
                                                                                                                                                                    }
                                                                                                                                                                </div>
                                                                                                                                                            )
                                                                                                                                                        })}
                                                                                                                                                    </div>
                                                                                                                                                </> :
                                                                                                                                                <>
                                                                                                                                                    <span>{`For this call no recording is available`}</span>
                                                                                                                                                </>
                                                                                                                                            }

                                                                                                                                        </div>
                                                                                                                                    </div>
                                                                                                                                </div>
                                                                                                                            )
                                                                                                                        })}
                                                                                                                    </> :
                                                                                                                    <>
                                                                                                                        <span className=''>{`For this call no recording is available`}</span>
                                                                                                                    </>
                                                                                                                }
                                                                                                            </>
                                                                                                        }


                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    }

                                                                                    {permissionArray.includes("ASSIGN SERVICE REQUEST") &&
                                                                                        <div
                                                                                            className='row mx-0 px-3 py-2 mb-1'
                                                                                            style={{
                                                                                                borderBottom: '2px dashed #fbf3ec',
                                                                                            }}
                                                                                        >
                                                                                            <div className='col-4'>
                                                                                                <span>{`Assign to`}</span>
                                                                                            </div>
                                                                                            <div className='col-8'>
                                                                                                <span className='text-black font-w600'>{`${receiverData?.assigned_to_name_chr ? `${receiverData?.assigned_to_name_chr}` : "-"}`}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    }

                                                                                    <div
                                                                                        className='row mx-0 px-3 py-2 mb-1'
                                                                                        style={{
                                                                                            // borderBottom: '2px dashed #fbf3ec',
                                                                                        }}
                                                                                    >
                                                                                        <div className='col-4'>

                                                                                            <div className="tooltipCustom">
                                                                                                <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Add note"}</span>
                                                                                                <i className="bi bi-info-circle text-hovered"></i>
                                                                                            </div>

                                                                                            <span className='ms-2'>{`My note`}</span>

                                                                                        </div>
                                                                                        <div className='col-8'>
                                                                                            <div className='row'>
                                                                                                {/* (Object?.keys(receiverData?.personal_notes)?.length !== 0) */}
                                                                                                {(Object?.keys(personalNoteObj)?.length !== 0) ?
                                                                                                    <>
                                                                                                        <div className='row'>
                                                                                                            <div className='col-10 d-flex flex-column'>
                                                                                                                {!toggleForAddPersonalNote ?
                                                                                                                    <span className='font-w600'>{`${receiverData?.personal_notes?.note_chr}`}</span> :
                                                                                                                    <>
                                                                                                                        <InputField
                                                                                                                            labelName={`My personal note`}
                                                                                                                            value={discussionVal}
                                                                                                                            onChange={discussionOnChange}
                                                                                                                            onBlur={() => { }}
                                                                                                                        />

                                                                                                                        <div
                                                                                                                            className=''
                                                                                                                            style={{
                                                                                                                                pointerEvents: (selectedFile.length > 0 || discussionVal !== "") ? 'auto' : 'none',
                                                                                                                                opacity: (selectedFile.length > 0 || discussionVal !== "") ? '1' : '0.5',
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            <PrimaryButton
                                                                                                                                buttonName={`SAVE CHANGES`}
                                                                                                                                onClick={() => { handleSaveDiscussion() }}
                                                                                                                                loadingMessage={"Saving..."}
                                                                                                                                isLoading={saveLoading}
                                                                                                                                style={{
                                                                                                                                    width: '100%',
                                                                                                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                                                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                                                                }}
                                                                                                                            />
                                                                                                                        </div>
                                                                                                                    </>}

                                                                                                            </div>

                                                                                                            <div className='col-2 d-flex justify-content-center'>
                                                                                                                {!toggleForAddPersonalNote ?
                                                                                                                    <i
                                                                                                                        onClick={() => { setToggleForAddPersonalNote(true); setDiscussionVal(receiverData?.personal_notes?.note_chr) }}
                                                                                                                        className='bi bi-pencil cursor-pointer text-black text-hovered'
                                                                                                                        style={{ fontSize: '12px' }}
                                                                                                                    ></i> :
                                                                                                                    <i
                                                                                                                        className='bi bi-x-lg cursor-pointer text-hovered fs-4'
                                                                                                                        onClick={() => { setToggleForAddPersonalNote(false) }}
                                                                                                                    ></i>
                                                                                                                }

                                                                                                            </div>
                                                                                                        </div>

                                                                                                    </>

                                                                                                    :
                                                                                                    <>
                                                                                                        {!toggleForAddPersonalNote ?
                                                                                                            <div className='col-12 d-flex'>
                                                                                                                <div
                                                                                                                    className='cursor-pointer text-hovered'
                                                                                                                    onClick={() => { setToggleForAddPersonalNote(true) }}
                                                                                                                >
                                                                                                                    <span className='font-w600'>{`Add note`}</span>
                                                                                                                    <span className='font-w600' style={{ fontSize: '12px' }}>
                                                                                                                        <i className="bi bi-pencil ps-2 text-black"></i>
                                                                                                                    </span>
                                                                                                                </div>
                                                                                                            </div> :

                                                                                                            <div className='row'>
                                                                                                                <div className='col-10 d-flex flex-column'>
                                                                                                                    <InputField
                                                                                                                        labelName={`My personal note`}
                                                                                                                        value={discussionVal}
                                                                                                                        onChange={discussionOnChange}
                                                                                                                        onBlur={() => { }}
                                                                                                                    />

                                                                                                                    <div
                                                                                                                        className=''
                                                                                                                        style={{
                                                                                                                            pointerEvents: (selectedFile.length > 0 || discussionVal !== "") ? 'auto' : 'none',
                                                                                                                            opacity: (selectedFile.length > 0 || discussionVal !== "") ? '1' : '0.5',
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <PrimaryButton
                                                                                                                            buttonName={`SAVE CHANGES`}
                                                                                                                            onClick={() => { handleSaveDiscussion() }}
                                                                                                                            loadingMessage={"Saving..."}
                                                                                                                            isLoading={saveLoading}
                                                                                                                            style={{
                                                                                                                                width: '100%',
                                                                                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                                                            }}
                                                                                                                        />
                                                                                                                    </div>

                                                                                                                </div>

                                                                                                                <div className='col-2 d-flex justify-content-center'>
                                                                                                                    <i
                                                                                                                        onClick={() => { setToggleForAddPersonalNote(false) }}
                                                                                                                        className='bi bi-x-lg cursor-pointer text-hovered fs-4'
                                                                                                                    ></i>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        }
                                                                                                    </>
                                                                                                }
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        }

                                                        {/* New Services Estimates or repair and install */}
                                                        {tabsToggleServiceReq === 6 &&
                                                            <>
                                                                <div className='row  mx-2 mt-3'  >
                                                                    <div className='col-12 px-0  '>
                                                                        <div
                                                                            className='row mx-0 overflow-auto'
                                                                            style={{
                                                                                //  minHeight: "300px", 
                                                                                //  maxHeight: "300px",
                                                                                // maxHeight: `${imgMaxHeight - 60}px`,
                                                                                minHeight: window.innerWidth < 768 ? "calc(100dvh - 205px)" : `${imgMaxHeight - 60}px`,
                                                                            }}
                                                                        >
                                                                            {toggleForEstimationsTab == `1` ?
                                                                                <div className='col-12 px-0 bg-white shadow py-2 rounded-2'>

                                                                                    {false && <>
                                                                                        <div className='row mx-0 px-3 py-2 mb-1 shadow-sm border border-light rounded-2'>
                                                                                            <div className='col-4'>
                                                                                                <span>
                                                                                                    {receiverData?.ticket_type_int == 1 ?
                                                                                                        <>{"Image Summary"}</> :
                                                                                                        receiverData?.ticket_type_int == 2 ?
                                                                                                            <>{"Repair and Install Summary"}</> : <>{"Service Summary"}</>
                                                                                                    }
                                                                                                </span>

                                                                                            </div>
                                                                                            <div className='col-8'>
                                                                                                <span className='text-black'>

                                                                                                    {(receiverData?.ticket_type_int == 1) ?
                                                                                                        <>
                                                                                                            {
                                                                                                                // serviceSummaryMetaData?.recognized_estimation_summary ?
                                                                                                                //     serviceSummaryMetaData?.recognized_estimation_summary
                                                                                                                serviceSummaryMetaData?.recognized_image_summary ?
                                                                                                                    serviceSummaryMetaData?.recognized_image_summary
                                                                                                                        .split(/\\n|\n/)
                                                                                                                        .map((line, idx) => {
                                                                                                                            const match = line.match(/^(\d+)\.\s*\*\*(.+?)\*\*(.*)$/);
                                                                                                                            if (match) {
                                                                                                                                const number = match[1];
                                                                                                                                const label = match[2];
                                                                                                                                const value = match[3]?.trim();
                                                                                                                                return (
                                                                                                                                    <div key={idx}>
                                                                                                                                        <span>{number}. </span>
                                                                                                                                        <strong>{label}</strong>
                                                                                                                                        {value ? ` ${value}` : ""}
                                                                                                                                    </div>
                                                                                                                                );
                                                                                                                            }
                                                                                                                            // Try to match only bold label
                                                                                                                            const boldMatch = line.match(/\*\*(.+?)\*\*/);
                                                                                                                            if (boldMatch) {
                                                                                                                                const label = boldMatch[1];
                                                                                                                                const value = line.split(/\*\*(.+?)\*\*/)[1]?.trim() || "";
                                                                                                                                return (
                                                                                                                                    <div key={idx}>
                                                                                                                                        <strong>{label}</strong>
                                                                                                                                        {value ? ` ${value}` : ""}
                                                                                                                                    </div>
                                                                                                                                );
                                                                                                                            }
                                                                                                                            return <div key={idx}>{line}</div>;
                                                                                                                        })

                                                                                                                    : "No summary available"}
                                                                                                        </> :
                                                                                                        (receiverData?.ticket_type_int == 2) ?
                                                                                                            <>
                                                                                                                {serviceSummaryMetaData?.recognized_repair_and_install_summary ?
                                                                                                                    serviceSummaryMetaData?.recognized_repair_and_install_summary
                                                                                                                        .split(/\\n|\n/)
                                                                                                                        .map((line, idx) => {
                                                                                                                            const match = line.match(/^(\d+)\.\s*\*\*(.+?)\*\*(.*)$/);
                                                                                                                            if (match) {
                                                                                                                                const number = match[1];
                                                                                                                                const label = match[2];
                                                                                                                                const value = match[3]?.trim();
                                                                                                                                return (
                                                                                                                                    <div key={idx}>
                                                                                                                                        <span>{number}. </span>
                                                                                                                                        <strong>{label}</strong>
                                                                                                                                        {value ? ` ${value}` : ""}
                                                                                                                                    </div>
                                                                                                                                );
                                                                                                                            }
                                                                                                                            const boldMatch = line.match(/\*\*(.+?)\*\*/);
                                                                                                                            if (boldMatch) {
                                                                                                                                const label = boldMatch[1];
                                                                                                                                const value = line.split(/\*\*(.+?)\*\*/)[1]?.trim() || "";
                                                                                                                                return (
                                                                                                                                    <div key={idx}>
                                                                                                                                        <strong>{label}</strong>
                                                                                                                                        {value ? ` ${value}` : ""}
                                                                                                                                    </div>
                                                                                                                                );
                                                                                                                            }
                                                                                                                            return <div key={idx}>{line}</div>;
                                                                                                                        })
                                                                                                                    : "No summary available"}
                                                                                                            </> :
                                                                                                            <>
                                                                                                                <span className="fs-6 py-1 w-100 text-black font-w700">
                                                                                                                    {serviceSummaryMetaData?.recognized_image_summary ?
                                                                                                                        serviceSummaryMetaData?.recognized_image_summary
                                                                                                                            .split(/\\n|\n/)
                                                                                                                            .map((line, idx) => {
                                                                                                                                const match = line.match(/^(\d+)\.\s*\*\*(.+?)\*\*(.*)$/);
                                                                                                                                if (match) {
                                                                                                                                    const number = match[1];
                                                                                                                                    const label = match[2];
                                                                                                                                    const value = match[3]?.trim();
                                                                                                                                    return (
                                                                                                                                        <div key={idx}>
                                                                                                                                            <span>{number}. </span>
                                                                                                                                            <strong>{label}</strong>
                                                                                                                                            {value ? ` ${value}` : ""}
                                                                                                                                        </div>
                                                                                                                                    );
                                                                                                                                }
                                                                                                                                const boldMatch = line.match(/\*\*(.+?)\*\*/);
                                                                                                                                if (boldMatch) {
                                                                                                                                    const label = boldMatch[1];
                                                                                                                                    const value = line.split(/\*\*(.+?)\*\*/)[1]?.trim() || "";
                                                                                                                                    return (
                                                                                                                                        <div key={idx}>
                                                                                                                                            <strong>{label}</strong>
                                                                                                                                            {value ? ` ${value}` : ""}
                                                                                                                                        </div>
                                                                                                                                    );
                                                                                                                                }
                                                                                                                                return <div key={idx}>{line}</div>;
                                                                                                                            })
                                                                                                                        : "No summary available"}
                                                                                                                </span>
                                                                                                            </>}
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className='row mx-0 px-3 py-2 mb-1 shadow-sm border border-light rounded-2'>
                                                                                            <div className='col-4'>
                                                                                                <span>{`Diagnosis`}</span>
                                                                                            </div>
                                                                                            <div className='col-8'>
                                                                                                <span className=' text-black'>
                                                                                                    {serviceSummaryMetaData?.pro_check_info?.pro_diagnosis ?
                                                                                                        serviceSummaryMetaData?.pro_check_info?.pro_diagnosis :
                                                                                                        `-`}
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className='row mx-0 px-3 py-2'>
                                                                                            <span className='font-w600 fs-6 text-black'>{`Estimated Cost Range`}</span>
                                                                                        </div>

                                                                                        <div className='row mx-0 px-3 py-2 mb-1 shadow-sm border border-light rounded-2'>
                                                                                            <div className='col-4'>
                                                                                                <span>{`Min Cost`}</span>
                                                                                            </div>
                                                                                            <div className='col-8'>
                                                                                                <span className='text-black font-w600'>
                                                                                                    {serviceSummaryMetaData?.pro_check_info?.pro_estimated_cost_min ?
                                                                                                        USDollar.format(parseFloat(serviceSummaryMetaData.pro_check_info.pro_estimated_cost_min.toFixed(2))) :
                                                                                                        `-`}
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className='row mx-0 px-3 py-2 mb-1 shadow-sm border border-light rounded-2'>
                                                                                            <div className='col-4'>
                                                                                                <span>{`Max Cost`}</span>
                                                                                            </div>
                                                                                            <div className='col-8'>
                                                                                                <span className='text-black font-w600'>
                                                                                                    {serviceSummaryMetaData?.pro_check_info?.pro_estimated_cost_max ?
                                                                                                        USDollar.format(parseFloat(serviceSummaryMetaData.pro_check_info.pro_estimated_cost_max.toFixed(2))) :
                                                                                                        `-`}
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </>}


                                                                                    <div
                                                                                        className='row mx-0 mt-1 pb-2'
                                                                                        style={{
                                                                                            borderBottom: '4px solid rgb(250 239 230)',
                                                                                        }}
                                                                                    >
                                                                                        <div
                                                                                            className='col-12 px-3 d-flex align-items-center'

                                                                                        >
                                                                                            <div className='d-flex align-items-center justify-content-center pe-2'>
                                                                                                {attachmentsArr.length > 0 && <>
                                                                                                    <img className='rounded-2' src={attachmentsArr[0].url} style={{ width: "100px", height: "93px", objectFit: "cover", background: 'grey' }} alt="Error" />
                                                                                                </>}
                                                                                            </div>

                                                                                            <div className=''>
                                                                                                {
                                                                                                    <div className='d-flex pb-1'>
                                                                                                        <div className='px-3 py-1 rounded-3 fs-7 font-w600'
                                                                                                            style={{
                                                                                                                // top: '10px',
                                                                                                                // left: '10px',
                                                                                                                background: 'rgba(255, 231, 213, 1)',
                                                                                                                color: 'rgba(216, 122, 36, 1)',
                                                                                                                zIndex: 1,
                                                                                                            }}
                                                                                                        >
                                                                                                            <span>{`${receiverData?.category_display_name_chr ? receiverData?.category_display_name_chr : '-'} `}</span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                }

                                                                                                <div className='pb-1 font-w600 text-black'>
                                                                                                    <span>
                                                                                                        {receiverData?.product_type_chr ? receiverData?.product_type_chr : '-'}
                                                                                                    </span>
                                                                                                </div>

                                                                                                {permissionArray.includes("SCAN TAB") &&
                                                                                                    <div className='pb-1'><span className='font-w600 text-black'>By Pro : </span><span>{sentRequest[0]?.joinee_name_chr?.trim()?.split(/\s+/)[0] || '-'}</span></div>
                                                                                                }

                                                                                                <div className=''><span className='font-w600 text-black'>Date & Time : </span><span>
                                                                                                    {`${receiverData?.created_date_dtm ?
                                                                                                        new Intl.DateTimeFormat("en-US", {
                                                                                                            year: "numeric",
                                                                                                            month: "short",
                                                                                                            day: "numeric",
                                                                                                            hour: 'numeric',
                                                                                                            minute: 'numeric',
                                                                                                            hour12: true
                                                                                                        }).format(
                                                                                                            receiverData?.created_date_dtm * 1000
                                                                                                        ) : '-'}`}
                                                                                                </span></div>

                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                    {proDiagnosis ?
                                                                                        <div
                                                                                            className='row'
                                                                                        >
                                                                                            <div
                                                                                                className='col-12 px-3 py-2 d-flex  flex-column'
                                                                                            >
                                                                                                <div className='pb-2 d-flex align-items-center justify-content-between'>
                                                                                                    <span className='font-w600 text-black fs-5'>
                                                                                                        {!toggleEditProDiagnosis ? <>{`Comments`}</> : null}
                                                                                                    </span>

                                                                                                    {permissionArray.includes("UPDATE WORK INFORMATION") &&
                                                                                                        <div className={`d-flex`}>
                                                                                                            {toggleEditProDiagnosis ?
                                                                                                                <>
                                                                                                                    <div className="d-flex align-items-center justify-content-center mx-2">
                                                                                                                        <div className="tooltipCustom">
                                                                                                                            <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Save"}</span>
                                                                                                                            <span
                                                                                                                                className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center"
                                                                                                                                onClick={(e) => { handleUpdateTicketSummary(e) }}
                                                                                                                                style={{ height: '30px', width: '30px', }}
                                                                                                                            >
                                                                                                                                <i className="bi bi-check2-circle text-success" style={{ color: 'green', fontSize: '18px' }} />
                                                                                                                            </span>
                                                                                                                        </div>
                                                                                                                    </div>

                                                                                                                    <div className="d-flex align-items-center justify-content-center">
                                                                                                                        <div className="tooltipCustom">
                                                                                                                            <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Close"}</span>
                                                                                                                            <span
                                                                                                                                className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center"
                                                                                                                                onClick={(e) => { setToggleEditProDiagnosis(false) }}
                                                                                                                                style={{ height: '30px', width: '30px', }}
                                                                                                                            >
                                                                                                                                <i className="bi bi-x-circle text-danger" style={{ fontSize: '18px' }} />
                                                                                                                            </span>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </> :
                                                                                                                <div className="d-flex align-items-center justify-content-center mx-2">
                                                                                                                    <div className="tooltipCustom">
                                                                                                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Edit"}</span>
                                                                                                                        <span
                                                                                                                            className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center"
                                                                                                                            onClick={(e) => {
                                                                                                                                setToggleEditProDiagnosis(true);
                                                                                                                            }}
                                                                                                                            style={{ height: '25px', width: '25px', }}
                                                                                                                        >
                                                                                                                            <i className="bi bi-pencil" style={{ fontSize: '12px' }} />
                                                                                                                        </span>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            }
                                                                                                        </div>
                                                                                                    }
                                                                                                </div>

                                                                                                <div
                                                                                                    className=' p-2 px-3'
                                                                                                    style={{
                                                                                                        border: toggleEditProDiagnosis ? 'none' : '1px solid rgb(0 0 0 / 26%)',
                                                                                                        borderRadius: '8px',
                                                                                                        backgroundColor: toggleEditProDiagnosis ? 'white' : 'rgba(245, 247, 251, 1)'
                                                                                                    }}
                                                                                                >
                                                                                                    {toggleEditProDiagnosis ?
                                                                                                        <TextArea
                                                                                                            labelName={"Comments *"}
                                                                                                            placeholderName={"Diagnosis"}
                                                                                                            value={`${proDiagnosis}`}
                                                                                                            onChange={(e) => { handleProDiagnosis(e) }}
                                                                                                            onBlur={() => { }}
                                                                                                            errorOccured={proDiagnosisErr}
                                                                                                            errorMessage={"Please add Diagnosis"}
                                                                                                            isRequired={true}
                                                                                                            rows={3}
                                                                                                        /> :
                                                                                                        <span>
                                                                                                            {proDiagnosis ?
                                                                                                                proDiagnosis :
                                                                                                                `-`}
                                                                                                        </span>
                                                                                                    }

                                                                                                </div>
                                                                                            </div>
                                                                                        </div> :
                                                                                        <>
                                                                                            <div className='px-3 py-2'>
                                                                                                <span className='font-w600 text-black fs-5'>
                                                                                                    {permissionArray.includes("CONNECT TO PRO") ? `Waiting for pro to provide an estimate.` : `No estimation available at the moment.`}
                                                                                                </span>
                                                                                            </div>
                                                                                        </>
                                                                                    }

                                                                                    {proDiagnosis &&
                                                                                        <div
                                                                                            className='row'
                                                                                        >
                                                                                            <div
                                                                                                className='col-12 px-3 pb-2 d-flex  flex-column'
                                                                                            >
                                                                                                <div className='pb-2'><span className='font-w600 text-black fs-5'>Estimated Cost</span></div>

                                                                                                <div
                                                                                                    className='p-2 px-3'
                                                                                                    style={{
                                                                                                        border: '1px solid rgb(0 0 0 / 26%)',
                                                                                                        borderRadius: '8px',
                                                                                                        backgroundColor: 'rgba(245, 247, 251, 1)'
                                                                                                    }}
                                                                                                >
                                                                                                    <div className='pb-3'><span> {`Our diagnosis puts the cost range between`}</span></div>

                                                                                                    <div className='d-flex align-items-center justify-content-between'>
                                                                                                        <div
                                                                                                            className='p-2 d-flex align-items-center justify-content-center bg-white'
                                                                                                            style={{
                                                                                                                border: '1px solid orange',
                                                                                                                borderRadius: '4px',
                                                                                                                width: '45%',
                                                                                                            }}
                                                                                                        >
                                                                                                            <span className='font-w600 text-black'>
                                                                                                                {serviceSummaryMetaData?.pro_check_info?.pro_estimated_cost_min ?
                                                                                                                    USDollar.format(parseFloat(serviceSummaryMetaData.pro_check_info.pro_estimated_cost_min.toFixed(2))) :
                                                                                                                    `-`}
                                                                                                            </span>
                                                                                                        </div>

                                                                                                        <div
                                                                                                            className='p-2 d-flex align-items-center justify-content-center'
                                                                                                        >
                                                                                                            <span> {`and`}</span>
                                                                                                        </div>

                                                                                                        <div
                                                                                                            className='p-2 d-flex align-items-center justify-content-center bg-white'
                                                                                                            style={{
                                                                                                                border: '1px solid orange',
                                                                                                                borderRadius: '4px',
                                                                                                                width: '45%',
                                                                                                            }}
                                                                                                        >
                                                                                                            <span className='font-w600 text-black'>

                                                                                                                {serviceSummaryMetaData?.pro_check_info?.pro_estimated_cost_max ?
                                                                                                                    USDollar.format(parseFloat(serviceSummaryMetaData.pro_check_info.pro_estimated_cost_max.toFixed(2))) :
                                                                                                                    `-`}
                                                                                                            </span>
                                                                                                        </div>

                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    }

                                                                                    {/* Pro Recommendation */}
                                                                                    {proRecommendedSolution ?
                                                                                        <div
                                                                                            className='row'
                                                                                        >
                                                                                            <div
                                                                                                className='col-12 px-3 pb-2 d-flex  flex-column'
                                                                                            >
                                                                                                <div className='pb-2'><span className='font-w600 text-black fs-5'>Pro Recommendation</span></div>

                                                                                                <div className='d-flex align-items-center'>
                                                                                                    <div
                                                                                                        className='p-2 px-3 me-3 d-flex align-items-center justify-content-center'
                                                                                                        style={{
                                                                                                            border: '1px solid rgb(0 0 0 / 26%)',
                                                                                                            borderRadius: '8px',
                                                                                                            backgroundColor: 'rgba(245, 247, 251, 1)',
                                                                                                            width: '90px',
                                                                                                            height: '75px',
                                                                                                        }}
                                                                                                    >
                                                                                                        <img
                                                                                                            src={
                                                                                                                proRecommendedSolution == 1 ?
                                                                                                                    NewDIYSoloImg :
                                                                                                                    proRecommendedSolution == 2 ?
                                                                                                                        NewDIYRemoteProImg :
                                                                                                                        proRecommendedSolution == 3 ?
                                                                                                                            NewLocalProImg :
                                                                                                                            NewLocalProImg
                                                                                                            }
                                                                                                            alt="Error"
                                                                                                            style={{ width: '35px', height: '35px', }}
                                                                                                        />
                                                                                                    </div>

                                                                                                    <div className='d-flex flex-column text-black'>
                                                                                                        <span className='font-w600 pb-1'>
                                                                                                            {`${proRecommendedSolution == 1 ? 'DIY (Solo)' : proRecommendedSolution == 2 ? 'DIY + Remote Pro' : proRecommendedSolution == 3 ? 'Local Pro' : 'Local Pro'}`}
                                                                                                        </span>
                                                                                                        <span className='font-w500'>
                                                                                                            {
                                                                                                                `
                                                                                                        ${proRecommendedSolution == 1 ? 'Use the Chilll Tech Tool Box to manage your project.' :
                                                                                                                    proRecommendedSolution == 2 ? 'Connect with a remote pro & get expert guidance.' :
                                                                                                                        proRecommendedSolution == 3 ? 'Get a qualified Pro to your house on your terms.' : ''}`
                                                                                                            }
                                                                                                        </span>
                                                                                                    </div>
                                                                                                </div>



                                                                                            </div>
                                                                                        </div> :
                                                                                        null
                                                                                    }


                                                                                    {/* Customer selection */}
                                                                                    {customerSelectedSolution != 4 ?
                                                                                        <div
                                                                                            className='row'
                                                                                        >
                                                                                            <div
                                                                                                className='col-12 px-3 pb-2 d-flex  flex-column'
                                                                                            >
                                                                                                <div className='pb-2'><span className='font-w600 text-black fs-5'>{`${permissionArray.includes("CONNECT TO PRO") ? 'Your' : 'Customer'}  Selection`}</span></div>

                                                                                                <div
                                                                                                    className='d-flex align-items-center p-2 rounded-2'
                                                                                                    style={{
                                                                                                        backgroundColor: 'rgba(255, 238, 208, 1)',
                                                                                                        border: '1px solid rgba(216, 122, 36, 1)',
                                                                                                    }}
                                                                                                >
                                                                                                    <div
                                                                                                        className='p-2 px-3 me-3 d-flex align-items-center justify-content-center'
                                                                                                        style={{
                                                                                                            // border: '1px solid rgb(0 0 0 / 26%)',
                                                                                                            // borderRadius: '8px',
                                                                                                            // backgroundColor: 'rgba(245, 247, 251, 1)',
                                                                                                            width: '90px',
                                                                                                            height: '75px',
                                                                                                        }}
                                                                                                    >
                                                                                                        <img
                                                                                                            src={
                                                                                                                customerSelectedSolution == 1 ?
                                                                                                                    NewDIYSoloImg :
                                                                                                                    customerSelectedSolution == 2 ?
                                                                                                                        NewDIYRemoteProImg :
                                                                                                                        customerSelectedSolution == 3 ?
                                                                                                                            NewLocalProImg :
                                                                                                                            NewLocalProImg
                                                                                                            }
                                                                                                            alt="Error"
                                                                                                            style={{ width: '35px', height: '35px', }}
                                                                                                        />
                                                                                                    </div>

                                                                                                    <div className='d-flex flex-column text-black'>
                                                                                                        <span className='font-w600 pb-1'>
                                                                                                            {`${customerSelectedSolution == 1 ? 'DIY (Solo)' : customerSelectedSolution == 2 ? 'DIY + Remote Pro' : customerSelectedSolution == 3 ? 'Local Pro' : 'Local Pro'}`}
                                                                                                        </span>
                                                                                                        <span className='font-w500'>
                                                                                                            {
                                                                                                                `
                                                                                                        ${customerSelectedSolution == 1 ? 'Use the Chilll Tech Tool Box to manage your project.' :
                                                                                                                    customerSelectedSolution == 2 ? 'Connect with a remote pro & get expert guidance.' :
                                                                                                                        customerSelectedSolution == 3 ? 'Get a qualified Pro to your house on your terms.' : ''}`
                                                                                                            }
                                                                                                        </span>
                                                                                                    </div>
                                                                                                </div>

                                                                                            </div>
                                                                                        </div> :
                                                                                        null
                                                                                    }

                                                                                    {permissionArray.includes("CONNECT TO PRO") && proDiagnosis &&
                                                                                        <div
                                                                                            className='row m-2 mx-3 pb-2'
                                                                                            style={{
                                                                                                // border: '3px solid orange',
                                                                                                // borderRadius: '8px',
                                                                                                opacity: (permissionArray.includes("CONNECT TO PRO") && receiverData.ticket_status_ysn != 0 && receiverData.ticket_status_ysn != 7) ? 1 : 0.8,
                                                                                                pointerEvents: (permissionArray.includes("CONNECT TO PRO") && receiverData.ticket_status_ysn != 0 && receiverData.ticket_status_ysn != 7) ? 'auto' : 'none',
                                                                                            }}
                                                                                        >
                                                                                            <div
                                                                                                className='col-12 d-flex  flex-column'
                                                                                            >
                                                                                                <div className='d-flex justify-content-center align-items-center'>
                                                                                                    <PrimaryButton
                                                                                                        buttonName={`NEXT`}
                                                                                                        onClick={(e) => { setToggleForEstimationsTab(`2`) }}
                                                                                                        loadingMessage={"Saving..."}
                                                                                                        isLoading={false}
                                                                                                        style={{
                                                                                                            width: '100%',
                                                                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                                            fontWeight: '600',
                                                                                                        }}
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    }

                                                                                    {/* Currently disabled for the new design */}
                                                                                    {false &&
                                                                                        <div
                                                                                            className='row m-2 mx-3'
                                                                                            style={{
                                                                                                border: '3px solid orange',
                                                                                                borderRadius: '8px',
                                                                                                opacity: (permissionArray.includes("CONNECT TO PRO") && receiverData.ticket_status_ysn != 0 && receiverData.ticket_status_ysn != 7) ? 1 : 0.8,
                                                                                                pointerEvents: (permissionArray.includes("CONNECT TO PRO") && receiverData.ticket_status_ysn != 0 && receiverData.ticket_status_ysn != 7) ? 'auto' : 'none',
                                                                                            }}
                                                                                        >
                                                                                            <div
                                                                                                className='col-12 p-3 d-flex  flex-column'
                                                                                            >
                                                                                                <div className='pb-2'><span className='font-w600 text-primary fs-5'>{`Pro Recommendation`}</span></div>

                                                                                                <div className='d-flex align-items-center justify-content-between'>
                                                                                                    <div
                                                                                                        className='p-2 d-flex align-items-center justify-content-center flex-column justify-content-between position-relative'
                                                                                                        // onClick={(e) => {
                                                                                                        //     setProRecommendedSolution(1);
                                                                                                        //     if (receiverData?.project_id_lng) {
                                                                                                        //         localStorage.setItem("projectId", receiverData?.project_id_lng);
                                                                                                        //         localStorage.setItem("DIYprojectStep", 3);
                                                                                                        //         navigate('/DIYproject')
                                                                                                        //     } else {
                                                                                                        //         handleCreateDIYProject(attachmentsArr[0].url);
                                                                                                        //         handleUpdateTicketSummary(e, 1);
                                                                                                        //     }
                                                                                                        // }}
                                                                                                        style={{
                                                                                                            // border: '3px solid #fd6516',
                                                                                                            borderRadius: '10px',
                                                                                                            width: '32%',
                                                                                                            height: '120px',
                                                                                                            backgroundColor: proRecommendedSolution == 1 ? '#fd6516' : 'rgba(79, 93, 116, 1)',
                                                                                                            // pointerEvents: createUpdateProjectLoading ? 'none' : 'auto',
                                                                                                            // opacity: 0.6,
                                                                                                        }}
                                                                                                    >
                                                                                                        {createUpdateProjectLoading &&
                                                                                                            <div
                                                                                                                className='position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center'
                                                                                                                style={{
                                                                                                                    borderRadius: '10px',
                                                                                                                    backgroundColor: 'rgb(146 65 47 / 62%)',
                                                                                                                }}
                                                                                                            >
                                                                                                                <Spinner animation="border" style={{ color: 'black' }} className='' />
                                                                                                            </div>
                                                                                                        }
                                                                                                        <div className='text-center d-flex flex-column'>
                                                                                                            <span className='font-w600 text-white text-center'>
                                                                                                                {`DIY`}
                                                                                                            </span>
                                                                                                            <span className='font-w600 text-white text-center'>
                                                                                                                {`(Solo)`}
                                                                                                            </span>
                                                                                                        </div>

                                                                                                        <img src={DIYSoloImg} alt="Error" style={{ width: '60px', height: '50px', marginTop: '5px', }} />
                                                                                                    </div>

                                                                                                    <div
                                                                                                        className='p-2 d-flex align-items-center justify-content-center flex-column justify-content-between '
                                                                                                        // onClick={(e) => {
                                                                                                        //     setProRecommendedSolution(2);
                                                                                                        //     initiateProSearching();
                                                                                                        //     handleUpdateTicketSummary(e, 2);
                                                                                                        // }}
                                                                                                        style={{
                                                                                                            // border: '3px solid #fd6516',
                                                                                                            borderRadius: '10px',
                                                                                                            width: '32%',
                                                                                                            height: '120px',
                                                                                                            backgroundColor: proRecommendedSolution == 2 ? '#fd6516' : 'rgba(79, 93, 116, 1)',
                                                                                                        }}
                                                                                                    >
                                                                                                        <div className='text-center d-flex flex-column'>
                                                                                                            <span className='font-w600 text-white text-center'>
                                                                                                                {`DIY + remote`}
                                                                                                            </span>
                                                                                                            <span className='font-w600 text-white text-center'>
                                                                                                                {`Pro`}
                                                                                                            </span>
                                                                                                        </div>

                                                                                                        <img src={remoteProImg} alt="Error" style={{ width: '60px', height: '50px', marginTop: '5px', }} />
                                                                                                    </div>

                                                                                                    <div
                                                                                                        className='p-2 d-flex align-items-center justify-content-center flex-column justify-content-between'
                                                                                                        // onClick={() => {
                                                                                                        //     setProRecommendedSolution(3);
                                                                                                        //     handleOpenLocalProModal();
                                                                                                        // }}
                                                                                                        style={{
                                                                                                            // border: '3px solid #fd6516',
                                                                                                            borderRadius: '10px',
                                                                                                            width: '32%',
                                                                                                            height: '120px',
                                                                                                            backgroundColor: proRecommendedSolution == 3 ? '#fd6516' : 'rgba(79, 93, 116, 1)',
                                                                                                        }}
                                                                                                    >
                                                                                                        <span className='font-w600 text-white text-center'>
                                                                                                            {`Local Pro`}
                                                                                                        </span>

                                                                                                        <img src={localProImg} alt="Error" style={{ width: '60px', height: '60px', marginTop: '5px', }} />
                                                                                                    </div>

                                                                                                </div>

                                                                                            </div>
                                                                                        </div>
                                                                                    }

                                                                                    {/* Hide for now as per feedback on 3 feb 2026 */}
                                                                                    {Object.keys(serviceSummaryMetaData?.estimated_by_customer || {}).length > 0 && false &&
                                                                                        <div
                                                                                            className='row'
                                                                                        >
                                                                                            <div
                                                                                                className='col-12 px-3 pb-2 d-flex  flex-column'
                                                                                            >
                                                                                                <div className='pb-3'><span className='font-w600 text-black fs-5'>{`Estimated Cost by Customer`}</span></div>
                                                                                                <div
                                                                                                    className='p-2 px-3'
                                                                                                    style={{
                                                                                                        border: '1px solid rgb(0 0 0 / 26%)',
                                                                                                        borderRadius: '8px',
                                                                                                        backgroundColor: 'rgba(245, 247, 251, 1)'
                                                                                                    }}
                                                                                                >
                                                                                                    {serviceSummaryMetaData?.estimated_by_customer?.date && <div className='pb-3'><span>  {`${serviceSummaryMetaData?.estimated_by_customer?.date}, ${serviceSummaryMetaData?.estimated_by_customer?.time}`}</span></div>}

                                                                                                    <div className='d-flex align-items-center justify-content-between'>
                                                                                                        <div
                                                                                                            className='p-2 d-flex align-items-center justify-content-center bg-white'
                                                                                                            style={{
                                                                                                                border: '1px solid orange',
                                                                                                                borderRadius: '4px',
                                                                                                                width: '45%',
                                                                                                            }}
                                                                                                        >
                                                                                                            <span className='font-w600 text-black'>
                                                                                                                {serviceSummaryMetaData?.estimated_by_customer?.min_cost ?
                                                                                                                    USDollar.format(parseFloat(serviceSummaryMetaData?.estimated_by_customer.min_cost.toFixed(2))) :
                                                                                                                    `-`}
                                                                                                            </span>
                                                                                                        </div>

                                                                                                        <div
                                                                                                            className='p-2 d-flex align-items-center justify-content-center'
                                                                                                        >
                                                                                                            <span> {`and`}</span>
                                                                                                        </div>

                                                                                                        <div
                                                                                                            className='p-2 d-flex align-items-center justify-content-center bg-white'
                                                                                                            style={{
                                                                                                                border: '1px solid orange',
                                                                                                                borderRadius: '4px',
                                                                                                                width: '45%',
                                                                                                            }}
                                                                                                        >
                                                                                                            <span className='font-w600 text-black'>

                                                                                                                {serviceSummaryMetaData?.estimated_by_customer?.max_cost ?
                                                                                                                    USDollar.format(parseFloat(serviceSummaryMetaData?.estimated_by_customer?.max_cost.toFixed(2))) :
                                                                                                                    `-`}
                                                                                                            </span>
                                                                                                        </div>

                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>}
                                                                                </div> :
                                                                                toggleForEstimationsTab == `2` ?
                                                                                    <div className='col-12 px-0  '>
                                                                                        <div
                                                                                            className='row'
                                                                                        >
                                                                                            <div
                                                                                                className='col-12 d-flex  flex-column'
                                                                                            >
                                                                                                <div className='d-flex align-items-center justify-content-start'>
                                                                                                    <span
                                                                                                        className='font-w600 overlay-action-btn cursor-pointer p-1 d-flex align-items-center justify-content-center rounded-3'
                                                                                                        style={{}}
                                                                                                        onClick={() => { setToggleForEstimationsTab(`1`) }}
                                                                                                    >
                                                                                                        <i className="bi bi-arrow-left me-2"></i>
                                                                                                        <span>{`Back`}</span>
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>

                                                                                        <div
                                                                                            className='row m-2 mb-3 bg-white shadow-sm'
                                                                                            style={{
                                                                                                // border: '3px solid orange',
                                                                                                borderRadius: '8px',
                                                                                            }}
                                                                                        >
                                                                                            <div
                                                                                                className='col-12  d-flex  flex-column'
                                                                                            >
                                                                                                <div
                                                                                                    className=' p-3 d-flex align-items-center'
                                                                                                    style={{
                                                                                                        borderBottom: '4px solid rgb(250, 239, 230)'
                                                                                                    }}
                                                                                                >
                                                                                                    <span className='font-w600 text-black fs-5'>
                                                                                                        {`Pro Recommendation`}
                                                                                                    </span>
                                                                                                </div>

                                                                                                <div className='p-2'>
                                                                                                    <div className='row mx-0'>
                                                                                                        <div className=' col-12 px-0 d-flex align-items-center'>
                                                                                                            {proRecommendedSolution ?
                                                                                                                <div className='row mx-0 w-100 font-w600'>
                                                                                                                    <div className='d-flex align-items-center col-12'>
                                                                                                                        <span className='me-3 text-center' style={{ color: 'rgba(91, 72, 169, 1)', fontSize: '20px' }}>
                                                                                                                            <i class="bi bi-check2-all"></i>
                                                                                                                        </span>
                                                                                                                        <span className=' text-center me-1'>
                                                                                                                            {"Go with the"}
                                                                                                                        </span>
                                                                                                                        <span className=' text-center font-w600 text-primary'>
                                                                                                                            {`${proRecommendedSolution == 1 ? `DIY (Solo)` : proRecommendedSolution == 2 ? `DIY + remote Pro` : proRecommendedSolution == 3 ? `Local Pro` : ``} `}
                                                                                                                        </span>
                                                                                                                    </div>

                                                                                                                    <div className='d-flex align-items-center col-12'>
                                                                                                                        <span className='me-3 text-center' style={{ color: 'rgba(91, 72, 169, 1)', fontSize: '20px' }}>
                                                                                                                            <i class="bi bi-check2-all"></i>
                                                                                                                        </span>

                                                                                                                        <div className='d-flex flex-column'>
                                                                                                                            <span className='me-1'>
                                                                                                                                {"Expected to pay between "}
                                                                                                                            </span>

                                                                                                                            <div className='text-primary font-w600'>
                                                                                                                                <span className=''>
                                                                                                                                    {serviceSummaryMetaData?.pro_check_info?.pro_estimated_cost_min ?
                                                                                                                                        USDollar.format(parseFloat(serviceSummaryMetaData.pro_check_info.pro_estimated_cost_min.toFixed(2))) :
                                                                                                                                        `$0.00`}
                                                                                                                                </span>
                                                                                                                                {` & `}
                                                                                                                                <span className=''>
                                                                                                                                    {serviceSummaryMetaData?.pro_check_info?.pro_estimated_cost_max ?
                                                                                                                                        USDollar.format(parseFloat(serviceSummaryMetaData.pro_check_info.pro_estimated_cost_max.toFixed(2))) :
                                                                                                                                        `$0.00`}
                                                                                                                                </span>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div> :
                                                                                                                <span className='font-w600 '>
                                                                                                                    {`No recommendations available yet.`}
                                                                                                                </span>
                                                                                                            }
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>

                                                                                        <div
                                                                                            className='row m-2 bg-white shadow-sm'
                                                                                            style={{
                                                                                                // border: '3px solid orange',
                                                                                                borderRadius: '8px',
                                                                                                opacity: (permissionArray.includes("CONNECT TO PRO") && receiverData.ticket_status_ysn != 0 && receiverData.ticket_status_ysn != 7) ? 1 : 0.8,
                                                                                                pointerEvents: (permissionArray.includes("CONNECT TO PRO") && receiverData.ticket_status_ysn != 0 && receiverData.ticket_status_ysn != 7) ? 'auto' : 'none',
                                                                                            }}
                                                                                        >
                                                                                            <div
                                                                                                className='col-12  d-flex  flex-column'
                                                                                            >
                                                                                                <div
                                                                                                    className=' p-3'
                                                                                                    style={{
                                                                                                        borderBottom: '4px solid rgb(250, 239, 230)'
                                                                                                    }}
                                                                                                >
                                                                                                    <span className='font-w600 text-black fs-5'>{`What would you like to do?`}</span>
                                                                                                </div>

                                                                                                <div className='m-2'>

                                                                                                    <div
                                                                                                        className='d-flex align-items-center p-3 rounded-2 mb-2 flex-column'
                                                                                                        onClick={(e) => {
                                                                                                            e.preventDefault();
                                                                                                            e.stopPropagation();
                                                                                                            // setProRecommendedSolution(1);
                                                                                                            setCustomerSelectedSolution(1);

                                                                                                            // Action are updated to buttons as per feedback so commented for now
                                                                                                            // if (receiverData?.project_id_lng) {
                                                                                                            //     localStorage.setItem("projectId", receiverData?.project_id_lng);
                                                                                                            //     localStorage.setItem("DIYprojectStep", 3);
                                                                                                            //     navigate('/DIYproject')
                                                                                                            // } else {
                                                                                                            //     // handleCreateDIYProject(attachmentsArr[0].url);
                                                                                                            //     handleCreateDIYProjectNewFlow();
                                                                                                            //     handleUpdateTicketSummary(e, 1);
                                                                                                            // }
                                                                                                        }}
                                                                                                        style={{
                                                                                                            backgroundColor: customerSelectedSolution == 1 ? 'rgba(255, 238, 208, 1)' : '',
                                                                                                            border: '1px solid rgba(216, 122, 36, 1)',
                                                                                                        }}
                                                                                                    >
                                                                                                        <div className='d-flex align-items-center justify-content-between w-100 pb-2'>
                                                                                                            <div className='d-flex align-items-center'>
                                                                                                                <div
                                                                                                                    className='p-2 px-3 me-3 ms-2 d-flex align-items-center justify-content-center'
                                                                                                                    style={{
                                                                                                                        // border: '1px solid rgb(0 0 0 / 26%)',
                                                                                                                        // borderRadius: '8px',
                                                                                                                        // backgroundColor: 'rgba(245, 247, 251, 1)',
                                                                                                                        width: '30px',
                                                                                                                        height: '30px',
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <img
                                                                                                                        src={NewDIYSoloImg}
                                                                                                                        alt="Error"
                                                                                                                        style={{ width: '25px', height: '25px', }}
                                                                                                                    />
                                                                                                                </div>

                                                                                                                <span className='font-w600 pb-1 text-black'>
                                                                                                                    {`DIY (Solo)`}
                                                                                                                </span>
                                                                                                            </div>

                                                                                                            <div className="ms-2">

                                                                                                                <div
                                                                                                                    className="align-items-center d-flex fs-3 justify-content-center "
                                                                                                                    style={{
                                                                                                                        // height: "41px",
                                                                                                                        // width: "30px",
                                                                                                                        // border: "1px solid rgb(179 179 179 / 64%)",
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <span
                                                                                                                        className='rounded-circle d-flex align-items-center justify-content-center cursor-pointer text-white'
                                                                                                                        style={{
                                                                                                                            height: '20px',
                                                                                                                            width: '20px',
                                                                                                                            border: '2px solid rgb(252 128 25)',
                                                                                                                            backgroundColor: customerSelectedSolution == 1 ? 'rgb(252 128 25)' : 'transparent',
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <i className="bi bi-check" />
                                                                                                                    </span>
                                                                                                                </div>

                                                                                                            </div>
                                                                                                        </div>

                                                                                                        <div className='d-flex align-items-end justify-content-between w-100'>
                                                                                                            <div className='d-flex align-items-center pe-4'>


                                                                                                                <span className='font-w500 pb-1'>
                                                                                                                    {`Use the Chilll Tech Tool Box to manage your project.`}
                                                                                                                </span>
                                                                                                            </div>

                                                                                                            <div>
                                                                                                                <span className='font-w600 text-black'>
                                                                                                                    {`Free`}
                                                                                                                </span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    <div
                                                                                                        className='d-flex align-items-center p-3 rounded-2 mb-2 flex-column'
                                                                                                        onClick={(e) => {
                                                                                                            e.preventDefault();
                                                                                                            e.stopPropagation();
                                                                                                            // setProRecommendedSolution(2);
                                                                                                            // initiateProSearching();
                                                                                                            // handleUpdateTicketSummary(e, 2);

                                                                                                            setCustomerSelectedSolution(2);

                                                                                                            // Code commented for the new flow for connect to new flow
                                                                                                            // if (cardArr?.length === 0 && sentRequest?.length > 0) {
                                                                                                            //     setAlertCardsModalTrigger(true);
                                                                                                            // } else {
                                                                                                            //     handleShowConfirmationForConnectToProModal();
                                                                                                            // }


                                                                                                            // Code commented for the new flow for connect to new flow

                                                                                                            // if (permissionArray.includes("CONNECT TO PRO") && Object.keys(receiverData)?.length > 0) {
                                                                                                            //     if (receiverData?.calls[0]?.call_log_id_ids &&
                                                                                                            //         localStorage.getItem("user_id") &&
                                                                                                            //         receiverData?.remaining_time_in_sec == 0) {
                                                                                                            //         handleShowConfirmationForConnectToProModal();
                                                                                                            //     } else {
                                                                                                            //         setProRecommendedSolution(2);
                                                                                                            //         initiateProSearching();
                                                                                                            //         handleUpdateTicketSummary(e, 2);
                                                                                                            //     }
                                                                                                            // } else {
                                                                                                            //     setProRecommendedSolution(2);
                                                                                                            //     initiateProSearching();
                                                                                                            //     handleUpdateTicketSummary(e, 2);
                                                                                                            // }
                                                                                                        }}
                                                                                                        style={{
                                                                                                            backgroundColor: customerSelectedSolution == 2 ? 'rgba(255, 238, 208, 1)' : '',
                                                                                                            border: '1px solid rgba(216, 122, 36, 1)',
                                                                                                        }}
                                                                                                    >
                                                                                                        <div className='d-flex align-items-center justify-content-between w-100 pb-2'>
                                                                                                            <div className='d-flex align-items-center'>
                                                                                                                <div
                                                                                                                    className='p-2 px-3 me-3 ms-2 d-flex align-items-center justify-content-center'
                                                                                                                    style={{
                                                                                                                        // border: '1px solid rgb(0 0 0 / 26%)',
                                                                                                                        // borderRadius: '8px',
                                                                                                                        // backgroundColor: 'rgba(245, 247, 251, 1)',
                                                                                                                        width: '30px',
                                                                                                                        height: '30px',
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <img
                                                                                                                        src={NewDIYRemoteProImg}
                                                                                                                        alt="Error"
                                                                                                                        style={{ width: '25px', height: '25px', }}
                                                                                                                    />
                                                                                                                </div>

                                                                                                                <span className='font-w600 pb-1 text-black'>
                                                                                                                    {`DIY + Remote Pro`}
                                                                                                                </span>
                                                                                                            </div>

                                                                                                            <div className="ms-2">
                                                                                                                <div
                                                                                                                    className="align-items-center d-flex fs-3 justify-content-center "
                                                                                                                    style={{
                                                                                                                        // height: "41px",
                                                                                                                        // width: "30px",
                                                                                                                        // border: "1px solid rgb(179 179 179 / 64%)",
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <span
                                                                                                                        className='rounded-circle d-flex align-items-center justify-content-center cursor-pointer text-white'
                                                                                                                        style={{
                                                                                                                            height: '20px',
                                                                                                                            width: '20px',
                                                                                                                            border: '2px solid rgb(252 128 25)',
                                                                                                                            backgroundColor: customerSelectedSolution == 2 ? 'rgb(252 128 25)' : 'transparent',
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <i className="bi bi-check" />
                                                                                                                    </span>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>

                                                                                                        <div className='d-flex align-items-end justify-content-between w-100'>
                                                                                                            <div className='d-flex align-items-center pe-4'>


                                                                                                                <span className='font-w500 pb-1'>
                                                                                                                    {`Connect with a remote pro & get expert guidance.`}
                                                                                                                </span>
                                                                                                            </div>

                                                                                                            <div
                                                                                                                className='d-flex justify-content-end align-items-end'
                                                                                                                style={{
                                                                                                                    minWidth: 'max-content'
                                                                                                                }}
                                                                                                            >
                                                                                                                <span className='font-w600 text-black fs-5'>
                                                                                                                    {`${USDollar.format(
                                                                                                                        parseFloat(callChargeAmount?.toFixed(2))
                                                                                                                    )}`}
                                                                                                                </span>
                                                                                                                <span className='fs-7'>
                                                                                                                    {`/${callDurationTimeLimit} mins`}
                                                                                                                </span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    <div
                                                                                                        className='d-flex align-items-center p-3 rounded-2 mb-2 flex-column'
                                                                                                        onClick={(e) => {
                                                                                                            e.preventDefault();
                                                                                                            e.stopPropagation();
                                                                                                            setCustomerSelectedSolution(3);

                                                                                                            // Commented as per new flow
                                                                                                            // handleOpenLocalProModal();
                                                                                                        }}
                                                                                                        style={{
                                                                                                            backgroundColor: customerSelectedSolution == 3 ? 'rgba(255, 238, 208, 1)' : '',
                                                                                                            border: '1px solid rgba(216, 122, 36, 1)',
                                                                                                            // pointerEvents: customerSelectedSolution == 3 ? 'none' : 'auto',
                                                                                                            // opacity: customerSelectedSolution == 3 ? 0.6 : 1,
                                                                                                        }}
                                                                                                    >
                                                                                                        <div className='d-flex align-items-center justify-content-between w-100 pb-2'>
                                                                                                            <div className='d-flex align-items-center'>
                                                                                                                <div
                                                                                                                    className='p-2 px-3 me-3 ms-2 d-flex align-items-center justify-content-center'
                                                                                                                    style={{
                                                                                                                        // border: '1px solid rgb(0 0 0 / 26%)',
                                                                                                                        // borderRadius: '8px',
                                                                                                                        // backgroundColor: 'rgba(245, 247, 251, 1)',
                                                                                                                        width: '30px',
                                                                                                                        height: '30px',
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <img
                                                                                                                        src={NewLocalProImg}
                                                                                                                        alt="Error"
                                                                                                                        style={{ width: '25px', height: '25px', }}
                                                                                                                    />
                                                                                                                </div>

                                                                                                                <span className='font-w600 pb-1 text-black'>
                                                                                                                    {`Local Pro`}
                                                                                                                </span>
                                                                                                            </div>

                                                                                                            <div className="ms-2">

                                                                                                                <div
                                                                                                                    className="align-items-center d-flex fs-3 justify-content-center "
                                                                                                                    style={{
                                                                                                                        // height: "41px",
                                                                                                                        // width: "30px",
                                                                                                                        // border: "1px solid rgb(179 179 179 / 64%)",
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <span
                                                                                                                        className='rounded-circle d-flex align-items-center justify-content-center cursor-pointer text-white'
                                                                                                                        style={{
                                                                                                                            height: '20px',
                                                                                                                            width: '20px',
                                                                                                                            border: '2px solid rgb(252 128 25)',
                                                                                                                            backgroundColor: customerSelectedSolution == 3 ? 'rgb(252 128 25)' : 'transparent',
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <i className="bi bi-check" />
                                                                                                                    </span>
                                                                                                                </div>

                                                                                                            </div>
                                                                                                        </div>

                                                                                                        <div className='d-flex align-items-end justify-content-between w-100'>
                                                                                                            <div className='d-flex align-items-center pe-4'>


                                                                                                                <span className='font-w500 pb-1'>
                                                                                                                    {`Get a qualified Pro to your house on your terms.`}
                                                                                                                </span>
                                                                                                            </div>

                                                                                                            <div
                                                                                                                className='d-flex justify-content-end flex-column'
                                                                                                                style={{
                                                                                                                    minWidth: 'max-content'
                                                                                                                }}
                                                                                                            >
                                                                                                                <span className='font-w600 text-black text-center'>
                                                                                                                    {`Free Match`}
                                                                                                                </span>
                                                                                                                <span className='font-w600 text-black text-center'>
                                                                                                                    {` Making`}
                                                                                                                </span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    {permissionArray.includes("CONNECT TO PRO") &&
                                                                                                        <div
                                                                                                            className='row mt-4 pb-2'
                                                                                                            style={{
                                                                                                                // border: '3px solid orange',
                                                                                                                // borderRadius: '8px',
                                                                                                                opacity: (customerSelectedSolution && permissionArray.includes("CONNECT TO PRO") && receiverData.ticket_status_ysn != 0 && receiverData.ticket_status_ysn != 7) ? 1 : 0.8,
                                                                                                                pointerEvents: (customerSelectedSolution && permissionArray.includes("CONNECT TO PRO") && receiverData.ticket_status_ysn != 0 && receiverData.ticket_status_ysn != 7) ? 'auto' : 'none',
                                                                                                            }}
                                                                                                        >
                                                                                                            <div
                                                                                                                className='col-12 d-flex  flex-column'
                                                                                                            >
                                                                                                                <div className='d-flex justify-content-center align-items-center'>
                                                                                                                    <PrimaryButton
                                                                                                                        buttonName={`NEXT`}
                                                                                                                        onClick={(e) => { handleCustomerSelectedSolutionFn(e) }}
                                                                                                                        loadingMessage={"Saving..."}
                                                                                                                        isLoading={false}
                                                                                                                        style={{
                                                                                                                            width: '100%',
                                                                                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                                                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                                                            fontWeight: '600',
                                                                                                                        }}
                                                                                                                    />
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    }


                                                                                                </div>

                                                                                                {/* Old design for the customer selection process hide for now */}
                                                                                                {false &&
                                                                                                    <div className='d-flex align-items-center justify-content-between p-2'>
                                                                                                        <div
                                                                                                            className='p-2 d-flex align-items-center justify-content-center flex-column justify-content-between border-hovered cursor-pointer position-relative'
                                                                                                            onClick={(e) => {
                                                                                                                // setProRecommendedSolution(1);
                                                                                                                setCustomerSelectedSolution(1);
                                                                                                                if (receiverData?.project_id_lng) {
                                                                                                                    localStorage.setItem("projectId", receiverData?.project_id_lng);
                                                                                                                    localStorage.setItem("DIYprojectStep", 3);
                                                                                                                    navigate('/DIYproject')
                                                                                                                } else {
                                                                                                                    // handleCreateDIYProject(attachmentsArr[0].url);
                                                                                                                    handleCreateDIYProjectNewFlow();
                                                                                                                    handleUpdateTicketSummary(e, 1);
                                                                                                                }
                                                                                                            }}
                                                                                                            style={{
                                                                                                                // border: '3px solid #fd6516',
                                                                                                                borderRadius: '10px',
                                                                                                                width: '32%',
                                                                                                                height: '250px',
                                                                                                                backgroundColor: 'rgba(79, 93, 116, 1)',
                                                                                                                // backgroundColor: proRecommendedSolution == 1 ? '#fd6516' : 'rgba(79, 93, 116, 1)',
                                                                                                                // pointerEvents: createUpdateProjectLoading ? 'none' : 'auto',
                                                                                                                // opacity: 0.6,
                                                                                                            }}
                                                                                                        >
                                                                                                            {/* {proRecommendedSolution == 1 && */}
                                                                                                            {customerSelectedSolution == 1 &&
                                                                                                                <div
                                                                                                                    style={{
                                                                                                                        position: 'absolute',
                                                                                                                        top: '-25px',
                                                                                                                        left: 'translate(-50%, 0)'
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <i
                                                                                                                        class="bi bi-star-fill"
                                                                                                                        style={{
                                                                                                                            fontSize: '30px',
                                                                                                                            color: 'rgb(0 198 43)',
                                                                                                                            // textShadow: '0 0 10px green',
                                                                                                                            WebkitTextStroke: '2px white',     // outline
                                                                                                                            WebkitTextStrokeWidth: '2px'       // some browsers want this separate
                                                                                                                        }}
                                                                                                                    ></i>
                                                                                                                </div>
                                                                                                            }
                                                                                                            {createUpdateProjectLoading &&
                                                                                                                <div
                                                                                                                    className='position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center'
                                                                                                                    style={{
                                                                                                                        borderRadius: '10px',
                                                                                                                        backgroundColor: 'rgb(146 65 47 / 62%)',
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <Spinner animation="border" style={{ color: 'black' }} className='' />
                                                                                                                </div>
                                                                                                            }
                                                                                                            <div className='text-center d-flex flex-column mt-3'>
                                                                                                                <span className='font-w600 text-white text-center'>
                                                                                                                    {`DIY`}
                                                                                                                </span>
                                                                                                                <span className='font-w600 text-white text-center'>
                                                                                                                    {`(Solo)`}
                                                                                                                </span>
                                                                                                            </div>

                                                                                                            <img src={DIYSoloImg} alt="Error" style={{ width: '60px', height: '50px', marginTop: '5px', }} />

                                                                                                            <div className='text-center d-flex flex-column'>
                                                                                                                <span className='font-w600 text-white text-center fs-7'>
                                                                                                                    {`Use the Chilll tech Tool Box to manage your project`}
                                                                                                                </span>
                                                                                                            </div>

                                                                                                            <div className='text-center d-flex flex-column'>
                                                                                                                <span className='font-w600 text-white text-center fs-7'>
                                                                                                                    {`FREE`}
                                                                                                                </span>
                                                                                                            </div>
                                                                                                        </div>

                                                                                                        <div
                                                                                                            className='p-2 d-flex align-items-center justify-content-center flex-column justify-content-between border-hovered cursor-pointer position-relative'
                                                                                                            onClick={(e) => {
                                                                                                                // setProRecommendedSolution(2);
                                                                                                                // initiateProSearching();
                                                                                                                // handleUpdateTicketSummary(e, 2);

                                                                                                                if (cardArr?.length === 0 && sentRequest?.length > 0) {
                                                                                                                    setAlertCardsModalTrigger(true);
                                                                                                                } else {
                                                                                                                    handleShowConfirmationForConnectToProModal();
                                                                                                                }


                                                                                                                // Code commented for the new flow for connect to new flow

                                                                                                                // if (permissionArray.includes("CONNECT TO PRO") && Object.keys(receiverData)?.length > 0) {
                                                                                                                //     if (receiverData?.calls[0]?.call_log_id_ids &&
                                                                                                                //         localStorage.getItem("user_id") &&
                                                                                                                //         receiverData?.remaining_time_in_sec == 0) {
                                                                                                                //         handleShowConfirmationForConnectToProModal();
                                                                                                                //     } else {
                                                                                                                //         setProRecommendedSolution(2);
                                                                                                                //         initiateProSearching();
                                                                                                                //         handleUpdateTicketSummary(e, 2);
                                                                                                                //     }
                                                                                                                // } else {
                                                                                                                //     setProRecommendedSolution(2);
                                                                                                                //     initiateProSearching();
                                                                                                                //     handleUpdateTicketSummary(e, 2);
                                                                                                                // }
                                                                                                            }}
                                                                                                            style={{
                                                                                                                // border: '3px solid #fd6516',
                                                                                                                borderRadius: '10px',
                                                                                                                width: '32%',
                                                                                                                height: '250px',
                                                                                                                backgroundColor: 'rgba(79, 93, 116, 1)',
                                                                                                                // backgroundColor: proRecommendedSolution == 2 ? '#fd6516' : 'rgba(79, 93, 116, 1)',
                                                                                                            }}
                                                                                                        >
                                                                                                            {/* {proRecommendedSolution == 2 && */}
                                                                                                            {customerSelectedSolution == 2 &&
                                                                                                                <div
                                                                                                                    style={{
                                                                                                                        position: 'absolute',
                                                                                                                        top: '-25px',
                                                                                                                        left: 'translate(-50%, 0)'
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <i
                                                                                                                        class="bi bi-star-fill"
                                                                                                                        style={{
                                                                                                                            fontSize: '30px',
                                                                                                                            color: 'rgb(0 198 43)',
                                                                                                                            // textShadow: '0 0 10px green',
                                                                                                                            WebkitTextStroke: '2px white',     // outline
                                                                                                                            WebkitTextStrokeWidth: '2px'       // some browsers want this separate
                                                                                                                        }}
                                                                                                                    ></i>
                                                                                                                </div>
                                                                                                            }
                                                                                                            <div className='text-center d-flex flex-column mt-3'>
                                                                                                                <span className='font-w600 text-white text-center'>
                                                                                                                    {`DIY + remote`}
                                                                                                                </span>
                                                                                                                <span className='font-w600 text-white text-center'>
                                                                                                                    {`Pro`}
                                                                                                                </span>
                                                                                                            </div>

                                                                                                            <img src={remoteProImg} alt="Error" style={{ width: '60px', height: '50px', marginTop: '5px', }} />

                                                                                                            <div className='text-center d-flex flex-column'>
                                                                                                                <span className='font-w600 text-white text-center fs-7'>
                                                                                                                    {`Connect with a remote Pro & get expert guidance`}
                                                                                                                </span>
                                                                                                            </div>

                                                                                                            <div className='text-center d-flex flex-column'>
                                                                                                                <span className='font-w600 text-white text-center fs-7'>
                                                                                                                    {`${USDollar.format(
                                                                                                                        parseFloat(callChargeAmount?.toFixed(2))
                                                                                                                    )} for ${callDurationTimeLimit} min`}
                                                                                                                </span>
                                                                                                            </div>
                                                                                                        </div>

                                                                                                        <div
                                                                                                            className='p-2 d-flex align-items-center justify-content-center flex-column justify-content-between border-hovered cursor-pointer position-relative'
                                                                                                            onClick={() => {
                                                                                                                // setProRecommendedSolution(3);
                                                                                                                setCustomerSelectedSolution(3);
                                                                                                                handleOpenLocalProModal();
                                                                                                            }}
                                                                                                            style={{
                                                                                                                // border: '3px solid #fd6516',
                                                                                                                borderRadius: '10px',
                                                                                                                width: '32%',
                                                                                                                height: '250px',
                                                                                                                backgroundColor: 'rgba(79, 93, 116, 1)',
                                                                                                                // backgroundColor: proRecommendedSolution == 3 ? '#fd6516' : 'rgba(79, 93, 116, 1)',
                                                                                                            }}
                                                                                                        >
                                                                                                            {/* {proRecommendedSolution == 3 && */}
                                                                                                            {customerSelectedSolution == 3 &&
                                                                                                                <div
                                                                                                                    style={{
                                                                                                                        position: 'absolute',
                                                                                                                        top: '-25px',
                                                                                                                        left: 'translate(-50%, 0)'
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <i
                                                                                                                        class="bi bi-star-fill"
                                                                                                                        style={{
                                                                                                                            fontSize: '30px',
                                                                                                                            color: 'rgb(0 198 43)',
                                                                                                                            // textShadow: '0 0 10px green',
                                                                                                                            WebkitTextStroke: '2px white',     // outline
                                                                                                                            WebkitTextStrokeWidth: '2px'       // some browsers want this separate
                                                                                                                        }}
                                                                                                                    ></i>
                                                                                                                </div>
                                                                                                            }

                                                                                                            <span className='font-w600 text-white text-center mt-3'>
                                                                                                                {`Local Pro`}
                                                                                                            </span>

                                                                                                            <img src={localProImg} alt="Error" style={{ width: '60px', height: '60px', marginTop: '5px', }} />

                                                                                                            <div className='text-center d-flex flex-column'>
                                                                                                                <span className='font-w600 text-white text-center fs-7'>
                                                                                                                    {`Get a qualified pro to your house on your terms`}
                                                                                                                </span>
                                                                                                            </div>

                                                                                                            <div className='text-center d-flex flex-column'>
                                                                                                                <span className='font-w600 text-white text-center fs-7'>
                                                                                                                    {`FREE Match Making`}
                                                                                                                </span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                }
                                                                                            </div>
                                                                                        </div>

                                                                                    </div> : <></>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        }

                                                        {/* Call Notes list */}
                                                        {tabsToggleServiceReq === 5 &&
                                                            <>
                                                                <div className='row mt-2'>
                                                                    <div className='col-12 px-0'>
                                                                        <div className='row mx-0 overflow-auto pb-5'
                                                                            style={{
                                                                                //  minHeight: "300px", 
                                                                                //  maxHeight: "300px",  
                                                                                maxHeight: window.innerWidth < 768 ? "calc(100dvh - 196px)" : `${imgMaxHeight - 60}px`,
                                                                                minHeight: window.innerWidth < 768 ? "calc(100dvh - 196px)" : `${imgMaxHeight - 60}px`,
                                                                            }}
                                                                        >
                                                                            <div className='col-12 px-0'>

                                                                                {callNoteDetailsArr.length > 0 ?
                                                                                    <>
                                                                                        {
                                                                                            callNoteDetailsArr.map((element, index) => {
                                                                                                return (
                                                                                                    <div key={index} className='row px-3 fs-6 border-bottom py-2 '>
                                                                                                        <div className='col-12 px-0 d-flex'>

                                                                                                            <div className='pe-3 d-flex justify-content-center'>
                                                                                                                <div>
                                                                                                                    <div className='rounded-2 shadow-lg'>
                                                                                                                        <div
                                                                                                                            className='rounded-2 d-flex justify-content-center align-items-center'
                                                                                                                            style={{ height: '40px', width: '40px', background: 'rgba(79, 93, 116, 1)' }}
                                                                                                                        >
                                                                                                                            {element?.preferred_profile_picture_url ?
                                                                                                                                <img src={element?.preferred_profile_picture_url} alt="Avatar" className="rounded-2" style={{ height: '40px', width: '40px' }} /> :
                                                                                                                                <i className="bi bi-file-earmark-image-fill fs-3 text-white"></i>
                                                                                                                            }
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>

                                                                                                            <div className='w-100'>
                                                                                                                <div className='row mx-0 mb-1'>
                                                                                                                    <div className='col-10 px-0  font-w500'>
                                                                                                                        <span className='text-black pe-2'>{`${element?.created_by_name}`}</span>
                                                                                                                        <span className='fs-7'>{`${formatUnixTimestamp(element?.created_date_dtm)}`}</span>
                                                                                                                    </div>

                                                                                                                    <div className='col-2 px-0 d-flex justify-content-end'>

                                                                                                                        <span className=' text-black'>
                                                                                                                            <OverlayTrigger
                                                                                                                                key={index}
                                                                                                                                trigger="click"
                                                                                                                                placement="bottom"
                                                                                                                                // overlay={popover}
                                                                                                                                overlay={popoverNoteActions(index)}
                                                                                                                                rootClose={true}
                                                                                                                                show={activePopoverNotes === index}
                                                                                                                                onToggle={(show) =>
                                                                                                                                    setActivePopoverNotes(
                                                                                                                                        show ? index : null
                                                                                                                                    )
                                                                                                                                }>
                                                                                                                                <i
                                                                                                                                    onClick={() => handleMenuClickNotes(element, index)}
                                                                                                                                    className="bi bi-three-dots-vertical cursor-pointer text-hovered"
                                                                                                                                ></i>
                                                                                                                            </OverlayTrigger>
                                                                                                                        </span>
                                                                                                                    </div>
                                                                                                                </div>

                                                                                                                <div className='row mx-0 mb-1'>
                                                                                                                    <div className='col-12 px-0 d-flex justify-content-start font-w500'>
                                                                                                                        <span className=' pe-3'>
                                                                                                                            {`${element?.note_chr}`}
                                                                                                                        </span>
                                                                                                                    </div>
                                                                                                                </div>

                                                                                                                <div className='row mx-0 mb-1'>
                                                                                                                    <div
                                                                                                                        className='col-12 px-0 d-flex '
                                                                                                                        style={{ overflow: 'auto', }}
                                                                                                                    >
                                                                                                                        {element?.attachment_url.map((elem, ind) => {
                                                                                                                            return (
                                                                                                                                <span className='call-notes-individual-img-download-span' key={index}>

                                                                                                                                    <img
                                                                                                                                        className='call-notes-individual-img-download'
                                                                                                                                        src={elem}
                                                                                                                                        alt='Error'
                                                                                                                                        title='Download'
                                                                                                                                        onClick={() => {
                                                                                                                                            handleOpenDoc();
                                                                                                                                            setImageAttachURL(elem);
                                                                                                                                            setNotesMessage(element?.note_chr)
                                                                                                                                        }}
                                                                                                                                        style={{ cursor: 'pointer' }}
                                                                                                                                    />

                                                                                                                                </span>
                                                                                                                            )
                                                                                                                        })}
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>

                                                                                                        </div>
                                                                                                    </div>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </> :

                                                                                    <div className='row mx-2 fs-6 py-2 mt-3'>
                                                                                        <div className='col-12 px-0 d-flex justify-content-center align-items-center flex-column'>
                                                                                            <img src={emptyListImg} style={{ width: "70px" }} alt="" />
                                                                                            <span className='mt-3 fs-7'>{"No notes added yet"}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </>
                                                        }


                                                        {/* Shopping list */}
                                                        {tabsToggleServiceReq === 2 &&
                                                            <>
                                                                <div className='row mt-2'>
                                                                    <div className='col-12 px-0'>

                                                                        <div className='d-flex px-3 fs-6 border-bottom pb-2 justify-content-between'>
                                                                            <div className='px-0 d-flex justify-content-start '>
                                                                                <span className=' '>{"Added: "}</span> &nbsp;
                                                                                <span className='font-w600 pe-2'>{`${rows.length} items`}</span>
                                                                            </div>

                                                                            <div className='px-0 d-flex justify-content-end align-items-center'>
                                                                                <span >{`Total cost: `}</span> &nbsp;
                                                                                {totalCost && <span className='text-black font-w600'>{USDollar.format(parseFloat(totalCost.toFixed(2)))}</span>}

                                                                                <span className='ps-3 text-black font-w600'>
                                                                                    <OverlayTrigger
                                                                                        trigger="click"
                                                                                        placement="bottom"
                                                                                        overlay={popoverShopping}
                                                                                        rootClose={true}
                                                                                        show={showPopoverShopping}
                                                                                        onToggle={(isOpen) => setShowPopoverShopping(isOpen)}
                                                                                    >
                                                                                        <i className="bi bi-three-dots-vertical cursor-pointer text-hovered"></i>
                                                                                    </OverlayTrigger>
                                                                                </span>

                                                                            </div>
                                                                        </div>

                                                                        <div className='row mx-0 pb-4 overflow-auto'
                                                                            style={{
                                                                                // minHeight: "300px",
                                                                                // maxHeight: "300px",
                                                                                maxHeight: window.innerWidth < 768 ? "calc(100dvh - 224px)" : `${imgMaxHeight - 87}px`,
                                                                                minHeight: window.innerWidth < 768 ? "calc(100dvh - 224px)" : `${imgMaxHeight - 87}px`,
                                                                            }}
                                                                        >
                                                                            <div className='col-12 px-0'>

                                                                                {rows.length > 0 ?
                                                                                    <>
                                                                                        <>
                                                                                            {rows?.map((element, index) => {
                                                                                                return (
                                                                                                    <div
                                                                                                        className="row pb-2 border-bottom"
                                                                                                        style={{
                                                                                                            pointerEvents: purchaseLoading ? 'none' : 'auto',
                                                                                                            opacity: purchaseLoading ? '0.5' : '1',
                                                                                                        }}
                                                                                                    >
                                                                                                        <div className="col-12 px-3 py-2 d-flex">

                                                                                                            {/* <div className='pe-3 d-flex justify-content-center'>
                                                                                                                <div>
                                                                                                                {
                                                                                                                    <div className='rounded-2 shadow-lg'>
                                                                                                                    <div
                                                                                                                        className='rounded-2 d-flex justify-content-center align-items-center'
                                                                                                                        style={{ height: '40px', width: '40px', background: 'rgba(79, 93, 116, 1)' }}
                                                                                                                    >
                                                                                                                        <i className="bi bi-file-earmark-image-fill fs-3 text-white"></i>
                                                                                                                    </div>
                                                                                                                    </div>
                                                                                                                }
                                                                                                                </div>
                                                                                                            </div> */}
                                                                                                            <div className="w-100">
                                                                                                                <div className="row mx-0">
                                                                                                                    <div className="col-6 d-flex justify-content-start align-items-center">
                                                                                                                        <span className="">
                                                                                                                            <span className='pe-2'>{index + 1}.</span>
                                                                                                                            <span className="text-black font-w600">{element?.item_name_chr}</span>
                                                                                                                        </span>
                                                                                                                    </div>

                                                                                                                    <div className="col-6 d-flex justify-content-end align-items-center">
                                                                                                                        <span
                                                                                                                            className="text-black font-w600"
                                                                                                                            style={{}}>
                                                                                                                            ({element?.quantity_int}) X{" "}
                                                                                                                            {USDollar.format(
                                                                                                                                element?.estimated_price_float /
                                                                                                                                element?.quantity_int
                                                                                                                            )}{" "}
                                                                                                                            &nbsp; &nbsp;{" "}
                                                                                                                            <OverlayTrigger
                                                                                                                                key={index}
                                                                                                                                trigger="click"
                                                                                                                                placement="bottom"
                                                                                                                                // overlay={popover}
                                                                                                                                overlay={popoverShoppingActions(
                                                                                                                                    index
                                                                                                                                )}
                                                                                                                                rootClose={true}
                                                                                                                                show={
                                                                                                                                    activePopoverShopping === index
                                                                                                                                }
                                                                                                                                onToggle={(show) =>
                                                                                                                                    setActivePopoverShopping(
                                                                                                                                        show ? index : null
                                                                                                                                    )
                                                                                                                                }>
                                                                                                                                <span style={{}}>
                                                                                                                                    <LuMoreVertical
                                                                                                                                        className="cursor-pointer text-black"
                                                                                                                                        onClick={() => {
                                                                                                                                            handleMenuClickShopping(
                                                                                                                                                element,
                                                                                                                                                index
                                                                                                                                            );
                                                                                                                                        }}
                                                                                                                                    />
                                                                                                                                </span>
                                                                                                                            </OverlayTrigger>
                                                                                                                        </span>
                                                                                                                    </div>
                                                                                                                </div>

                                                                                                                <div className="row mx-0  mt-2">
                                                                                                                    <span className="fs-7">
                                                                                                                        {element?.description_chr}
                                                                                                                    </span>
                                                                                                                </div>

                                                                                                                {element?.purchase_link_chr != "" && (
                                                                                                                    <div className="row mx-0  mt-2">
                                                                                                                        <div className="col-12 d-flex justify-content-start align-items-center">
                                                                                                                            {urlPattern.test(element?.purchase_link_chr) ?
                                                                                                                                <div className="d-flex align-items-center">
                                                                                                                                    <a
                                                                                                                                        className="text-black font-w600 text-hovered"
                                                                                                                                        href={
                                                                                                                                            // element?.purchase_link_chr
                                                                                                                                            element?.purchase_link_chr && !element?.purchase_link_chr.startsWith('http')
                                                                                                                                                ? `https://${element?.purchase_link_chr}`
                                                                                                                                                : element?.purchase_link_chr
                                                                                                                                        }
                                                                                                                                        target="_blank"
                                                                                                                                        rel="noreferrer"
                                                                                                                                        onClick={(e) => {
                                                                                                                                            e.stopPropagation();
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        <span
                                                                                                                                            className="fs-7 pointer cursor-pointer text-truncate d-flex"
                                                                                                                                            style={{ maxWidth: '350px' }}
                                                                                                                                        // onClick={() => {
                                                                                                                                        //   navigator.clipboard.writeText(
                                                                                                                                        //     `${element?.purchase_link_chr}`
                                                                                                                                        //   );
                                                                                                                                        //   copyToClipboard();
                                                                                                                                        // }}
                                                                                                                                        >
                                                                                                                                            {`${element?.purchase_link_chr}`}
                                                                                                                                        </span>
                                                                                                                                    </a>
                                                                                                                                    <span >{`...`}</span>
                                                                                                                                </div> :
                                                                                                                                <span
                                                                                                                                    className="fs-7 text-black"
                                                                                                                                >
                                                                                                                                    {element?.purchase_link_chr}
                                                                                                                                </span>
                                                                                                                            }
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                )}

                                                                                                                {permissionArray.includes("UPDATE PURCHASE LIST") &&
                                                                                                                    <div className="row mx-0  mt-2">
                                                                                                                        <div className={`col-12 d-flex fs-7 font-w600 `}>
                                                                                                                            <div className="d-flex align-items-center justify-content-between w-100">
                                                                                                                                <div
                                                                                                                                    className="me-4 d-flex align-items-center"
                                                                                                                                    style={{
                                                                                                                                        pointerEvents: purchaseLoading ? 'none' : 'auto',
                                                                                                                                        opacity: purchaseLoading ? '0.5' : '1'
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    <span
                                                                                                                                        className="me-2"
                                                                                                                                    >
                                                                                                                                        {purchaseLoading && (element?.item_id_ids === shoppingItemId) ?
                                                                                                                                            <Spinner animation="border" size="sm" /> :
                                                                                                                                            <input
                                                                                                                                                type="checkbox"
                                                                                                                                                checked={element?.is_purchased_ysn}
                                                                                                                                                className="form-check-input"
                                                                                                                                                id="customCheckBox4"
                                                                                                                                                onChange={(e) => {
                                                                                                                                                    handleMarkPurchaseItem(element, element?.is_purchased_ysn ? 0 : 1)
                                                                                                                                                    setShoppingItemId(element?.item_id_ids)
                                                                                                                                                }}
                                                                                                                                                onClick={() => {
                                                                                                                                                    handleMarkPurchaseItem(element, element?.is_purchased_ysn ? 0 : 1)
                                                                                                                                                    setShoppingItemId(element?.item_id_ids)
                                                                                                                                                }}
                                                                                                                                            />
                                                                                                                                        }
                                                                                                                                    </span>
                                                                                                                                    <span
                                                                                                                                        className="pt-1 cursor-pointer text-hovered"
                                                                                                                                        onClick={() => {
                                                                                                                                            handleMarkPurchaseItem(element, element?.is_purchased_ysn ? 0 : 1)
                                                                                                                                            setShoppingItemId(element?.item_id_ids)
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        {`Item Acquired`}
                                                                                                                                    </span>
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                }

                                                                                                                <div className="row mx-0  mt-2">
                                                                                                                    <div className='col-12 px-0 d-flex justify-content-end'>
                                                                                                                        {element?.is_purchased_ysn ?
                                                                                                                            <span className='font-w600 fs-7 text-success'>{`Purchased`}</span> :
                                                                                                                            <span className='font-w600 fs-7'>{`Not purchased yet`}</span>
                                                                                                                        }
                                                                                                                    </div>
                                                                                                                </div>


                                                                                                            </div>

                                                                                                        </div>

                                                                                                    </div>
                                                                                                );
                                                                                            })}
                                                                                        </>



                                                                                        {/* {
                                                                                            rows.map((element, index) => {
                                                                                                return (
                                                                                                    <div
                                                                                                        className='row px-3 fs-6 border-bottom py-2 '
                                                                                                        style={{
                                                                                                            pointerEvents: purchaseLoading ? 'none' : 'auto',
                                                                                                            opacity: purchaseLoading ? '0.5' : '1',
                                                                                                        }}
                                                                                                    >
                                                                                                        <div className='col-12 px-0 d-flex'>

                                                                                                            <div className='pe-3 d-flex justify-content-center'>
                                                                                                                <div>
                                                                                                                    {!permissionArray.includes("SCAN TAB") &&
                                                                                                                        <div className='rounded-2 shadow-lg'>
                                                                                                                            <div
                                                                                                                                className='rounded-2 d-flex justify-content-center align-items-center'
                                                                                                                                style={{ height: '40px', width: '40px', background: 'rgba(79, 93, 116, 1)' }}
                                                                                                                            >
                                                                                                                                <i className="bi bi-file-earmark-image-fill fs-3 text-white"></i>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    }

                                                                                                                    {permissionArray.includes("SCAN TAB") &&
                                                                                                                        <>
                                                                                                                            {!element?.is_purchased_ysn ?
                                                                                                                                <div
                                                                                                                                    className='rounded-circle d-flex justify-content-center align-items-center shadow-lg cursor-pointer overlay-action-btn'
                                                                                                                                    onClick={() => handleMarkPurchaseItem(element)}
                                                                                                                                    style={{
                                                                                                                                        height: '40px',
                                                                                                                                        width: '40px',
                                                                                                                                        border: '1px solid black',
                                                                                                                                        borderStyle: 'dashed'
                                                                                                                                    }}
                                                                                                                                    title='Mark as purchased'
                                                                                                                                >
                                                                                                                                    <i className="bi bi-check2 fs-3 text-black pt-1"></i>
                                                                                                                                </div> :
                                                                                                                                <div
                                                                                                                                    className='rounded-circle d-flex justify-content-center align-items-center shadow-lg'
                                                                                                                                    style={{
                                                                                                                                        height: '40px',
                                                                                                                                        width: '40px',
                                                                                                                                        border: '1px solid green',
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    <i className="bi bi-check2 fs-3 pt-1 text-success"></i>
                                                                                                                                </div>
                                                                                                                            }
                                                                                                                        </>
                                                                                                                    }
                                                                                                                </div>
                                                                                                            </div>

                                                                                                            <div className='w-100'>
                                                                                                                <div className='row mx-0 mb-1'>
                                                                                                                    <div className='col-6 px-0 d-flex justify-content-start font-w500'>
                                                                                                                        <span className=' pe-2'>{`${index + 1}.`}</span>
                                                                                                                        <span className='text-black pe-2'>{element.item_name_chr ? element.item_name_chr : 'NA'}</span>
                                                                                                                    </div>

                                                                                                                    <div className='col-6 px-0 d-flex justify-content-end'>
                                                                                                                        {(element?.quantity_int || element?.estimated_price_float) &&
                                                                                                                            <>
                                                                                                                                <span className=''>{`${element?.quantity_int} X `}</span> &nbsp;
                                                                                                                                <span className='pe-3 font-w600  text-black'>{USDollar.format((element?.estimated_price_float) / (element?.quantity_int))}</span>
                                                                                                                            </>
                                                                                                                        }


                                                                                                                        <span className=' text-black '>
                                                                                                                            <OverlayTrigger
                                                                                                                                key={index}
                                                                                                                                trigger="click"
                                                                                                                                placement="bottom"
                                                                                                                                // overlay={popover}
                                                                                                                                overlay={popoverShoppingActions(index)}
                                                                                                                                rootClose={true}
                                                                                                                                show={activePopoverShopping === index}
                                                                                                                                onToggle={(show) => setActivePopoverShopping(show ? index : null)}
                                                                                                                            >
                                                                                                                                <i onClick={() => handleMenuClickShopping(element, index)} className="bi bi-three-dots-vertical cursor-pointer text-hovered"></i>
                                                                                                                            </OverlayTrigger>

                                                                                                                        </span>
                                                                                                                    </div>
                                                                                                                </div>

                                                                                                                <div className='row mx-0 mb-1'>
                                                                                                                    <div className='col-12 px-0 d-flex justify-content-start font-w500'>
                                                                                                                        <span className=' pe-3'>
                                                                                                                            {element?.description_chr ? <>{element?.description_chr}</> : <>{`Description not specified`}</>}
                                                                                                                        </span>
                                                                                                                    </div>
                                                                                                                </div>




                                                                                                                <div className='row mx-0'>
                                                                                                                    <div className='col-6 px-0 d-flex align-items-center justify-content-start font-w600 text-black'>
                                                                                                                        {element?.purchase_link_chr &&
                                                                                                                            <div>
                                                                                                                                {urlPattern.test(element?.purchase_link_chr) ?
                                                                                                                                    <a href={element?.purchase_link_chr} target="_blank" rel="noreferrer">
                                                                                                                                        <div>
                                                                                                                                            <span className='pe-2'>
                                                                                                                                                {`Buy it`}
                                                                                                                                            </span>
                                                                                                                                            <span className=''>
                                                                                                                                                <i className="bi bi-chevron-right"></i>
                                                                                                                                            </span>
                                                                                                                                        </div>
                                                                                                                                    </a> :
                                                                                                                                    <div>
                                                                                                                                        <span className='pe-2'>
                                                                                                                                            {element?.purchase_link_chr}
                                                                                                                                        </span>
                                                                                                                                    </div>
                                                                                                                                }
                                                                                                                            </div>
                                                                                                                        }
                                                                                                                    </div>


                                                                                                                    <div className='col-6 px-0 d-flex justify-content-end'>

                                                                                                                        {element?.is_purchased_ysn ?
                                                                                                                            <span className='font-w600 fs-7 text-success'>{`Purchased`}</span> :
                                                                                                                            <span className='font-w600 fs-7'>{`Not purchased yet`}</span>
                                                                                                                        }

                                                                                                                    </div>
                                                                                                                </div>



                                                                                                            </div>

                                                                                                        </div>
                                                                                                    </div>
                                                                                                )
                                                                                            })
                                                                                        } */}
                                                                                    </> :

                                                                                    <div className='row mx-2 fs-6 py-2 mt-3'>
                                                                                        <div className='col-12 px-0 d-flex justify-content-center align-items-center flex-column'>
                                                                                            <img src={emptyListImg} style={{ width: "70px" }} alt="" />
                                                                                            <span className='mt-3 fs-7'>{"No shopping item added yet"}</span>
                                                                                        </div>
                                                                                    </div>

                                                                                }






                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </>
                                                        }

                                                        {/* Call details */}
                                                        {tabsToggleServiceReq === 3 &&
                                                            <>
                                                                <div className='row mx-2 mt-3'  >
                                                                    <div className='col-12 px-0 '>

                                                                        <div
                                                                            className='row mx-0 overflow-auto'
                                                                            style={{
                                                                                maxHeight: window.innerWidth < 768 ? "calc(100dvh - 205px)" : `${imgMaxHeight - 60}px`,
                                                                                minHeight: window.innerWidth < 768 ? "calc(100dvh - 205px)" : `${imgMaxHeight - 60}px`,
                                                                            }}
                                                                        >
                                                                            <div className='col-12 px-0'>
                                                                                {sentRequest.length > 0 ?
                                                                                    <>
                                                                                        {sentRequest.map((element, index) => {
                                                                                            return (
                                                                                                <>
                                                                                                    <div key={index} className='row mx-0 border-bottom mb-2'>
                                                                                                        <div className='col-12 px-0'>

                                                                                                            <div className='row mx-0 py-2'>
                                                                                                                <div className='col-2 px-0 d-flex align-items-center'>
                                                                                                                    {element?.preferred_profile_picture_url ?
                                                                                                                        <img alt="" src={element?.preferred_profile_picture_url} className='rounded-circle' style={{ height: "50px", width: "50px", aspectRatio: "1" }} /> :
                                                                                                                        <div className='bg-light rounded-circle' style={{ height: "50px", width: "50px" }}>

                                                                                                                        </div>}
                                                                                                                </div>

                                                                                                                <div className='col-7 px-0 d-flex align-items-center justify-content-between h-100 flex-column'>
                                                                                                                    <div className='row mx-0 w-100 font-w500'>
                                                                                                                        <span>
                                                                                                                            {formatUnixTimestamp(element?.created_date_dtm)}
                                                                                                                        </span>
                                                                                                                    </div>

                                                                                                                    <div className='row mx-0 w-100 font-w500 text-black'>
                                                                                                                        <span>
                                                                                                                            {element.message_chr ? element.message_chr : 'Message not specified'}
                                                                                                                        </span>
                                                                                                                    </div>

                                                                                                                    <div className='row mx-0 w-100 font-w500 text-black mt-2'>
                                                                                                                        <div>
                                                                                                                            <span
                                                                                                                                className='font-w600 text-hovered cursor-pointer'
                                                                                                                                onClick={() => {
                                                                                                                                    if (element?.call_log_id_ids === particularCallLogId) {
                                                                                                                                        setParticularCallLogId('')
                                                                                                                                    } else {
                                                                                                                                        setParticularCallLogId(element?.call_log_id_ids)
                                                                                                                                    }
                                                                                                                                }}
                                                                                                                                style={{
                                                                                                                                    color: 'rgba(131, 154, 192, 1)'
                                                                                                                                }}
                                                                                                                            >
                                                                                                                                {`Transactions history`}

                                                                                                                                {element?.call_log_id_ids === particularCallLogId ?
                                                                                                                                    <><i className='bi bi-chevron-down ps-2'></i></> :
                                                                                                                                    <> <i className='bi bi-chevron-right ps-2'></i></>
                                                                                                                                }
                                                                                                                            </span>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>

                                                                                                                <div className='col-3 px-0 d-flex align-items-center justify-content-center flex-column'>
                                                                                                                    {(element.is_accepted_ysn) === 1 ?
                                                                                                                        <>
                                                                                                                            {
                                                                                                                                isCurrentUnixTimeLessThan(element?.video_token_expiry_time)
                                                                                                                                    // element.status_ysn !== 0 
                                                                                                                                    ?
                                                                                                                                    <>
                                                                                                                                        <div
                                                                                                                                            onClick={() => {
                                                                                                                                                localStorage.setItem("triggerFlag", 1)
                                                                                                                                                navigate("/videoCall")
                                                                                                                                            }}
                                                                                                                                            className='text-success d-flex align-items-center justify-content-center overlay-action-btn p-2 rounded cursor-pointer fw-bold'
                                                                                                                                        >
                                                                                                                                            <i className="bi bi-camera-video pe-2"></i>
                                                                                                                                            <span>{"Join"}</span>
                                                                                                                                        </div>
                                                                                                                                    </>
                                                                                                                                    // <Button style={{ background: 'red' }}>User Busy</Button>
                                                                                                                                    :
                                                                                                                                    <>
                                                                                                                                        <div
                                                                                                                                            onClick={() => { }}
                                                                                                                                            className='text-danger d-flex align-items-center justify-content-center overlay-action-btn p-2 rounded fw-bold'
                                                                                                                                            style={{ pointerEvents: 'none', opacity: '0.5' }}
                                                                                                                                        >
                                                                                                                                            <i className="bi bi-camera-video-off pe-2"></i>
                                                                                                                                            <span>{"Join"}</span>
                                                                                                                                        </div>

                                                                                                                                    </>
                                                                                                                            }
                                                                                                                        </> :
                                                                                                                        (element.is_accepted_ysn) === 2 ?
                                                                                                                            <>
                                                                                                                                <div
                                                                                                                                    onClick={() => { }}
                                                                                                                                    className='text-danger d-flex align-items-center justify-content-center overlay-action-btn p-2 rounded fw-bold'
                                                                                                                                    style={{ pointerEvents: 'none', opacity: '0.5' }}
                                                                                                                                >
                                                                                                                                    <i className="bi bi-x-lg pe-2"></i>
                                                                                                                                    <span>{"Rejected"}</span>
                                                                                                                                </div>
                                                                                                                            </>
                                                                                                                            :
                                                                                                                            (element.is_accepted_ysn) === 3 ?
                                                                                                                                <>
                                                                                                                                    <div
                                                                                                                                        onClick={() => { }}
                                                                                                                                        className='text-success d-flex align-items-center justify-content-center overlay-action-btn p-2 rounded fw-bold'
                                                                                                                                        style={{ pointerEvents: 'none', opacity: '0.5' }}
                                                                                                                                    >
                                                                                                                                        <i className="bi bi-check-lg pe-2"></i>
                                                                                                                                        <span>{"Closed"}</span>
                                                                                                                                    </div>
                                                                                                                                </> : ('')

                                                                                                                    }


                                                                                                                    {/* <div
                                                                                                            onClick={() => handleShowCallDetails(element)}
                                                                                                            className='text-black d-flex align-items-center justify-content-center overlay-action-btn p-2 rounded cursor-pointer fw-bold'

                                                                                                        >
                                                                                                            <i className="bi bi-eye pe-2"></i>
                                                                                                            <span>{"View"}</span>
                                                                                                        </div> */}
                                                                                                                </div>


                                                                                                            </div>

                                                                                                            {element?.call_log_id_ids === particularCallLogId &&
                                                                                                                <>
                                                                                                                    {element?.transactions?.length > 0 ?
                                                                                                                        <>
                                                                                                                            {element?.transactions?.map((item, i) => {
                                                                                                                                return (
                                                                                                                                    <>
                                                                                                                                        <div className='row mx-0 mt-1'>
                                                                                                                                            <div className='col-2'></div>

                                                                                                                                            <div className='col-12 p-2 px-3 border-bottom'>
                                                                                                                                                <div className='w-100'>
                                                                                                                                                    <div>
                                                                                                                                                        <span>
                                                                                                                                                            {item?.payment_intent_meta_data?.description ? item?.payment_intent_meta_data?.description :
                                                                                                                                                                item?.payment_intent_meta_data?.message_chr ? item?.payment_intent_meta_data?.message_chr : '-'}</span>
                                                                                                                                                    </div>

                                                                                                                                                    <div className='d-flex align-items-center justify-content-between mt-2'>
                                                                                                                                                        <div>
                                                                                                                                                            {item?.created_date_dtm && <span>{`${formatUnixTimestamp(item?.created_date_dtm)}`}</span>}
                                                                                                                                                        </div>

                                                                                                                                                        <div>
                                                                                                                                                            <span
                                                                                                                                                                className='font-w600 text-hovered cursor-pointer'
                                                                                                                                                                onClick={() => { setTabsToggleServiceReq(1); }}
                                                                                                                                                                style={{
                                                                                                                                                                    color: 'rgba(131, 154, 192, 1)'
                                                                                                                                                                }}
                                                                                                                                                            >
                                                                                                                                                                {`See service details`}
                                                                                                                                                                <i className='bi bi-chevron-right ps-2'></i>
                                                                                                                                                            </span>
                                                                                                                                                        </div>
                                                                                                                                                    </div>
                                                                                                                                                </div>
                                                                                                                                            </div>
                                                                                                                                        </div>
                                                                                                                                    </>
                                                                                                                                )
                                                                                                                            })}

                                                                                                                            {permissionArray.includes("SCAN TAB") && receiverData.ticket_status_ysn !== 0 &&
                                                                                                                                <div className='row mx-0'>
                                                                                                                                    <div className='col-12 p-2 d-flex align-items-center justify-content-center'>
                                                                                                                                        <PrimaryButton
                                                                                                                                            buttonName={
                                                                                                                                                !element?.transactions[0]?.refund_status ? `RAISE REFUND` :
                                                                                                                                                    element?.transactions[0]?.refund_status === 1 ? "REFUND RAISED" :
                                                                                                                                                        element?.transactions[0]?.refund_status === 2 ? "REFUND IN-PROGRESS" :
                                                                                                                                                            element?.transactions[0]?.refund_status === 3 ? "REFUND COMPLETED" :
                                                                                                                                                                `RAISE REFUND`
                                                                                                                                            }

                                                                                                                                            loadingMessage={"LOADING..."}
                                                                                                                                            onClick={(e) => { raiseRefundForParticularFn() }}
                                                                                                                                            isLoading={raiseRefundLoading}
                                                                                                                                            style={{
                                                                                                                                                pointerEvents: !element?.transactions[0]?.refund_status ? 'auto' : 'none',
                                                                                                                                                opacity: !element?.transactions[0]?.refund_status ? '1' : '0.5',
                                                                                                                                                width: "100%",
                                                                                                                                                background: !element?.transactions[0]?.refund_status ? 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)' :
                                                                                                                                                    element?.transactions[0]?.refund_status === 1 ? "#abb8d8" :
                                                                                                                                                        element?.transactions[0]?.refund_status === 2 ? "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)" :
                                                                                                                                                            element?.transactions[0]?.refund_status === 3 ? "linear-gradient(142.98deg, rgb(22, 186, 78) 1.99%, rgb(25, 223, 92) 99.97%)" :
                                                                                                                                                                `linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)`
                                                                                                                                                ,
                                                                                                                                                // fontWeight: '600',
                                                                                                                                                border: 'none',
                                                                                                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                                                                                borderRadius: '4px',
                                                                                                                                            }}
                                                                                                                                        />
                                                                                                                                    </div>
                                                                                                                                </div>
                                                                                                                            }
                                                                                                                        </> :
                                                                                                                        <div className='row mx-2 fs-6 py-2 mt-3'>
                                                                                                                            <div className='col-12 px-0 d-flex justify-content-center align-items-center flex-column'>
                                                                                                                                <img src={emptyListImg} style={{ width: "70px" }} alt="" />
                                                                                                                                <span className='mt-3 fs-7'>{"No transactions"}</span>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    }


                                                                                                                </>}

                                                                                                        </div>
                                                                                                    </div>
                                                                                                </>
                                                                                            )
                                                                                        })}
                                                                                    </>
                                                                                    :
                                                                                    <div className='row mx-2 fs-6 py-2 mt-3'>
                                                                                        <div className='col-12 px-0 d-flex justify-content-center align-items-center flex-column'>
                                                                                            <img src={emptyListImg} style={{ width: "70px" }} alt="" />
                                                                                            <span className='mt-3 fs-7'>{"No data available"}</span>
                                                                                        </div>
                                                                                    </div>

                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        }

                                                        {/* Service history */}
                                                        {tabsToggleServiceReq === 4 &&
                                                            <>
                                                                <div className='row mt-2'>
                                                                    <div className='col-12 px-0'>

                                                                        <div
                                                                            className='row mx-0 overflow-auto'
                                                                            style={{
                                                                                maxHeight: window.innerWidth < 768 ? "calc(100dvh - 196px)" : `${imgMaxHeight - 60}px`,
                                                                                minHeight: window.innerWidth < 768 ? "calc(100dvh - 196px)" : `${imgMaxHeight - 60}px`,
                                                                            }}
                                                                        >
                                                                            <div className='col-12 px-0'>

                                                                                {serviceReqHistoryArr.length > 0 ?
                                                                                    <>
                                                                                        {
                                                                                            serviceReqHistoryArr.map((element, index) => {
                                                                                                return (
                                                                                                    <div className='row px-3 fs-6 border-bottom py-2 '>
                                                                                                        <div className='col-12 px-0 d-flex'>

                                                                                                            <div className='pe-3 d-flex justify-content-center'>
                                                                                                                <div>
                                                                                                                    <div className='rounded-2 shadow-lg'>
                                                                                                                        <div
                                                                                                                            className='rounded-2 d-flex justify-content-center align-items-center'
                                                                                                                            style={{
                                                                                                                                height: '40px',
                                                                                                                                width: '40px',
                                                                                                                                // background: 'rgba(79, 93, 116, 1)'
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            {element?.preferred_profile_picture_url ?
                                                                                                                                <img src={element?.preferred_profile_picture_url} alt="" className="rounded-2" style={{ height: '40px', width: '40px' }} /> :
                                                                                                                                <i className="bi bi-file-earmark-image-fill fs-3 text-white"></i>
                                                                                                                            }
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>

                                                                                                            <div className='w-100'>
                                                                                                                <div className='row mx-0 mb-1'>
                                                                                                                    <div className='col-12 px-0 d-flex justify-content-start font-w500'>
                                                                                                                        <span className='font-w600 pe-2 fs-7'>{`${formatUnixTimestamp(element?.created_date)}`}</span>
                                                                                                                    </div>
                                                                                                                </div>

                                                                                                                <div className='row mx-0 mb-1'>
                                                                                                                    <div className='col-12 px-0 d-flex justify-content-start font-w500'>
                                                                                                                        <span className='text-black pe-1'>
                                                                                                                            {`${element?.description_chr}`}
                                                                                                                        </span>
                                                                                                                    </div>
                                                                                                                </div>

                                                                                                                {/* <div className='row mx-0 mb-1'>
                                                                                                                    <div className='col-12 px-0 d-flex justify-content-start font-w500'>
                                                                                                                        <span className='font-w600 pe-3 fs-7'>
                                                                                                                            {`${element?.user_name_chr}`}
                                                                                                                        </span>
                                                                                                                    </div>
                                                                                                                </div> */}
                                                                                                            </div>

                                                                                                        </div>
                                                                                                    </div>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </> :

                                                                                    <div className='row mx-2 fs-6 py-2 mt-3'>
                                                                                        <div className='col-12 px-0 d-flex justify-content-center align-items-center flex-column'>
                                                                                            <img src={emptyListImg} style={{ width: "70px" }} alt="" />
                                                                                            <span className='mt-3 fs-7'>{"No service history available"}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                }

                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </>
                                                        }






                                                    </div>

                                                    {/* Bottom actions */}
                                                    <div className='row mx-0 mb-3 mt-1 position-relative'>
                                                        {/* Info action btns */}
                                                        {tabsToggleServiceReq === 1 &&
                                                            <div
                                                                className='col-12 px-3'
                                                            >
                                                                {/* For customer bottom button */}
                                                                {permissionArray.includes("SCAN TAB") &&
                                                                    <>
                                                                        {/* New actions for customer bottom buttons */}
                                                                        {Object.keys(receiverData).length > 0 ? <>
                                                                            {
                                                                                // Open or reopen service request
                                                                                (receiverData.ticket_status_ysn == 1 || receiverData.ticket_status_ysn == 5) ?
                                                                                    <div className='row mx-0'>
                                                                                        <div className='col-md-6 pe-md-2 mt-2'>
                                                                                            <>
                                                                                                <Button
                                                                                                    className='w-100 d-flex align-items-center justify-content-center text-black shadow'
                                                                                                    onClick={() => { handleOpenScheduleModal() }}
                                                                                                    style={{
                                                                                                        background: 'white',
                                                                                                        borderRadius: '4px',
                                                                                                        border: '2px solid #E8E8E8',
                                                                                                        fontWeight: '600',
                                                                                                    }}
                                                                                                >
                                                                                                    {"RESCHEDULE"}
                                                                                                </Button>
                                                                                            </>
                                                                                        </div>

                                                                                        <div className='col-md-6 ps-md-2 mt-2'>
                                                                                            <>
                                                                                                <Button
                                                                                                    className='w-100  d-flex align-items-center justify-content-center font-w500 '
                                                                                                    // onClick={() => { acceptGlobalRequest() }}
                                                                                                    onClick={() => { handleOpenCancelServiceModal() }}
                                                                                                    style={{
                                                                                                        // background: '#565656',
                                                                                                        pointerEvents: dialogLoader ? 'none' : 'auto',
                                                                                                        opacity: dialogLoader ? '0.5' : '1',
                                                                                                        background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                                                                                        border: '2px solid rgba(240, 72, 72, 1)',
                                                                                                        boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                                                                                        borderRadius: '4px',
                                                                                                        fontWeight: '600',
                                                                                                    }}
                                                                                                >
                                                                                                    {"CANCEL REQUEST"}
                                                                                                </Button>
                                                                                            </>
                                                                                        </div>
                                                                                    </div> :
                                                                                    (receiverData.ticket_status_ysn == 2) ?
                                                                                        <>
                                                                                            <div className='row mx-0'>
                                                                                                <div className='col-md-6 pe-md-2 mt-2'>
                                                                                                    {!(receiverData?.remaining_time_in_sec == 0 && sentRequest.length == 1) &&
                                                                                                        <>
                                                                                                            {/* <Button
                                                                                                            className='w-100  d-flex align-items-center justify-content-center font-w500 '
                                                                                                            // onClick={() => { acceptGlobalRequest() }}
                                                                                                            onClick={() => {
                                                                                                                localStorage.setItem("triggerFlag", 1);
                                                                                                                navigate("/videoCall");
                                                                                                            }}
                                                                                                            style={{
                                                                                                                background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                                                border: '2px solid rgba(45, 204, 99, 1)',
                                                                                                                boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                                                borderRadius: '4px',
                                                                                                                pointerEvents: isActiveVideoLink == 1 ? 'auto' : 'none',
                                                                                                                opacity: isActiveVideoLink == 1 ? '1' : '0.5',
                                                                                                            }}
                                                                                                        >
                                                                                                            {"JOIN VIDEO CALL"}
                                                                                                        </Button> */}
                                                                                                            {isActiveVideoLink == 1 ?
                                                                                                                <PrimaryButton
                                                                                                                    buttonName={`JOIN VIDEO CALL`}
                                                                                                                    onClick={() => {
                                                                                                                        localStorage.setItem("triggerFlag", 1);
                                                                                                                        navigate("/videoCall");
                                                                                                                    }}
                                                                                                                    loadingMessage={"LOADING..."}
                                                                                                                    isLoading={resendLoading}
                                                                                                                    style={{
                                                                                                                        width: '100%',
                                                                                                                        background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                                                        border: '2px solid rgba(45, 204, 99, 1)',
                                                                                                                        boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                                                        borderRadius: '4px',
                                                                                                                        fontWeight: '600',
                                                                                                                    }}
                                                                                                                /> :
                                                                                                                <>
                                                                                                                    {permissionArray.includes("RESEND VIDEO LINK") &&
                                                                                                                        <PrimaryButton
                                                                                                                            buttonName={`RESEND LINK`}
                                                                                                                            onClick={() => {
                                                                                                                                resendLink();
                                                                                                                            }}
                                                                                                                            loadingMessage={"LOADING..."}
                                                                                                                            isLoading={resendLoading}
                                                                                                                            style={{
                                                                                                                                width: '100%',
                                                                                                                                background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                                                                border: '2px solid rgba(45, 204, 99, 1)',
                                                                                                                                boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                                                                borderRadius: '4px',
                                                                                                                                fontWeight: '600',
                                                                                                                            }}
                                                                                                                        />
                                                                                                                    }
                                                                                                                </>
                                                                                                            }
                                                                                                        </>
                                                                                                    }
                                                                                                </div>

                                                                                                <div className='col-md-6 ps-md-2 mt-2'>
                                                                                                    <>
                                                                                                        <Button
                                                                                                            className='w-100  d-flex align-items-center justify-content-center font-w500 '
                                                                                                            // onClick={() => { acceptGlobalRequest() }}
                                                                                                            onClick={() => { handleOpenChangeJobStatusModal() }}
                                                                                                            style={{
                                                                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                                                borderRadius: '8px',
                                                                                                            }}
                                                                                                        >
                                                                                                            {"CHANGE STATUS"}
                                                                                                        </Button>
                                                                                                    </>
                                                                                                </div>
                                                                                            </div>


                                                                                            {/* <div className='row mx-0'>
                                                                                                <div className='col-12 mt-2'>
                                                                                                    <>
                                                                                                        <Button
                                                                                                            className='w-100  d-flex align-items-center justify-content-center font-w500 '
                                                                                                            // onClick={() => { acceptGlobalRequest() }}
                                                                                                            onClick={() => { handleOpenChangeJobStatusModal() }}
                                                                                                            style={{
                                                                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                                                borderRadius: '4px',
                                                                                                            }}
                                                                                                        >
                                                                                                            {"CHANGE STATUS"}
                                                                                                        </Button>
                                                                                                    </>
                                                                                                </div>
                                                                                            </div> */}
                                                                                        </> :
                                                                                        (receiverData?.category_name_chr !== null && receiverData?.category_name_chr !== 'null') && (receiverData.ticket_status_ysn !== 0 || receiverData.ticket_status_ysn === 4 || receiverData.ticket_status_ysn === 7) ?
                                                                                            <div className='row mx-0'>
                                                                                                <div className='col-12 mt-2'>
                                                                                                    <>
                                                                                                        {/* <Button
                                                                                                        className='w-100 d-flex align-items-center justify-content-center font-w500 text-black shadow'
                                                                                                        onClick={() => { reOpenRequest() }}
                                                                                                        style={{
                                                                                                            background: 'white',
                                                                                                            borderRadius: '4px',
                                                                                                            border: '2px solid #E8E8E8',
                                                                                                        }}
                                                                                                    >
                                                                                                        {"REACTIVATE REQUEST"}
                                                                                                    </Button> */}
                                                                                                        <PrimaryButton
                                                                                                            buttonName={`REACTIVATE REQUEST`}
                                                                                                            onClick={() => { handleOpenReactivateServiceModal() }}
                                                                                                            loadingMessage={"LOADING..."}
                                                                                                            // isLoading={statusUpdateLoaderCust}
                                                                                                            style={{
                                                                                                                width: '100%',
                                                                                                                background: 'rgba(251, 252, 255, 1)',
                                                                                                                border: '1px solid rgba(199, 212, 234, 1)',
                                                                                                                boxShadow: '0px 6px 12px 0px rgba(102, 129, 172, 0.12)',
                                                                                                                color: 'black',
                                                                                                                fontWeight: '600',
                                                                                                            }}
                                                                                                        />
                                                                                                    </>
                                                                                                </div>
                                                                                            </div> :
                                                                                            <></>
                                                                            }
                                                                        </> : <></>}

                                                                        {/* Old actions for customer bottom buttons */}
                                                                        {false && <div className='row mx-0'>
                                                                            <div className='col-md-6 pe-2 mt-2'>
                                                                                <>
                                                                                    {/* <OverlayTrigger
                                                                                    trigger="click"
                                                                                    placement="top"
                                                                                    overlay={popoverServiceStatus}
                                                                                    rootClose={true}
                                                                                > */}
                                                                                    <Button
                                                                                        className='w-100  d-flex align-items-center justify-content-center font-w500 '
                                                                                        // onClick={() => { acceptGlobalRequest() }}
                                                                                        onClick={() => { handleOpenChangeJobStatusModal() }}
                                                                                        style={{
                                                                                            // background: '#565656',
                                                                                            pointerEvents: dialogLoader ? 'none' : 'auto',
                                                                                            opacity: dialogLoader ? '0.5' : '1',
                                                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                            borderRadius: '4px'
                                                                                        }}
                                                                                    >
                                                                                        {"CHANGE JOB STATUS"}
                                                                                        <span className='ps-2'>
                                                                                            <i className="bi bi-check2"></i>
                                                                                        </span>
                                                                                    </Button>
                                                                                    {/* </OverlayTrigger> */}
                                                                                </>
                                                                            </div>

                                                                            <div className='col-md-6 pe-2 mt-2'>

                                                                                <>
                                                                                    <OverlayTrigger
                                                                                        trigger="click"
                                                                                        placement="top"
                                                                                        overlay={popover}
                                                                                        rootClose={true}
                                                                                        show={showPopover}
                                                                                        onToggle={(isOpen) => setShowPopover(isOpen)}
                                                                                    >
                                                                                        <Button
                                                                                            className='w-100 d-flex align-items-center justify-content-center font-w500 text-black shadow'
                                                                                            // onClick={() => { acceptGlobalRequest() }}
                                                                                            style={{
                                                                                                background: 'white',
                                                                                                borderRadius: '4px',
                                                                                                border: '2px solid #E8E8E8',
                                                                                            }}
                                                                                        >
                                                                                            {"MORE ACTIONS"}
                                                                                            <span className='ps-2'>
                                                                                                <i className="bi bi-three-dots-vertical"></i>
                                                                                            </span>
                                                                                        </Button>
                                                                                    </OverlayTrigger>
                                                                                </>
                                                                            </div>
                                                                        </div>}

                                                                    </>
                                                                }


                                                                {/* For professional bottom button */}
                                                                {Object.keys(receiverData).length > 0 ? <>
                                                                    {permissionArray.includes("UPDATE WORK INFORMATION") && sentRequest.length > 0 &&
                                                                        <>
                                                                            {(receiverData.ticket_status_ysn == 1 || receiverData.ticket_status_ysn == 5) ?
                                                                                <>
                                                                                    {receiverData.user_id_lng == localStorage.getItem("user_id") &&
                                                                                        <div className='row mx-0'>
                                                                                            <div className='col-md-6 pe-2 mt-2'>
                                                                                                <>
                                                                                                    <Button
                                                                                                        className='w-100 d-flex align-items-center justify-content-center text-black shadow'
                                                                                                        onClick={() => { handleOpenScheduleModal() }}
                                                                                                        style={{
                                                                                                            background: 'white',
                                                                                                            borderRadius: '4px',
                                                                                                            border: '2px solid #E8E8E8',
                                                                                                            fontWeight: '600',
                                                                                                        }}
                                                                                                    >
                                                                                                        {"RESCHEDULE"}
                                                                                                    </Button>
                                                                                                </>
                                                                                            </div>

                                                                                            <div className='col-md-6 pe-2 mt-2'>
                                                                                                <>
                                                                                                    <Button
                                                                                                        className='w-100  d-flex align-items-center justify-content-center font-w500 '
                                                                                                        // onClick={() => { acceptGlobalRequest() }}
                                                                                                        onClick={() => { handleOpenCancelServiceModal() }}
                                                                                                        style={{
                                                                                                            // background: '#565656',
                                                                                                            pointerEvents: dialogLoader ? 'none' : 'auto',
                                                                                                            opacity: dialogLoader ? '0.5' : '1',
                                                                                                            background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                                                                                            border: '2px solid rgba(240, 72, 72, 1)',
                                                                                                            boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                                                                                            borderRadius: '4px',
                                                                                                            fontWeight: '600',
                                                                                                        }}
                                                                                                    >
                                                                                                        {"CANCEL REQUEST"}
                                                                                                    </Button>
                                                                                                </>
                                                                                            </div>
                                                                                        </div>}
                                                                                </> :
                                                                                (receiverData.ticket_status_ysn == 2) ?
                                                                                    <>
                                                                                        {isActiveVideoLink == 1 ?
                                                                                            <PrimaryButton
                                                                                                buttonName={`JOIN VIDEO CALL`}
                                                                                                onClick={() => {
                                                                                                    localStorage.setItem("triggerFlag", 1);
                                                                                                    navigate("/videoCall");
                                                                                                }}
                                                                                                loadingMessage={"LOADING..."}
                                                                                                isLoading={resendLoading}
                                                                                                style={{
                                                                                                    width: '100%',
                                                                                                    background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                                    border: '2px solid rgba(45, 204, 99, 1)',
                                                                                                    boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                                    borderRadius: '4px',
                                                                                                    fontWeight: '600',
                                                                                                }}
                                                                                            /> :
                                                                                            <>
                                                                                                {permissionArray.includes("RESEND VIDEO LINK") &&
                                                                                                    <PrimaryButton
                                                                                                        buttonName={`RESEND LINK`}
                                                                                                        onClick={() => {
                                                                                                            resendLink();
                                                                                                        }}
                                                                                                        loadingMessage={"LOADING..."}
                                                                                                        isLoading={resendLoading}
                                                                                                        style={{
                                                                                                            width: '100%',
                                                                                                            background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                                            border: '2px solid rgba(45, 204, 99, 1)',
                                                                                                            boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                                            borderRadius: '4px',
                                                                                                            fontWeight: '600',
                                                                                                        }}
                                                                                                    />
                                                                                                }
                                                                                            </>
                                                                                        }
                                                                                        {/* <PrimaryButton
                                                                                            buttonName={isActiveVideoLink == 1 ? `JOIN VIDEO CALL` : `RESEND LINK`}
                                                                                            onClick={() => {
                                                                                                if (isActiveVideoLink == 1) {
                                                                                                    localStorage.setItem("triggerFlag", 1);
                                                                                                    navigate("/videoCall");
                                                                                                } else {
                                                                                                    resendLink();
                                                                                                }
                                                                                            }}
                                                                                            loadingMessage={"LOADING..."}
                                                                                            isLoading={resendLoading}
                                                                                            style={{
                                                                                                width: '100%',
                                                                                                background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                                border: '2px solid rgba(45, 204, 99, 1)',
                                                                                                boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                                borderRadius: '4px',
                                                                                                fontWeight: '600',
                                                                                            }}
                                                                                        /> */}

                                                                                        {/* <div className='row mx-0'>
                                                                                        <div className='col-12 mt-2'>
                                                                                            <>
                                                                                                <Button
                                                                                                    className='w-100  d-flex align-items-center justify-content-center font-w500 '
                                                                                                    // onClick={() => { acceptGlobalRequest() }}
                                                                                                    onClick={() => { handleOpenChangeJobStatusModal() }}
                                                                                                    style={{
                                                                                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                                        border: '2px solid rgba(255, 154, 32, 1)',
                                                                                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                                        borderRadius: '4px'
                                                                                                    }}
                                                                                                >
                                                                                                    {"CHANGE STATUS"}
                                                                                                </Button>
                                                                                            </>
                                                                                        </div>
                                                                                    </div> */}
                                                                                    </>
                                                                                    : <></>
                                                                            }

                                                                            {false &&
                                                                                <div className='row mx-0'>
                                                                                    <div className='col-md-6 pe-2 mt-2'>
                                                                                        <>
                                                                                            <OverlayTrigger
                                                                                                trigger="click"
                                                                                                placement="top"
                                                                                                overlay={popoverServiceStatus}
                                                                                                rootClose={true}
                                                                                            >
                                                                                                <Button
                                                                                                    className='w-100 d-flex align-items-center justify-content-center font-w500 '
                                                                                                    style={{
                                                                                                        // background: '#565656',
                                                                                                        pointerEvents: dialogLoader ? 'none' : 'auto',
                                                                                                        opacity: dialogLoader ? '0.5' : '1',
                                                                                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                                        border: '2px solid rgba(255, 154, 32, 1)',
                                                                                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                                        borderRadius: '4px'
                                                                                                    }}
                                                                                                >
                                                                                                    {"CHANGE JOB STATUS"}
                                                                                                    <span className='ps-2'>
                                                                                                        <i className="bi bi-check2"></i>
                                                                                                    </span>
                                                                                                </Button>
                                                                                            </OverlayTrigger>
                                                                                        </>
                                                                                    </div>

                                                                                    <div className='col-md-6 pe-2 mt-2'>

                                                                                        <>
                                                                                            <OverlayTrigger
                                                                                                trigger="click"
                                                                                                placement="top"
                                                                                                overlay={popover}
                                                                                                rootClose={true}
                                                                                                show={showPopover}
                                                                                                onToggle={(isOpen) => setShowPopover(isOpen)}
                                                                                            >
                                                                                                <Button
                                                                                                    className='w-100  d-flex align-items-center justify-content-center font-w500 text-black shadow'
                                                                                                    style={{
                                                                                                        background: 'white',
                                                                                                        borderRadius: '4px',
                                                                                                        border: '2px solid #E8E8E8',
                                                                                                    }}
                                                                                                >
                                                                                                    {"MORE ACTIONS"}
                                                                                                    <span className='ps-2'>
                                                                                                        <i className="bi bi-three-dots-vertical"></i>
                                                                                                    </span>
                                                                                                </Button>
                                                                                            </OverlayTrigger>
                                                                                        </>
                                                                                    </div>
                                                                                </div>
                                                                            }

                                                                            {(companyId && permissionArray.includes("ASSIGN SERVICE REQUEST") && (receiverData?.ticket_status_ysn === 2)) && receiverData.created_by_chr == localStorage.getItem("user_id") &&
                                                                                <div className='row mx-0 my-2'>
                                                                                    <Button
                                                                                        className='w-100 rounded-2  d-flex align-items-center justify-content-center font-w500 '
                                                                                        onClick={() => {
                                                                                            handleOpenReAssignServiceModal();
                                                                                        }}
                                                                                        style={{
                                                                                            // background: '#1FC758',
                                                                                            // pointerEvents: dialogLoader || !isVerified ? 'none' : 'auto',
                                                                                            // opacity: dialogLoader || !isVerified ? '0.5' : '1',
                                                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                        }}
                                                                                    >
                                                                                        {"ASSIGN SERVICE"}
                                                                                    </Button>
                                                                                </div>
                                                                            }
                                                                        </>
                                                                    }</> : <></>
                                                                }


                                                                {permissionArray.includes("UPDATE WORK INFORMATION") && sentRequest.length == 0 &&
                                                                    <div className='row mx-0'>
                                                                        <>
                                                                            {(receiverData?.ticket_status_ysn === 0) &&
                                                                                <Button className='w-100 rounded-2 border border-none d-flex align-items-center justify-content-center font-w500 ' disabled>
                                                                                    {txtClosed}
                                                                                </Button>}

                                                                            {(receiverData?.ticket_status_ysn === 1) && receiverData.user_id_lng !== localStorage.getItem("user_id") ?
                                                                                <>
                                                                                    <Button
                                                                                        className='w-100 rounded-2  d-flex align-items-center justify-content-center font-w500 '
                                                                                        onClick={() => {

                                                                                            acceptGlobalRequest();
                                                                                            // Changes in flow all Pro's able to accept global services keep commencted code
                                                                                            // if (!isSubscribedUser) {
                                                                                            //     setIsSubscriptionExpired(true)
                                                                                            // } else {
                                                                                            //     acceptGlobalRequest()
                                                                                            // }
                                                                                        }}
                                                                                        style={{
                                                                                            // background: '#1FC758',
                                                                                            pointerEvents: dialogLoader || !isVerified ? 'none' : 'auto',
                                                                                            opacity: dialogLoader || !isVerified ? '0.5' : '1',
                                                                                            border: 'none',
                                                                                            background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                            boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                        }}
                                                                                    >
                                                                                        {dialogLoader ? "Loading..." : "ACCEPT"}
                                                                                        {!dialogLoader &&
                                                                                            <span className='ps-2'>
                                                                                                <i className="bi bi-check-lg"></i>
                                                                                            </span>
                                                                                        }
                                                                                    </Button>
                                                                                </> : <>
                                                                                    {receiverData.user_id_lng == localStorage.getItem("user_id") && (receiverData?.ticket_status_ysn !== 2) && (receiverData?.ticket_status_ysn !== 10) &&
                                                                                        <div className='row mx-0'>
                                                                                            <div className='col-md-6 pe-2 mt-2'>
                                                                                                <>
                                                                                                    <Button
                                                                                                        className='w-100 d-flex align-items-center justify-content-center text-black shadow'
                                                                                                        onClick={() => { handleOpenScheduleModal() }}
                                                                                                        style={{
                                                                                                            background: 'white',
                                                                                                            borderRadius: '4px',
                                                                                                            border: '2px solid #E8E8E8',
                                                                                                            fontWeight: '600',
                                                                                                        }}
                                                                                                    >
                                                                                                        {"RESCHEDULE"}
                                                                                                    </Button>
                                                                                                </>
                                                                                            </div>

                                                                                            <div className='col-md-6 pe-2 mt-2'>
                                                                                                <>
                                                                                                    <Button
                                                                                                        className='w-100  d-flex align-items-center justify-content-center font-w500 '
                                                                                                        // onClick={() => { acceptGlobalRequest() }}
                                                                                                        onClick={() => { handleOpenCancelServiceModal() }}
                                                                                                        style={{
                                                                                                            // background: '#565656',
                                                                                                            pointerEvents: dialogLoader ? 'none' : 'auto',
                                                                                                            opacity: dialogLoader ? '0.5' : '1',
                                                                                                            background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                                                                                            border: '2px solid rgba(240, 72, 72, 1)',
                                                                                                            boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                                                                                            borderRadius: '4px',
                                                                                                            fontWeight: '600',
                                                                                                        }}
                                                                                                    >
                                                                                                        {"CANCEL REQUEST"}
                                                                                                    </Button>
                                                                                                </>
                                                                                            </div>
                                                                                        </div>
                                                                                    }
                                                                                </>
                                                                            }
                                                                            {(receiverData?.ticket_status_ysn === 2) &&
                                                                                <Button disabled
                                                                                    className='w-100 rounded-0 border border-none d-flex align-items-center justify-content-center font-w500 '
                                                                                    style={{
                                                                                        background: '#1FC758',
                                                                                    }}
                                                                                >
                                                                                    {btnAcceptedByotherPro}
                                                                                </Button>
                                                                            }
                                                                            {(receiverData?.ticket_status_ysn === 3) &&
                                                                                <>
                                                                                    {/* <Button disabled>
                                                                            {btnRejectedService}
                                                                        </Button> */}
                                                                                    <Button
                                                                                        disabled
                                                                                        className='w-100 rounded-0 border border-none d-flex align-items-center justify-content-center font-w500 '

                                                                                        style={{
                                                                                            background: '#1FC758',
                                                                                            border: 'none',
                                                                                            borderRadius: '0px !important',
                                                                                        }}
                                                                                    >
                                                                                        {btnRejectedService}
                                                                                    </Button>
                                                                                </>
                                                                            }
                                                                            {(receiverData?.ticket_status_ysn === 4) &&
                                                                                <>
                                                                                    {/* <Button disabled>
                                                                         {btnRejectedService}
                                                                     </Button> */}
                                                                                    <Button
                                                                                        disabled
                                                                                        className='w-100 rounded-0 border border-none d-flex align-items-center justify-content-center font-w500 '
                                                                                        style={{
                                                                                            background: '#1FC758',
                                                                                            border: 'none',
                                                                                            borderRadius: '0px !important',
                                                                                        }}
                                                                                    >
                                                                                        {txtClosed}
                                                                                    </Button>
                                                                                </>
                                                                            }

                                                                            {(receiverData?.ticket_status_ysn === 5) &&

                                                                                <>
                                                                                    {/* <PrimaryButton onClick={() => { acceptGlobalRequest() }} buttonName={btnConnect} */}

                                                                                    {/* <PrimaryButton
                                                                            onClick={() => { acceptGlobalRequest() }}
                                                                            buttonName={btnAcceptService}
                                                                            isLoading={dialogLoader}
                                                                            loadingMessage={'please wait...'}
                                                                        /> */}

                                                                                    <Button
                                                                                        className='w-100 rounded-2 d-flex align-items-center justify-content-center font-w500 '
                                                                                        onClick={() => {
                                                                                            acceptGlobalRequest();

                                                                                            // if (!isSubscribedUser) {
                                                                                            //     setIsSubscriptionExpired(true)
                                                                                            // } else {
                                                                                            //     acceptGlobalRequest()
                                                                                            // }
                                                                                        }}
                                                                                        style={{
                                                                                            // background: '#1FC758',
                                                                                            pointerEvents: dialogLoader || !isVerified ? 'none' : 'auto',
                                                                                            opacity: dialogLoader || !isVerified ? '0.5' : '1',
                                                                                            border: 'none',
                                                                                            background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                            boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                        }}
                                                                                    >
                                                                                        {dialogLoader ? "Loading..." : "ACCEPT"}
                                                                                        {!dialogLoader &&
                                                                                            <span className='ps-2'>
                                                                                                <i className="bi bi-check-lg"></i>
                                                                                            </span>
                                                                                        }
                                                                                    </Button>
                                                                                </>
                                                                            }

                                                                            {(receiverData?.ticket_status_ysn === 6) &&
                                                                                <>
                                                                                    {/* <Button disabled>
                                                                         {btnRejectedService}
                                                                     </Button> */}
                                                                                    <Button disabled
                                                                                        className='w-100 rounded-0 border border-none d-flex align-items-center justify-content-center font-w500 '
                                                                                        style={{
                                                                                            background: '#1FC758',
                                                                                            border: 'none',
                                                                                            borderRadius: '0px !important',
                                                                                        }}
                                                                                    >
                                                                                        {"Incomplete"}
                                                                                    </Button>
                                                                                </>
                                                                            }

                                                                            {(receiverData?.ticket_status_ysn === 7) &&
                                                                                <>
                                                                                    {/* <Button disabled>
                                                                         {btnRejectedService}
                                                                     </Button> */}
                                                                                    <Button disabled
                                                                                        className='w-100 bg-danger rounded-0 border border-none d-flex align-items-center justify-content-center font-w500 '
                                                                                        style={{
                                                                                            border: 'none',
                                                                                            borderRadius: '0px !important',
                                                                                        }}
                                                                                    >
                                                                                        {"Cancelled"}
                                                                                    </Button>
                                                                                </>
                                                                            }

                                                                            {(receiverData?.ticket_status_ysn === 10) &&
                                                                                <>
                                                                                    <Button
                                                                                        className='w-100 rounded-2  d-flex align-items-center justify-content-center font-w500 '
                                                                                        onClick={() => {

                                                                                            acceptGlobalRequest();
                                                                                            // if (!isSubscribedUser) {
                                                                                            //     setIsSubscriptionExpired(true)
                                                                                            // } else {
                                                                                            //     acceptAssignedTicketFn()
                                                                                            // }
                                                                                        }}
                                                                                        style={{
                                                                                            // background: '#1FC758',
                                                                                            pointerEvents: dialogLoader || !isVerified ? 'none' : 'auto',
                                                                                            opacity: dialogLoader || !isVerified ? '0.5' : '1',
                                                                                            border: 'none',
                                                                                            background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                            boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                        }}
                                                                                    >
                                                                                        {dialogLoader ? "Loading..." : "ACCEPT"}
                                                                                        {!dialogLoader &&
                                                                                            <span className='ps-2'>
                                                                                                <i className="bi bi-check-lg"></i>
                                                                                            </span>
                                                                                        }
                                                                                    </Button>
                                                                                </>
                                                                            }
                                                                        </>
                                                                    </div>
                                                                }

                                                                {/* For Assign Service Request by company admin */}
                                                                {permissionArray.includes("VIEW COMPANY USERS") && permissionArray.includes("ASSIGN SERVICE REQUEST") &&
                                                                    <>
                                                                        {/* {((receiverData?.ticket_status_ysn === 10) || (receiverData?.ticket_status_ysn === 2) || (receiverData?.ticket_status_ysn === 1)) && */}
                                                                        {((receiverData?.ticket_status_ysn !== 0)) &&
                                                                            <div className='row mx-0 my-2'>
                                                                                <Button
                                                                                    className='w-100 rounded-2  d-flex align-items-center justify-content-center font-w500 '
                                                                                    onClick={() => {
                                                                                        handleOpenReAssignServiceModal();
                                                                                    }}
                                                                                    style={{
                                                                                        // background: '#1FC758',
                                                                                        // pointerEvents: dialogLoader || !isVerified ? 'none' : 'auto',
                                                                                        // opacity: dialogLoader || !isVerified ? '0.5' : '1',
                                                                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                        border: '2px solid rgba(255, 154, 32, 1)',
                                                                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                    }}
                                                                                >
                                                                                    {"ASSIGN SERVICE"}
                                                                                </Button>
                                                                            </div>
                                                                        }
                                                                    </>
                                                                }
                                                            </div>
                                                        }

                                                        {/* Shopping actions */}
                                                        {tabsToggleServiceReq === 2 &&
                                                            <div
                                                                className=' col-12 bg-white  position-absolute bottom-0 w-100'
                                                                style={{
                                                                    boxShadow: '0px -6px 10px -2px #0000004f',
                                                                    zIndex: 1,
                                                                }}
                                                            >
                                                                <div>
                                                                    <div
                                                                        className={`row mx-0  ${bottomShoppingDrawerTrigger && 'mb-3'}`}
                                                                    >
                                                                        <div className='col-1'></div>
                                                                        <div
                                                                            className='col-10 px-0 d-flex align-items-center justify-content-center pt-3 px-3'
                                                                        >
                                                                            <div
                                                                                className='font-w600  cursor-pointer text-hovered '
                                                                                onClick={() => {
                                                                                    // handleCreatePurchaseList() 
                                                                                    setBottomShoppingDrawerTrigger(!bottomShoppingDrawerTrigger)
                                                                                }}
                                                                            >
                                                                                <span className='fs-5'>
                                                                                    {toggleForPurchase === 1 ? `Add shopping item` :
                                                                                        toggleForPurchase === 2 ? "Edit Shopping Item" : ''
                                                                                    }
                                                                                </span>

                                                                                {bottomShoppingDrawerTrigger ?
                                                                                    <i class="bi bi-chevron-down ms-2 border rounded px-1 "></i> :
                                                                                    <i class="bi bi-chevron-up ms-2 border rounded px-1 "></i>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                        <div className='col-1 align-items-center d-flex fs-4 justify-content-center text-black'>
                                                                            {bottomShoppingDrawerTrigger &&
                                                                                <i className="bi bi-x-lg cursor-pointer text-hovered" onClick={() => { setBottomShoppingDrawerTrigger(!bottomShoppingDrawerTrigger) }}></i>
                                                                            }
                                                                        </div>
                                                                    </div>

                                                                    {bottomShoppingDrawerTrigger &&
                                                                        <div className='px-3'>
                                                                            <div className='row mx-0 mt-1'>
                                                                                <div className='col-8 pe-2'>
                                                                                    <InputField
                                                                                        labelName={"Item name"}
                                                                                        placeholderName={"Item Name"}
                                                                                        value={itemName}
                                                                                        onChange={handleItemName}
                                                                                        onBlur={handleItemNameBlurCheck}
                                                                                        errorOccured={itemNameErr}
                                                                                        errorMeesage={"Please add item name"}
                                                                                    />
                                                                                </div>

                                                                                <div className='col-4 ps-2'>
                                                                                    <InputField
                                                                                        labelName={"Quantity"}
                                                                                        placeholderName={"Quantity"}
                                                                                        value={quantity ? `${quantity}` : ''}
                                                                                        onChange={handleQuantity}
                                                                                        onBlur={() => { }}
                                                                                    // errorOccured={quantityErr}
                                                                                    // errorMeesage={"Please add quantity"}
                                                                                    />
                                                                                </div>
                                                                            </div>

                                                                            <div className='row mx-0 mt-1'>
                                                                                <div className='col-8 pe-2'>
                                                                                    <InputField
                                                                                        labelName={`Website or Location`}
                                                                                        placeholderName={"Website or Location"}
                                                                                        value={purchaseLink}
                                                                                        onChange={handlePurchaseLink}
                                                                                        onBlur={() => { }}
                                                                                    // errorOccured={purchaseLinkErr}
                                                                                    // errorMeesage={"Please add purchase link"}
                                                                                    />
                                                                                </div>

                                                                                <div className='col-4 ps-2'>
                                                                                    <InputField
                                                                                        labelName={`Price`}
                                                                                        placeholderName={"Cost Per Item"}
                                                                                        value={totalEstimatedCost ? `${totalEstimatedCost}` : ''}
                                                                                        onChange={handleTotalEstimatedCost}
                                                                                        onBlur={() => { }}
                                                                                    // errorOccured={totalEstimatedCostErr}
                                                                                    // errorMeesage={"Please add total estimated cost"}
                                                                                    />
                                                                                </div>
                                                                            </div>

                                                                            <div className='row mx-0 mt-1'>
                                                                                <div className='col-8 pe-2'>
                                                                                    <InputField
                                                                                        labelName={`Item Description`}
                                                                                        placeholder={"Item Description"}
                                                                                        value={itemDescription}
                                                                                        onChange={handleDescriptionShopping}
                                                                                        onBlur={() => { }}
                                                                                    // errorOccured={itemDescriptionErr}
                                                                                    // errorMessage={'Please add description'}
                                                                                    />
                                                                                </div>

                                                                                <div className='col-4 ps-2'>
                                                                                    {toggleForPurchase === 1 &&
                                                                                        <PrimaryButton
                                                                                            buttonName={`Save`}
                                                                                            onClick={(e) => handleSubmitPurchase(e)}
                                                                                            loadingMessage={"Saving..."}
                                                                                            isLoading={purchaseLoading}
                                                                                            style={{
                                                                                                width: '100%',
                                                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                            }}
                                                                                        />
                                                                                    }

                                                                                    {toggleForPurchase === 2 &&
                                                                                        <PrimaryButton
                                                                                            buttonName={`Save`}
                                                                                            onClick={(e) => handleUpdatePurchase(e)}
                                                                                            loadingMessage={"Saving..."}
                                                                                            isLoading={purchaseLoading}
                                                                                            style={{
                                                                                                width: '100%',
                                                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                            }}
                                                                                        />
                                                                                    }

                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    }


                                                                </div>

                                                            </div>
                                                        }

                                                        {/* Notes actions */}
                                                        {tabsToggleServiceReq === 5 &&
                                                            <div
                                                                className=' col-12 bg-white  position-absolute bottom-0 w-100'
                                                                style={{
                                                                    boxShadow: '0px -6px 10px -2px #0000004f',
                                                                    zIndex: 1,
                                                                }}
                                                            >
                                                                <div>
                                                                    <div
                                                                        className={`row mx-0 ${bottomNotesDrawerTrigger && 'mb-3'}`}
                                                                    >
                                                                        <div className='col-1'></div>
                                                                        <div
                                                                            className='col-10 px-0 d-flex align-items-center justify-content-center pt-3 px-3'
                                                                        >
                                                                            <div
                                                                                className='font-w600  cursor-pointer text-hovered'
                                                                                onClick={() => {
                                                                                    setBottomNotesDrawerTrigger(!bottomNotesDrawerTrigger)
                                                                                }}
                                                                            >
                                                                                <span className='fs-5'>
                                                                                    {`Add note`}
                                                                                </span>

                                                                                {bottomNotesDrawerTrigger ?
                                                                                    <i class="bi bi-chevron-down ms-2 border rounded px-1 "></i> :
                                                                                    <i class="bi bi-chevron-up ms-2 border rounded px-1 "></i>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                        <div className='col-1 align-items-center d-flex fs-4 justify-content-center text-black'>
                                                                            {bottomNotesDrawerTrigger &&
                                                                                <i className="bi bi-x-lg cursor-pointer text-hovered " onClick={() => { setBottomNotesDrawerTrigger(!bottomNotesDrawerTrigger) }}></i>
                                                                            }
                                                                        </div>
                                                                    </div>

                                                                    {bottomNotesDrawerTrigger &&
                                                                        <div className='px-3'>

                                                                            <div className='row mx-0 mt-1 '>

                                                                                <div className='col-1 pe-2 d-flex justify-content-center pt-3 cursor-pointer text-hovered'>
                                                                                    <div className="tooltipCustom">
                                                                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Attachemts"}</span>
                                                                                        <i onClick={() => handleAttach()} className='bi bi-paperclip fs-3'></i>
                                                                                    </div>
                                                                                    <input
                                                                                        accept="image/*"
                                                                                        type="file"
                                                                                        multiple
                                                                                        style={{ display: "none" }}
                                                                                        ref={hiddenFileInput}
                                                                                        onChange={(e) => {
                                                                                            inputFileTarget(e);
                                                                                        }}
                                                                                    />
                                                                                </div>

                                                                                <div className='col-8 pe-2 pt-1'>
                                                                                    <InputField
                                                                                        labelName={`Message`}
                                                                                        value={discussionVal}
                                                                                        onChange={discussionOnChange}
                                                                                        onBlur={() => { }}
                                                                                    // errorOccured={itemDescriptionErr}
                                                                                    // errorMessage={'Please add description'}
                                                                                    />
                                                                                </div>

                                                                                <div
                                                                                    className='col-3 ps-2'
                                                                                    style={{
                                                                                        pointerEvents: (selectedFile.length > 0 || discussionVal !== "") ? 'auto' : 'none',
                                                                                        opacity: (selectedFile.length > 0 || discussionVal !== "") ? '1' : '0.5',
                                                                                    }}
                                                                                >

                                                                                    <PrimaryButton
                                                                                        buttonName={`Save`}
                                                                                        onClick={() => { handleSaveDiscussion() }}
                                                                                        loadingMessage={"Saving..."}
                                                                                        isLoading={saveLoading}
                                                                                        style={{
                                                                                            width: '100%',
                                                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </div>

                                                                            <div className='row mx-0 mb-2'>
                                                                                <div className='col-12 px-0'>
                                                                                    <div className='text-danger'>
                                                                                        <span>{selectedFileLimit}</span>
                                                                                    </div>

                                                                                    <div className='attachment-img-preview-bar justify-content-start'>
                                                                                        {selectedFile?.map((previewFile, index) => {
                                                                                            return (
                                                                                                <span key={index} className='attachment-img-preview-span'>
                                                                                                    <i onClick={() => deleteUpload(index)} class="bi bi-x-circle attachment-img-preview-delete-icon"></i>
                                                                                                    <img
                                                                                                        style={{ width: '40px', height: '50px', borderRadius: '5px' }}
                                                                                                        src={previewFile ? URL.createObjectURL(previewFile) : null}
                                                                                                        alt='Error'
                                                                                                    />
                                                                                                </span>
                                                                                            )
                                                                                        })}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>

                                            </>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div >

                    </div>
                </div>
            </>

            {/* Modal for the update the service request */}

            <Modal className="fade" show={updateServiceModalTrigger}
                // onHide={handleClose} 
                centered
            >
                {/* <Modal.Header style={{ borderBottom: 'none' }}>
                    <Modal.Title>{txtUpdateServiceRequest}</Modal.Title>
                    <Button
                        variant=""
                        className="btn-close btn-close-service"
                        onClick={() => handleCloseUpdateServiceModal()}
                    >

                    </Button>
                </Modal.Header> */}
                <Modal.Body>
                    <>
                        <div className='row mx-0'>
                            <div className='col-12 px-0'>

                                <div className='row mx-0'>
                                    <div className='col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black'>
                                        <span onClick={() => handleCloseUpdateServiceModal()} className='cursor-pointer text-hovered'>
                                            <i className="bi bi-x-lg "></i>
                                        </span>
                                    </div>
                                </div>

                                <div className='row mx-0 mb-2'>
                                    <div className='fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black'>
                                        <span className=''>
                                            {/* {txtUpdateServiceRequest} */}
                                            {`Edit request information`}
                                        </span>
                                    </div>
                                </div>

                                <div className='row mx-0'>
                                    <div className='col-12 px-0 d-flex align-items-center justify-content-center fs-5'>
                                        <span className=''>
                                            {`Fill in the main properties of the inventory item`}
                                        </span>
                                    </div>
                                </div>

                                <form className='mt-4' onSubmit={(e) => updateServiceRequestFn(e)} >

                                    <div className='row mx-0 mb-1'>
                                        <div className='col-12 px-0'>
                                            <InputField
                                                value={brandName}
                                                labelName={`Brand`}
                                                placeholderName={`Brand`}
                                                onChange={handleBrandName}
                                                onBlur={() => { }}
                                                errorOccured={false}
                                                errorMeesage={''}
                                            />
                                        </div>
                                    </div>

                                    <div className='row mx-0 mb-1'>
                                        <div className='col-12 px-0'>
                                            <InputField
                                                value={modelNum}
                                                labelName={`Model`}
                                                placeholderName={`Model`}
                                                onChange={handleModelNumber}
                                                onBlur={() => { }}
                                                errorOccured={false}
                                                errorMeesage={''}
                                            />
                                        </div>
                                    </div>

                                    <div className='row mx-0 mb-1'>
                                        <div className='col-12 px-0'>
                                            <InputField
                                                value={serialNumber}
                                                labelName={`Serial #`}
                                                placeholderName={`Serial #`}
                                                onChange={handleSerialNumber}
                                                onBlur={() => { }}
                                                errorOccured={false}
                                                errorMeesage={''}
                                            />
                                        </div>
                                    </div>

                                    <div className='row mx-0'>
                                        <div className='col-12 px-0'>
                                            <TextArea
                                                onChange={handleDescription}
                                                value={description}
                                                labelName={"Description"}
                                                errorOccured={isDescrError}
                                                errorMessage={"Please provide description"}
                                                rows={'3'}
                                                onBlur={() => { }}
                                            />
                                        </div>
                                    </div>




                                    {/* <div className='row mx-0 justify-content-between mt-2'>
                                        <div className='col-md-6 px-0 pe-md-2'>
                                            <SelectInputTimeSlot
                                                labelName={'Best Time To Contact'}
                                                onChange={(e) => updateTimeSlotFn(e)}
                                                defaultValue={timeSlotID ? timeSlotID : ''}
                                                options={timeSlotArr}
                                            />
                                        </div>

                                        <div className='col-md-6 px-0  ps-md-2'>
                                            <SelectInputCommunicationMode
                                                labelName={'Best Contact Method'}
                                                onChange={(e) => updateCommunicationModeFn(e)}
                                                defaultValue={communicationModeID ? communicationModeID : ''}
                                                options={communicationModeArr}
                                            />
                                        </div>
                                    </div> */}

                                    {(attachmentsArr?.length < 3 || true) &&
                                        <div className='row mx-0 mb-3'>
                                            <div className='col-12 px-0 d-flex align-items-center'>
                                                <div
                                                    className='d-flex align-items-center justify-content-center cursor-pointer text-hovered fs-5 font-w600'
                                                    onClick={() => { handleAttachService() }}
                                                >
                                                    <span>
                                                        <i onClick={() => { }} className='bi bi-paperclip '></i>
                                                    </span>
                                                    <span className='ms-2'>
                                                        {`Attach file`}
                                                    </span>
                                                    <input
                                                        accept="image/*"
                                                        type="file"
                                                        multiple
                                                        style={{ display: "none" }}
                                                        ref={hiddenFileInputAttach}
                                                        onChange={(e) => {
                                                            inputFileTargetAttach(e);
                                                        }}
                                                    />
                                                </div>
                                            </div>


                                            <div className='row mx-0 mb-2'>
                                                <div className='col-12 px-0'>
                                                    <div className='text-danger'>
                                                        <span>{selectedFileLimitAttach}</span>
                                                    </div>

                                                    <div className='attachment-img-preview-bar justify-content-start'>
                                                        {selectedFileAttach?.map((previewFile, index) => {
                                                            return (
                                                                <span key={index} className='attachment-img-preview-span'>
                                                                    <i onClick={() => deleteUploadAttach(index)} class="bi bi-x-circle attachment-img-preview-delete-icon"></i>
                                                                    <img
                                                                        style={{ width: '40px', height: '50px', borderRadius: '5px' }}
                                                                        src={previewFile ? URL.createObjectURL(previewFile) : null}
                                                                        alt='Error'
                                                                    />
                                                                </span>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    {false && <div className='row mx-0'>
                                        <div className='col-12 px-1 d-flex py-2 mb-1  overflow-auto '>
                                            {attachmentsArr?.length > 0 &&
                                                <>
                                                    {attachmentsArr.map((attachment, index) => {
                                                        return (
                                                            <div
                                                                className='update-attachment-img-container-individual'
                                                                style={{
                                                                    height: '120px',
                                                                    width: '100px',
                                                                    minWidth: '100px'
                                                                }}
                                                            >
                                                                <img
                                                                    src={attachment?.url}
                                                                    alt=""
                                                                    className='rounded cursor-pointer update-attachment-img-individual'
                                                                    onClick={() => {
                                                                        handleOpenDoc();
                                                                        setImageAttachURL(attachment?.url);
                                                                    }}
                                                                />
                                                            </div>
                                                        )
                                                    })}
                                                </>
                                            }

                                            {(attachmentsArr?.length <= 2) && <>
                                                {attachedImage1 ?
                                                    <div
                                                        className='update-attachment-img-container-individual'
                                                        style={{
                                                            height: '120px',
                                                            width: '100px',
                                                            minWidth: '100px'
                                                        }}
                                                    >
                                                        <i onClick={() => { deleteAttachedImage1(); deleteAttachedImage2() }} className="bi bi-x-circle-fill attachment-img-delete-icon"></i>
                                                        <img onClick={() => { handleOpenDoc(); setImageAttachURL(attachedImage1); }} src={attachedImage1} alt="Attachments" className='update-attachment-img-individual' />
                                                    </div> :
                                                    <div
                                                        className='update-attachment-img-container-individual'
                                                        onClick={handleClickAttachedImage1}
                                                        style={{
                                                            height: '120px',
                                                            width: '100px',
                                                            minWidth: '100px'
                                                        }}
                                                    >
                                                        <i className="bi bi-plus-circle-fill update-attachment-img-individual-icon"></i>
                                                        <input ref={attachedImage1Ref} type="file" accept="image/*" hidden onChange={(e) => { handleAttachedImage1(e) }} />
                                                    </div>
                                                }
                                            </>}

                                            {attachedImage1 && (attachmentsArr?.length == 1) &&
                                                <>
                                                    {attachedImage2 ?
                                                        <div
                                                            className='update-attachment-img-container-individual'
                                                            style={{
                                                                height: '120px',
                                                                width: '100px',
                                                                minWidth: '100px'
                                                            }}
                                                        >
                                                            <i onClick={() => { deleteAttachedImage2() }} className="bi bi-x-circle-fill attachment-img-delete-icon"></i>
                                                            <img onClick={() => { handleOpenDoc(); setImageAttachURL(attachedImage2); }} src={attachedImage2} alt="Attachments" className='update-attachment-img-individual' />
                                                        </div> :
                                                        <div
                                                            className='update-attachment-img-container-individual'
                                                            onClick={handleClickAttachedImage2}
                                                            style={{
                                                                height: '120px',
                                                                width: '100px',
                                                                minWidth: '100px'
                                                            }}
                                                        >
                                                            <i className="bi bi-plus-circle-fill update-attachment-img-individual-icon"></i>
                                                            <input ref={attachedImage2Ref} type="file" accept="image/*" hidden onChange={(e) => { handleAttachedImage2(e) }} />
                                                        </div>}
                                                </>
                                            }
                                        </div>
                                    </div>}


                                    <div className='row mx-0'>
                                        <div className='col-12 px-0'>
                                            <PrimaryButton
                                                onClick={(e) => updateServiceRequestFn(e)}
                                                buttonName={'SAVE'}
                                                type={"submit"}
                                                loadingMessage={'Saving...'}
                                                isLoading={saveUpdateTicketLoading}
                                                style={{
                                                    width: '100%',
                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                    borderRadius: '4px'
                                                }}
                                            />
                                        </div>
                                    </div>
                                </form>

                            </div>

                        </div>
                    </>
                </Modal.Body>
            </Modal>

            {/* Modal for the getting the confirmation from the user to search for another pro */}

            <Modal className="fade" show={connectWithAnotherProModalTrigger}
                // onHide={handleClose} 
                centered
            >
                {/* <Modal.Header style={{ borderBottom: 'none' }}>
                    <Modal.Title>{"Connect with another pro"}</Modal.Title>
                    <Button
                        variant=""
                        className="btn-close btn-close-service"
                        onClick={() => handleCloseConnectWithAnotherProModal()}
                    >

                    </Button>
                </Modal.Header> */}
                <Modal.Body>
                    <>
                        <div className='row mx-0'>
                            <div className='col-12 px-0'>

                                <div className='row mx-0'>
                                    <div className='col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black'>
                                        <span onClick={() => handleCloseConnectWithAnotherProModal()} className='cursor-pointer'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className='row mx-0'>
                                    <div className='fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black'>
                                        <span className=''>
                                            {"Connect to another pro"}
                                        </span>
                                    </div>
                                </div>

                                <div className='row mx-0 mt-3'>
                                    <div className='font-fw600 col-12 px-0 d-flex align-items-center justify-content-center fs-5 '>
                                        <span className=''>
                                            {txtSearchProConfirmation}
                                        </span>
                                    </div>
                                </div>

                                <div className='row mx-0 mt-3'>
                                    <div className='col-12 px-0'>
                                        <PrimaryButton
                                            onClick={() => ReInitiateByCust()}
                                            buttonName={'Confirm'}
                                            style={{ width: '100%' }}
                                        />
                                    </div>

                                </div>


                            </div>
                        </div>

                    </>
                </Modal.Body>
            </Modal>



            {/* Modal for previewing the attached image preview */}
            {openDoc &&
                <ImagePreviewer
                    openDoc={openDoc}
                    handleCloseDoc={handleCloseDoc}
                    imageAttachURL={imageAttachURL}
                    notesMessage={notesMessage}
                />
            }


            {/* Share Service request modal */}
            <>
                {/* <!-- Modal --> */}
                <Modal className="fade" show={showShareServiceModal}
                    // onHide={handleClose} 
                    centered
                >

                    <Modal.Body>
                        <>
                            <div className='row mx-0'>
                                <div className='col-12 px-0'>

                                    <div className='row mx-0'>
                                        <div className='col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black'>
                                            <span onClick={() => handleCloseShareServiceModal()} className='cursor-pointer'>
                                                <i className="bi bi-x-lg"></i>
                                            </span>
                                        </div>
                                    </div>

                                    <div className='row mx-0'>
                                        <div className='fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black'>
                                            <span className=''>
                                                {"Share via email or SMS"}
                                            </span>
                                        </div>
                                    </div>

                                    <div className='row mx-0 mt-3'>
                                        <div className='font-w500 col-12 px-0 d-flex align-items-center justify-content-center fs-5 '>
                                            <span className=' text-center'>
                                                {"You can send all notes to the third party to their email or phone number"}
                                            </span>
                                        </div>
                                    </div>

                                    <form className='w-100' onSubmit={(e) => handleShareService(e)}>
                                        <EmailPhoneCombine
                                            inputValue={emailPhoneValue}
                                            handleChangeCode={handleDropdownValue}
                                            handleInputValue={handleEmailPhone}
                                            isEnteringNumber={isPhone}
                                            setIsEnteringNumber={setIsPhone}
                                            errorOccured={isEmailPhoneVal}
                                            errorMessage={validEmail_OR_MobileNumberText}
                                            handleOnBlur={handleEmailPhoneBlur}
                                            defaultCodeValue={codeValue}
                                        />

                                        <div className='row mx-0 mt-1'>
                                            <div className='font-w500 col-12 px-0 d-flex align-items-center justify-content-center fs-5 '>
                                                <PrimaryButton
                                                    buttonName={"Submit"}
                                                    onClick={(e) => handleShareService(e)}
                                                    loadingMessage={"Loading..."}
                                                    isLoading={shareLoading}
                                                    style={{ 'width': '100%' }}
                                                />
                                            </div>
                                        </div>
                                    </form>

                                </div>
                            </div>
                        </>
                    </Modal.Body>
                </Modal>
            </>

            {/* Old Modal for shopping list starts */}
            {/* <!-- Modal --> */}
            <Modal
                className="fade"
                show={purchaseListTrigger}
                // onHide={handleClose} 
                centered
            >
                <Modal.Body>

                    <div className='row mx-0'>
                        <div className='col-12 px-0'>

                            <div className='row mx-0'>
                                <div className='col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black'>
                                    <span onClick={() => handleClosePurchaseList()} className='cursor-pointer'>
                                        <i className="bi bi-x-lg"></i>
                                    </span>
                                </div>
                            </div>

                            <div className='row mx-0 mb-3'>
                                <div className='fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black'>
                                    <span className=''>
                                        {toggleForPurchase === 1 ? "Add Shopping Item" :
                                            toggleForPurchase === 2 ? "Edit Shopping Item" :
                                                toggleForPurchase === 3 ? "Share Shopping List" :
                                                    toggleForPurchase === 4 ? "Are you sure to delete shopping item" : ""}
                                    </span>
                                </div>
                            </div>

                            {/* Add Or Edit shopping items */}
                            {(toggleForPurchase === 1 || toggleForPurchase === 2) ?
                                <>
                                    <div className='row mx-0'>
                                        <div className='col-12 px-0'>
                                            <InputField
                                                labelName={"Item Name"}
                                                placeholderName={"Item Name"}
                                                value={itemName}
                                                onChange={handleItemName}
                                                onBlur={handleItemNameBlurCheck}
                                                errorOccured={itemNameErr}
                                                errorMeesage={"Please add item name"}
                                            />
                                        </div>
                                    </div>

                                    <div className='row mx-0'>
                                        <div className='col-md-6 px-0 pe-md-2'>
                                            <InputField
                                                labelName={"Quantity"}
                                                placeholderName={"Quantity"}
                                                value={quantity ? `${quantity}` : ''}
                                                onChange={handleQuantity}
                                            // onBlur={handleQuantityBlurCheck}
                                            // errorOccured={quantityErr}
                                            // errorMeesage={"Please add quantity"}
                                            />
                                        </div>

                                        <div className='col-md-6 px-0 ps-md-2'>
                                            <InputField
                                                labelName={"Cost Per Item"}
                                                placeholderName={"Cost Per Item"}
                                                value={totalEstimatedCost ? `${totalEstimatedCost}` : ''}
                                                onChange={handleTotalEstimatedCost}
                                            // onBlur={handleTotalEstimatedCostBlurCheck}
                                            // errorOccured={totalEstimatedCostErr}
                                            // errorMeesage={"Please add total estimated cost"}
                                            />
                                        </div>

                                    </div>

                                    {/* <div className='row mx-0'>
                                        <div className='col-12 px-0'>
                                            <InputField
                                                labelName={"Cost Per Item"}
                                                placeholderName={"Cost Per Item"}
                                                value={totalEstimatedCost ? `${totalEstimatedCost}` : ''}
                                                onChange={handleTotalEstimatedCost}
                                            // onBlur={handleTotalEstimatedCostBlurCheck}
                                            // errorOccured={totalEstimatedCostErr}
                                            // errorMeesage={"Please add total estimated cost"}
                                            />
                                        </div>
                                    </div> */}

                                    <div className='row mx-0'>
                                        <div className='col-12 px-0'>
                                            <InputField
                                                labelName={"Website or Location"}
                                                placeholderName={"Website or Location"}
                                                value={purchaseLink}
                                                onChange={handlePurchaseLink}
                                            // onBlur={handlePurchaseLinkBlurCheck}
                                            // errorOccured={purchaseLinkErr}
                                            // errorMeesage={"Please add purchase link"}
                                            />
                                        </div>
                                    </div>

                                    <div className='row mx-0'>
                                        <div className='col-12 px-0'>
                                            <TextArea
                                                labelName={"Item Description"}
                                                placeholder={"Item Description"}
                                                value={itemDescription}
                                                onChange={handleDescriptionShopping}
                                            // onBlur={handleDescriptionBlurCheck}
                                            // errorOccured={itemDescriptionErr}
                                            // errorMessage={'Please add description'}
                                            />
                                        </div>
                                    </div>

                                    <div className='row mx-0 mb-3'>
                                        <div className='col-12 px-0'>
                                            <span>{"Total Estimated Cost : "}</span>
                                            <span className='fw-bold'>${(quantity * totalEstimatedCost).toFixed(2)}</span>
                                        </div>
                                    </div>

                                    {toggleForPurchase === 1 &&
                                        <div className='row mx-0'>
                                            <div className='col-12 px-0'>
                                                <PrimaryButton
                                                    buttonName={"Submit"}
                                                    onClick={(e) => handleSubmitPurchase(e)}
                                                    loadingMessage={"Loading..."}
                                                    isLoading={purchaseLoading}
                                                    style={{ width: "100%" }}
                                                />
                                            </div>
                                        </div>}

                                    {toggleForPurchase === 2 &&
                                        <div className='row mx-0'>
                                            <div className='col-12 px-0'>
                                                <PrimaryButton
                                                    buttonName={"Submit"}
                                                    onClick={(e) => handleUpdatePurchase(e)}
                                                    loadingMessage={"Loading..."}
                                                    isLoading={purchaseLoading}
                                                    style={{ width: "100%" }}
                                                />
                                            </div>
                                        </div>}
                                </> :
                                // Send Purchase List
                                toggleForPurchase === 3 ?
                                    <>
                                        <div>
                                            <div className='row mx-0 '>
                                                <div className='col-12 px-0 text-center'>
                                                    <span className='fw-bold fs-5 '>
                                                        {"You can send all shopping items to the third party to their email or phone number"}
                                                    </span>

                                                </div>

                                            </div>
                                            <form onSubmit={(e) => handleSendPurchaseList(e)}>
                                                <EmailPhoneCombine
                                                    inputValue={emailPhoneValue}
                                                    handleChangeCode={handleDropdownValue}
                                                    handleInputValue={handleEmailPhone}
                                                    isEnteringNumber={isPhone}
                                                    setIsEnteringNumber={setIsPhone}
                                                    errorOccured={isEmailPhoneVal}
                                                    errorMessage={validEmail_OR_MobileNumberText}
                                                    handleOnBlur={handleEmailPhoneBlur}
                                                    defaultCodeValue={codeValue}
                                                />

                                                <div className='row mx-0'>
                                                    <div className='col-12 px-0'>
                                                        <PrimaryButton
                                                            buttonName={"Submit"}
                                                            onClick={(e) => handleSendPurchaseList(e)}
                                                            loadingMessage={"Loading..."}
                                                            isLoading={purchaseLoading}
                                                            style={{ width: "100%" }}
                                                        />
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </> :
                                    // Delete shopping item
                                    toggleForPurchase === 4 ?
                                        <>
                                            <div className='row mx-0 text-black lh-lg'>
                                                <div className='col-6 px-0 font-w600'>
                                                    <span>{"Item Name"}</span>
                                                </div>
                                                <div className='col-6 px-0'>
                                                    <span>{itemName}</span>
                                                </div>
                                            </div>

                                            {quantity && <div className='row mx-0 text-black lh-lg'>
                                                <div className='col-6 px-0 font-w600'>
                                                    <span>{"Quantity"}</span>
                                                </div>
                                                <div className='col-6 px-0'>
                                                    <span>{quantity}</span>
                                                </div>
                                            </div>}



                                            {totalEstimatedCost && <div className='row mx-0 text-black lh-lg'>
                                                <div className='col-6 px-0 font-w600'>
                                                    <span>{"Total Estimated Cost"}</span>
                                                </div>
                                                <div className='col-6 px-0'>
                                                    <span>{`$ ${totalEstimatedCost.toFixed(2)}`}</span>
                                                </div>
                                            </div>}

                                            {
                                                itemDescription &&
                                                <div className='row mx-0 text-black lh-lg'>
                                                    <div className='col-6 px-0 font-w600'>
                                                        <span>{"Item Description"}</span>
                                                    </div>
                                                    <div className='col-6 px-0'>
                                                        <span>{itemDescription}</span>
                                                    </div>
                                                </div>
                                            }

                                            {
                                                purchaseLink &&
                                                <div className='row mx-0 text-black lh-lg'>
                                                    <div className='col-6 px-0 font-w600'>
                                                        <span>{"Purchase Link"}</span>
                                                    </div>
                                                    <div className='col-6 px-0'>
                                                        <a href={purchaseLink} target="_blank" rel="noreferrer" >
                                                            <span>{purchaseLink}</span>
                                                        </a>
                                                    </div>
                                                </div>
                                            }



                                            <div className='row mx-0 text-black mt-2'>
                                                <div className='col-12 px-0 font-w600'>
                                                    <PrimaryButton
                                                        onClick={(e) => handleDeletePurchaseList(shoppingItemObject, e)}
                                                        buttonName={'Yes, I confirm'}
                                                        type={"submit"}
                                                        loadingMessage={'Deleting...'}
                                                        isLoading={purchaseLoading}
                                                        style={{
                                                            width: '100%',
                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </> : ''
                            }


                        </div>
                    </div>



                </Modal.Body>
            </Modal>

            {/* Modal for shopping list ends */}

            {/* Modal for delete notes starts */}
            <Modal
                className="fade"
                show={modalTriggerNotes}
                // onHide={handleClose}
                centered>
                <Modal.Body>
                    <div className="row mx-0">
                        <div className="col-12 px-0">
                            <div className="row mx-0">
                                <div className="col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black">
                                    <span
                                        onClick={() => handleCloseModalNotes()}
                                        className="cursor-pointer">
                                        <i className="bi bi-x-lg"></i>
                                    </span>
                                </div>
                            </div>

                            <div className="row mx-0 mb-3">
                                <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                    <span className="">{"Delete note"}</span>
                                </div>
                            </div>

                            <div className="row mx-0 mt-3 pb-2">
                                <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                    <span className="fs-5">
                                        {"Are you sure you want to delete this note?"}
                                    </span>
                                </div>
                            </div>

                            {/* <div className="row mx-0 text-black mt-2">
                                <div className="col-12 px-0 font-w600">
                                    <PrimaryButton
                                        onClick={(e) => handleCloseModalNotes()}
                                        buttonName={"Cancel"}
                                        style={{
                                            width: "100%",
                                            backgroundColor: "white",
                                            border: "none",
                                            color: "grey",
                                        }}
                                    />
                                </div>
                            </div> */}

                            <div className="row mx-0 text-black mt-2">
                                <div className="col-sm-6 pe-sm-2 font-w600">
                                    <PrimaryButton
                                        onClick={(e) => handleCloseModalNotes()}
                                        buttonName={"NO, GO BACK"}
                                        style={{
                                            width: "100%",
                                            background: 'rgba(251, 252, 255, 1)',
                                            border: '1px solid rgba(199, 212, 234, 1)',
                                            color: "grey",
                                            boxshadow: '0px 6px 12px 0px rgba(102, 129, 172, 0.12)',
                                        }}
                                    />
                                </div>

                                <div className="col-sm-6 ps-sm-2 font-w600">
                                    <PrimaryButton
                                        onClick={(e) => handleDeleteNote(noteObject, e)}
                                        buttonName={"YES, DELETE IT"}
                                        loadingMessage={"Deleting..."}
                                        isLoading={saveLoading}
                                        style={{
                                            width: "100%",
                                            background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                            boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                            border: '1px solid rgba(240, 72, 72, 1)',
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {/* Modal for delete notes ends */}

            {/* Modal for Change job status starts */}
            <Modal
                className="fade"
                show={changeJobStatusModalTrigger}
                // show={true}
                // onHide={handleClose}
                centered
            >
                <Modal.Body>
                    <div className="row mx-0">
                        <div className="col-12 px-0">
                            <div className="row mx-0">
                                <div className="col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black">
                                    <span
                                        onClick={() => handleCloseChangeJobStatusModal()}
                                        className="cursor-pointer">
                                        <i className="bi bi-x-lg text-hovered"></i>
                                    </span>
                                </div>
                            </div>

                            <div className="row mx-0 mb-3">
                                <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                    <span className="">{`Change request status`}</span>
                                </div>
                            </div>

                            {/* Customer updating job statuses */}
                            {permissionArray.includes("SCAN TAB") &&
                                <div>
                                    {/* Re-initiate service when pro or customer closes it */}
                                    {(receiverData?.category_name_chr !== null && receiverData?.category_name_chr !== 'null') && (receiverData.ticket_status_ysn === 0 || receiverData.ticket_status_ysn === 4 || receiverData.ticket_status_ysn === 7) &&
                                        <div
                                            className="row mx-0 rounded-2 p-3 shadow-lg mb-2 cursor-pointer border border-light border-hovered bg-white"
                                            onClick={() => { setJobStatus(5) }}
                                        >
                                            <div className="col-12 px-0 font-w600 d-flex align-items-center ">
                                                <div className='d-flex'>
                                                    <div className='d-flex align-items-center justify-content-center'>
                                                        <div className="pe-4">
                                                            <input
                                                                className="form-check-input"
                                                                style={{ display: 'inline-block' }}
                                                                name="selectJobStatus"
                                                                type="radio"
                                                                value={1}
                                                                onChange={(e) => { setJobStatus(5) }}
                                                                checked={jobStatus == 5}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <span className='font-w700 text-black fs-5'>{`Re-initiate service`}</span>
                                                        <span className=''>{`Re-initiate your service`}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    {/* Cancel open service request */}
                                    {(receiverData.ticket_status_ysn == 1 || receiverData.ticket_status_ysn == 5) &&
                                        <div
                                            className="row mx-0 rounded-2 p-3 shadow-lg mb-2 cursor-pointer border border-light border-hovered bg-white"
                                            onClick={() => { setJobStatus(7) }}
                                        >
                                            <div className="col-12 px-0 font-w600 d-flex align-items-center ">
                                                <div className='d-flex'>
                                                    <div className='d-flex align-items-center justify-content-center'>
                                                        <div className="pe-4">
                                                            <input
                                                                className="form-check-input"
                                                                style={{ display: 'inline-block' }}
                                                                name="selectJobStatus"
                                                                type="radio"
                                                                value={7}
                                                                onChange={(e) => { setJobStatus(7) }}
                                                                checked={jobStatus == 7}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <span className='font-w700 text-black fs-5'>{`Cancel service`}</span>
                                                        <span className=''>{`Cancel your service request`}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }


                                    {/* Resolved */}
                                    {/* Condition changed to new one 
                                    sentRequest.length > 0 && acceptRejectFlag === 1 && receiverData.ticket_status_ysn !== 0 && */}
                                    {sentRequest.length > 0 && acceptRejectFlag === 1 && receiverData.ticket_status_ysn === 2 &&
                                        <div
                                            className="row mx-0 rounded-2 p-3 shadow-lg mb-2 cursor-pointer border-hovered  bg-white"
                                            onClick={() => { setJobStatus(0) }}
                                            style={{
                                                border: jobStatus == 0 ? '2px solid orange' : '',
                                            }}
                                        >
                                            <div className="col-12 px-0 font-w600 d-flex align-items-center ">
                                                <div className='d-flex'>
                                                    <div className='d-flex align-items-center justify-content-center'>
                                                        <div className="pe-4">
                                                            {/* <input
                                                                className="form-check-input"
                                                                style={{ display: 'inline-block' }}
                                                                name="selectJobStatus"
                                                                type="radio"
                                                                value={0}
                                                                onChange={(e) => { setJobStatus(0) }}
                                                                checked={jobStatus == 0}
                                                            /> */}
                                                        </div>
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <span className='font-w700 text-black fs-5'>{`Resolved`}</span>
                                                        <span className=''>{`The issue is completed to my satisfaction`}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            {jobStatus == 0 &&
                                                <>
                                                    <div className='col-12 px-0 d-flex align-items-center justify-content-center flex-column mt-2'>
                                                        <div>
                                                            <span className='fs-5 text-black font-w700'>{`How would you rate the a Pro's help?`}</span>
                                                        </div>
                                                        <div>
                                                            <div
                                                                className="font-w600 fs-3 mb-3"
                                                                style={{ display: "flex", justifyContent: "center", alignItems: 'center' }}>
                                                                {[...Array(5)].map((star, i) => {
                                                                    const rating = i + 1;
                                                                    return (
                                                                        <label key={i}>
                                                                            <input
                                                                                type="radio"
                                                                                name="rating"
                                                                                value={ratingValue}
                                                                                onClick={(e) => {
                                                                                    setRatingValue(rating);
                                                                                }}
                                                                                style={{ display: "none" }}
                                                                            />
                                                                            {rating <= (hover || ratingValue) ? (
                                                                                <BsStarFill
                                                                                    onMouseEnter={() => setHover(rating)}
                                                                                    onMouseLeave={() => setHover(0)}
                                                                                    className="star"
                                                                                    style={{
                                                                                        width: "24px",
                                                                                        height: "24px",
                                                                                        cursor: "pointer",
                                                                                        color: "gold",
                                                                                    }}
                                                                                />
                                                                            ) : (
                                                                                <BiStar
                                                                                    onMouseEnter={() => setHover(rating)}
                                                                                    onMouseLeave={() => setHover(0)}
                                                                                    className="star"
                                                                                    style={{
                                                                                        width: "24px",
                                                                                        height: "24px",
                                                                                        cursor: "pointer",
                                                                                        color: "gray",
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        </label>
                                                                    );
                                                                })} &nbsp;&nbsp;
                                                                {/* <span className="fs-6 ">{"("}{`${ratingValue} of 5`}{")"}</span> */}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='col-12 px-0'>
                                                        <TextArea
                                                            // onChange={onChangeFeedBackMsg}
                                                            value={feedbackMessage}
                                                            labelName={`Your feedback(optional)`}
                                                            rows={'2'}
                                                            onChange={(e) => { setFeedbackMessage(e.target.value) }}
                                                            onBlur={() => { }}
                                                        />
                                                    </div>
                                                </>
                                            }

                                        </div>
                                    }

                                    {/* Unresolved */}
                                    {/* Condition changed to new one ->
                                    sentRequest.length > 0 && acceptRejectFlag === 1 && receiverData.ticket_status_ysn !== 0 && */}
                                    {sentRequest.length > 0 && acceptRejectFlag === 1 && receiverData.ticket_status_ysn === 2 &&
                                        <div
                                            className="row mx-0 rounded-2 p-3 shadow-lg mb-2 cursor-pointer border-hovered  bg-white"
                                            onClick={() => { setJobStatus(4) }}
                                            style={{
                                                border: jobStatus == 4 ? '2px solid orange' : '',
                                            }}
                                        >
                                            <div className="col-12 px-0 font-w600 d-flex align-items-center ">
                                                <div className='d-flex'>
                                                    <div className='d-flex align-items-center justify-content-center'>
                                                        <div className="pe-4">
                                                            {/* <input
                                                                className="form-check-input"
                                                                style={{ display: 'inline-block' }}
                                                                name="selectJobStatus"
                                                                type="radio"
                                                                value={4}
                                                                onChange={(e) => { setJobStatus(4) }}
                                                                checked={jobStatus == 4}
                                                            /> */}
                                                        </div>
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <span className='font-w700 text-black fs-5'>{`Unresolved`}</span>
                                                        <span className=''>{`The Pro was unable to assit me`}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            {jobStatus == 4 &&
                                                <>
                                                    <div className='col-12 px-0 d-flex align-items-center justify-content-center flex-column mt-2'>
                                                        <div>
                                                            <span className='fs-5 text-black font-w700'>{`How would you rate the a Pro's help?`}</span>
                                                        </div>
                                                        <div>
                                                            <div
                                                                className="font-w600 fs-3 mb-3"
                                                                style={{ display: "flex", justifyContent: "center", alignItems: 'center' }}>
                                                                {[...Array(5)].map((star, i) => {
                                                                    const rating = i + 1;
                                                                    return (
                                                                        <label key={i}>
                                                                            <input
                                                                                type="radio"
                                                                                name="rating"
                                                                                value={ratingValue}
                                                                                onClick={(e) => {
                                                                                    setRatingValue(rating);
                                                                                }}
                                                                                style={{ display: "none" }}
                                                                            />
                                                                            {rating <= (hover || ratingValue) ? (
                                                                                <BsStarFill
                                                                                    onMouseEnter={() => setHover(rating)}
                                                                                    onMouseLeave={() => setHover(0)}
                                                                                    className="star"
                                                                                    style={{
                                                                                        width: "24px",
                                                                                        height: "24px",
                                                                                        cursor: "pointer",
                                                                                        color: "gold",
                                                                                    }}
                                                                                />
                                                                            ) : (
                                                                                <BiStar
                                                                                    onMouseEnter={() => setHover(rating)}
                                                                                    onMouseLeave={() => setHover(0)}
                                                                                    className="star"
                                                                                    style={{
                                                                                        width: "24px",
                                                                                        height: "24px",
                                                                                        cursor: "pointer",
                                                                                        color: "gray",
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        </label>
                                                                    );
                                                                })} &nbsp;&nbsp;
                                                                {/* <span className="fs-6 ">{"("}{`${ratingValue} of 5`}{")"}</span> */}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='col-12 px-0'>
                                                        <TextArea
                                                            // onChange={onChangeFeedBackMsg}
                                                            value={feedbackMessage}
                                                            labelName={`Your feedback(optional)`}
                                                            rows={'2'}
                                                            onChange={(e) => { setFeedbackMessage(e.target.value) }}
                                                            onBlur={() => { }}
                                                        />
                                                    </div>

                                                    {paymentGatewayFlag && receiverData.amount_after_discount > 0 && !sentRequest[0]?.transactions[0]?.refund_status &&
                                                        <div className='col-12 d-flex align-items-center'>
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                id="refund"
                                                                name="refund"
                                                                onChange={(e) => { setIsReqRefund(!isReqRefund) }}
                                                                value={isReqRefund}
                                                                checked={isReqRefund}
                                                            />
                                                            <span
                                                                className='ps-3 font-w600 fs-5 pt-1'
                                                                onClick={() => { setIsReqRefund(!isReqRefund) }}
                                                            >
                                                                {`I want to request a refund`}
                                                            </span>
                                                        </div>
                                                    }
                                                </>
                                            }
                                        </div>
                                    }

                                    {/* work in progress */}
                                    {receiverData.ticket_status_ysn == 2 &&
                                        <div
                                            className="row mx-0 rounded-2 p-3 shadow-lg mb-2 cursor-pointer border-hovered bg-white"
                                            onClick={() => { setJobStatus(2) }}
                                            style={{
                                                border: jobStatus == 2 ? '2px solid orange' : '',
                                            }}
                                        >
                                            <div className="col-12 px-0 font-w600 d-flex align-items-center ">
                                                <div className='d-flex'>
                                                    <div className='d-flex align-items-center justify-content-center'>
                                                        <div className="pe-4">
                                                            {/* <input
                                                                className="form-check-input"
                                                                style={{ display: 'inline-block' }}
                                                                name="selectJobStatus"
                                                                type="radio"
                                                                value={2}
                                                                onChange={(e) => { setJobStatus(2) }}
                                                                checked={jobStatus == 2}
                                                            /> */}
                                                        </div>
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <span className='font-w700 text-black fs-5'>{`Work in Process`}</span>
                                                        <span className=''>{`The work is still ongoing`}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    <div className="row mx-0 text-black mt-4">
                                        <div className="col-12 "
                                            style={{
                                                pointerEvents: jobStatus == 2 ? "none" : "auto",
                                                opacity: jobStatus == 2 ? "0.5" : "1",
                                            }}
                                        >
                                            <PrimaryButton
                                                onClick={(e) => {
                                                    if (jobStatus == 2) {
                                                        handleCloseChangeJobStatusModal();
                                                    } else {
                                                        if (jobStatus || jobStatus == 0) {
                                                            handleChangeJobStatusFn();
                                                        }
                                                    }
                                                }}
                                                buttonName={`SUBMIT`}
                                                loadingMessage={"Loading..."}
                                                isLoading={changeJobStatusLoading}
                                                style={{
                                                    width: "100%",
                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                    borderRadius: '4px'
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }

                            {permissionArray.includes("UPDATE WORK INFORMATION") &&
                                <>
                                    <div>
                                        {/* Resolved */}
                                        {/* Condition changed to new one 
                                    sentRequest.length > 0 && acceptRejectFlag === 1 && receiverData.ticket_status_ysn !== 0 && */}
                                        {sentRequest.length > 0 && acceptRejectFlag === 1 && receiverData.ticket_status_ysn === 2 &&
                                            <div
                                                className="row mx-0 rounded-2 p-3 shadow-lg mb-2 cursor-pointer border-hovered  bg-white"
                                                onClick={() => { setJobStatus(0) }}
                                                style={{
                                                    border: jobStatus == 0 ? '1px solid orange' : '',
                                                }}
                                            >
                                                <div className="col-12 px-0 font-w600 d-flex align-items-center ">
                                                    <div className='d-flex'>
                                                        <div className='d-flex align-items-center justify-content-center'>
                                                            <div className="pe-4">
                                                                {/* <input
                                                                className="form-check-input"
                                                                style={{ display: 'inline-block' }}
                                                                name="selectJobStatus"
                                                                type="radio"
                                                                value={0}
                                                                onChange={(e) => { setJobStatus(0) }}
                                                                checked={jobStatus == 0}
                                                            /> */}
                                                            </div>
                                                        </div>
                                                        <div className='d-flex flex-column'>
                                                            <span className='font-w700 text-black fs-5'>{`Resolved`}</span>
                                                            <span className=''>{`I successfully helped the customer`}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {jobStatus == 0 &&
                                                    <>
                                                        <div className='col-12 px-0 d-flex align-items-center justify-content-center flex-column mt-2'>
                                                            <div>
                                                                <span className='fs-5 text-black font-w700'>{`How would you rate the a job?`}</span>
                                                            </div>
                                                            <div>
                                                                <div
                                                                    className="font-w600 fs-3 mb-3"
                                                                    style={{ display: "flex", justifyContent: "center", alignItems: 'center' }}>
                                                                    {[...Array(5)].map((star, i) => {
                                                                        const rating = i + 1;
                                                                        return (
                                                                            <label key={i}>
                                                                                <input
                                                                                    type="radio"
                                                                                    name="rating"
                                                                                    value={ratingValue}
                                                                                    onClick={(e) => {
                                                                                        setRatingValue(rating);
                                                                                    }}
                                                                                    style={{ display: "none" }}
                                                                                />
                                                                                {rating <= (hover || ratingValue) ? (
                                                                                    <BsStarFill
                                                                                        onMouseEnter={() => setHover(rating)}
                                                                                        onMouseLeave={() => setHover(0)}
                                                                                        className="star"
                                                                                        style={{
                                                                                            width: "24px",
                                                                                            height: "24px",
                                                                                            cursor: "pointer",
                                                                                            color: "gold",
                                                                                        }}
                                                                                    />
                                                                                ) : (
                                                                                    <BiStar
                                                                                        onMouseEnter={() => setHover(rating)}
                                                                                        onMouseLeave={() => setHover(0)}
                                                                                        className="star"
                                                                                        style={{
                                                                                            width: "24px",
                                                                                            height: "24px",
                                                                                            cursor: "pointer",
                                                                                            color: "gray",
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            </label>
                                                                        );
                                                                    })} &nbsp;&nbsp;
                                                                    {/* <span className="fs-6 ">{"("}{`${ratingValue} of 5`}{")"}</span> */}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-12 px-0'>
                                                            <TextArea
                                                                // onChange={onChangeFeedBackMsg}
                                                                value={feedbackMessage}
                                                                labelName={`Your feedback(optional)`}
                                                                rows={'2'}
                                                                onChange={(e) => { setFeedbackMessage(e.target.value) }}
                                                                onBlur={() => { }}
                                                            />
                                                        </div>
                                                    </>
                                                }

                                            </div>
                                        }

                                        {/* Unresolved */}
                                        {/* Condition changed to new one ->
                                    sentRequest.length > 0 && acceptRejectFlag === 1 && receiverData.ticket_status_ysn !== 0 && */}
                                        {sentRequest.length > 0 && acceptRejectFlag === 1 && receiverData.ticket_status_ysn === 2 &&
                                            <div
                                                className="row mx-0 rounded-2 p-3 shadow-lg mb-2 cursor-pointer border-hovered  bg-white"
                                                onClick={() => { setJobStatus(4) }}
                                                style={{
                                                    border: jobStatus == 4 ? '1px solid orange' : '',
                                                }}
                                            >
                                                <div className="col-12 px-0 font-w600 d-flex align-items-center ">
                                                    <div className='d-flex'>
                                                        <div className='d-flex align-items-center justify-content-center'>
                                                            <div className="pe-4">
                                                                {/* <input
                                                                className="form-check-input"
                                                                style={{ display: 'inline-block' }}
                                                                name="selectJobStatus"
                                                                type="radio"
                                                                value={4}
                                                                onChange={(e) => { setJobStatus(4) }}
                                                                checked={jobStatus == 4}
                                                            /> */}
                                                            </div>
                                                        </div>
                                                        <div className='d-flex flex-column'>
                                                            <span className='font-w700 text-black fs-5'>{`Unresolved`}</span>
                                                            <span className=''>{`I couldn’t assist the customer`}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {jobStatus == 4 &&
                                                    <>
                                                        <div className='col-12 px-0 d-flex align-items-center justify-content-center flex-column mt-2'>
                                                            <div>
                                                                <span className='fs-5 text-black font-w700'>{`How would you rate the a job?`}</span>
                                                            </div>
                                                            <div>
                                                                <div
                                                                    className="font-w600 fs-3 mb-3"
                                                                    style={{ display: "flex", justifyContent: "center", alignItems: 'center' }}>
                                                                    {[...Array(5)].map((star, i) => {
                                                                        const rating = i + 1;
                                                                        return (
                                                                            <label key={i}>
                                                                                <input
                                                                                    type="radio"
                                                                                    name="rating"
                                                                                    value={ratingValue}
                                                                                    onClick={(e) => {
                                                                                        setRatingValue(rating);
                                                                                    }}
                                                                                    style={{ display: "none" }}
                                                                                />
                                                                                {rating <= (hover || ratingValue) ? (
                                                                                    <BsStarFill
                                                                                        onMouseEnter={() => setHover(rating)}
                                                                                        onMouseLeave={() => setHover(0)}
                                                                                        className="star"
                                                                                        style={{
                                                                                            width: "24px",
                                                                                            height: "24px",
                                                                                            cursor: "pointer",
                                                                                            color: "gold",
                                                                                        }}
                                                                                    />
                                                                                ) : (
                                                                                    <BiStar
                                                                                        onMouseEnter={() => setHover(rating)}
                                                                                        onMouseLeave={() => setHover(0)}
                                                                                        className="star"
                                                                                        style={{
                                                                                            width: "24px",
                                                                                            height: "24px",
                                                                                            cursor: "pointer",
                                                                                            color: "gray",
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            </label>
                                                                        );
                                                                    })} &nbsp;&nbsp;
                                                                    {/* <span className="fs-6 ">{"("}{`${ratingValue} of 5`}{")"}</span> */}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-12 px-0'>
                                                            <TextArea
                                                                // onChange={onChangeFeedBackMsg}
                                                                value={feedbackMessage}
                                                                labelName={`Your feedback(optional)`}
                                                                rows={'2'}
                                                                onChange={(e) => { setFeedbackMessage(e.target.value) }}
                                                                onBlur={() => { }}
                                                            />
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                        }

                                        {/* work in progress */}
                                        {receiverData.ticket_status_ysn == 2 &&
                                            <div
                                                className="row mx-0 rounded-2 p-3 shadow-lg mb-2 cursor-pointer border-hovered bg-white"
                                                onClick={() => { setJobStatus(2) }}
                                                style={{
                                                    border: jobStatus == 2 ? '1px solid orange' : '',
                                                }}
                                            >
                                                <div className="col-12 px-0 font-w600 d-flex align-items-center ">
                                                    <div className='d-flex'>
                                                        <div className='d-flex align-items-center justify-content-center'>
                                                            <div className="pe-4">
                                                                {/* <input
                                                                className="form-check-input"
                                                                style={{ display: 'inline-block' }}
                                                                name="selectJobStatus"
                                                                type="radio"
                                                                value={2}
                                                                onChange={(e) => { setJobStatus(2) }}
                                                                checked={jobStatus == 2}
                                                            /> */}
                                                            </div>
                                                        </div>
                                                        <div className='d-flex flex-column'>
                                                            <span className='font-w700 text-black fs-5'>{`Work in Process`}</span>
                                                            <span className=''>{`The work is still ongoing`}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        <div className="row mx-0 text-black mt-4">
                                            <div className="col-12 "
                                                style={{
                                                    pointerEvents: jobStatus == 2 ? "none" : "auto",
                                                    opacity: jobStatus == 2 ? "0.5" : "1",
                                                }}
                                            >
                                                <PrimaryButton
                                                    onClick={(e) => {
                                                        if (jobStatus == 2) {
                                                            handleCloseChangeJobStatusModal();
                                                        } else {
                                                            if (jobStatus || jobStatus == 0) {
                                                                handleChangeJobStatusFn();
                                                            }
                                                        }
                                                    }}
                                                    buttonName={`SUBMIT`}
                                                    loadingMessage={"Loading..."}
                                                    isLoading={changeJobStatusLoading}
                                                    style={{
                                                        width: "100%",
                                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                        border: '2px solid rgba(255, 154, 32, 1)',
                                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                        borderRadius: '4px'
                                                    }}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                </>
                            }


                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {/* Modal for Change job status ends */}

            {/* Modal for cancel service */}
            <Modal
                className="fade"
                show={cancelServiceModalTrigger}
                // onHide={handleClose}
                centered
            >
                <Modal.Body>
                    <div className="row mx-0">
                        <div className="col-12 px-0">
                            <div className="row mx-0">
                                <div className="col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black">
                                    <span
                                        onClick={() => handleCloseCancelServiceModal()}
                                        className="cursor-pointer">
                                        <i className="bi bi-x-lg"></i>
                                    </span>
                                </div>
                            </div>

                            <div className="row mx-0 mb-3">
                                <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                    <span className="">{"Cancel request"}</span>
                                </div>
                            </div>

                            <div className="row mx-0 mt-3 pb-3">
                                <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                    <span className="fs-6 text-center">
                                        {"Are you sure you want to cancel it?"}
                                    </span>
                                </div>
                            </div>

                            {/* <div className="row mx-0 text-black mt-2">
                                <div className="col-12 px-0 font-w600">
                                    <PrimaryButton
                                        onClick={(e) => handleCloseModalNotes()}
                                        buttonName={"Cancel"}
                                        style={{
                                            width: "100%",
                                            backgroundColor: "white",
                                            border: "none",
                                            color: "grey",
                                        }}
                                    />
                                </div>
                            </div> */}

                            <div className="row mx-0 text-black mt-2">
                                <div className="col-sm-6 pe-sm-2 font-w600 mt-2">
                                    <PrimaryButton
                                        onClick={(e) => handleCloseCancelServiceModal()}
                                        buttonName={"NO, GO BACK"}
                                        style={{
                                            width: "100%",
                                            background: 'rgba(251, 252, 255, 1)',
                                            border: '1px solid rgba(199, 212, 234, 1)',
                                            color: "black",
                                            boxshadow: '0px 6px 12px 0px rgba(102, 129, 172, 0.12)',
                                            fontWeight: '600',
                                        }}
                                    />
                                </div>

                                <div className="col-sm-6 ps-sm-2 font-w600 mt-2">
                                    <PrimaryButton
                                        onClick={(e) => cancelRequest()}
                                        buttonName={"YES, CANCEL IT"}
                                        loadingMessage={"LOADING..."}
                                        isLoading={loadingForCancelRequest}
                                        style={{
                                            width: "100%",
                                            background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                            boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                            border: '1px solid rgba(240, 72, 72, 1)',
                                            fontWeight: '600',
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {/* Modal for cancel service */}

            {/* Modal for reactivate service */}
            <Modal
                className="fade"
                show={reactivateServiceModalTrigger}
                // onHide={handleClose}
                centered
            >
                <Modal.Body>
                    <div className="row mx-0">
                        <div className="col-12 px-0">
                            <div className="row mx-0">
                                <div className="col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black">
                                    <span
                                        onClick={() => handleCloseReactivateServiceModal()}
                                        className="cursor-pointer">
                                        <i className="bi bi-x-lg"></i>
                                    </span>
                                </div>
                            </div>

                            <div className="row mx-0 mb-3">
                                <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                    <span className="">{"Reactivate service request"}</span>
                                </div>
                            </div>

                            <div className="row mx-0 mt-3 pb-3">
                                <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                    <span className="fs-6 text-center">
                                        {"Would you like to reactivate this service request to connect to a Pro who can help you resolve your problem?"}
                                    </span>
                                </div>
                            </div>

                            {/* <div className="row mx-0 text-black mt-2">
                                <div className="col-12 px-0 font-w600">
                                    <PrimaryButton
                                        onClick={(e) => handleCloseModalNotes()}
                                        buttonName={"Cancel"}
                                        style={{
                                            width: "100%",
                                            backgroundColor: "white",
                                            border: "none",
                                            color: "grey",
                                        }}
                                    />
                                </div>
                            </div> */}

                            <div className="row mx-0 text-black mt-2">
                                <div className="col-sm-6 pe-sm-2 font-w600 mt-2">
                                    <PrimaryButton
                                        onClick={(e) => handleCloseReactivateServiceModal()}
                                        buttonName={"NO, GO BACK"}
                                        style={{
                                            width: "100%",
                                            background: 'rgba(251, 252, 255, 1)',
                                            border: '1px solid rgba(199, 212, 234, 1)',
                                            color: "black",
                                            boxshadow: '0px 6px 12px 0px rgba(102, 129, 172, 0.12)',
                                            fontWeight: '600',
                                        }}
                                    />
                                </div>

                                <div className="col-sm-6 ps-sm-2 font-w600 mt-2">
                                    <PrimaryButton
                                        onClick={(e) => reOpenRequest()}
                                        buttonName={"YES, REACTIVATE"}
                                        loadingMessage={"LOADING..."}
                                        isLoading={statusUpdateLoaderCust}
                                        style={{
                                            width: "100%",
                                            background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                            boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                            border: '1px solid rgba(240, 72, 72, 1)',
                                            fontWeight: '600',
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {/* Modal for reactivate service */}

            {/* Modal for schedule call for later */}
            <>
                <Modal
                    className="fade"
                    show={scheduleModalTrigger}
                    // onHide={handleClose}
                    centered
                    size=""
                >
                    {/* <Modal.Header style={{ borderBottom: 'none' }}>
            <Modal.Title style={{ display: 'flex', }}>

              {toggleForSchedule === 1 ? "Do you want to connect now or schedule for later?" :
                toggleForSchedule === 2 ? "Select date and time to schedule call for later" : ""}

            </Modal.Title>
            <Button
              variant=""
              className="btn-close btn-close-service"
              onClick={() => handleCloseDocScheduleModal()}
            >

            </Button>
          </Modal.Header> */}
                    <Modal.Body style={{ padding: "5px" }}>
                        <div className="row mx-0">
                            <div className="col-12 px-0 position-relative">
                                <div
                                    className="mx-0 row  schedule-modal-close-btn position-absolute text-hovered "
                                    style={{
                                        top: "5px",
                                        right: "10px",
                                    }}>
                                    <div className="col-12 d-flex fs-4 justify-content-end px-0">
                                        <span
                                            onClick={() => handleCloseDocScheduleModal()}
                                            className="cursor-pointer">
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className="row mx-0 ">
                                    <div
                                        className="col-sm-6 px-2 rounded-1"
                                        style={{
                                            background: "rgba(79, 93, 116, 1)",
                                        }}>
                                        <div className="mx-0 row m-2">
                                            <div className="col-12  px-0 text-center text-white fs-7 fw-light my-3 px-2">
                                                <span>{`Please note that the standard call duration is 20 minutes`}</span>
                                            </div>
                                        </div>

                                        <div className="mx-0 row">
                                            <div className="col-12  px-0 text-center">
                                                <InputField
                                                    type="time"
                                                    labelName={"Time"}
                                                    placeholder={"Date and time"}
                                                    value={currentTime}
                                                    // onChange={(e) => setCurrentTime(e.target.value)}
                                                    onChange={handleTimeChange}
                                                    errorOccured={isDateTimeErr}
                                                    errorMeesage={"Please enter date and time"}
                                                />
                                            </div>
                                        </div>

                                        <div className="row mx-0">
                                            <div className="col-12 px-0 d-flex justify-content-center">
                                                <DatePicker
                                                    selected={selectedDate}
                                                    onChange={handleDateChange}
                                                    // dateFormat="MMMM d, yyyy" // Format of the date displayed
                                                    // isClearable={true} // Shows a clear button to clear the selection
                                                    // showYearDropdown
                                                    scrollableMonthYearDropdown
                                                    inline // This prop makes the calendar always visible
                                                    style={{}}
                                                    minDate={today} // Disables all past dates before today
                                                    formatWeekDay={(nameOfDay) =>
                                                        nameOfDay.substring(0, 3)
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-sm-6" style={{}}>
                                        <div className="row h-100 w-100">
                                            <div className="col-12 p-3 d-flex flex-column justify-content-between">
                                                <div>
                                                    <div className="mx-0 row text-black my-2">
                                                        <div className="col-12 px-0 text-center d-flex align-items-cente justify-content-center">
                                                            <img
                                                                src={calendarImg}
                                                                alt="Calendar"
                                                                style={{ height: "70px", width: "70px" }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="mx-0 row text-black mb-3">
                                                        <div className="col-12 font-w600 fs-3 px-0 text-center">
                                                            <span>{"Schedule a call"}</span>
                                                        </div>
                                                    </div>

                                                    <div className="mx-0 row mb-3">
                                                        <div className="col-12  px-0 text-center">
                                                            <span>
                                                                {
                                                                    "Set the desired date and time for your video call or set it to go live right now"
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className="mx-0 row">
                                                        <div
                                                            className="col-12  px-0 text-center rounded p-2 d-flex align-items-center justify-content-center flex-column"
                                                            style={{
                                                                background: "rgba(244, 248, 255, 1)",
                                                                border: "1px solid rgba(199, 212, 234, 1)",
                                                            }}>
                                                            <span>{`Scheduled date & time`}</span>
                                                            <span className="fs-6 text-black">{`${formatUnixTimestamp(
                                                                convertToUnixTime()
                                                            )}`}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div>
                                                    <div className="mx-0 row mt-3">
                                                        <div className="col-12  px-0 text-center">
                                                            <PrimaryButton
                                                                buttonName={"SAVE CHANGES"}
                                                                onClick={() => updateServiceScheduleCallFn()}
                                                                isLoading={saveUpdateTicketLoading}
                                                                loadingMessage={"Saving..."}
                                                                style={{
                                                                    width: "100%",
                                                                    background:
                                                                        "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)",
                                                                    border: "2px solid rgba(255, 154, 32, 1)",
                                                                    boxShadow:
                                                                        "0px 6px 12px 0px rgba(255, 154, 32, 0.24)",
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>

              <div style={{ width: '100%', marginBottom: '5px', textAlign: 'center' }}>
                <p style={{ fontSize: '14px', fontWeight: '600', color: 'black' }}>{"Select date and time to schedule call for later"}</p>
              </div>


              <div style={{ width: '70%', marginBottom: '15px' }}>
                <InputField
                  type="datetime-local"
                  labelName={"Date and time"}
                  placeholder={"Date and time"}
                  value={dateTime}
                  onChange={handleDateTime}
                  errorOccured={isDateTimeErr}
                  errorMeesage={"Please enter date and time"}
                />
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                <PrimaryButton
                  buttonName={"Submit"}
                  onClick={() => handleSubmitSchedule()}
                  isLoading={scheduleLoader}
                  loadingMessage={"Submiting..."}
                />
              </div>
            </div> */}
                    </Modal.Body>
                </Modal>
            </>

            {/* Subscription check */}
            <>
                <AcceptRejectModal
                    modalStatus={isSubscriptionExpired}
                    text={`${(permissionArray.includes("UPDATE WORK INFORMATION") && !companyId) ? "Please upgrade your subscription to accept service." : "Your company subscription expired. Please contact the company admin."}`}
                    onClickReject={() => {
                        setIsSubscriptionExpired(false)
                    }}
                    onClickAccept={() => {
                        setIsSubscriptionExpired(false)
                        if ((permissionArray.includes("UPDATE WORK INFORMATION") && !companyId)) {
                            dispatch(setUserProfileTab(5))
                            navigate('/userProfile')
                        }
                    }}
                    yesBtnTxt={`${(permissionArray.includes("UPDATE WORK INFORMATION") && !companyId) ? "BUY NOW" : "OK"}`}
                    noBtnTxt={"NO, GO BACK"}
                    isTwoActionsReq={(permissionArray.includes("UPDATE WORK INFORMATION") && !companyId)}
                />
            </>

            {/* Modal for re-assign service by company admin */}
            <Modal
                className="fade"
                show={reAssignServiceModalTrigger}
                // onHide={handleClose}
                centered
                size=""
            >
                <Modal.Body>
                    <div className="row mx-0">
                        <div className="col-12 px-0">
                            <div className="row mx-0">
                                <div className="col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black">
                                    <span
                                        onClick={() => handleCloseReAssignServiceModal()}
                                        className="cursor-pointer">
                                        <i className="bi bi-x-lg"></i>
                                    </span>
                                </div>
                            </div>

                            <div className="row mx-0 mb-3">
                                <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                    <span className="">{"Search professional"}</span>
                                </div>
                            </div>

                            <div className="row mx-0 mt-3 pb-3">
                                <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                    <span className="fs-6 text-center">
                                        {"Select professional to assign a service request."}
                                    </span>
                                </div>
                            </div>

                            <form onSubmit={(e) => handleReAssignViaRoleFn(e)}>
                                <div className='row mx-0'>
                                    <div className='col-12 px-0'>
                                        {/* <SearchableSelect
                                            userArray={elements}
                                            handleChangeSearchValue={(e) => { setSearchValue(e) }}
                                            handleChangeCode={(e) => { setUserId(e); setIsProSelected(false) }}
                                            labelName={"Select pro *"}
                                            errorOccured={isProSelected}
                                            errorMessage={`Please select a pro`}
                                        /> */}

                                        <SearchableSelectForInvites
                                            userArray={elements}
                                            handleChangeSearchValue={(e) => { setSearchValue(e) }}
                                            handleChangeCode={(e) => {
                                                setUserId(e?.user_id_ids);
                                                setUserInvitationId(e?.invitation_id_ids);
                                                setIsProSelected(false)
                                            }}
                                            labelName={"Select pro *"}
                                            errorOccured={isProSelected}
                                            errorMessage={`Please select a pro`}
                                        />
                                    </div>
                                </div>

                                <div className="row mx-0 text-black mt-2">
                                    <div className="col-12 px-0 font-w600">
                                        <PrimaryButton
                                            onClick={(e) => { handleReAssignViaRoleFn() }}
                                            buttonName={"ASSIGN SERVICE"}
                                            loadingMessage={"LOADING..."}
                                            isLoading={reAssignViaRoleLoading}
                                            style={{
                                                width: "100%",
                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                fontWeight: '600',
                                            }}
                                        />
                                    </div>
                                </div>
                            </form>


                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Connect to Local Pro modal */}
            <>
                {/* <!-- Modal --> */}
                <Modal className="fade" show={localProModaltrigger}
                    // onHide={handleClose} 
                    centered
                    size=""

                >
                    <Modal.Body
                        style={{
                            background: 'linear-gradient(182deg, rgba(250, 238, 227, 0.67) 33%, rgb(255, 255, 255) 85%)',
                            borderRadius: '8px',
                        }}
                    >
                        <>
                            <div className='row mx-0'>
                                <div className='col-12 px-0'>

                                    <div className='row mx-0'>
                                        <div className='col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black'>
                                            <span onClick={() => handleCloseLocalProModal()} className='cursor-pointer'>
                                                <i className="bi bi-x-lg"></i>
                                            </span>
                                        </div>
                                    </div>

                                    {toggleForLocalProModal == 1 ?
                                        <>
                                            <>
                                                <div className='row mx-0'>
                                                    <div className='fw-bold col-12 px-0 d-flex align-items-center fs-3 text-black'>
                                                        <span className=''>
                                                            {"I need a Local Pro"}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div
                                                    className='row mx-0 mt-3 pb-2'
                                                    style={{
                                                        borderBottom: '4px solid rgb(250, 239, 230)'
                                                    }}
                                                >
                                                    <div className='font-w500 col-12 px-0 d-flex align-items-center fs-5 '>
                                                        <span className=' text-black'>
                                                            {"We've flipped the local Pro Process script"}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className='row mx-0 mt-3'>
                                                    <div className='font-w600 text-black col-12 px-0 d-flex align-items-center fs-5 '>
                                                        <div className='row mx-0 w-100'>
                                                            <div className='d-flex col-md-6 mb-2'>
                                                                <span className='me-2 text-center' style={{ color: 'rgba(91, 72, 169, 1)', fontSize: '20px' }}>
                                                                    <i class="bi bi-check2-all"></i>
                                                                </span>
                                                                <span className=' '>
                                                                    {`For your ${receiverData?.category_display_name_chr} Project.`}
                                                                </span>
                                                            </div>

                                                            <div className='d-flex col-md-6 mb-2'>
                                                                <span className='me-2 text-center' style={{ color: 'rgba(91, 72, 169, 1)', fontSize: '20px' }}>
                                                                    <i class="bi bi-check2-all"></i>
                                                                </span>
                                                                <span className='  '>
                                                                    {"Expected to pay."}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <form className='w-100' onSubmit={(e) => { handleUpdateTicketSummary(e, 3); }}>

                                                    <div className="row mt-3">
                                                        <span className='mb-3'>{`Between`}</span>

                                                        <div className='col-12 px-0 '>
                                                            {/* Edit of Low and Max values restricted as per feedback */}
                                                            <div
                                                                className='d-flex align-items-center justify-content-between'
                                                                style={{
                                                                    pointerEvents: 'none',
                                                                }}
                                                            >
                                                                <div className="" style={{ width: '45%', }}>
                                                                    <InputField
                                                                        labelName={"Low ($)"}
                                                                        placeholderName={"Low ($)"}
                                                                        value={`${customerEstimatedCostMin}`}
                                                                        onChange={(e) => { handleCustomerEstimatedCostMin(e) }}
                                                                        onBlur={() => { }}
                                                                        errorOccured={false}
                                                                        errorMeesage={"Please add Labor"}
                                                                    />
                                                                </div>

                                                                <div
                                                                    className='p-2 d-flex align-items-center justify-content-center'
                                                                >
                                                                    <span className='font-w600 text-black fs-6 mb-3'> {`to`}</span>
                                                                </div>

                                                                <div className="" style={{ width: '45%', }}>
                                                                    <InputField
                                                                        labelName={"High ($)"}
                                                                        placeholderName={"High ($)"}
                                                                        value={`${customerEstimatedCostMax}`}
                                                                        onChange={(e) => { handleCustomerEstimatedCostMax(e) }}
                                                                        onBlur={() => { }}
                                                                        errorOccured={false}
                                                                        errorMeesage={"Please add Labor"}
                                                                    />
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mx-0 '>
                                                        <div className='font-w600 text-black col-12 px-0 d-flex align-items-center fs-5 '>
                                                            <div className='d-flex align-items-center mb-2'>
                                                                <span className='me-2 text-center' style={{ color: '#27AE60', fontSize: '20px' }}>
                                                                    <i class="bi bi-check-lg"></i>
                                                                </span>
                                                                <span className=' text-center'>
                                                                    {"When do you want it done?"}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mx-0 '>
                                                        <div className='row'>
                                                            <div className='col-12 px-0' >
                                                                <div className="d-flex align-items-center">
                                                                    <input
                                                                        className="form-check-input"
                                                                        style={{ display: 'inline-block' }}
                                                                        name="selectRole"
                                                                        type="radio"
                                                                        value={`1`}
                                                                        onChange={(e) => { setLocalProSectionDateTime(e.target.value); }}
                                                                        checked={localProSectionDateTime == "1"}
                                                                    />
                                                                    <span
                                                                        className='ps-2 pt-1 text-black fs-5 font-w600'
                                                                    >
                                                                        {`As soon as possible`}
                                                                    </span>
                                                                </div>
                                                                {/* {termsAndConditionsErr &&
                                                    <div className='mt-2 text-danger fs-12'>
                                                        <span>{`Please accept the Terms & Conditions`}</span>
                                                    </div>
                                                } */}
                                                            </div>
                                                        </div>

                                                        <div className='row mt-1'>
                                                            <div className='col-12 px-0' >
                                                                <div className="d-flex align-items-center mt-2">
                                                                    <input
                                                                        className="form-check-input mb-3"
                                                                        style={{ display: 'inline-block', minWidth: '18px' }}
                                                                        name="selectRole"
                                                                        type="radio"
                                                                        value={`2`}
                                                                        onChange={(e) => { setLocalProSectionDateTime(e.target.value); }}
                                                                        checked={localProSectionDateTime == "2"}
                                                                    />
                                                                    <span
                                                                        className='ps-2 pt-1 w-100'
                                                                    >
                                                                        <div className='col-12 px-0 '>
                                                                            <div className='d-flex align-items-center justify-content-between'>


                                                                                <div className="" style={{ width: '45%', }}>

                                                                                    <InputField
                                                                                        type="date"
                                                                                        labelName={"Date"}
                                                                                        placeholder={"Date"}
                                                                                        value={currentDateLocalPro}
                                                                                        onChange={(e) => setCurrentDateLocalPro(e.target.value)}
                                                                                        errorOccured={false}
                                                                                        errorMeesage={"Please enter date"}
                                                                                        onBlur={() => { }}
                                                                                    />
                                                                                </div>

                                                                                <div
                                                                                    className='p-2 px-1 d-flex align-items-center justify-content-center'
                                                                                >
                                                                                    <span className='font-w600 text-black fs-6 mb-3'> {`near`}</span>
                                                                                </div>

                                                                                <div className="" style={{ width: '45%', }}>
                                                                                    <InputField
                                                                                        type="time"
                                                                                        labelName={"Time"}
                                                                                        placeholder={"Date and time"}
                                                                                        value={currentTimeLocalPro}
                                                                                        onChange={(e) => {
                                                                                            setCurrentTimeLocalPro(e.target.value)
                                                                                        }}
                                                                                        errorOccured={false}
                                                                                        errorMeesage={""}
                                                                                        onBlur={() => { }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </span>
                                                                </div>
                                                                {/* {termsAndConditionsErr &&
                                                    <div className='mt-2 text-danger fs-12'>
                                                        <span>{`Please accept the Terms & Conditions`}</span>
                                                    </div>
                                                } */}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mx-0 mt-3'>
                                                        <div className='row'>
                                                            <div className='col-12 px-0' >
                                                                <div className="d-flex align-items-center">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        id="refund"
                                                                        name="refund"
                                                                        onChange={(e) => {
                                                                            setTermsAndConditions(!termsAndConditions);
                                                                            setTermsAndConditionsErr(false)
                                                                        }}
                                                                        value={termsAndConditions}
                                                                        checked={termsAndConditions}
                                                                    />
                                                                    <span
                                                                        className='ps-3 pt-1 text-black fs-5'
                                                                    >
                                                                        {`Agree to`}
                                                                        <strong className='text-hovered cursor-pointer ps-1' >
                                                                            <a
                                                                                className="terms-condition-link"
                                                                                href="https://chilll.com/chilll-terms-conditions/"
                                                                                target="_blank"
                                                                                rel="noreferrer">
                                                                                {"Terms and Conditions "}
                                                                            </a>
                                                                        </strong>
                                                                    </span>
                                                                </div>
                                                                {termsAndConditionsErr &&
                                                                    <div className='mt-2 text-danger fs-12'>
                                                                        <span>{`Please accept the Terms & Conditions`}</span>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>





                                                    <div className='row mx-0 mt-3'>
                                                        <div className='font-w500 col-12 px-0 d-flex align-items-center justify-content-center fs-5 '>
                                                            <PrimaryButton
                                                                buttonName={"Send to Chilll Pro Network"}
                                                                onClick={(e) => {
                                                                    handleUpdateTicketSummary(e, 3);
                                                                    // handleCloseLocalProModal(e);
                                                                }}
                                                                loadingMessage={"Loading..."}
                                                                isLoading={updateTicketSummaryLoading}
                                                                style={{
                                                                    width: '100%',
                                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </form>
                                            </>
                                        </> :
                                        toggleForLocalProModal == 2 ?
                                            <>
                                                <div className='mx-0 row text-black mb-3'>
                                                    <div className='col-12 font-w600 fs-4 px-0 text-center'>
                                                        <img src={logo} alt="" style={{ maxWidth: '125px' }} />
                                                    </div>
                                                </div>

                                                <div className='row mx-0'>
                                                    <div className='font-w600 col-12 px-0 d-flex align-items-center justify-content-center fs-5 '>
                                                        <span className=' text-center text-black'>
                                                            {"We've submitted your project proposal to our local vetted pro network"}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className='row mx-0 mt-3'>
                                                    <div className='font-w600 col-12 px-0 d-flex align-items-center justify-content-center fs-5 '>
                                                        <span className=' text-center text-black'>
                                                            {"We'll be in touch when the job is accepted"}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className='row mx-0 mt-3'>
                                                    <div className='font-w600 col-12 px-0 d-flex align-items-center justify-content-center fs-5 '>
                                                        <span className=' text-center text-black'>
                                                            {"Thanks for choosing Chilll"}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className='row mx-0 mt-3'>
                                                    <div className='font-w500 col-12 px-0 d-flex align-items-center justify-content-center fs-5 '>
                                                        <PrimaryButton
                                                            buttonName={"OK"}
                                                            onClick={(e) => {
                                                                handleCloseLocalProModal(e);
                                                                navigate('/');
                                                            }}
                                                            loadingMessage={"Loading..."}
                                                            isLoading={false}
                                                            style={{
                                                                width: '100%',
                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </> : <> </>
                                    }


                                </div>
                            </div>
                        </>
                    </Modal.Body>
                </Modal>
            </>

            {/* Confirmation to Connect to DIY remote Pro from recommendations */}
            <Modal className="fade" show={confirmationForConnectToProModalTrigger}
                // onHide={handleClose} 
                centered
            >
                {/* <Modal.Header style={{ borderBottom: 'none' }}>
                    <Modal.Title>{"Connect with another pro"}</Modal.Title>
                    <Button
                        variant=""
                        className="btn-close btn-close-service"
                        onClick={() => handleCloseConnectWithAnotherProModal()}
                    >

                    </Button>
                </Modal.Header> */}
                <Modal.Body>
                    <>
                        <div className='row mx-0'>
                            <div className='col-12 px-0'>

                                <div className='row mx-0'>
                                    <div className='col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black'>
                                        <span onClick={() => handleCloseConfirmationForConnectToProModal()} className='cursor-pointer'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className='row mx-0'>
                                    <div className='fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black'>
                                        <span className=''>
                                            {"Confirmation"}
                                        </span>
                                    </div>
                                </div>

                                <div className='row mx-0 mt-3'>
                                    <div className='font-fw600 col-12 px-0 d-flex align-items-center justify-content-center fs-5 '>
                                        <span className='text-center'>
                                            {`Are you ready to connect with the DIY + Remote Pro?`}
                                        </span>
                                    </div>
                                </div>

                                <div className='row mx-0 mt-3'>
                                    <div className='col-12 px-0'>
                                        <PrimaryButton
                                            onClick={(e) => {
                                                // saveCallDurationForRegisteredCustomer();
                                                ReInitiateByCust();
                                                // setProRecommendedSolution(2);
                                                setCustomerSelectedSolution(2);
                                                handleUpdateTicketSummary(e, 2);
                                            }}
                                            buttonName={'CONFIRM'}
                                            loadingMessage="LOADING..."
                                            isLoading={backDropLoaderResp}
                                            style={{
                                                width: '100%',
                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                border: '1px solid rgba(255, 154, 32, 1)',
                                                fontWeight: '600',
                                            }}
                                        />
                                    </div>

                                </div>


                            </div>
                        </div>

                    </>
                </Modal.Body>
            </Modal>

            {/* Confirmation to take the card details to DIY remote Pro from recommendations */}
            <Modal show={alertCardsModalTrigger} centered>

                <Modal.Body>
                    <div className='row mx-0'>
                        <div className='col-12 px-0'>
                            <>
                                <div className='mx-0 row text-black mb-4'>
                                    <div className='col-12 font-w600 fs-4 px-0 text-center'>
                                        <img src={logo} alt="" style={{ maxWidth: '125px' }} />
                                    </div>
                                </div>

                                <div className='mx-0 row text-black mb-4'>
                                    <div className='col-12 font-w600 fs-4 px-0 text-center'>
                                        <span>
                                            {'Before we can connect you with a remote pro, you need to set up a payment method.  Click Okay here to enter that information.'}
                                        </span>
                                    </div>
                                </div>

                                <div className='row mx-0'>
                                    <div className='col-6 pe-2 px-0'>
                                        <PrimaryButton
                                            onClick={() => {
                                                navigate('/userProfile')
                                                dispatch(setUserProfileTab(3))
                                            }}
                                            buttonName={"OKAY"}
                                            type="submit"
                                            loadingMessage="SUBMITTING..."
                                            isLoading={false}
                                            style={{
                                                width: "100%",
                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                border: '1px solid rgba(255, 154, 32, 1)',
                                                fontWeight: '600',
                                            }}
                                        />
                                    </div>

                                    <div className='col-6 ps-2 px-0'>
                                        <PrimaryButton
                                            onClick={() => {
                                                setAlertCardsModalTrigger(false);
                                            }}
                                            buttonName={"CANCEL"}
                                            type="submit"
                                            loadingMessage="SUBMITTING..."
                                            isLoading={false}
                                            style={{
                                                width: "100%",
                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                border: '1px solid rgba(255, 154, 32, 1)',
                                                fontWeight: '600',
                                            }}
                                        />
                                    </div>
                                </div>
                            </>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Modal for the Payment Error  */}
            <Modal show={paymentErrorModalTrigger} centered>

                <Modal.Body>
                    <div className='row mx-0'>
                        <div className='col-12 px-0'>
                            <>
                                <div className='mx-0 row text-black mb-3'>
                                    <div className='col-12 font-w600 fs-4 px-0 text-center'>
                                        <img src={serviceImg} alt="" style={{ maxWidth: '150px' }} />
                                    </div>
                                </div>

                                <div className='mx-0 row text-black mb-3'>
                                    <div className='col-12 font-w600 fs-4 px-0 text-center'>
                                        <span>
                                            {responceMsg || 'Something went wrong, please try after some time.'}
                                        </span>
                                    </div>

                                </div>

                                <div className='row mx-0'>
                                    <div className='col-12 px-0'>
                                        <PrimaryButton
                                            onClick={() => {
                                                if (paymentErrorStatusCode == 402) {
                                                    navigate('/userProfile');
                                                    dispatch(setUserProfileTab(3));
                                                }
                                                setPaymentErrorModalTrigger(false);
                                            }}
                                            buttonName={"ADD PAYMENT METHOD"}
                                            type="submit"
                                            loadingMessage="SUBMITTING..."
                                            isLoading={false}
                                            style={{
                                                width: "100%",
                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                border: '1px solid rgba(255, 154, 32, 1)',
                                                fontWeight: '600',
                                            }}
                                        />
                                    </div>
                                </div>
                            </>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {(openVideoAudio) && <VideoAudioPlayer videoAudioURL={videoAudioURL} handleCloseVideoAudio={handleCloseVideoAudio} />}

            {/* {(openVideoAudio) && <DemoReactPlayer videoAudioURL={videoAudioURL} handleCloseVideoAudio={handleCloseVideoAudio} />} */}

            {/* {backDropLoaderResp && <DummyBackdropLoader />} */}

            {backDropLoaderStatus && <BackDrop showUpdate={false} openLoader={backDropLoaderStatus} descriptionVal={description} modelNumVal={modelNum} timeSlotArr={timeSlotArr} />}
            {errBackDropLoaderResp && <ErrorBackdropLoader resMessage={responceMsg} />}

            {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}
        </>
    )
}

export default ServiceRequestDetailsPage